var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _slicedToArray = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _toConsumableArray = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

/*! For license information please see index.cjs.js.LICENSE.txt */
(function () {
  var e = {
    8162: function _(e, t, r) {
      "use strict";

      var n = r(9509).Buffer;

      e.exports = function (e) {
        if (e.length >= 255) throw new TypeError("Alphabet too long");
        var t = new Uint8Array(256);
        t.fill(255);

        for (var r = 0; r < e.length; r++) {
          var i = e.charAt(r),
              o = i.charCodeAt(0);
          if (255 !== t[o]) throw new TypeError(i + " is ambiguous");
          t[o] = r;
        }

        var a = e.length,
            c = e.charAt(0),
            s = Math.log(a) / Math.log(256),
            f = Math.log(256) / Math.log(a);

        function d(e) {
          if ("string" != typeof e) throw new TypeError("Expected String");
          if (0 === e.length) return n.alloc(0);
          var r = 0;

          if (" " !== e[r]) {
            for (var i = 0, o = 0; e[r] === c;) {
              i++, r++;
            }

            for (var f = (e.length - r) * s + 1 >>> 0, d = new Uint8Array(f); e[r];) {
              var u = t[e.charCodeAt(r)];
              if (255 === u) return;

              for (var h = 0, l = f - 1; (0 !== u || h < o) && -1 !== l; l--, h++) {
                u += a * d[l] >>> 0, d[l] = u % 256 >>> 0, u = u / 256 >>> 0;
              }

              if (0 !== u) throw new Error("Non-zero carry");
              o = h, r++;
            }

            if (" " !== e[r]) {
              for (var p = f - o; p !== f && 0 === d[p];) {
                p++;
              }

              var m = n.allocUnsafe(i + (f - p));
              m.fill(0, 0, i);

              for (var b = i; p !== f;) {
                m[b++] = d[p++];
              }

              return m;
            }
          }
        }

        return {
          encode: function encode(t) {
            if (!n.isBuffer(t)) throw new TypeError("Expected Buffer");
            if (0 === t.length) return "";

            for (var r = 0, i = 0, o = 0, s = t.length; o !== s && 0 === t[o];) {
              o++, r++;
            }

            for (var d = (s - o) * f + 1 >>> 0, u = new Uint8Array(d); o !== s;) {
              for (var h = t[o], l = 0, p = d - 1; (0 !== h || l < i) && -1 !== p; p--, l++) {
                h += 256 * u[p] >>> 0, u[p] = h % a >>> 0, h = h / a >>> 0;
              }

              if (0 !== h) throw new Error("Non-zero carry");
              i = l, o++;
            }

            for (var m = d - i; m !== d && 0 === u[m];) {
              m++;
            }

            for (var b = c.repeat(r); m < d; ++m) {
              b += e.charAt(u[m]);
            }

            return b;
          },
          decodeUnsafe: d,
          decode: function decode(e) {
            var t = d(e);
            if (t) return t;
            throw new Error("Non-base" + a + " character");
          }
        };
      };
    },
    4736: function _(e, t, r) {
      var n;
      e = r.nmd(e);

      var i = function (e) {
        "use strict";

        var t = 1e7,
            r = 9007199254740992,
            n = d(r),
            o = Math.log(r);

        function a(e, t) {
          return void 0 === e ? a[0] : void 0 !== t ? 10 == +t ? W(e) : z(e, t) : W(e);
        }

        function c(e, t) {
          this.value = e, this.sign = t, this.isSmall = !1;
        }

        function s(e) {
          this.value = e, this.sign = e < 0, this.isSmall = !0;
        }

        function f(e) {
          return -r < e && e < r;
        }

        function d(e) {
          return e < 1e7 ? [e] : e < 1e14 ? [e % 1e7, Math.floor(e / 1e7)] : [e % 1e7, Math.floor(e / 1e7) % 1e7, Math.floor(e / 1e14)];
        }

        function u(e) {
          h(e);
          var r = e.length;
          if (r < 4 && I(e, n) < 0) switch (r) {
            case 0:
              return 0;

            case 1:
              return e[0];

            case 2:
              return e[0] + e[1] * t;

            default:
              return e[0] + (e[1] + e[2] * t) * t;
          }
          return e;
        }

        function h(e) {
          for (var t = e.length; 0 === e[--t];) {
            ;
          }

          e.length = t + 1;
        }

        function l(e) {
          for (var t = new Array(e), r = -1; ++r < e;) {
            t[r] = 0;
          }

          return t;
        }

        function p(e) {
          return e > 0 ? Math.floor(e) : Math.ceil(e);
        }

        function m(e, r) {
          var n,
              i,
              o = e.length,
              a = r.length,
              c = new Array(o),
              s = 0,
              f = t;

          for (i = 0; i < a; i++) {
            s = (n = e[i] + r[i] + s) >= f ? 1 : 0, c[i] = n - s * f;
          }

          for (; i < o;) {
            s = (n = e[i] + s) === f ? 1 : 0, c[i++] = n - s * f;
          }

          return s > 0 && c.push(s), c;
        }

        function b(e, t) {
          return e.length >= t.length ? m(e, t) : m(t, e);
        }

        function g(e, r) {
          var n,
              i,
              o = e.length,
              a = new Array(o),
              c = t;

          for (i = 0; i < o; i++) {
            n = e[i] - c + r, r = Math.floor(n / c), a[i] = n - r * c, r += 1;
          }

          for (; r > 0;) {
            a[i++] = r % c, r = Math.floor(r / c);
          }

          return a;
        }

        function v(e, r) {
          var n,
              i,
              o = e.length,
              a = r.length,
              c = new Array(o),
              s = 0,
              f = t;

          for (n = 0; n < a; n++) {
            (i = e[n] - s - r[n]) < 0 ? (i += f, s = 1) : s = 0, c[n] = i;
          }

          for (n = a; n < o; n++) {
            if (!((i = e[n] - s) < 0)) {
              c[n++] = i;
              break;
            }

            i += f, c[n] = i;
          }

          for (; n < o; n++) {
            c[n] = e[n];
          }

          return h(c), c;
        }

        function y(e, r, n) {
          var i,
              o,
              a = e.length,
              f = new Array(a),
              d = -r,
              h = t;

          for (i = 0; i < a; i++) {
            o = e[i] + d, d = Math.floor(o / h), o %= h, f[i] = o < 0 ? o + h : o;
          }

          return "number" == typeof (f = u(f)) ? (n && (f = -f), new s(f)) : new c(f, n);
        }

        function w(e, r) {
          var n,
              i,
              o,
              a,
              c = e.length,
              s = r.length,
              f = l(c + s),
              d = t;

          for (o = 0; o < c; ++o) {
            a = e[o];

            for (var u = 0; u < s; ++u) {
              n = a * r[u] + f[o + u], i = Math.floor(n / d), f[o + u] = n - i * d, f[o + u + 1] += i;
            }
          }

          return h(f), f;
        }

        function A(e, r) {
          var n,
              i,
              o = e.length,
              a = new Array(o),
              c = t,
              s = 0;

          for (i = 0; i < o; i++) {
            n = e[i] * r + s, s = Math.floor(n / c), a[i] = n - s * c;
          }

          for (; s > 0;) {
            a[i++] = s % c, s = Math.floor(s / c);
          }

          return a;
        }

        function _(e, t) {
          for (var r = []; t-- > 0;) {
            r.push(0);
          }

          return r.concat(e);
        }

        function M(e, t) {
          var r = Math.max(e.length, t.length);
          if (r <= 30) return w(e, t);
          r = Math.ceil(r / 2);
          var n = e.slice(r),
              i = e.slice(0, r),
              o = t.slice(r),
              a = t.slice(0, r),
              c = M(i, a),
              s = M(n, o),
              f = M(b(i, n), b(a, o)),
              d = b(b(c, _(v(v(f, c), s), r)), _(s, 2 * r));
          return h(d), d;
        }

        function x(e, r, n) {
          return new c(e < t ? A(r, e) : w(r, d(e)), n);
        }

        function k(e) {
          var r,
              n,
              i,
              o,
              a = e.length,
              c = l(a + a),
              s = t;

          for (i = 0; i < a; i++) {
            n = 0 - (o = e[i]) * o;

            for (var f = i; f < a; f++) {
              r = o * e[f] * 2 + c[i + f] + n, n = Math.floor(r / s), c[i + f] = r - n * s;
            }

            c[i + a] = n;
          }

          return h(c), c;
        }

        function E(e, t) {
          var r,
              n,
              i,
              o,
              a = e.length,
              c = l(a);

          for (i = 0, r = a - 1; r >= 0; --r) {
            i = (o = 1e7 * i + e[r]) - (n = p(o / t)) * t, c[r] = 0 | n;
          }

          return [c, 0 | i];
        }

        function S(e, r) {
          var n,
              i,
              o = W(r),
              f = e.value,
              m = o.value;
          if (0 === m) throw new Error("Cannot divide by zero");
          if (e.isSmall) return o.isSmall ? [new s(p(f / m)), new s(f % m)] : [a[0], e];

          if (o.isSmall) {
            if (1 === m) return [e, a[0]];
            if (-1 == m) return [e.negate(), a[0]];
            var b = Math.abs(m);

            if (b < t) {
              i = u((n = E(f, b))[0]);
              var g = n[1];
              return e.sign && (g = -g), "number" == typeof i ? (e.sign !== o.sign && (i = -i), [new s(i), new s(g)]) : [new c(i, e.sign !== o.sign), new s(g)];
            }

            m = d(b);
          }

          var y = I(f, m);
          if (-1 === y) return [a[0], e];
          if (0 === y) return [a[e.sign === o.sign ? 1 : -1], a[0]];
          n = f.length + m.length <= 200 ? function (e, r) {
            var n,
                i,
                o,
                a,
                c,
                s,
                f,
                d = e.length,
                h = r.length,
                p = t,
                m = l(r.length),
                b = r[h - 1],
                g = Math.ceil(p / (2 * b)),
                v = A(e, g),
                y = A(r, g);

            for (v.length <= d && v.push(0), y.push(0), b = y[h - 1], i = d - h; i >= 0; i--) {
              for (n = p - 1, v[i + h] !== b && (n = Math.floor((v[i + h] * p + v[i + h - 1]) / b)), o = 0, a = 0, s = y.length, c = 0; c < s; c++) {
                o += n * y[c], f = Math.floor(o / p), a += v[i + c] - (o - f * p), o = f, a < 0 ? (v[i + c] = a + p, a = -1) : (v[i + c] = a, a = 0);
              }

              for (; 0 !== a;) {
                for (n -= 1, o = 0, c = 0; c < s; c++) {
                  (o += v[i + c] - p + y[c]) < 0 ? (v[i + c] = o + p, o = 0) : (v[i + c] = o, o = 1);
                }

                a += o;
              }

              m[i] = n;
            }

            return v = E(v, g)[0], [u(m), u(v)];
          }(f, m) : function (e, r) {
            for (var n, i, o, a, c, s = e.length, f = r.length, d = [], l = [], p = t; s;) {
              if (l.unshift(e[--s]), h(l), I(l, r) < 0) d.push(0);else {
                o = l[(i = l.length) - 1] * p + l[i - 2], a = r[f - 1] * p + r[f - 2], i > f && (o = (o + 1) * p), n = Math.ceil(o / a);

                do {
                  if (I(c = A(r, n), l) <= 0) break;
                  n--;
                } while (n);

                d.push(n), l = v(l, c);
              }
            }

            return d.reverse(), [u(d), u(l)];
          }(f, m), i = n[0];
          var w = e.sign !== o.sign,
              _ = n[1],
              M = e.sign;
          return "number" == typeof i ? (w && (i = -i), i = new s(i)) : i = new c(i, w), "number" == typeof _ ? (M && (_ = -_), _ = new s(_)) : _ = new c(_, M), [i, _];
        }

        function I(e, t) {
          if (e.length !== t.length) return e.length > t.length ? 1 : -1;

          for (var r = e.length - 1; r >= 0; r--) {
            if (e[r] !== t[r]) return e[r] > t[r] ? 1 : -1;
          }

          return 0;
        }

        function C(e) {
          var t = e.abs();
          return !t.isUnit() && (!!(t.equals(2) || t.equals(3) || t.equals(5)) || !(t.isEven() || t.isDivisibleBy(3) || t.isDivisibleBy(5)) && (!!t.lesser(49) || void 0));
        }

        function T(e, t) {
          for (var r, n, o, c = e.prev(), s = c, f = 0; s.isEven();) {
            s = s.divide(2), f++;
          }

          e: for (n = 0; n < t.length; n++) {
            if (!e.lesser(t[n]) && !(o = i(t[n]).modPow(s, e)).equals(a[1]) && !o.equals(c)) {
              for (r = f - 1; 0 != r; r--) {
                if ((o = o.square().mod(e)).isUnit()) return !1;
                if (o.equals(c)) continue e;
              }

              return !1;
            }
          }

          return !0;
        }

        c.prototype = Object.create(a.prototype), s.prototype = Object.create(a.prototype), c.prototype.add = function (e) {
          var t = W(e);
          if (this.sign !== t.sign) return this.subtract(t.negate());
          var r = this.value,
              n = t.value;
          return t.isSmall ? new c(g(r, Math.abs(n)), this.sign) : new c(b(r, n), this.sign);
        }, c.prototype.plus = c.prototype.add, s.prototype.add = function (e) {
          var t = W(e),
              r = this.value;
          if (r < 0 !== t.sign) return this.subtract(t.negate());
          var n = t.value;

          if (t.isSmall) {
            if (f(r + n)) return new s(r + n);
            n = d(Math.abs(n));
          }

          return new c(g(n, Math.abs(r)), r < 0);
        }, s.prototype.plus = s.prototype.add, c.prototype.subtract = function (e) {
          var t = W(e);
          if (this.sign !== t.sign) return this.add(t.negate());
          var r = this.value,
              n = t.value;
          return t.isSmall ? y(r, Math.abs(n), this.sign) : function (e, t, r) {
            var n;
            return I(e, t) >= 0 ? n = v(e, t) : (n = v(t, e), r = !r), "number" == typeof (n = u(n)) ? (r && (n = -n), new s(n)) : new c(n, r);
          }(r, n, this.sign);
        }, c.prototype.minus = c.prototype.subtract, s.prototype.subtract = function (e) {
          var t = W(e),
              r = this.value;
          if (r < 0 !== t.sign) return this.add(t.negate());
          var n = t.value;
          return t.isSmall ? new s(r - n) : y(n, Math.abs(r), r >= 0);
        }, s.prototype.minus = s.prototype.subtract, c.prototype.negate = function () {
          return new c(this.value, !this.sign);
        }, s.prototype.negate = function () {
          var e = this.sign,
              t = new s(-this.value);
          return t.sign = !e, t;
        }, c.prototype.abs = function () {
          return new c(this.value, !1);
        }, s.prototype.abs = function () {
          return new s(Math.abs(this.value));
        }, c.prototype.multiply = function (e) {
          var r,
              n,
              i,
              o = W(e),
              s = this.value,
              f = o.value,
              u = this.sign !== o.sign;

          if (o.isSmall) {
            if (0 === f) return a[0];
            if (1 === f) return this;
            if (-1 === f) return this.negate();
            if ((r = Math.abs(f)) < t) return new c(A(s, r), u);
            f = d(r);
          }

          return new c(-.012 * (n = s.length) - .012 * (i = f.length) + 15e-6 * n * i > 0 ? M(s, f) : w(s, f), u);
        }, c.prototype.times = c.prototype.multiply, s.prototype._multiplyBySmall = function (e) {
          return f(e.value * this.value) ? new s(e.value * this.value) : x(Math.abs(e.value), d(Math.abs(this.value)), this.sign !== e.sign);
        }, c.prototype._multiplyBySmall = function (e) {
          return 0 === e.value ? a[0] : 1 === e.value ? this : -1 === e.value ? this.negate() : x(Math.abs(e.value), this.value, this.sign !== e.sign);
        }, s.prototype.multiply = function (e) {
          return W(e)._multiplyBySmall(this);
        }, s.prototype.times = s.prototype.multiply, c.prototype.square = function () {
          return new c(k(this.value), !1);
        }, s.prototype.square = function () {
          var e = this.value * this.value;
          return f(e) ? new s(e) : new c(k(d(Math.abs(this.value))), !1);
        }, c.prototype.divmod = function (e) {
          var t = S(this, e);
          return {
            quotient: t[0],
            remainder: t[1]
          };
        }, s.prototype.divmod = c.prototype.divmod, c.prototype.divide = function (e) {
          return S(this, e)[0];
        }, s.prototype.over = s.prototype.divide = c.prototype.over = c.prototype.divide, c.prototype.mod = function (e) {
          return S(this, e)[1];
        }, s.prototype.remainder = s.prototype.mod = c.prototype.remainder = c.prototype.mod, c.prototype.pow = function (e) {
          var t,
              r,
              n,
              i = W(e),
              o = this.value,
              c = i.value;
          if (0 === c) return a[1];
          if (0 === o) return a[0];
          if (1 === o) return a[1];
          if (-1 === o) return i.isEven() ? a[1] : a[-1];
          if (i.sign) return a[0];
          if (!i.isSmall) throw new Error("The exponent " + i.toString() + " is too large.");
          if (this.isSmall && f(t = Math.pow(o, c))) return new s(p(t));

          for (r = this, n = a[1]; !0 & c && (n = n.times(r), --c), 0 !== c;) {
            c /= 2, r = r.square();
          }

          return n;
        }, s.prototype.pow = c.prototype.pow, c.prototype.modPow = function (e, t) {
          if (e = W(e), (t = W(t)).isZero()) throw new Error("Cannot take modPow with modulus 0");

          for (var r = a[1], n = this.mod(t); e.isPositive();) {
            if (n.isZero()) return a[0];
            e.isOdd() && (r = r.multiply(n).mod(t)), e = e.divide(2), n = n.square().mod(t);
          }

          return r;
        }, s.prototype.modPow = c.prototype.modPow, c.prototype.compareAbs = function (e) {
          var t = W(e),
              r = this.value,
              n = t.value;
          return t.isSmall ? 1 : I(r, n);
        }, s.prototype.compareAbs = function (e) {
          var t = W(e),
              r = Math.abs(this.value),
              n = t.value;
          return t.isSmall ? r === (n = Math.abs(n)) ? 0 : r > n ? 1 : -1 : -1;
        }, c.prototype.compare = function (e) {
          if (e === 1 / 0) return -1;
          if (e === -1 / 0) return 1;
          var t = W(e),
              r = this.value,
              n = t.value;
          return this.sign !== t.sign ? t.sign ? 1 : -1 : t.isSmall ? this.sign ? -1 : 1 : I(r, n) * (this.sign ? -1 : 1);
        }, c.prototype.compareTo = c.prototype.compare, s.prototype.compare = function (e) {
          if (e === 1 / 0) return -1;
          if (e === -1 / 0) return 1;
          var t = W(e),
              r = this.value,
              n = t.value;
          return t.isSmall ? r == n ? 0 : r > n ? 1 : -1 : r < 0 !== t.sign ? r < 0 ? -1 : 1 : r < 0 ? 1 : -1;
        }, s.prototype.compareTo = s.prototype.compare, c.prototype.equals = function (e) {
          return 0 === this.compare(e);
        }, s.prototype.eq = s.prototype.equals = c.prototype.eq = c.prototype.equals, c.prototype.notEquals = function (e) {
          return 0 !== this.compare(e);
        }, s.prototype.neq = s.prototype.notEquals = c.prototype.neq = c.prototype.notEquals, c.prototype.greater = function (e) {
          return this.compare(e) > 0;
        }, s.prototype.gt = s.prototype.greater = c.prototype.gt = c.prototype.greater, c.prototype.lesser = function (e) {
          return this.compare(e) < 0;
        }, s.prototype.lt = s.prototype.lesser = c.prototype.lt = c.prototype.lesser, c.prototype.greaterOrEquals = function (e) {
          return this.compare(e) >= 0;
        }, s.prototype.geq = s.prototype.greaterOrEquals = c.prototype.geq = c.prototype.greaterOrEquals, c.prototype.lesserOrEquals = function (e) {
          return this.compare(e) <= 0;
        }, s.prototype.leq = s.prototype.lesserOrEquals = c.prototype.leq = c.prototype.lesserOrEquals, c.prototype.isEven = function () {
          return 0 == (1 & this.value[0]);
        }, s.prototype.isEven = function () {
          return 0 == (1 & this.value);
        }, c.prototype.isOdd = function () {
          return 1 == (1 & this.value[0]);
        }, s.prototype.isOdd = function () {
          return 1 == (1 & this.value);
        }, c.prototype.isPositive = function () {
          return !this.sign;
        }, s.prototype.isPositive = function () {
          return this.value > 0;
        }, c.prototype.isNegative = function () {
          return this.sign;
        }, s.prototype.isNegative = function () {
          return this.value < 0;
        }, c.prototype.isUnit = function () {
          return !1;
        }, s.prototype.isUnit = function () {
          return 1 === Math.abs(this.value);
        }, c.prototype.isZero = function () {
          return !1;
        }, s.prototype.isZero = function () {
          return 0 === this.value;
        }, c.prototype.isDivisibleBy = function (e) {
          var t = W(e),
              r = t.value;
          return 0 !== r && (1 === r || (2 === r ? this.isEven() : this.mod(t).equals(a[0])));
        }, s.prototype.isDivisibleBy = c.prototype.isDivisibleBy, c.prototype.isPrime = function (t) {
          var r = C(this);
          if (r !== e) return r;
          var n = this.abs(),
              o = n.bitLength();
          if (o <= 64) return T(n, [2, 325, 9375, 28178, 450775, 9780504, 1795265022]);

          for (var a = Math.log(2) * o, c = Math.ceil(!0 === t ? 2 * Math.pow(a, 2) : a), s = [], f = 0; f < c; f++) {
            s.push(i(f + 2));
          }

          return T(n, s);
        }, s.prototype.isPrime = c.prototype.isPrime, c.prototype.isProbablePrime = function (t) {
          var r = C(this);
          if (r !== e) return r;

          for (var n = this.abs(), o = t === e ? 5 : t, a = [], c = 0; c < o; c++) {
            a.push(i.randBetween(2, n.minus(2)));
          }

          return T(n, a);
        }, s.prototype.isProbablePrime = c.prototype.isProbablePrime, c.prototype.modInv = function (e) {
          for (var t, r, n, o = i.zero, a = i.one, c = W(e), s = this.abs(); !s.equals(i.zero);) {
            t = c.divide(s), r = o, n = c, o = a, c = s, a = r.subtract(t.multiply(a)), s = n.subtract(t.multiply(s));
          }

          if (!c.equals(1)) throw new Error(this.toString() + " and " + e.toString() + " are not co-prime");
          return -1 === o.compare(0) && (o = o.add(e)), this.isNegative() ? o.negate() : o;
        }, s.prototype.modInv = c.prototype.modInv, c.prototype.next = function () {
          var e = this.value;
          return this.sign ? y(e, 1, this.sign) : new c(g(e, 1), this.sign);
        }, s.prototype.next = function () {
          var e = this.value;
          return e + 1 < r ? new s(e + 1) : new c(n, !1);
        }, c.prototype.prev = function () {
          var e = this.value;
          return this.sign ? new c(g(e, 1), !0) : y(e, 1, this.sign);
        }, s.prototype.prev = function () {
          var e = this.value;
          return e - 1 > -r ? new s(e - 1) : new c(n, !0);
        };

        for (var B = [1]; 2 * B[B.length - 1] <= t;) {
          B.push(2 * B[B.length - 1]);
        }

        var D = B.length,
            N = B[D - 1];

        function R(e) {
          return ("number" == typeof e || "string" == typeof e) && +Math.abs(e) <= t || e instanceof c && e.value.length <= 1;
        }

        function O(e, t, r) {
          t = W(t);

          for (var n = e.isNegative(), o = t.isNegative(), a = n ? e.not() : e, c = o ? t.not() : t, s = 0, f = 0, d = null, u = null, h = []; !a.isZero() || !c.isZero();) {
            s = (d = S(a, N))[1].toJSNumber(), n && (s = N - 1 - s), f = (u = S(c, N))[1].toJSNumber(), o && (f = N - 1 - f), a = d[0], c = u[0], h.push(r(s, f));
          }

          for (var l = 0 !== r(n ? 1 : 0, o ? 1 : 0) ? i(-1) : i(0), p = h.length - 1; p >= 0; p -= 1) {
            l = l.multiply(N).add(i(h[p]));
          }

          return l;
        }

        c.prototype.shiftLeft = function (e) {
          if (!R(e)) throw new Error(String(e) + " is too large for shifting.");
          if ((e = +e) < 0) return this.shiftRight(-e);
          var t = this;
          if (t.isZero()) return t;

          for (; e >= D;) {
            t = t.multiply(N), e -= D - 1;
          }

          return t.multiply(B[e]);
        }, s.prototype.shiftLeft = c.prototype.shiftLeft, c.prototype.shiftRight = function (e) {
          var t;
          if (!R(e)) throw new Error(String(e) + " is too large for shifting.");
          if ((e = +e) < 0) return this.shiftLeft(-e);

          for (var r = this; e >= D;) {
            if (r.isZero() || r.isNegative() && r.isUnit()) return r;
            r = (t = S(r, N))[1].isNegative() ? t[0].prev() : t[0], e -= D - 1;
          }

          return (t = S(r, B[e]))[1].isNegative() ? t[0].prev() : t[0];
        }, s.prototype.shiftRight = c.prototype.shiftRight, c.prototype.not = function () {
          return this.negate().prev();
        }, s.prototype.not = c.prototype.not, c.prototype.and = function (e) {
          return O(this, e, function (e, t) {
            return e & t;
          });
        }, s.prototype.and = c.prototype.and, c.prototype.or = function (e) {
          return O(this, e, function (e, t) {
            return e | t;
          });
        }, s.prototype.or = c.prototype.or, c.prototype.xor = function (e) {
          return O(this, e, function (e, t) {
            return e ^ t;
          });
        }, s.prototype.xor = c.prototype.xor;

        function P(e) {
          var r = e.value,
              n = "number" == typeof r ? 1073741824 | r : r[0] + r[1] * t | 1073758208;
          return n & -n;
        }

        function F(e, t) {
          if (t.compareTo(e) <= 0) {
            var r = F(e, t.square(t)),
                n = r.p,
                o = r.e,
                a = n.multiply(t);
            return a.compareTo(e) <= 0 ? {
              p: a,
              e: 2 * o + 1
            } : {
              p: n,
              e: 2 * o
            };
          }

          return {
            p: i(1),
            e: 0
          };
        }

        function L(e, t) {
          return e = W(e), t = W(t), e.greater(t) ? e : t;
        }

        function G(e, t) {
          return e = W(e), t = W(t), e.lesser(t) ? e : t;
        }

        function j(e, t) {
          if (e = W(e).abs(), t = W(t).abs(), e.equals(t)) return e;
          if (e.isZero()) return t;
          if (t.isZero()) return e;

          for (var r, n, i = a[1]; e.isEven() && t.isEven();) {
            r = Math.min(P(e), P(t)), e = e.divide(r), t = t.divide(r), i = i.multiply(r);
          }

          for (; e.isEven();) {
            e = e.divide(P(e));
          }

          do {
            for (; t.isEven();) {
              t = t.divide(P(t));
            }

            e.greater(t) && (n = t, t = e, e = n), t = t.subtract(e);
          } while (!t.isZero());

          return i.isUnit() ? e : e.multiply(i);
        }

        c.prototype.bitLength = function () {
          var e = this;
          return e.compareTo(i(0)) < 0 && (e = e.negate().subtract(i(1))), 0 === e.compareTo(i(0)) ? i(0) : i(F(e, i(2)).e).add(i(1));
        }, s.prototype.bitLength = c.prototype.bitLength;

        var z = function z(e, t) {
          for (var r = e.length, n = Math.abs(t), i = 0; i < r; i++) {
            if ("-" !== (d = e[i].toLowerCase()) && /[a-z0-9]/.test(d)) {
              if (/[0-9]/.test(d) && +d >= n) {
                if ("1" === d && 1 === n) continue;
                throw new Error(d + " is not a valid digit in base " + t + ".");
              }

              if (d.charCodeAt(0) - 87 >= n) throw new Error(d + " is not a valid digit in base " + t + ".");
            }
          }

          if (2 <= t && t <= 36 && r <= o / Math.log(t)) {
            var a = parseInt(e, t);
            if (isNaN(a)) throw new Error(d + " is not a valid digit in base " + t + ".");
            return new s(parseInt(e, t));
          }

          t = W(t);
          var c = [],
              f = "-" === e[0];

          for (i = f ? 1 : 0; i < e.length; i++) {
            var d,
                u = (d = e[i].toLowerCase()).charCodeAt(0);
            if (48 <= u && u <= 57) c.push(W(d));else if (97 <= u && u <= 122) c.push(W(d.charCodeAt(0) - 87));else {
              if ("<" !== d) throw new Error(d + " is not a valid character");
              var h = i;

              do {
                i++;
              } while (">" !== e[i]);

              c.push(W(e.slice(h + 1, i)));
            }
          }

          return q(c, t, f);
        };

        function q(e, t, r) {
          var n,
              i = a[0],
              o = a[1];

          for (n = e.length - 1; n >= 0; n--) {
            i = i.add(e[n].times(o)), o = o.times(t);
          }

          return r ? i.negate() : i;
        }

        function U(e) {
          return e <= 35 ? "0123456789abcdefghijklmnopqrstuvwxyz".charAt(e) : "<" + e + ">";
        }

        function H(e, t) {
          if ((t = i(t)).isZero()) {
            if (e.isZero()) return {
              value: [0],
              isNegative: !1
            };
            throw new Error("Cannot convert nonzero numbers to base 0.");
          }

          if (t.equals(-1)) {
            if (e.isZero()) return {
              value: [0],
              isNegative: !1
            };
            if (e.isNegative()) return {
              value: [].concat.apply([], Array.apply(null, Array(-e)).map(Array.prototype.valueOf, [1, 0])),
              isNegative: !1
            };
            var r = Array.apply(null, Array(+e - 1)).map(Array.prototype.valueOf, [0, 1]);
            return r.unshift([1]), {
              value: [].concat.apply([], r),
              isNegative: !1
            };
          }

          var n = !1;
          if (e.isNegative() && t.isPositive() && (n = !0, e = e.abs()), t.equals(1)) return e.isZero() ? {
            value: [0],
            isNegative: !1
          } : {
            value: Array.apply(null, Array(+e)).map(Number.prototype.valueOf, 1),
            isNegative: n
          };

          for (var o, a = [], c = e; c.isNegative() || c.compareAbs(t) >= 0;) {
            o = c.divmod(t), c = o.quotient;
            var s = o.remainder;
            s.isNegative() && (s = t.minus(s).abs(), c = c.next()), a.push(s.toJSNumber());
          }

          return a.push(c.toJSNumber()), {
            value: a.reverse(),
            isNegative: n
          };
        }

        function K(e, t) {
          var r = H(e, t);
          return (r.isNegative ? "-" : "") + r.value.map(U).join("");
        }

        function V(e) {
          if (f(+e)) {
            var t = +e;
            if (t === p(t)) return new s(t);
            throw new Error("Invalid integer: " + e);
          }

          var r = "-" === e[0];
          r && (e = e.slice(1));
          var n = e.split(/e/i);
          if (n.length > 2) throw new Error("Invalid integer: " + n.join("e"));

          if (2 === n.length) {
            var i = n[1];
            if ("+" === i[0] && (i = i.slice(1)), (i = +i) !== p(i) || !f(i)) throw new Error("Invalid integer: " + i + " is not a valid exponent.");
            var o = n[0],
                a = o.indexOf(".");
            if (a >= 0 && (i -= o.length - a - 1, o = o.slice(0, a) + o.slice(a + 1)), i < 0) throw new Error("Cannot include negative exponent part for integers");
            e = o += new Array(i + 1).join("0");
          }

          if (!/^([0-9][0-9]*)$/.test(e)) throw new Error("Invalid integer: " + e);

          for (var d = [], u = e.length, l = u - 7; u > 0;) {
            d.push(+e.slice(l, u)), (l -= 7) < 0 && (l = 0), u -= 7;
          }

          return h(d), new c(d, r);
        }

        function W(e) {
          return "number" == typeof e ? function (e) {
            if (f(e)) {
              if (e !== p(e)) throw new Error(e + " is not an integer.");
              return new s(e);
            }

            return V(e.toString());
          }(e) : "string" == typeof e ? V(e) : e;
        }

        c.prototype.toArray = function (e) {
          return H(this, e);
        }, s.prototype.toArray = function (e) {
          return H(this, e);
        }, c.prototype.toString = function (t) {
          if (t === e && (t = 10), 10 !== t) return K(this, t);

          for (var r, n = this.value, i = n.length, o = String(n[--i]); --i >= 0;) {
            r = String(n[i]), o += "0000000".slice(r.length) + r;
          }

          return (this.sign ? "-" : "") + o;
        }, s.prototype.toString = function (t) {
          return t === e && (t = 10), 10 != t ? K(this, t) : String(this.value);
        }, c.prototype.toJSON = s.prototype.toJSON = function () {
          return this.toString();
        }, c.prototype.valueOf = function () {
          return parseInt(this.toString(), 10);
        }, c.prototype.toJSNumber = c.prototype.valueOf, s.prototype.valueOf = function () {
          return this.value;
        }, s.prototype.toJSNumber = s.prototype.valueOf;

        for (var X = 0; X < 1e3; X++) {
          a[X] = new s(X), X > 0 && (a[-X] = new s(-X));
        }

        return a.one = a[1], a.zero = a[0], a.minusOne = a[-1], a.max = L, a.min = G, a.gcd = j, a.lcm = function (e, t) {
          return e = W(e).abs(), t = W(t).abs(), e.divide(j(e, t)).multiply(t);
        }, a.isInstance = function (e) {
          return e instanceof c || e instanceof s;
        }, a.randBetween = function (e, r) {
          var n = G(e = W(e), r = W(r)),
              i = L(e, r).subtract(n).add(1);
          if (i.isSmall) return n.add(Math.floor(Math.random() * i));

          for (var o = [], a = !0, f = i.value.length - 1; f >= 0; f--) {
            var d = a ? i.value[f] : t,
                h = p(Math.random() * d);
            o.unshift(h), h < d && (a = !1);
          }

          return o = u(o), n.add("number" == typeof o ? new s(o) : new c(o, !1));
        }, a.fromArray = function (e, t, r) {
          return q(e.map(W), W(t || 10), r);
        }, a;
      }();

      e.hasOwnProperty("exports") && (e.exports = i), void 0 === (n = function () {
        return i;
      }.apply(t, [])) || (e.exports = n);
    },
    9918: function _(e, t, r) {
      "use strict";

      r.r(t), r.d(t, {
        AddressType: function AddressType() {
          return l;
        },
        Network: function Network() {
          return h;
        },
        default: function _default() {
          return v;
        },
        getAddressInfo: function getAddressInfo() {
          return g;
        },
        validate: function validate() {
          return v;
        }
      });

      var _n2 = function n() {
        return _n2 = Object.assign || function (e) {
          for (var t, r = 1, n = arguments.length; r < n; r++) {
            for (var i in t = arguments[r]) {
              Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
            }
          }

          return e;
        }, _n2.apply(this, arguments);
      },
          i = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";

      (function () {
        var e = Array(256).fill(-1);

        for (var _t2 = 0; _t2 < i.length; ++_t2) {
          e[i.charCodeAt(_t2)] = _t2;
        }
      })();

      var o = function o(e) {
        if (!e || "string" != typeof e) throw new Error("Expected base58 string but got \u201C".concat(e, "\u201D"));
        if (e.match(/[IOl0]/gm)) throw new Error("Invalid base58 character \u201C".concat(e.match(/[IOl0]/gm), "\u201D"));
        var t = e.match(/^1+/gm),
            r = t ? t[0].length : 0,
            n = (e.length - r) * (Math.log(58) / Math.log(256)) + 1 >>> 0;
        return new Uint8Array([].concat(_toConsumableArray(new Uint8Array(r)), _toConsumableArray(e.match(/.{1}/g).map(function (e) {
          return i.indexOf(e);
        }).reduce(function (e, t) {
          return e.map(function (e) {
            var r = 58 * e + t;
            return t = r >> 8, r;
          });
        }, new Uint8Array(n)).reverse().filter((o = !1, function (e) {
          return o = o || e;
        })))));
        var o;
      };

      function a(e) {
        return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
      }

      function c(e, t) {
        return e(t = {
          exports: {}
        }, t.exports), t.exports;
      }

      var s = c(function (e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.bech32m = t.bech32 = void 0;
        var r = "qpzry9x8gf2tvdw0s3jn54khce6mua7l",
            n = {};

        for (var _e2 = 0; _e2 < r.length; _e2++) {
          var _t3 = r.charAt(_e2);

          n[_t3] = _e2;
        }

        function i(e) {
          var t = e >> 25;
          return (33554431 & e) << 5 ^ 996825010 & -(t >> 0 & 1) ^ 642813549 & -(t >> 1 & 1) ^ 513874426 & -(t >> 2 & 1) ^ 1027748829 & -(t >> 3 & 1) ^ 705979059 & -(t >> 4 & 1);
        }

        function o(e) {
          var t = 1;

          for (var _r2 = 0; _r2 < e.length; ++_r2) {
            var _n3 = e.charCodeAt(_r2);

            if (_n3 < 33 || _n3 > 126) return "Invalid prefix (" + e + ")";
            t = i(t) ^ _n3 >> 5;
          }

          t = i(t);

          for (var _r3 = 0; _r3 < e.length; ++_r3) {
            var _n4 = e.charCodeAt(_r3);

            t = i(t) ^ 31 & _n4;
          }

          return t;
        }

        function a(e, t, r, n) {
          var i = 0,
              o = 0;
          var a = (1 << r) - 1,
              c = [];

          for (var _n5 = 0; _n5 < e.length; ++_n5) {
            for (i = i << t | e[_n5], o += t; o >= r;) {
              o -= r, c.push(i >> o & a);
            }
          }

          if (n) o > 0 && c.push(i << r - o & a);else {
            if (o >= t) return "Excess padding";
            if (i << r - o & a) return "Non-zero padding";
          }
          return c;
        }

        function c(e) {
          return a(e, 8, 5, !0);
        }

        function s(e) {
          var t = a(e, 5, 8, !1);
          if (Array.isArray(t)) return t;
        }

        function f(e) {
          var t = a(e, 5, 8, !1);
          if (Array.isArray(t)) return t;
          throw new Error(t);
        }

        function d(e) {
          var t;

          function a(e, r) {
            if (r = r || 90, e.length < 8) return e + " too short";
            if (e.length > r) return "Exceeds length limit";
            var a = e.toLowerCase(),
                c = e.toUpperCase();
            if (e !== a && e !== c) return "Mixed-case string " + e;
            var s = (e = a).lastIndexOf("1");
            if (-1 === s) return "No separator character for " + e;
            if (0 === s) return "Missing prefix for " + e;
            var f = e.slice(0, s),
                d = e.slice(s + 1);
            if (d.length < 6) return "Data too short";
            var u = o(f);
            if ("string" == typeof u) return u;
            var h = [];

            for (var _e3 = 0; _e3 < d.length; ++_e3) {
              var _t4 = d.charAt(_e3),
                  _r4 = n[_t4];

              if (void 0 === _r4) return "Unknown character " + _t4;
              u = i(u) ^ _r4, _e3 + 6 >= d.length || h.push(_r4);
            }

            return u !== t ? "Invalid checksum for " + e : {
              prefix: f,
              words: h
            };
          }

          return t = "bech32" === e ? 1 : 734539939, {
            decodeUnsafe: function decodeUnsafe(e, t) {
              var r = a(e, t);
              if ("object" == typeof r) return r;
            },
            decode: function decode(e, t) {
              var r = a(e, t);
              if ("object" == typeof r) return r;
              throw new Error(r);
            },
            encode: function encode(e, n, a) {
              if (a = a || 90, e.length + 7 + n.length > a) throw new TypeError("Exceeds length limit");
              var c = o(e = e.toLowerCase());
              if ("string" == typeof c) throw new Error(c);
              var s = e + "1";

              for (var _e4 = 0; _e4 < n.length; ++_e4) {
                var _t5 = n[_e4];
                if (_t5 >> 5 != 0) throw new Error("Non 5-bit word");
                c = i(c) ^ _t5, s += r.charAt(_t5);
              }

              for (var _e5 = 0; _e5 < 6; ++_e5) {
                c = i(c);
              }

              c ^= t;

              for (var _e6 = 0; _e6 < 6; ++_e6) {
                s += r.charAt(c >> 5 * (5 - _e6) & 31);
              }

              return s;
            },
            toWords: c,
            fromWordsUnsafe: s,
            fromWords: f
          };
        }

        t.bech32 = d("bech32"), t.bech32m = d("bech32m");
      });
      a(s);
      var f = s.bech32m,
          d = s.bech32,
          u = c(function (e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.Hash = t.createHash = void 0;
        var r = [1116352408, 1899447441, -1245643825, -373957723, 961987163, 1508970993, -1841331548, -1424204075, -670586216, 310598401, 607225278, 1426881987, 1925078388, -2132889090, -1680079193, -1046744716, -459576895, -272742522, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, -1740746414, -1473132947, -1341970488, -1084653625, -958395405, -710438585, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, -2117940946, -1838011259, -1564481375, -1474664885, -1035236496, -949202525, -778901479, -694614492, -200395387, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, -2067236844, -1933114872, -1866530822, -1538233109, -1090935817, -965641998],
            n = {
          sha256: 1
        };

        t.createHash = function (e) {
          if (e && !n[e] && !n[e.toLowerCase()]) throw new Error("Digest method not supported");
          return new i();
        };

        var i = /*#__PURE__*/function () {
          function i() {
            _classCallCheck(this, i);

            this.A = 1779033703, this.B = -1150833019, this.C = 1013904242, this.D = -1521486534, this.E = 1359893119, this.F = -1694144372, this.G = 528734635, this.H = 1541459225, this._size = 0, this._sp = 0, (!a || c >= 8e3) && (a = new ArrayBuffer(8e3), c = 0), this._byte = new Uint8Array(a, c, 80), this._word = new Int32Array(a, c, 20), c += 80;
          }

          _createClass(i, [{
            key: "update",
            value: function update(e) {
              if ("string" == typeof e) return this._utf8(e);
              if (null == e) throw new TypeError("Invalid type: " + typeof e);
              var t = e.byteOffset,
                  r = e.byteLength;
              var n = r / 64 | 0,
                  i = 0;

              if (n && !(3 & t) && !(this._size % 64)) {
                var _r5 = new Int32Array(e.buffer, t, 16 * n);

                for (; n--;) {
                  this._int32(_r5, i >> 2), i += 64;
                }

                this._size += i;
              }

              if (1 !== e.BYTES_PER_ELEMENT && e.buffer) {
                var _n6 = new Uint8Array(e.buffer, t + i, r - i);

                return this._uint8(_n6);
              }

              return i === r ? this : this._uint8(e, i);
            }
          }, {
            key: "_uint8",
            value: function _uint8(e, t) {
              var r = this._byte,
                  n = this._word,
                  i = e.length;

              for (t |= 0; t < i;) {
                var _o2 = this._size % 64;

                var _a2 = _o2;

                for (; t < i && _a2 < 64;) {
                  r[_a2++] = e[t++];
                }

                _a2 >= 64 && this._int32(n), this._size += _a2 - _o2;
              }

              return this;
            }
          }, {
            key: "_utf8",
            value: function _utf8(e) {
              var t = this._byte,
                  r = this._word,
                  n = e.length;
              var i = this._sp;

              for (var _o3 = 0; _o3 < n;) {
                var _a3 = this._size % 64;

                var _c2 = _a3;

                for (; _o3 < n && _c2 < 64;) {
                  var _r6 = 0 | e.charCodeAt(_o3++);

                  _r6 < 128 ? t[_c2++] = _r6 : _r6 < 2048 ? (t[_c2++] = 192 | _r6 >>> 6, t[_c2++] = 128 | 63 & _r6) : _r6 < 55296 || _r6 > 57343 ? (t[_c2++] = 224 | _r6 >>> 12, t[_c2++] = 128 | _r6 >>> 6 & 63, t[_c2++] = 128 | 63 & _r6) : i ? (_r6 = ((1023 & i) << 10) + (1023 & _r6) + 65536, t[_c2++] = 240 | _r6 >>> 18, t[_c2++] = 128 | _r6 >>> 12 & 63, t[_c2++] = 128 | _r6 >>> 6 & 63, t[_c2++] = 128 | 63 & _r6, i = 0) : i = _r6;
                }

                _c2 >= 64 && (this._int32(r), r[0] = r[16]), this._size += _c2 - _a3;
              }

              return this._sp = i, this;
            }
          }, {
            key: "_int32",
            value: function _int32(e, t) {
              var n = this.A,
                  i = this.B,
                  a = this.C,
                  c = this.D,
                  s = this.E,
                  b = this.F,
                  g = this.G,
                  v = this.H,
                  y = 0;

              for (t |= 0; y < 16;) {
                o[y++] = f(e[t++]);
              }

              for (y = 16; y < 64; y++) {
                o[y] = m(o[y - 2]) + o[y - 7] + p(o[y - 15]) + o[y - 16] | 0;
              }

              for (y = 0; y < 64; y++) {
                var _e7 = v + l(s) + d(s, b, g) + r[y] + o[y] | 0,
                    _t6 = h(n) + u(n, i, a) | 0;

                v = g, g = b, b = s, s = c + _e7 | 0, c = a, a = i, i = n, n = _e7 + _t6 | 0;
              }

              this.A = n + this.A | 0, this.B = i + this.B | 0, this.C = a + this.C | 0, this.D = c + this.D | 0, this.E = s + this.E | 0, this.F = b + this.F | 0, this.G = g + this.G | 0, this.H = v + this.H | 0;
            }
          }, {
            key: "digest",
            value: function digest(e) {
              var t = this._byte,
                  r = this._word;
              var n = this._size % 64 | 0;

              for (t[n++] = 128; 3 & n;) {
                t[n++] = 0;
              }

              if (n >>= 2, n > 14) {
                for (; n < 16;) {
                  r[n++] = 0;
                }

                n = 0, this._int32(r);
              }

              for (; n < 16;) {
                r[n++] = 0;
              }

              var i = 8 * this._size,
                  o = (4294967295 & i) >>> 0,
                  a = (i - o) / 4294967296;
              return a && (r[14] = f(a)), o && (r[15] = f(o)), this._int32(r), "hex" === e ? this._hex() : this._bin();
            }
          }, {
            key: "_hex",
            value: function _hex() {
              var e = this.A,
                  t = this.B,
                  r = this.C,
                  n = this.D,
                  i = this.E,
                  o = this.F,
                  a = this.G,
                  c = this.H;
              return s(e) + s(t) + s(r) + s(n) + s(i) + s(o) + s(a) + s(c);
            }
          }, {
            key: "_bin",
            value: function _bin() {
              var e = this.A,
                  t = this.B,
                  r = this.C,
                  n = this.D,
                  i = this.E,
                  o = this.F,
                  a = this.G,
                  c = this.H,
                  s = this._byte,
                  d = this._word;
              return d[0] = f(e), d[1] = f(t), d[2] = f(r), d[3] = f(n), d[4] = f(i), d[5] = f(o), d[6] = f(a), d[7] = f(c), s.slice(0, 32);
            }
          }]);

          return i;
        }();

        t.Hash = i;
        var o = new Int32Array(64);
        var a,
            c = 0;

        var s = function s(e) {
          return (e + 4294967296).toString(16).substr(-8);
        },
            f = 254 === new Uint8Array(new Uint16Array([65279]).buffer)[0] ? function (e) {
          return e;
        } : function (e) {
          return e << 24 & 4278190080 | e << 8 & 16711680 | e >> 8 & 65280 | e >> 24 & 255;
        },
            d = function d(e, t, r) {
          return r ^ e & (t ^ r);
        },
            u = function u(e, t, r) {
          return e & t | r & (e | t);
        },
            h = function h(e) {
          return (e >>> 2 | e << 30) ^ (e >>> 13 | e << 19) ^ (e >>> 22 | e << 10);
        },
            l = function l(e) {
          return (e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7);
        },
            p = function p(e) {
          return (e >>> 7 | e << 25) ^ (e >>> 18 | e << 14) ^ e >>> 3;
        },
            m = function m(e) {
          return (e >>> 17 | e << 15) ^ (e >>> 19 | e << 13) ^ e >>> 10;
        };
      });
      a(u), u.Hash;

      var h,
          l,
          p = u.createHash,
          m = function m(e) {
        return p().update(e).digest();
      };

      !function (e) {
        e.mainnet = "mainnet", e.testnet = "testnet", e.regtest = "regtest";
      }(h || (h = {})), function (e) {
        e.p2pkh = "p2pkh", e.p2sh = "p2sh", e.p2wpkh = "p2wpkh", e.p2wsh = "p2wsh", e.p2tr = "p2tr";
      }(l || (l = {}));

      var b = {
        0: {
          type: l.p2pkh,
          network: h.mainnet
        },
        111: {
          type: l.p2pkh,
          network: h.testnet
        },
        5: {
          type: l.p2sh,
          network: h.mainnet
        },
        196: {
          type: l.p2sh,
          network: h.testnet
        }
      },
          g = function g(e) {
        var t,
            r = e.substr(0, 2).toLowerCase();
        if ("bc" === r || "tb" === r) return function (e) {
          var t;

          try {
            t = e.startsWith("bc1p") || e.startsWith("tb1p") || e.startsWith("bcrt1p") ? f.decode(e) : d.decode(e);
          } catch (e) {
            throw new Error("Invalid address");
          }

          var r = {
            bc: h.mainnet,
            tb: h.testnet,
            bcrt: h.regtest
          }[t.prefix];
          if (void 0 === r) throw new Error("Invalid address");
          var n = t.words[0];
          if (n < 0 || n > 16) throw new Error("Invalid address");
          return {
            bech32: !0,
            network: r,
            address: e,
            type: 20 === d.fromWords(t.words.slice(1)).length ? l.p2wpkh : 1 === n ? l.p2tr : l.p2wsh
          };
        }(e);

        try {
          t = o(e);
        } catch (e) {
          throw new Error("Invalid address");
        }

        var i = t.length;
        if (25 !== i) throw new Error("Invalid address");
        var a = t[0],
            c = t.slice(i - 4, i),
            s = t.slice(0, i - 4),
            u = m(m(s)).slice(0, 4);
        if (c.some(function (e, t) {
          return e !== u[t];
        })) throw new Error("Invalid address");
        if (!Object.keys(b).map(Number).includes(a)) throw new Error("Invalid address");
        return _n2(_n2({}, b[a]), {
          address: e,
          bech32: !1
        });
      },
          v = function v(e, t) {
        try {
          var r = g(e);
          return !t || t === r.network;
        } catch (e) {
          return !1;
        }
      };
    },
    3550: function _(e, t, r) {
      !function (e, t) {
        "use strict";

        function n(e, t) {
          if (!e) throw new Error(t || "Assertion failed");
        }

        function i(e, t) {
          e.super_ = t;

          var r = function r() {};

          r.prototype = t.prototype, e.prototype = new r(), e.prototype.constructor = e;
        }

        function o(e, t, r) {
          if (o.isBN(e)) return e;
          this.negative = 0, this.words = null, this.length = 0, this.red = null, null !== e && ("le" !== t && "be" !== t || (r = t, t = 10), this._init(e || 0, t || 10, r || "be"));
        }

        var a;
        "object" == typeof e ? e.exports = o : t.BN = o, o.BN = o, o.wordSize = 26;

        try {
          a = "undefined" != typeof window && void 0 !== window.Buffer ? window.Buffer : r(4300).Buffer;
        } catch (e) {}

        function c(e, t) {
          var r = e.charCodeAt(t);
          return r >= 48 && r <= 57 ? r - 48 : r >= 65 && r <= 70 ? r - 55 : r >= 97 && r <= 102 ? r - 87 : void n(!1, "Invalid character in " + e);
        }

        function s(e, t, r) {
          var n = c(e, r);
          return r - 1 >= t && (n |= c(e, r - 1) << 4), n;
        }

        function f(e, t, r, i) {
          for (var o = 0, a = 0, c = Math.min(e.length, r), s = t; s < c; s++) {
            var f = e.charCodeAt(s) - 48;
            o *= i, a = f >= 49 ? f - 49 + 10 : f >= 17 ? f - 17 + 10 : f, n(f >= 0 && a < i, "Invalid character"), o += a;
          }

          return o;
        }

        function d(e, t) {
          e.words = t.words, e.length = t.length, e.negative = t.negative, e.red = t.red;
        }

        if (o.isBN = function (e) {
          return e instanceof o || null !== e && "object" == typeof e && e.constructor.wordSize === o.wordSize && Array.isArray(e.words);
        }, o.max = function (e, t) {
          return e.cmp(t) > 0 ? e : t;
        }, o.min = function (e, t) {
          return e.cmp(t) < 0 ? e : t;
        }, o.prototype._init = function (e, t, r) {
          if ("number" == typeof e) return this._initNumber(e, t, r);
          if ("object" == typeof e) return this._initArray(e, t, r);
          "hex" === t && (t = 16), n(t === (0 | t) && t >= 2 && t <= 36);
          var i = 0;
          "-" === (e = e.toString().replace(/\s+/g, ""))[0] && (i++, this.negative = 1), i < e.length && (16 === t ? this._parseHex(e, i, r) : (this._parseBase(e, t, i), "le" === r && this._initArray(this.toArray(), t, r)));
        }, o.prototype._initNumber = function (e, t, r) {
          e < 0 && (this.negative = 1, e = -e), e < 67108864 ? (this.words = [67108863 & e], this.length = 1) : e < 4503599627370496 ? (this.words = [67108863 & e, e / 67108864 & 67108863], this.length = 2) : (n(e < 9007199254740992), this.words = [67108863 & e, e / 67108864 & 67108863, 1], this.length = 3), "le" === r && this._initArray(this.toArray(), t, r);
        }, o.prototype._initArray = function (e, t, r) {
          if (n("number" == typeof e.length), e.length <= 0) return this.words = [0], this.length = 1, this;
          this.length = Math.ceil(e.length / 3), this.words = new Array(this.length);

          for (var i = 0; i < this.length; i++) {
            this.words[i] = 0;
          }

          var o,
              a,
              c = 0;
          if ("be" === r) for (i = e.length - 1, o = 0; i >= 0; i -= 3) {
            a = e[i] | e[i - 1] << 8 | e[i - 2] << 16, this.words[o] |= a << c & 67108863, this.words[o + 1] = a >>> 26 - c & 67108863, (c += 24) >= 26 && (c -= 26, o++);
          } else if ("le" === r) for (i = 0, o = 0; i < e.length; i += 3) {
            a = e[i] | e[i + 1] << 8 | e[i + 2] << 16, this.words[o] |= a << c & 67108863, this.words[o + 1] = a >>> 26 - c & 67108863, (c += 24) >= 26 && (c -= 26, o++);
          }
          return this._strip();
        }, o.prototype._parseHex = function (e, t, r) {
          this.length = Math.ceil((e.length - t) / 6), this.words = new Array(this.length);

          for (var n = 0; n < this.length; n++) {
            this.words[n] = 0;
          }

          var i,
              o = 0,
              a = 0;
          if ("be" === r) for (n = e.length - 1; n >= t; n -= 2) {
            i = s(e, t, n) << o, this.words[a] |= 67108863 & i, o >= 18 ? (o -= 18, a += 1, this.words[a] |= i >>> 26) : o += 8;
          } else for (n = (e.length - t) % 2 == 0 ? t + 1 : t; n < e.length; n += 2) {
            i = s(e, t, n) << o, this.words[a] |= 67108863 & i, o >= 18 ? (o -= 18, a += 1, this.words[a] |= i >>> 26) : o += 8;
          }

          this._strip();
        }, o.prototype._parseBase = function (e, t, r) {
          this.words = [0], this.length = 1;

          for (var n = 0, i = 1; i <= 67108863; i *= t) {
            n++;
          }

          n--, i = i / t | 0;

          for (var o = e.length - r, a = o % n, c = Math.min(o, o - a) + r, s = 0, d = r; d < c; d += n) {
            s = f(e, d, d + n, t), this.imuln(i), this.words[0] + s < 67108864 ? this.words[0] += s : this._iaddn(s);
          }

          if (0 !== a) {
            var u = 1;

            for (s = f(e, d, e.length, t), d = 0; d < a; d++) {
              u *= t;
            }

            this.imuln(u), this.words[0] + s < 67108864 ? this.words[0] += s : this._iaddn(s);
          }

          this._strip();
        }, o.prototype.copy = function (e) {
          e.words = new Array(this.length);

          for (var t = 0; t < this.length; t++) {
            e.words[t] = this.words[t];
          }

          e.length = this.length, e.negative = this.negative, e.red = this.red;
        }, o.prototype._move = function (e) {
          d(e, this);
        }, o.prototype.clone = function () {
          var e = new o(null);
          return this.copy(e), e;
        }, o.prototype._expand = function (e) {
          for (; this.length < e;) {
            this.words[this.length++] = 0;
          }

          return this;
        }, o.prototype._strip = function () {
          for (; this.length > 1 && 0 === this.words[this.length - 1];) {
            this.length--;
          }

          return this._normSign();
        }, o.prototype._normSign = function () {
          return 1 === this.length && 0 === this.words[0] && (this.negative = 0), this;
        }, "undefined" != typeof Symbol && "function" == typeof Symbol.for) try {
          o.prototype[Symbol.for("nodejs.util.inspect.custom")] = u;
        } catch (e) {
          o.prototype.inspect = u;
        } else o.prototype.inspect = u;

        function u() {
          return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
        }

        var h = ["", "0", "00", "000", "0000", "00000", "000000", "0000000", "00000000", "000000000", "0000000000", "00000000000", "000000000000", "0000000000000", "00000000000000", "000000000000000", "0000000000000000", "00000000000000000", "000000000000000000", "0000000000000000000", "00000000000000000000", "000000000000000000000", "0000000000000000000000", "00000000000000000000000", "000000000000000000000000", "0000000000000000000000000"],
            l = [0, 0, 25, 16, 12, 11, 10, 9, 8, 8, 7, 7, 7, 7, 6, 6, 6, 6, 6, 6, 6, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5],
            p = [0, 0, 33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216, 43046721, 1e7, 19487171, 35831808, 62748517, 7529536, 11390625, 16777216, 24137569, 34012224, 47045881, 64e6, 4084101, 5153632, 6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149, 243e5, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176];

        function m(e, t, r) {
          r.negative = t.negative ^ e.negative;
          var n = e.length + t.length | 0;
          r.length = n, n = n - 1 | 0;
          var i = 0 | e.words[0],
              o = 0 | t.words[0],
              a = i * o,
              c = 67108863 & a,
              s = a / 67108864 | 0;
          r.words[0] = c;

          for (var f = 1; f < n; f++) {
            for (var d = s >>> 26, u = 67108863 & s, h = Math.min(f, t.length - 1), l = Math.max(0, f - e.length + 1); l <= h; l++) {
              var p = f - l | 0;
              d += (a = (i = 0 | e.words[p]) * (o = 0 | t.words[l]) + u) / 67108864 | 0, u = 67108863 & a;
            }

            r.words[f] = 0 | u, s = 0 | d;
          }

          return 0 !== s ? r.words[f] = 0 | s : r.length--, r._strip();
        }

        o.prototype.toString = function (e, t) {
          var r;

          if (t = 0 | t || 1, 16 === (e = e || 10) || "hex" === e) {
            r = "";

            for (var i = 0, o = 0, a = 0; a < this.length; a++) {
              var c = this.words[a],
                  s = (16777215 & (c << i | o)).toString(16);
              r = 0 != (o = c >>> 24 - i & 16777215) || a !== this.length - 1 ? h[6 - s.length] + s + r : s + r, (i += 2) >= 26 && (i -= 26, a--);
            }

            for (0 !== o && (r = o.toString(16) + r); r.length % t != 0;) {
              r = "0" + r;
            }

            return 0 !== this.negative && (r = "-" + r), r;
          }

          if (e === (0 | e) && e >= 2 && e <= 36) {
            var f = l[e],
                d = p[e];
            r = "";
            var u = this.clone();

            for (u.negative = 0; !u.isZero();) {
              var m = u.modrn(d).toString(e);
              r = (u = u.idivn(d)).isZero() ? m + r : h[f - m.length] + m + r;
            }

            for (this.isZero() && (r = "0" + r); r.length % t != 0;) {
              r = "0" + r;
            }

            return 0 !== this.negative && (r = "-" + r), r;
          }

          n(!1, "Base should be between 2 and 36");
        }, o.prototype.toNumber = function () {
          var e = this.words[0];
          return 2 === this.length ? e += 67108864 * this.words[1] : 3 === this.length && 1 === this.words[2] ? e += 4503599627370496 + 67108864 * this.words[1] : this.length > 2 && n(!1, "Number can only safely store up to 53 bits"), 0 !== this.negative ? -e : e;
        }, o.prototype.toJSON = function () {
          return this.toString(16, 2);
        }, a && (o.prototype.toBuffer = function (e, t) {
          return this.toArrayLike(a, e, t);
        }), o.prototype.toArray = function (e, t) {
          return this.toArrayLike(Array, e, t);
        }, o.prototype.toArrayLike = function (e, t, r) {
          this._strip();

          var i = this.byteLength(),
              o = r || Math.max(1, i);
          n(i <= o, "byte array longer than desired length"), n(o > 0, "Requested array length <= 0");

          var a = function (e, t) {
            return e.allocUnsafe ? e.allocUnsafe(t) : new e(t);
          }(e, o);

          return this["_toArrayLike" + ("le" === t ? "LE" : "BE")](a, i), a;
        }, o.prototype._toArrayLikeLE = function (e, t) {
          for (var r = 0, n = 0, i = 0, o = 0; i < this.length; i++) {
            var a = this.words[i] << o | n;
            e[r++] = 255 & a, r < e.length && (e[r++] = a >> 8 & 255), r < e.length && (e[r++] = a >> 16 & 255), 6 === o ? (r < e.length && (e[r++] = a >> 24 & 255), n = 0, o = 0) : (n = a >>> 24, o += 2);
          }

          if (r < e.length) for (e[r++] = n; r < e.length;) {
            e[r++] = 0;
          }
        }, o.prototype._toArrayLikeBE = function (e, t) {
          for (var r = e.length - 1, n = 0, i = 0, o = 0; i < this.length; i++) {
            var a = this.words[i] << o | n;
            e[r--] = 255 & a, r >= 0 && (e[r--] = a >> 8 & 255), r >= 0 && (e[r--] = a >> 16 & 255), 6 === o ? (r >= 0 && (e[r--] = a >> 24 & 255), n = 0, o = 0) : (n = a >>> 24, o += 2);
          }

          if (r >= 0) for (e[r--] = n; r >= 0;) {
            e[r--] = 0;
          }
        }, Math.clz32 ? o.prototype._countBits = function (e) {
          return 32 - Math.clz32(e);
        } : o.prototype._countBits = function (e) {
          var t = e,
              r = 0;
          return t >= 4096 && (r += 13, t >>>= 13), t >= 64 && (r += 7, t >>>= 7), t >= 8 && (r += 4, t >>>= 4), t >= 2 && (r += 2, t >>>= 2), r + t;
        }, o.prototype._zeroBits = function (e) {
          if (0 === e) return 26;
          var t = e,
              r = 0;
          return 0 == (8191 & t) && (r += 13, t >>>= 13), 0 == (127 & t) && (r += 7, t >>>= 7), 0 == (15 & t) && (r += 4, t >>>= 4), 0 == (3 & t) && (r += 2, t >>>= 2), 0 == (1 & t) && r++, r;
        }, o.prototype.bitLength = function () {
          var e = this.words[this.length - 1],
              t = this._countBits(e);

          return 26 * (this.length - 1) + t;
        }, o.prototype.zeroBits = function () {
          if (this.isZero()) return 0;

          for (var e = 0, t = 0; t < this.length; t++) {
            var r = this._zeroBits(this.words[t]);

            if (e += r, 26 !== r) break;
          }

          return e;
        }, o.prototype.byteLength = function () {
          return Math.ceil(this.bitLength() / 8);
        }, o.prototype.toTwos = function (e) {
          return 0 !== this.negative ? this.abs().inotn(e).iaddn(1) : this.clone();
        }, o.prototype.fromTwos = function (e) {
          return this.testn(e - 1) ? this.notn(e).iaddn(1).ineg() : this.clone();
        }, o.prototype.isNeg = function () {
          return 0 !== this.negative;
        }, o.prototype.neg = function () {
          return this.clone().ineg();
        }, o.prototype.ineg = function () {
          return this.isZero() || (this.negative ^= 1), this;
        }, o.prototype.iuor = function (e) {
          for (; this.length < e.length;) {
            this.words[this.length++] = 0;
          }

          for (var t = 0; t < e.length; t++) {
            this.words[t] = this.words[t] | e.words[t];
          }

          return this._strip();
        }, o.prototype.ior = function (e) {
          return n(0 == (this.negative | e.negative)), this.iuor(e);
        }, o.prototype.or = function (e) {
          return this.length > e.length ? this.clone().ior(e) : e.clone().ior(this);
        }, o.prototype.uor = function (e) {
          return this.length > e.length ? this.clone().iuor(e) : e.clone().iuor(this);
        }, o.prototype.iuand = function (e) {
          var t;
          t = this.length > e.length ? e : this;

          for (var r = 0; r < t.length; r++) {
            this.words[r] = this.words[r] & e.words[r];
          }

          return this.length = t.length, this._strip();
        }, o.prototype.iand = function (e) {
          return n(0 == (this.negative | e.negative)), this.iuand(e);
        }, o.prototype.and = function (e) {
          return this.length > e.length ? this.clone().iand(e) : e.clone().iand(this);
        }, o.prototype.uand = function (e) {
          return this.length > e.length ? this.clone().iuand(e) : e.clone().iuand(this);
        }, o.prototype.iuxor = function (e) {
          var t, r;
          this.length > e.length ? (t = this, r = e) : (t = e, r = this);

          for (var n = 0; n < r.length; n++) {
            this.words[n] = t.words[n] ^ r.words[n];
          }

          if (this !== t) for (; n < t.length; n++) {
            this.words[n] = t.words[n];
          }
          return this.length = t.length, this._strip();
        }, o.prototype.ixor = function (e) {
          return n(0 == (this.negative | e.negative)), this.iuxor(e);
        }, o.prototype.xor = function (e) {
          return this.length > e.length ? this.clone().ixor(e) : e.clone().ixor(this);
        }, o.prototype.uxor = function (e) {
          return this.length > e.length ? this.clone().iuxor(e) : e.clone().iuxor(this);
        }, o.prototype.inotn = function (e) {
          n("number" == typeof e && e >= 0);
          var t = 0 | Math.ceil(e / 26),
              r = e % 26;
          this._expand(t), r > 0 && t--;

          for (var i = 0; i < t; i++) {
            this.words[i] = 67108863 & ~this.words[i];
          }

          return r > 0 && (this.words[i] = ~this.words[i] & 67108863 >> 26 - r), this._strip();
        }, o.prototype.notn = function (e) {
          return this.clone().inotn(e);
        }, o.prototype.setn = function (e, t) {
          n("number" == typeof e && e >= 0);
          var r = e / 26 | 0,
              i = e % 26;
          return this._expand(r + 1), this.words[r] = t ? this.words[r] | 1 << i : this.words[r] & ~(1 << i), this._strip();
        }, o.prototype.iadd = function (e) {
          var t, r, n;
          if (0 !== this.negative && 0 === e.negative) return this.negative = 0, t = this.isub(e), this.negative ^= 1, this._normSign();
          if (0 === this.negative && 0 !== e.negative) return e.negative = 0, t = this.isub(e), e.negative = 1, t._normSign();
          this.length > e.length ? (r = this, n = e) : (r = e, n = this);

          for (var i = 0, o = 0; o < n.length; o++) {
            t = (0 | r.words[o]) + (0 | n.words[o]) + i, this.words[o] = 67108863 & t, i = t >>> 26;
          }

          for (; 0 !== i && o < r.length; o++) {
            t = (0 | r.words[o]) + i, this.words[o] = 67108863 & t, i = t >>> 26;
          }

          if (this.length = r.length, 0 !== i) this.words[this.length] = i, this.length++;else if (r !== this) for (; o < r.length; o++) {
            this.words[o] = r.words[o];
          }
          return this;
        }, o.prototype.add = function (e) {
          var t;
          return 0 !== e.negative && 0 === this.negative ? (e.negative = 0, t = this.sub(e), e.negative ^= 1, t) : 0 === e.negative && 0 !== this.negative ? (this.negative = 0, t = e.sub(this), this.negative = 1, t) : this.length > e.length ? this.clone().iadd(e) : e.clone().iadd(this);
        }, o.prototype.isub = function (e) {
          if (0 !== e.negative) {
            e.negative = 0;
            var t = this.iadd(e);
            return e.negative = 1, t._normSign();
          }

          if (0 !== this.negative) return this.negative = 0, this.iadd(e), this.negative = 1, this._normSign();
          var r,
              n,
              i = this.cmp(e);
          if (0 === i) return this.negative = 0, this.length = 1, this.words[0] = 0, this;
          i > 0 ? (r = this, n = e) : (r = e, n = this);

          for (var o = 0, a = 0; a < n.length; a++) {
            o = (t = (0 | r.words[a]) - (0 | n.words[a]) + o) >> 26, this.words[a] = 67108863 & t;
          }

          for (; 0 !== o && a < r.length; a++) {
            o = (t = (0 | r.words[a]) + o) >> 26, this.words[a] = 67108863 & t;
          }

          if (0 === o && a < r.length && r !== this) for (; a < r.length; a++) {
            this.words[a] = r.words[a];
          }
          return this.length = Math.max(this.length, a), r !== this && (this.negative = 1), this._strip();
        }, o.prototype.sub = function (e) {
          return this.clone().isub(e);
        };

        var b = function b(e, t, r) {
          var n,
              i,
              o,
              a = e.words,
              c = t.words,
              s = r.words,
              f = 0,
              d = 0 | a[0],
              u = 8191 & d,
              h = d >>> 13,
              l = 0 | a[1],
              p = 8191 & l,
              m = l >>> 13,
              b = 0 | a[2],
              g = 8191 & b,
              v = b >>> 13,
              y = 0 | a[3],
              w = 8191 & y,
              A = y >>> 13,
              _ = 0 | a[4],
              M = 8191 & _,
              x = _ >>> 13,
              k = 0 | a[5],
              E = 8191 & k,
              S = k >>> 13,
              I = 0 | a[6],
              C = 8191 & I,
              T = I >>> 13,
              B = 0 | a[7],
              D = 8191 & B,
              N = B >>> 13,
              R = 0 | a[8],
              O = 8191 & R,
              P = R >>> 13,
              F = 0 | a[9],
              L = 8191 & F,
              G = F >>> 13,
              j = 0 | c[0],
              z = 8191 & j,
              q = j >>> 13,
              U = 0 | c[1],
              H = 8191 & U,
              K = U >>> 13,
              V = 0 | c[2],
              W = 8191 & V,
              X = V >>> 13,
              Z = 0 | c[3],
              $ = 8191 & Z,
              Y = Z >>> 13,
              J = 0 | c[4],
              Q = 8191 & J,
              ee = J >>> 13,
              te = 0 | c[5],
              re = 8191 & te,
              ne = te >>> 13,
              ie = 0 | c[6],
              oe = 8191 & ie,
              ae = ie >>> 13,
              ce = 0 | c[7],
              se = 8191 & ce,
              fe = ce >>> 13,
              de = 0 | c[8],
              ue = 8191 & de,
              he = de >>> 13,
              le = 0 | c[9],
              pe = 8191 & le,
              me = le >>> 13;

          r.negative = e.negative ^ t.negative, r.length = 19;
          var be = (f + (n = Math.imul(u, z)) | 0) + ((8191 & (i = (i = Math.imul(u, q)) + Math.imul(h, z) | 0)) << 13) | 0;
          f = ((o = Math.imul(h, q)) + (i >>> 13) | 0) + (be >>> 26) | 0, be &= 67108863, n = Math.imul(p, z), i = (i = Math.imul(p, q)) + Math.imul(m, z) | 0, o = Math.imul(m, q);
          var ge = (f + (n = n + Math.imul(u, H) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(u, K) | 0) + Math.imul(h, H) | 0)) << 13) | 0;
          f = ((o = o + Math.imul(h, K) | 0) + (i >>> 13) | 0) + (ge >>> 26) | 0, ge &= 67108863, n = Math.imul(g, z), i = (i = Math.imul(g, q)) + Math.imul(v, z) | 0, o = Math.imul(v, q), n = n + Math.imul(p, H) | 0, i = (i = i + Math.imul(p, K) | 0) + Math.imul(m, H) | 0, o = o + Math.imul(m, K) | 0;
          var ve = (f + (n = n + Math.imul(u, W) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(u, X) | 0) + Math.imul(h, W) | 0)) << 13) | 0;
          f = ((o = o + Math.imul(h, X) | 0) + (i >>> 13) | 0) + (ve >>> 26) | 0, ve &= 67108863, n = Math.imul(w, z), i = (i = Math.imul(w, q)) + Math.imul(A, z) | 0, o = Math.imul(A, q), n = n + Math.imul(g, H) | 0, i = (i = i + Math.imul(g, K) | 0) + Math.imul(v, H) | 0, o = o + Math.imul(v, K) | 0, n = n + Math.imul(p, W) | 0, i = (i = i + Math.imul(p, X) | 0) + Math.imul(m, W) | 0, o = o + Math.imul(m, X) | 0;
          var ye = (f + (n = n + Math.imul(u, $) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(u, Y) | 0) + Math.imul(h, $) | 0)) << 13) | 0;
          f = ((o = o + Math.imul(h, Y) | 0) + (i >>> 13) | 0) + (ye >>> 26) | 0, ye &= 67108863, n = Math.imul(M, z), i = (i = Math.imul(M, q)) + Math.imul(x, z) | 0, o = Math.imul(x, q), n = n + Math.imul(w, H) | 0, i = (i = i + Math.imul(w, K) | 0) + Math.imul(A, H) | 0, o = o + Math.imul(A, K) | 0, n = n + Math.imul(g, W) | 0, i = (i = i + Math.imul(g, X) | 0) + Math.imul(v, W) | 0, o = o + Math.imul(v, X) | 0, n = n + Math.imul(p, $) | 0, i = (i = i + Math.imul(p, Y) | 0) + Math.imul(m, $) | 0, o = o + Math.imul(m, Y) | 0;
          var we = (f + (n = n + Math.imul(u, Q) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(u, ee) | 0) + Math.imul(h, Q) | 0)) << 13) | 0;
          f = ((o = o + Math.imul(h, ee) | 0) + (i >>> 13) | 0) + (we >>> 26) | 0, we &= 67108863, n = Math.imul(E, z), i = (i = Math.imul(E, q)) + Math.imul(S, z) | 0, o = Math.imul(S, q), n = n + Math.imul(M, H) | 0, i = (i = i + Math.imul(M, K) | 0) + Math.imul(x, H) | 0, o = o + Math.imul(x, K) | 0, n = n + Math.imul(w, W) | 0, i = (i = i + Math.imul(w, X) | 0) + Math.imul(A, W) | 0, o = o + Math.imul(A, X) | 0, n = n + Math.imul(g, $) | 0, i = (i = i + Math.imul(g, Y) | 0) + Math.imul(v, $) | 0, o = o + Math.imul(v, Y) | 0, n = n + Math.imul(p, Q) | 0, i = (i = i + Math.imul(p, ee) | 0) + Math.imul(m, Q) | 0, o = o + Math.imul(m, ee) | 0;
          var Ae = (f + (n = n + Math.imul(u, re) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(u, ne) | 0) + Math.imul(h, re) | 0)) << 13) | 0;
          f = ((o = o + Math.imul(h, ne) | 0) + (i >>> 13) | 0) + (Ae >>> 26) | 0, Ae &= 67108863, n = Math.imul(C, z), i = (i = Math.imul(C, q)) + Math.imul(T, z) | 0, o = Math.imul(T, q), n = n + Math.imul(E, H) | 0, i = (i = i + Math.imul(E, K) | 0) + Math.imul(S, H) | 0, o = o + Math.imul(S, K) | 0, n = n + Math.imul(M, W) | 0, i = (i = i + Math.imul(M, X) | 0) + Math.imul(x, W) | 0, o = o + Math.imul(x, X) | 0, n = n + Math.imul(w, $) | 0, i = (i = i + Math.imul(w, Y) | 0) + Math.imul(A, $) | 0, o = o + Math.imul(A, Y) | 0, n = n + Math.imul(g, Q) | 0, i = (i = i + Math.imul(g, ee) | 0) + Math.imul(v, Q) | 0, o = o + Math.imul(v, ee) | 0, n = n + Math.imul(p, re) | 0, i = (i = i + Math.imul(p, ne) | 0) + Math.imul(m, re) | 0, o = o + Math.imul(m, ne) | 0;

          var _e = (f + (n = n + Math.imul(u, oe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(u, ae) | 0) + Math.imul(h, oe) | 0)) << 13) | 0;

          f = ((o = o + Math.imul(h, ae) | 0) + (i >>> 13) | 0) + (_e >>> 26) | 0, _e &= 67108863, n = Math.imul(D, z), i = (i = Math.imul(D, q)) + Math.imul(N, z) | 0, o = Math.imul(N, q), n = n + Math.imul(C, H) | 0, i = (i = i + Math.imul(C, K) | 0) + Math.imul(T, H) | 0, o = o + Math.imul(T, K) | 0, n = n + Math.imul(E, W) | 0, i = (i = i + Math.imul(E, X) | 0) + Math.imul(S, W) | 0, o = o + Math.imul(S, X) | 0, n = n + Math.imul(M, $) | 0, i = (i = i + Math.imul(M, Y) | 0) + Math.imul(x, $) | 0, o = o + Math.imul(x, Y) | 0, n = n + Math.imul(w, Q) | 0, i = (i = i + Math.imul(w, ee) | 0) + Math.imul(A, Q) | 0, o = o + Math.imul(A, ee) | 0, n = n + Math.imul(g, re) | 0, i = (i = i + Math.imul(g, ne) | 0) + Math.imul(v, re) | 0, o = o + Math.imul(v, ne) | 0, n = n + Math.imul(p, oe) | 0, i = (i = i + Math.imul(p, ae) | 0) + Math.imul(m, oe) | 0, o = o + Math.imul(m, ae) | 0;
          var Me = (f + (n = n + Math.imul(u, se) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(u, fe) | 0) + Math.imul(h, se) | 0)) << 13) | 0;
          f = ((o = o + Math.imul(h, fe) | 0) + (i >>> 13) | 0) + (Me >>> 26) | 0, Me &= 67108863, n = Math.imul(O, z), i = (i = Math.imul(O, q)) + Math.imul(P, z) | 0, o = Math.imul(P, q), n = n + Math.imul(D, H) | 0, i = (i = i + Math.imul(D, K) | 0) + Math.imul(N, H) | 0, o = o + Math.imul(N, K) | 0, n = n + Math.imul(C, W) | 0, i = (i = i + Math.imul(C, X) | 0) + Math.imul(T, W) | 0, o = o + Math.imul(T, X) | 0, n = n + Math.imul(E, $) | 0, i = (i = i + Math.imul(E, Y) | 0) + Math.imul(S, $) | 0, o = o + Math.imul(S, Y) | 0, n = n + Math.imul(M, Q) | 0, i = (i = i + Math.imul(M, ee) | 0) + Math.imul(x, Q) | 0, o = o + Math.imul(x, ee) | 0, n = n + Math.imul(w, re) | 0, i = (i = i + Math.imul(w, ne) | 0) + Math.imul(A, re) | 0, o = o + Math.imul(A, ne) | 0, n = n + Math.imul(g, oe) | 0, i = (i = i + Math.imul(g, ae) | 0) + Math.imul(v, oe) | 0, o = o + Math.imul(v, ae) | 0, n = n + Math.imul(p, se) | 0, i = (i = i + Math.imul(p, fe) | 0) + Math.imul(m, se) | 0, o = o + Math.imul(m, fe) | 0;
          var xe = (f + (n = n + Math.imul(u, ue) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(u, he) | 0) + Math.imul(h, ue) | 0)) << 13) | 0;
          f = ((o = o + Math.imul(h, he) | 0) + (i >>> 13) | 0) + (xe >>> 26) | 0, xe &= 67108863, n = Math.imul(L, z), i = (i = Math.imul(L, q)) + Math.imul(G, z) | 0, o = Math.imul(G, q), n = n + Math.imul(O, H) | 0, i = (i = i + Math.imul(O, K) | 0) + Math.imul(P, H) | 0, o = o + Math.imul(P, K) | 0, n = n + Math.imul(D, W) | 0, i = (i = i + Math.imul(D, X) | 0) + Math.imul(N, W) | 0, o = o + Math.imul(N, X) | 0, n = n + Math.imul(C, $) | 0, i = (i = i + Math.imul(C, Y) | 0) + Math.imul(T, $) | 0, o = o + Math.imul(T, Y) | 0, n = n + Math.imul(E, Q) | 0, i = (i = i + Math.imul(E, ee) | 0) + Math.imul(S, Q) | 0, o = o + Math.imul(S, ee) | 0, n = n + Math.imul(M, re) | 0, i = (i = i + Math.imul(M, ne) | 0) + Math.imul(x, re) | 0, o = o + Math.imul(x, ne) | 0, n = n + Math.imul(w, oe) | 0, i = (i = i + Math.imul(w, ae) | 0) + Math.imul(A, oe) | 0, o = o + Math.imul(A, ae) | 0, n = n + Math.imul(g, se) | 0, i = (i = i + Math.imul(g, fe) | 0) + Math.imul(v, se) | 0, o = o + Math.imul(v, fe) | 0, n = n + Math.imul(p, ue) | 0, i = (i = i + Math.imul(p, he) | 0) + Math.imul(m, ue) | 0, o = o + Math.imul(m, he) | 0;
          var ke = (f + (n = n + Math.imul(u, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(u, me) | 0) + Math.imul(h, pe) | 0)) << 13) | 0;
          f = ((o = o + Math.imul(h, me) | 0) + (i >>> 13) | 0) + (ke >>> 26) | 0, ke &= 67108863, n = Math.imul(L, H), i = (i = Math.imul(L, K)) + Math.imul(G, H) | 0, o = Math.imul(G, K), n = n + Math.imul(O, W) | 0, i = (i = i + Math.imul(O, X) | 0) + Math.imul(P, W) | 0, o = o + Math.imul(P, X) | 0, n = n + Math.imul(D, $) | 0, i = (i = i + Math.imul(D, Y) | 0) + Math.imul(N, $) | 0, o = o + Math.imul(N, Y) | 0, n = n + Math.imul(C, Q) | 0, i = (i = i + Math.imul(C, ee) | 0) + Math.imul(T, Q) | 0, o = o + Math.imul(T, ee) | 0, n = n + Math.imul(E, re) | 0, i = (i = i + Math.imul(E, ne) | 0) + Math.imul(S, re) | 0, o = o + Math.imul(S, ne) | 0, n = n + Math.imul(M, oe) | 0, i = (i = i + Math.imul(M, ae) | 0) + Math.imul(x, oe) | 0, o = o + Math.imul(x, ae) | 0, n = n + Math.imul(w, se) | 0, i = (i = i + Math.imul(w, fe) | 0) + Math.imul(A, se) | 0, o = o + Math.imul(A, fe) | 0, n = n + Math.imul(g, ue) | 0, i = (i = i + Math.imul(g, he) | 0) + Math.imul(v, ue) | 0, o = o + Math.imul(v, he) | 0;
          var Ee = (f + (n = n + Math.imul(p, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(p, me) | 0) + Math.imul(m, pe) | 0)) << 13) | 0;
          f = ((o = o + Math.imul(m, me) | 0) + (i >>> 13) | 0) + (Ee >>> 26) | 0, Ee &= 67108863, n = Math.imul(L, W), i = (i = Math.imul(L, X)) + Math.imul(G, W) | 0, o = Math.imul(G, X), n = n + Math.imul(O, $) | 0, i = (i = i + Math.imul(O, Y) | 0) + Math.imul(P, $) | 0, o = o + Math.imul(P, Y) | 0, n = n + Math.imul(D, Q) | 0, i = (i = i + Math.imul(D, ee) | 0) + Math.imul(N, Q) | 0, o = o + Math.imul(N, ee) | 0, n = n + Math.imul(C, re) | 0, i = (i = i + Math.imul(C, ne) | 0) + Math.imul(T, re) | 0, o = o + Math.imul(T, ne) | 0, n = n + Math.imul(E, oe) | 0, i = (i = i + Math.imul(E, ae) | 0) + Math.imul(S, oe) | 0, o = o + Math.imul(S, ae) | 0, n = n + Math.imul(M, se) | 0, i = (i = i + Math.imul(M, fe) | 0) + Math.imul(x, se) | 0, o = o + Math.imul(x, fe) | 0, n = n + Math.imul(w, ue) | 0, i = (i = i + Math.imul(w, he) | 0) + Math.imul(A, ue) | 0, o = o + Math.imul(A, he) | 0;
          var Se = (f + (n = n + Math.imul(g, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(g, me) | 0) + Math.imul(v, pe) | 0)) << 13) | 0;
          f = ((o = o + Math.imul(v, me) | 0) + (i >>> 13) | 0) + (Se >>> 26) | 0, Se &= 67108863, n = Math.imul(L, $), i = (i = Math.imul(L, Y)) + Math.imul(G, $) | 0, o = Math.imul(G, Y), n = n + Math.imul(O, Q) | 0, i = (i = i + Math.imul(O, ee) | 0) + Math.imul(P, Q) | 0, o = o + Math.imul(P, ee) | 0, n = n + Math.imul(D, re) | 0, i = (i = i + Math.imul(D, ne) | 0) + Math.imul(N, re) | 0, o = o + Math.imul(N, ne) | 0, n = n + Math.imul(C, oe) | 0, i = (i = i + Math.imul(C, ae) | 0) + Math.imul(T, oe) | 0, o = o + Math.imul(T, ae) | 0, n = n + Math.imul(E, se) | 0, i = (i = i + Math.imul(E, fe) | 0) + Math.imul(S, se) | 0, o = o + Math.imul(S, fe) | 0, n = n + Math.imul(M, ue) | 0, i = (i = i + Math.imul(M, he) | 0) + Math.imul(x, ue) | 0, o = o + Math.imul(x, he) | 0;
          var Ie = (f + (n = n + Math.imul(w, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(w, me) | 0) + Math.imul(A, pe) | 0)) << 13) | 0;
          f = ((o = o + Math.imul(A, me) | 0) + (i >>> 13) | 0) + (Ie >>> 26) | 0, Ie &= 67108863, n = Math.imul(L, Q), i = (i = Math.imul(L, ee)) + Math.imul(G, Q) | 0, o = Math.imul(G, ee), n = n + Math.imul(O, re) | 0, i = (i = i + Math.imul(O, ne) | 0) + Math.imul(P, re) | 0, o = o + Math.imul(P, ne) | 0, n = n + Math.imul(D, oe) | 0, i = (i = i + Math.imul(D, ae) | 0) + Math.imul(N, oe) | 0, o = o + Math.imul(N, ae) | 0, n = n + Math.imul(C, se) | 0, i = (i = i + Math.imul(C, fe) | 0) + Math.imul(T, se) | 0, o = o + Math.imul(T, fe) | 0, n = n + Math.imul(E, ue) | 0, i = (i = i + Math.imul(E, he) | 0) + Math.imul(S, ue) | 0, o = o + Math.imul(S, he) | 0;
          var Ce = (f + (n = n + Math.imul(M, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(M, me) | 0) + Math.imul(x, pe) | 0)) << 13) | 0;
          f = ((o = o + Math.imul(x, me) | 0) + (i >>> 13) | 0) + (Ce >>> 26) | 0, Ce &= 67108863, n = Math.imul(L, re), i = (i = Math.imul(L, ne)) + Math.imul(G, re) | 0, o = Math.imul(G, ne), n = n + Math.imul(O, oe) | 0, i = (i = i + Math.imul(O, ae) | 0) + Math.imul(P, oe) | 0, o = o + Math.imul(P, ae) | 0, n = n + Math.imul(D, se) | 0, i = (i = i + Math.imul(D, fe) | 0) + Math.imul(N, se) | 0, o = o + Math.imul(N, fe) | 0, n = n + Math.imul(C, ue) | 0, i = (i = i + Math.imul(C, he) | 0) + Math.imul(T, ue) | 0, o = o + Math.imul(T, he) | 0;
          var Te = (f + (n = n + Math.imul(E, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(E, me) | 0) + Math.imul(S, pe) | 0)) << 13) | 0;
          f = ((o = o + Math.imul(S, me) | 0) + (i >>> 13) | 0) + (Te >>> 26) | 0, Te &= 67108863, n = Math.imul(L, oe), i = (i = Math.imul(L, ae)) + Math.imul(G, oe) | 0, o = Math.imul(G, ae), n = n + Math.imul(O, se) | 0, i = (i = i + Math.imul(O, fe) | 0) + Math.imul(P, se) | 0, o = o + Math.imul(P, fe) | 0, n = n + Math.imul(D, ue) | 0, i = (i = i + Math.imul(D, he) | 0) + Math.imul(N, ue) | 0, o = o + Math.imul(N, he) | 0;
          var Be = (f + (n = n + Math.imul(C, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(C, me) | 0) + Math.imul(T, pe) | 0)) << 13) | 0;
          f = ((o = o + Math.imul(T, me) | 0) + (i >>> 13) | 0) + (Be >>> 26) | 0, Be &= 67108863, n = Math.imul(L, se), i = (i = Math.imul(L, fe)) + Math.imul(G, se) | 0, o = Math.imul(G, fe), n = n + Math.imul(O, ue) | 0, i = (i = i + Math.imul(O, he) | 0) + Math.imul(P, ue) | 0, o = o + Math.imul(P, he) | 0;
          var De = (f + (n = n + Math.imul(D, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(D, me) | 0) + Math.imul(N, pe) | 0)) << 13) | 0;
          f = ((o = o + Math.imul(N, me) | 0) + (i >>> 13) | 0) + (De >>> 26) | 0, De &= 67108863, n = Math.imul(L, ue), i = (i = Math.imul(L, he)) + Math.imul(G, ue) | 0, o = Math.imul(G, he);
          var Ne = (f + (n = n + Math.imul(O, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(O, me) | 0) + Math.imul(P, pe) | 0)) << 13) | 0;
          f = ((o = o + Math.imul(P, me) | 0) + (i >>> 13) | 0) + (Ne >>> 26) | 0, Ne &= 67108863;
          var Re = (f + (n = Math.imul(L, pe)) | 0) + ((8191 & (i = (i = Math.imul(L, me)) + Math.imul(G, pe) | 0)) << 13) | 0;
          return f = ((o = Math.imul(G, me)) + (i >>> 13) | 0) + (Re >>> 26) | 0, Re &= 67108863, s[0] = be, s[1] = ge, s[2] = ve, s[3] = ye, s[4] = we, s[5] = Ae, s[6] = _e, s[7] = Me, s[8] = xe, s[9] = ke, s[10] = Ee, s[11] = Se, s[12] = Ie, s[13] = Ce, s[14] = Te, s[15] = Be, s[16] = De, s[17] = Ne, s[18] = Re, 0 !== f && (s[19] = f, r.length++), r;
        };

        function g(e, t, r) {
          r.negative = t.negative ^ e.negative, r.length = e.length + t.length;

          for (var n = 0, i = 0, o = 0; o < r.length - 1; o++) {
            var a = i;
            i = 0;

            for (var c = 67108863 & n, s = Math.min(o, t.length - 1), f = Math.max(0, o - e.length + 1); f <= s; f++) {
              var d = o - f,
                  u = (0 | e.words[d]) * (0 | t.words[f]),
                  h = 67108863 & u;
              c = 67108863 & (h = h + c | 0), i += (a = (a = a + (u / 67108864 | 0) | 0) + (h >>> 26) | 0) >>> 26, a &= 67108863;
            }

            r.words[o] = c, n = a, a = i;
          }

          return 0 !== n ? r.words[o] = n : r.length--, r._strip();
        }

        function v(e, t, r) {
          return g(e, t, r);
        }

        function y(e, t) {
          this.x = e, this.y = t;
        }

        Math.imul || (b = m), o.prototype.mulTo = function (e, t) {
          var r = this.length + e.length;
          return 10 === this.length && 10 === e.length ? b(this, e, t) : r < 63 ? m(this, e, t) : r < 1024 ? g(this, e, t) : v(this, e, t);
        }, y.prototype.makeRBT = function (e) {
          for (var t = new Array(e), r = o.prototype._countBits(e) - 1, n = 0; n < e; n++) {
            t[n] = this.revBin(n, r, e);
          }

          return t;
        }, y.prototype.revBin = function (e, t, r) {
          if (0 === e || e === r - 1) return e;

          for (var n = 0, i = 0; i < t; i++) {
            n |= (1 & e) << t - i - 1, e >>= 1;
          }

          return n;
        }, y.prototype.permute = function (e, t, r, n, i, o) {
          for (var a = 0; a < o; a++) {
            n[a] = t[e[a]], i[a] = r[e[a]];
          }
        }, y.prototype.transform = function (e, t, r, n, i, o) {
          this.permute(o, e, t, r, n, i);

          for (var a = 1; a < i; a <<= 1) {
            for (var c = a << 1, s = Math.cos(2 * Math.PI / c), f = Math.sin(2 * Math.PI / c), d = 0; d < i; d += c) {
              for (var u = s, h = f, l = 0; l < a; l++) {
                var p = r[d + l],
                    m = n[d + l],
                    b = r[d + l + a],
                    g = n[d + l + a],
                    v = u * b - h * g;
                g = u * g + h * b, b = v, r[d + l] = p + b, n[d + l] = m + g, r[d + l + a] = p - b, n[d + l + a] = m - g, l !== c && (v = s * u - f * h, h = s * h + f * u, u = v);
              }
            }
          }
        }, y.prototype.guessLen13b = function (e, t) {
          var r = 1 | Math.max(t, e),
              n = 1 & r,
              i = 0;

          for (r = r / 2 | 0; r; r >>>= 1) {
            i++;
          }

          return 1 << i + 1 + n;
        }, y.prototype.conjugate = function (e, t, r) {
          if (!(r <= 1)) for (var n = 0; n < r / 2; n++) {
            var i = e[n];
            e[n] = e[r - n - 1], e[r - n - 1] = i, i = t[n], t[n] = -t[r - n - 1], t[r - n - 1] = -i;
          }
        }, y.prototype.normalize13b = function (e, t) {
          for (var r = 0, n = 0; n < t / 2; n++) {
            var i = 8192 * Math.round(e[2 * n + 1] / t) + Math.round(e[2 * n] / t) + r;
            e[n] = 67108863 & i, r = i < 67108864 ? 0 : i / 67108864 | 0;
          }

          return e;
        }, y.prototype.convert13b = function (e, t, r, i) {
          for (var o = 0, a = 0; a < t; a++) {
            o += 0 | e[a], r[2 * a] = 8191 & o, o >>>= 13, r[2 * a + 1] = 8191 & o, o >>>= 13;
          }

          for (a = 2 * t; a < i; ++a) {
            r[a] = 0;
          }

          n(0 === o), n(0 == (-8192 & o));
        }, y.prototype.stub = function (e) {
          for (var t = new Array(e), r = 0; r < e; r++) {
            t[r] = 0;
          }

          return t;
        }, y.prototype.mulp = function (e, t, r) {
          var n = 2 * this.guessLen13b(e.length, t.length),
              i = this.makeRBT(n),
              o = this.stub(n),
              a = new Array(n),
              c = new Array(n),
              s = new Array(n),
              f = new Array(n),
              d = new Array(n),
              u = new Array(n),
              h = r.words;
          h.length = n, this.convert13b(e.words, e.length, a, n), this.convert13b(t.words, t.length, f, n), this.transform(a, o, c, s, n, i), this.transform(f, o, d, u, n, i);

          for (var l = 0; l < n; l++) {
            var p = c[l] * d[l] - s[l] * u[l];
            s[l] = c[l] * u[l] + s[l] * d[l], c[l] = p;
          }

          return this.conjugate(c, s, n), this.transform(c, s, h, o, n, i), this.conjugate(h, o, n), this.normalize13b(h, n), r.negative = e.negative ^ t.negative, r.length = e.length + t.length, r._strip();
        }, o.prototype.mul = function (e) {
          var t = new o(null);
          return t.words = new Array(this.length + e.length), this.mulTo(e, t);
        }, o.prototype.mulf = function (e) {
          var t = new o(null);
          return t.words = new Array(this.length + e.length), v(this, e, t);
        }, o.prototype.imul = function (e) {
          return this.clone().mulTo(e, this);
        }, o.prototype.imuln = function (e) {
          var t = e < 0;
          t && (e = -e), n("number" == typeof e), n(e < 67108864);

          for (var r = 0, i = 0; i < this.length; i++) {
            var o = (0 | this.words[i]) * e,
                a = (67108863 & o) + (67108863 & r);
            r >>= 26, r += o / 67108864 | 0, r += a >>> 26, this.words[i] = 67108863 & a;
          }

          return 0 !== r && (this.words[i] = r, this.length++), t ? this.ineg() : this;
        }, o.prototype.muln = function (e) {
          return this.clone().imuln(e);
        }, o.prototype.sqr = function () {
          return this.mul(this);
        }, o.prototype.isqr = function () {
          return this.imul(this.clone());
        }, o.prototype.pow = function (e) {
          var t = function (e) {
            for (var t = new Array(e.bitLength()), r = 0; r < t.length; r++) {
              var n = r / 26 | 0,
                  i = r % 26;
              t[r] = e.words[n] >>> i & 1;
            }

            return t;
          }(e);

          if (0 === t.length) return new o(1);

          for (var r = this, n = 0; n < t.length && 0 === t[n]; n++, r = r.sqr()) {
            ;
          }

          if (++n < t.length) for (var i = r.sqr(); n < t.length; n++, i = i.sqr()) {
            0 !== t[n] && (r = r.mul(i));
          }
          return r;
        }, o.prototype.iushln = function (e) {
          n("number" == typeof e && e >= 0);
          var t,
              r = e % 26,
              i = (e - r) / 26,
              o = 67108863 >>> 26 - r << 26 - r;

          if (0 !== r) {
            var a = 0;

            for (t = 0; t < this.length; t++) {
              var c = this.words[t] & o,
                  s = (0 | this.words[t]) - c << r;
              this.words[t] = s | a, a = c >>> 26 - r;
            }

            a && (this.words[t] = a, this.length++);
          }

          if (0 !== i) {
            for (t = this.length - 1; t >= 0; t--) {
              this.words[t + i] = this.words[t];
            }

            for (t = 0; t < i; t++) {
              this.words[t] = 0;
            }

            this.length += i;
          }

          return this._strip();
        }, o.prototype.ishln = function (e) {
          return n(0 === this.negative), this.iushln(e);
        }, o.prototype.iushrn = function (e, t, r) {
          var i;
          n("number" == typeof e && e >= 0), i = t ? (t - t % 26) / 26 : 0;
          var o = e % 26,
              a = Math.min((e - o) / 26, this.length),
              c = 67108863 ^ 67108863 >>> o << o,
              s = r;

          if (i -= a, i = Math.max(0, i), s) {
            for (var f = 0; f < a; f++) {
              s.words[f] = this.words[f];
            }

            s.length = a;
          }

          if (0 === a) ;else if (this.length > a) for (this.length -= a, f = 0; f < this.length; f++) {
            this.words[f] = this.words[f + a];
          } else this.words[0] = 0, this.length = 1;
          var d = 0;

          for (f = this.length - 1; f >= 0 && (0 !== d || f >= i); f--) {
            var u = 0 | this.words[f];
            this.words[f] = d << 26 - o | u >>> o, d = u & c;
          }

          return s && 0 !== d && (s.words[s.length++] = d), 0 === this.length && (this.words[0] = 0, this.length = 1), this._strip();
        }, o.prototype.ishrn = function (e, t, r) {
          return n(0 === this.negative), this.iushrn(e, t, r);
        }, o.prototype.shln = function (e) {
          return this.clone().ishln(e);
        }, o.prototype.ushln = function (e) {
          return this.clone().iushln(e);
        }, o.prototype.shrn = function (e) {
          return this.clone().ishrn(e);
        }, o.prototype.ushrn = function (e) {
          return this.clone().iushrn(e);
        }, o.prototype.testn = function (e) {
          n("number" == typeof e && e >= 0);
          var t = e % 26,
              r = (e - t) / 26,
              i = 1 << t;
          return !(this.length <= r || !(this.words[r] & i));
        }, o.prototype.imaskn = function (e) {
          n("number" == typeof e && e >= 0);
          var t = e % 26,
              r = (e - t) / 26;
          if (n(0 === this.negative, "imaskn works only with positive numbers"), this.length <= r) return this;

          if (0 !== t && r++, this.length = Math.min(r, this.length), 0 !== t) {
            var i = 67108863 ^ 67108863 >>> t << t;
            this.words[this.length - 1] &= i;
          }

          return this._strip();
        }, o.prototype.maskn = function (e) {
          return this.clone().imaskn(e);
        }, o.prototype.iaddn = function (e) {
          return n("number" == typeof e), n(e < 67108864), e < 0 ? this.isubn(-e) : 0 !== this.negative ? 1 === this.length && (0 | this.words[0]) <= e ? (this.words[0] = e - (0 | this.words[0]), this.negative = 0, this) : (this.negative = 0, this.isubn(e), this.negative = 1, this) : this._iaddn(e);
        }, o.prototype._iaddn = function (e) {
          this.words[0] += e;

          for (var t = 0; t < this.length && this.words[t] >= 67108864; t++) {
            this.words[t] -= 67108864, t === this.length - 1 ? this.words[t + 1] = 1 : this.words[t + 1]++;
          }

          return this.length = Math.max(this.length, t + 1), this;
        }, o.prototype.isubn = function (e) {
          if (n("number" == typeof e), n(e < 67108864), e < 0) return this.iaddn(-e);
          if (0 !== this.negative) return this.negative = 0, this.iaddn(e), this.negative = 1, this;
          if (this.words[0] -= e, 1 === this.length && this.words[0] < 0) this.words[0] = -this.words[0], this.negative = 1;else for (var t = 0; t < this.length && this.words[t] < 0; t++) {
            this.words[t] += 67108864, this.words[t + 1] -= 1;
          }
          return this._strip();
        }, o.prototype.addn = function (e) {
          return this.clone().iaddn(e);
        }, o.prototype.subn = function (e) {
          return this.clone().isubn(e);
        }, o.prototype.iabs = function () {
          return this.negative = 0, this;
        }, o.prototype.abs = function () {
          return this.clone().iabs();
        }, o.prototype._ishlnsubmul = function (e, t, r) {
          var i,
              o,
              a = e.length + r;

          this._expand(a);

          var c = 0;

          for (i = 0; i < e.length; i++) {
            o = (0 | this.words[i + r]) + c;
            var s = (0 | e.words[i]) * t;
            c = ((o -= 67108863 & s) >> 26) - (s / 67108864 | 0), this.words[i + r] = 67108863 & o;
          }

          for (; i < this.length - r; i++) {
            c = (o = (0 | this.words[i + r]) + c) >> 26, this.words[i + r] = 67108863 & o;
          }

          if (0 === c) return this._strip();

          for (n(-1 === c), c = 0, i = 0; i < this.length; i++) {
            c = (o = -(0 | this.words[i]) + c) >> 26, this.words[i] = 67108863 & o;
          }

          return this.negative = 1, this._strip();
        }, o.prototype._wordDiv = function (e, t) {
          var r = (this.length, e.length),
              n = this.clone(),
              i = e,
              a = 0 | i.words[i.length - 1];
          0 != (r = 26 - this._countBits(a)) && (i = i.ushln(r), n.iushln(r), a = 0 | i.words[i.length - 1]);
          var c,
              s = n.length - i.length;

          if ("mod" !== t) {
            (c = new o(null)).length = s + 1, c.words = new Array(c.length);

            for (var f = 0; f < c.length; f++) {
              c.words[f] = 0;
            }
          }

          var d = n.clone()._ishlnsubmul(i, 1, s);

          0 === d.negative && (n = d, c && (c.words[s] = 1));

          for (var u = s - 1; u >= 0; u--) {
            var h = 67108864 * (0 | n.words[i.length + u]) + (0 | n.words[i.length + u - 1]);

            for (h = Math.min(h / a | 0, 67108863), n._ishlnsubmul(i, h, u); 0 !== n.negative;) {
              h--, n.negative = 0, n._ishlnsubmul(i, 1, u), n.isZero() || (n.negative ^= 1);
            }

            c && (c.words[u] = h);
          }

          return c && c._strip(), n._strip(), "div" !== t && 0 !== r && n.iushrn(r), {
            div: c || null,
            mod: n
          };
        }, o.prototype.divmod = function (e, t, r) {
          return n(!e.isZero()), this.isZero() ? {
            div: new o(0),
            mod: new o(0)
          } : 0 !== this.negative && 0 === e.negative ? (c = this.neg().divmod(e, t), "mod" !== t && (i = c.div.neg()), "div" !== t && (a = c.mod.neg(), r && 0 !== a.negative && a.iadd(e)), {
            div: i,
            mod: a
          }) : 0 === this.negative && 0 !== e.negative ? (c = this.divmod(e.neg(), t), "mod" !== t && (i = c.div.neg()), {
            div: i,
            mod: c.mod
          }) : 0 != (this.negative & e.negative) ? (c = this.neg().divmod(e.neg(), t), "div" !== t && (a = c.mod.neg(), r && 0 !== a.negative && a.isub(e)), {
            div: c.div,
            mod: a
          }) : e.length > this.length || this.cmp(e) < 0 ? {
            div: new o(0),
            mod: this
          } : 1 === e.length ? "div" === t ? {
            div: this.divn(e.words[0]),
            mod: null
          } : "mod" === t ? {
            div: null,
            mod: new o(this.modrn(e.words[0]))
          } : {
            div: this.divn(e.words[0]),
            mod: new o(this.modrn(e.words[0]))
          } : this._wordDiv(e, t);
          var i, a, c;
        }, o.prototype.div = function (e) {
          return this.divmod(e, "div", !1).div;
        }, o.prototype.mod = function (e) {
          return this.divmod(e, "mod", !1).mod;
        }, o.prototype.umod = function (e) {
          return this.divmod(e, "mod", !0).mod;
        }, o.prototype.divRound = function (e) {
          var t = this.divmod(e);
          if (t.mod.isZero()) return t.div;
          var r = 0 !== t.div.negative ? t.mod.isub(e) : t.mod,
              n = e.ushrn(1),
              i = e.andln(1),
              o = r.cmp(n);
          return o < 0 || 1 === i && 0 === o ? t.div : 0 !== t.div.negative ? t.div.isubn(1) : t.div.iaddn(1);
        }, o.prototype.modrn = function (e) {
          var t = e < 0;
          t && (e = -e), n(e <= 67108863);

          for (var r = (1 << 26) % e, i = 0, o = this.length - 1; o >= 0; o--) {
            i = (r * i + (0 | this.words[o])) % e;
          }

          return t ? -i : i;
        }, o.prototype.modn = function (e) {
          return this.modrn(e);
        }, o.prototype.idivn = function (e) {
          var t = e < 0;
          t && (e = -e), n(e <= 67108863);

          for (var r = 0, i = this.length - 1; i >= 0; i--) {
            var o = (0 | this.words[i]) + 67108864 * r;
            this.words[i] = o / e | 0, r = o % e;
          }

          return this._strip(), t ? this.ineg() : this;
        }, o.prototype.divn = function (e) {
          return this.clone().idivn(e);
        }, o.prototype.egcd = function (e) {
          n(0 === e.negative), n(!e.isZero());
          var t = this,
              r = e.clone();
          t = 0 !== t.negative ? t.umod(e) : t.clone();

          for (var i = new o(1), a = new o(0), c = new o(0), s = new o(1), f = 0; t.isEven() && r.isEven();) {
            t.iushrn(1), r.iushrn(1), ++f;
          }

          for (var d = r.clone(), u = t.clone(); !t.isZero();) {
            for (var h = 0, l = 1; 0 == (t.words[0] & l) && h < 26; ++h, l <<= 1) {
              ;
            }

            if (h > 0) for (t.iushrn(h); h-- > 0;) {
              (i.isOdd() || a.isOdd()) && (i.iadd(d), a.isub(u)), i.iushrn(1), a.iushrn(1);
            }

            for (var p = 0, m = 1; 0 == (r.words[0] & m) && p < 26; ++p, m <<= 1) {
              ;
            }

            if (p > 0) for (r.iushrn(p); p-- > 0;) {
              (c.isOdd() || s.isOdd()) && (c.iadd(d), s.isub(u)), c.iushrn(1), s.iushrn(1);
            }
            t.cmp(r) >= 0 ? (t.isub(r), i.isub(c), a.isub(s)) : (r.isub(t), c.isub(i), s.isub(a));
          }

          return {
            a: c,
            b: s,
            gcd: r.iushln(f)
          };
        }, o.prototype._invmp = function (e) {
          n(0 === e.negative), n(!e.isZero());
          var t = this,
              r = e.clone();
          t = 0 !== t.negative ? t.umod(e) : t.clone();

          for (var i, a = new o(1), c = new o(0), s = r.clone(); t.cmpn(1) > 0 && r.cmpn(1) > 0;) {
            for (var f = 0, d = 1; 0 == (t.words[0] & d) && f < 26; ++f, d <<= 1) {
              ;
            }

            if (f > 0) for (t.iushrn(f); f-- > 0;) {
              a.isOdd() && a.iadd(s), a.iushrn(1);
            }

            for (var u = 0, h = 1; 0 == (r.words[0] & h) && u < 26; ++u, h <<= 1) {
              ;
            }

            if (u > 0) for (r.iushrn(u); u-- > 0;) {
              c.isOdd() && c.iadd(s), c.iushrn(1);
            }
            t.cmp(r) >= 0 ? (t.isub(r), a.isub(c)) : (r.isub(t), c.isub(a));
          }

          return (i = 0 === t.cmpn(1) ? a : c).cmpn(0) < 0 && i.iadd(e), i;
        }, o.prototype.gcd = function (e) {
          if (this.isZero()) return e.abs();
          if (e.isZero()) return this.abs();
          var t = this.clone(),
              r = e.clone();
          t.negative = 0, r.negative = 0;

          for (var n = 0; t.isEven() && r.isEven(); n++) {
            t.iushrn(1), r.iushrn(1);
          }

          for (;;) {
            for (; t.isEven();) {
              t.iushrn(1);
            }

            for (; r.isEven();) {
              r.iushrn(1);
            }

            var i = t.cmp(r);

            if (i < 0) {
              var o = t;
              t = r, r = o;
            } else if (0 === i || 0 === r.cmpn(1)) break;

            t.isub(r);
          }

          return r.iushln(n);
        }, o.prototype.invm = function (e) {
          return this.egcd(e).a.umod(e);
        }, o.prototype.isEven = function () {
          return 0 == (1 & this.words[0]);
        }, o.prototype.isOdd = function () {
          return 1 == (1 & this.words[0]);
        }, o.prototype.andln = function (e) {
          return this.words[0] & e;
        }, o.prototype.bincn = function (e) {
          n("number" == typeof e);
          var t = e % 26,
              r = (e - t) / 26,
              i = 1 << t;
          if (this.length <= r) return this._expand(r + 1), this.words[r] |= i, this;

          for (var o = i, a = r; 0 !== o && a < this.length; a++) {
            var c = 0 | this.words[a];
            o = (c += o) >>> 26, c &= 67108863, this.words[a] = c;
          }

          return 0 !== o && (this.words[a] = o, this.length++), this;
        }, o.prototype.isZero = function () {
          return 1 === this.length && 0 === this.words[0];
        }, o.prototype.cmpn = function (e) {
          var t,
              r = e < 0;
          if (0 !== this.negative && !r) return -1;
          if (0 === this.negative && r) return 1;
          if (this._strip(), this.length > 1) t = 1;else {
            r && (e = -e), n(e <= 67108863, "Number is too big");
            var i = 0 | this.words[0];
            t = i === e ? 0 : i < e ? -1 : 1;
          }
          return 0 !== this.negative ? 0 | -t : t;
        }, o.prototype.cmp = function (e) {
          if (0 !== this.negative && 0 === e.negative) return -1;
          if (0 === this.negative && 0 !== e.negative) return 1;
          var t = this.ucmp(e);
          return 0 !== this.negative ? 0 | -t : t;
        }, o.prototype.ucmp = function (e) {
          if (this.length > e.length) return 1;
          if (this.length < e.length) return -1;

          for (var t = 0, r = this.length - 1; r >= 0; r--) {
            var n = 0 | this.words[r],
                i = 0 | e.words[r];

            if (n !== i) {
              n < i ? t = -1 : n > i && (t = 1);
              break;
            }
          }

          return t;
        }, o.prototype.gtn = function (e) {
          return 1 === this.cmpn(e);
        }, o.prototype.gt = function (e) {
          return 1 === this.cmp(e);
        }, o.prototype.gten = function (e) {
          return this.cmpn(e) >= 0;
        }, o.prototype.gte = function (e) {
          return this.cmp(e) >= 0;
        }, o.prototype.ltn = function (e) {
          return -1 === this.cmpn(e);
        }, o.prototype.lt = function (e) {
          return -1 === this.cmp(e);
        }, o.prototype.lten = function (e) {
          return this.cmpn(e) <= 0;
        }, o.prototype.lte = function (e) {
          return this.cmp(e) <= 0;
        }, o.prototype.eqn = function (e) {
          return 0 === this.cmpn(e);
        }, o.prototype.eq = function (e) {
          return 0 === this.cmp(e);
        }, o.red = function (e) {
          return new E(e);
        }, o.prototype.toRed = function (e) {
          return n(!this.red, "Already a number in reduction context"), n(0 === this.negative, "red works only with positives"), e.convertTo(this)._forceRed(e);
        }, o.prototype.fromRed = function () {
          return n(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
        }, o.prototype._forceRed = function (e) {
          return this.red = e, this;
        }, o.prototype.forceRed = function (e) {
          return n(!this.red, "Already a number in reduction context"), this._forceRed(e);
        }, o.prototype.redAdd = function (e) {
          return n(this.red, "redAdd works only with red numbers"), this.red.add(this, e);
        }, o.prototype.redIAdd = function (e) {
          return n(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, e);
        }, o.prototype.redSub = function (e) {
          return n(this.red, "redSub works only with red numbers"), this.red.sub(this, e);
        }, o.prototype.redISub = function (e) {
          return n(this.red, "redISub works only with red numbers"), this.red.isub(this, e);
        }, o.prototype.redShl = function (e) {
          return n(this.red, "redShl works only with red numbers"), this.red.shl(this, e);
        }, o.prototype.redMul = function (e) {
          return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.mul(this, e);
        }, o.prototype.redIMul = function (e) {
          return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.imul(this, e);
        }, o.prototype.redSqr = function () {
          return n(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
        }, o.prototype.redISqr = function () {
          return n(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
        }, o.prototype.redSqrt = function () {
          return n(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
        }, o.prototype.redInvm = function () {
          return n(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
        }, o.prototype.redNeg = function () {
          return n(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
        }, o.prototype.redPow = function (e) {
          return n(this.red && !e.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, e);
        };
        var w = {
          k256: null,
          p224: null,
          p192: null,
          p25519: null
        };

        function A(e, t) {
          this.name = e, this.p = new o(t, 16), this.n = this.p.bitLength(), this.k = new o(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
        }

        function _() {
          A.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
        }

        function M() {
          A.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
        }

        function x() {
          A.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
        }

        function k() {
          A.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
        }

        function E(e) {
          if ("string" == typeof e) {
            var t = o._prime(e);

            this.m = t.p, this.prime = t;
          } else n(e.gtn(1), "modulus must be greater than 1"), this.m = e, this.prime = null;
        }

        function S(e) {
          E.call(this, e), this.shift = this.m.bitLength(), this.shift % 26 != 0 && (this.shift += 26 - this.shift % 26), this.r = new o(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
        }

        A.prototype._tmp = function () {
          var e = new o(null);
          return e.words = new Array(Math.ceil(this.n / 13)), e;
        }, A.prototype.ireduce = function (e) {
          var t,
              r = e;

          do {
            this.split(r, this.tmp), t = (r = (r = this.imulK(r)).iadd(this.tmp)).bitLength();
          } while (t > this.n);

          var n = t < this.n ? -1 : r.ucmp(this.p);
          return 0 === n ? (r.words[0] = 0, r.length = 1) : n > 0 ? r.isub(this.p) : void 0 !== r.strip ? r.strip() : r._strip(), r;
        }, A.prototype.split = function (e, t) {
          e.iushrn(this.n, 0, t);
        }, A.prototype.imulK = function (e) {
          return e.imul(this.k);
        }, i(_, A), _.prototype.split = function (e, t) {
          for (var r = 4194303, n = Math.min(e.length, 9), i = 0; i < n; i++) {
            t.words[i] = e.words[i];
          }

          if (t.length = n, e.length <= 9) return e.words[0] = 0, void (e.length = 1);
          var o = e.words[9];

          for (t.words[t.length++] = o & r, i = 10; i < e.length; i++) {
            var a = 0 | e.words[i];
            e.words[i - 10] = (a & r) << 4 | o >>> 22, o = a;
          }

          o >>>= 22, e.words[i - 10] = o, 0 === o && e.length > 10 ? e.length -= 10 : e.length -= 9;
        }, _.prototype.imulK = function (e) {
          e.words[e.length] = 0, e.words[e.length + 1] = 0, e.length += 2;

          for (var t = 0, r = 0; r < e.length; r++) {
            var n = 0 | e.words[r];
            t += 977 * n, e.words[r] = 67108863 & t, t = 64 * n + (t / 67108864 | 0);
          }

          return 0 === e.words[e.length - 1] && (e.length--, 0 === e.words[e.length - 1] && e.length--), e;
        }, i(M, A), i(x, A), i(k, A), k.prototype.imulK = function (e) {
          for (var t = 0, r = 0; r < e.length; r++) {
            var n = 19 * (0 | e.words[r]) + t,
                i = 67108863 & n;
            n >>>= 26, e.words[r] = i, t = n;
          }

          return 0 !== t && (e.words[e.length++] = t), e;
        }, o._prime = function (e) {
          if (w[e]) return w[e];
          var t;
          if ("k256" === e) t = new _();else if ("p224" === e) t = new M();else if ("p192" === e) t = new x();else {
            if ("p25519" !== e) throw new Error("Unknown prime " + e);
            t = new k();
          }
          return w[e] = t, t;
        }, E.prototype._verify1 = function (e) {
          n(0 === e.negative, "red works only with positives"), n(e.red, "red works only with red numbers");
        }, E.prototype._verify2 = function (e, t) {
          n(0 == (e.negative | t.negative), "red works only with positives"), n(e.red && e.red === t.red, "red works only with red numbers");
        }, E.prototype.imod = function (e) {
          return this.prime ? this.prime.ireduce(e)._forceRed(this) : (d(e, e.umod(this.m)._forceRed(this)), e);
        }, E.prototype.neg = function (e) {
          return e.isZero() ? e.clone() : this.m.sub(e)._forceRed(this);
        }, E.prototype.add = function (e, t) {
          this._verify2(e, t);

          var r = e.add(t);
          return r.cmp(this.m) >= 0 && r.isub(this.m), r._forceRed(this);
        }, E.prototype.iadd = function (e, t) {
          this._verify2(e, t);

          var r = e.iadd(t);
          return r.cmp(this.m) >= 0 && r.isub(this.m), r;
        }, E.prototype.sub = function (e, t) {
          this._verify2(e, t);

          var r = e.sub(t);
          return r.cmpn(0) < 0 && r.iadd(this.m), r._forceRed(this);
        }, E.prototype.isub = function (e, t) {
          this._verify2(e, t);

          var r = e.isub(t);
          return r.cmpn(0) < 0 && r.iadd(this.m), r;
        }, E.prototype.shl = function (e, t) {
          return this._verify1(e), this.imod(e.ushln(t));
        }, E.prototype.imul = function (e, t) {
          return this._verify2(e, t), this.imod(e.imul(t));
        }, E.prototype.mul = function (e, t) {
          return this._verify2(e, t), this.imod(e.mul(t));
        }, E.prototype.isqr = function (e) {
          return this.imul(e, e.clone());
        }, E.prototype.sqr = function (e) {
          return this.mul(e, e);
        }, E.prototype.sqrt = function (e) {
          if (e.isZero()) return e.clone();
          var t = this.m.andln(3);

          if (n(t % 2 == 1), 3 === t) {
            var r = this.m.add(new o(1)).iushrn(2);
            return this.pow(e, r);
          }

          for (var i = this.m.subn(1), a = 0; !i.isZero() && 0 === i.andln(1);) {
            a++, i.iushrn(1);
          }

          n(!i.isZero());
          var c = new o(1).toRed(this),
              s = c.redNeg(),
              f = this.m.subn(1).iushrn(1),
              d = this.m.bitLength();

          for (d = new o(2 * d * d).toRed(this); 0 !== this.pow(d, f).cmp(s);) {
            d.redIAdd(s);
          }

          for (var u = this.pow(d, i), h = this.pow(e, i.addn(1).iushrn(1)), l = this.pow(e, i), p = a; 0 !== l.cmp(c);) {
            for (var m = l, b = 0; 0 !== m.cmp(c); b++) {
              m = m.redSqr();
            }

            n(b < p);
            var g = this.pow(u, new o(1).iushln(p - b - 1));
            h = h.redMul(g), u = g.redSqr(), l = l.redMul(u), p = b;
          }

          return h;
        }, E.prototype.invm = function (e) {
          var t = e._invmp(this.m);

          return 0 !== t.negative ? (t.negative = 0, this.imod(t).redNeg()) : this.imod(t);
        }, E.prototype.pow = function (e, t) {
          if (t.isZero()) return new o(1).toRed(this);
          if (0 === t.cmpn(1)) return e.clone();
          var r = new Array(16);
          r[0] = new o(1).toRed(this), r[1] = e;

          for (var n = 2; n < r.length; n++) {
            r[n] = this.mul(r[n - 1], e);
          }

          var i = r[0],
              a = 0,
              c = 0,
              s = t.bitLength() % 26;

          for (0 === s && (s = 26), n = t.length - 1; n >= 0; n--) {
            for (var f = t.words[n], d = s - 1; d >= 0; d--) {
              var u = f >> d & 1;
              i !== r[0] && (i = this.sqr(i)), 0 !== u || 0 !== a ? (a <<= 1, a |= u, (4 == ++c || 0 === n && 0 === d) && (i = this.mul(i, r[a]), c = 0, a = 0)) : c = 0;
            }

            s = 26;
          }

          return i;
        }, E.prototype.convertTo = function (e) {
          var t = e.umod(this.m);
          return t === e ? t.clone() : t;
        }, E.prototype.convertFrom = function (e) {
          var t = e.clone();
          return t.red = null, t;
        }, o.mont = function (e) {
          return new S(e);
        }, i(S, E), S.prototype.convertTo = function (e) {
          return this.imod(e.ushln(this.shift));
        }, S.prototype.convertFrom = function (e) {
          var t = this.imod(e.mul(this.rinv));
          return t.red = null, t;
        }, S.prototype.imul = function (e, t) {
          if (e.isZero() || t.isZero()) return e.words[0] = 0, e.length = 1, e;
          var r = e.imul(t),
              n = r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
              i = r.isub(n).iushrn(this.shift),
              o = i;
          return i.cmp(this.m) >= 0 ? o = i.isub(this.m) : i.cmpn(0) < 0 && (o = i.iadd(this.m)), o._forceRed(this);
        }, S.prototype.mul = function (e, t) {
          if (e.isZero() || t.isZero()) return new o(0)._forceRed(this);
          var r = e.mul(t),
              n = r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
              i = r.isub(n).iushrn(this.shift),
              a = i;
          return i.cmp(this.m) >= 0 ? a = i.isub(this.m) : i.cmpn(0) < 0 && (a = i.iadd(this.m)), a._forceRed(this);
        }, S.prototype.invm = function (e) {
          return this.imod(e._invmp(this.m).mul(this.r2))._forceRed(this);
        };
      }(e = r.nmd(e), this);
    },
    9931: function _(e, t, r) {
      var n;

      function i(e) {
        this.rand = e;
      }

      if (e.exports = function (e) {
        return n || (n = new i(null)), n.generate(e);
      }, e.exports.Rand = i, i.prototype.generate = function (e) {
        return this._rand(e);
      }, i.prototype._rand = function (e) {
        if (this.rand.getBytes) return this.rand.getBytes(e);

        for (var t = new Uint8Array(e), r = 0; r < t.length; r++) {
          t[r] = this.rand.getByte();
        }

        return t;
      }, "object" == typeof self) self.crypto && self.crypto.getRandomValues ? i.prototype._rand = function (e) {
        var t = new Uint8Array(e);
        return self.crypto.getRandomValues(t), t;
      } : self.msCrypto && self.msCrypto.getRandomValues ? i.prototype._rand = function (e) {
        var t = new Uint8Array(e);
        return self.msCrypto.getRandomValues(t), t;
      } : "object" == typeof window && (i.prototype._rand = function () {
        throw new Error("Not implemented yet");
      });else try {
        var o = r(6113);
        if ("function" != typeof o.randomBytes) throw new Error("Not supported");

        i.prototype._rand = function (e) {
          return o.randomBytes(e);
        };
      } catch (e) {}
    },
    7191: function _(e, t, r) {
      var n = r(8162);
      e.exports = n("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz");
    },
    1653: function _(e, t, r) {
      "use strict";

      var n = r(3935).validate,
          i = {
        q: 0,
        p: 1,
        z: 2,
        r: 3,
        y: 4,
        9: 5,
        x: 6,
        8: 7,
        g: 8,
        f: 9,
        2: 10,
        t: 11,
        v: 12,
        d: 13,
        w: 14,
        0: 15,
        s: 16,
        3: 17,
        j: 18,
        n: 19,
        5: 20,
        4: 21,
        k: 22,
        h: 23,
        c: 24,
        e: 25,
        6: 26,
        m: 27,
        u: 28,
        a: 29,
        7: 30,
        l: 31
      };
      e.exports = {
        encode: function encode(e) {
          n(e instanceof Uint8Array, "Invalid data: " + e + ".");

          for (var t = "", r = 0; r < e.length; ++r) {
            var i = e[r];
            n(0 <= i && i < 32, "Invalid value: " + i + "."), t += "qpzry9x8gf2tvdw0s3jn54khce6mua7l"[i];
          }

          return t;
        },
        decode: function decode(e) {
          n("string" == typeof e, "Invalid base32-encoded string: " + e + ".");

          for (var t = new Uint8Array(e.length), r = 0; r < e.length; ++r) {
            var o = e[r];
            n(o in i, "Invalid value: " + o + "."), t[r] = i[o];
          }

          return t;
        }
      };
    },
    7707: function _(e, t, r) {
      "use strict";

      var n = r(1653),
          i = r(4736),
          o = r(3249),
          a = r(3935),
          c = a.validate,
          s = a.ValidationError,
          f = ["bitcoincash", "bchtest", "bchreg"];

      function d(e) {
        for (var t = new Uint8Array(e.length), r = 0; r < e.length; ++r) {
          t[r] = 31 & e[r].charCodeAt(0);
        }

        return t;
      }

      function u(e, t) {
        var r = new Uint8Array(e.length + t.length);
        return r.set(e), r.set(t, e.length), r;
      }

      function h(e) {
        for (var t = [656907472481, 522768456162, 0xf33e5fb3c4, 748107326120, 130178868336], r = i(1), n = 0; n < e.length; ++n) {
          var o = e[n],
              a = r.shiftRight(35);
          r = r.and(34359738367).shiftLeft(5).xor(o);

          for (var c = 0; c < t.length; ++c) {
            a.shiftRight(c).and(1).equals(1) && (r = r.xor(t[c]));
          }
        }

        return r.xor(1);
      }

      function l(e) {
        return e === e.toLowerCase() || e === e.toUpperCase();
      }

      e.exports = {
        encode: function encode(e, t, r) {
          c("string" == typeof e && function (e) {
            return l(e) && -1 !== f.indexOf(e.toLowerCase());
          }(e), "Invalid prefix: " + e + "."), c("string" == typeof t, "Invalid type: " + t + "."), c(r instanceof Uint8Array, "Invalid hash: " + r + ".");

          var i,
              a = u(d(e), new Uint8Array(1)),
              p = function (e) {
            switch (e) {
              case "P2PKH":
                return 0;

              case "P2SH":
                return 8;

              default:
                throw new s("Invalid type: " + e + ".");
            }
          }(t) + function (e) {
            switch (8 * e.length) {
              case 160:
                return 0;

              case 192:
                return 1;

              case 224:
                return 2;

              case 256:
                return 3;

              case 320:
                return 4;

              case 384:
                return 5;

              case 448:
                return 6;

              case 512:
                return 7;

              default:
                throw new s("Invalid hash size: " + e.length + ".");
            }
          }(r),
              m = (i = u(new Uint8Array([p]), r), o(i, 8, 5)),
              b = u(u(a, m), new Uint8Array(8)),
              g = u(m, function (e) {
            for (var t = new Uint8Array(8), r = 0; r < 8; ++r) {
              t[7 - r] = e.and(31).toJSNumber(), e = e.shiftRight(5);
            }

            return t;
          }(h(b)));

          return e + ":" + n.encode(g);
        },
        decode: function decode(e) {
          c("string" == typeof e && l(e), "Invalid address: " + e + ".");
          var t = e.toLowerCase().split(":");
          c(2 === t.length, "Missing prefix: " + e + ".");
          var r = t[0],
              i = n.decode(t[1]);
          c(function (e, t) {
            var r = u(d(e), new Uint8Array(1));
            return h(u(r, t)).equals(0);
          }(r, i), "Invalid checksum: " + e + ".");
          var a,
              f = (a = i.subarray(0, -8), o(a, 5, 8, !0)),
              p = f[0],
              m = f.subarray(1);
          c(function (e) {
            switch (7 & e) {
              case 0:
                return 160;

              case 1:
                return 192;

              case 2:
                return 224;

              case 3:
                return 256;

              case 4:
                return 320;

              case 5:
                return 384;

              case 6:
                return 448;

              case 7:
                return 512;
            }
          }(p) === 8 * m.length, "Invalid hash size: " + e + ".");

          var b = function (e) {
            switch (120 & e) {
              case 0:
                return "P2PKH";

              case 8:
                return "P2SH";

              default:
                throw new s("Invalid address type in version byte: " + e + ".");
            }
          }(p);

          return {
            prefix: r,
            type: b,
            hash: m
          };
        },
        ValidationError: s
      };
    },
    3249: function _(e, t, r) {
      "use strict";

      var n = r(3935).validate;

      e.exports = function (e, t, r, i) {
        for (var o = i ? Math.floor(e.length * t / r) : Math.ceil(e.length * t / r), a = (1 << r) - 1, c = new Uint8Array(o), s = 0, f = 0, d = 0, u = 0; u < e.length; ++u) {
          var h = e[u];

          for (n(0 <= h && h >> t == 0, "Invalid value: " + h + "."), f = f << t | h, d += t; d >= r;) {
            d -= r, c[s] = f >> d & a, ++s;
          }
        }

        return i ? n(d < t && 0 == (f << r - d & a), "Input cannot be converted to " + r + " bits without padding, but strict mode was used.") : d > 0 && (c[s] = f << r - d & a, ++s), c;
      };
    },
    3935: function _(e) {
      "use strict";

      function t(e) {
        var t = new Error();
        this.name = t.name = "ValidationError", this.message = t.message = e, this.stack = t.stack;
      }

      t.prototype = Object.create(Error.prototype), e.exports = {
        ValidationError: t,
        validate: function validate(e, r) {
          if (!e) throw new t(r);
        }
      };
    },
    9913: function _(e, t, r) {
      e.exports = r(6113).createHash;
    },
    6266: function _(e, t, r) {
      "use strict";

      var n = t;
      n.version = r(8597).i8, n.utils = r(953), n.rand = r(9931), n.curve = r(8254), n.curves = r(5427), n.ec = r(7954), n.eddsa = r(5980);
    },
    4918: function _(e, t, r) {
      "use strict";

      var n = r(3785),
          i = r(953),
          o = i.getNAF,
          a = i.getJSF,
          c = i.assert;

      function s(e, t) {
        this.type = e, this.p = new n(t.p, 16), this.red = t.prime ? n.red(t.prime) : n.mont(this.p), this.zero = new n(0).toRed(this.red), this.one = new n(1).toRed(this.red), this.two = new n(2).toRed(this.red), this.n = t.n && new n(t.n, 16), this.g = t.g && this.pointFromJSON(t.g, t.gRed), this._wnafT1 = new Array(4), this._wnafT2 = new Array(4), this._wnafT3 = new Array(4), this._wnafT4 = new Array(4), this._bitLength = this.n ? this.n.bitLength() : 0;
        var r = this.n && this.p.div(this.n);
        !r || r.cmpn(100) > 0 ? this.redN = null : (this._maxwellTrick = !0, this.redN = this.n.toRed(this.red));
      }

      function f(e, t) {
        this.curve = e, this.type = t, this.precomputed = null;
      }

      e.exports = s, s.prototype.point = function () {
        throw new Error("Not implemented");
      }, s.prototype.validate = function () {
        throw new Error("Not implemented");
      }, s.prototype._fixedNafMul = function (e, t) {
        c(e.precomputed);

        var r = e._getDoubles(),
            n = o(t, 1, this._bitLength),
            i = (1 << r.step + 1) - (r.step % 2 == 0 ? 2 : 1);

        i /= 3;
        var a,
            s,
            f = [];

        for (a = 0; a < n.length; a += r.step) {
          s = 0;

          for (var d = a + r.step - 1; d >= a; d--) {
            s = (s << 1) + n[d];
          }

          f.push(s);
        }

        for (var u = this.jpoint(null, null, null), h = this.jpoint(null, null, null), l = i; l > 0; l--) {
          for (a = 0; a < f.length; a++) {
            (s = f[a]) === l ? h = h.mixedAdd(r.points[a]) : s === -l && (h = h.mixedAdd(r.points[a].neg()));
          }

          u = u.add(h);
        }

        return u.toP();
      }, s.prototype._wnafMul = function (e, t) {
        var r = 4,
            n = e._getNAFPoints(r);

        r = n.wnd;

        for (var i = n.points, a = o(t, r, this._bitLength), s = this.jpoint(null, null, null), f = a.length - 1; f >= 0; f--) {
          for (var d = 0; f >= 0 && 0 === a[f]; f--) {
            d++;
          }

          if (f >= 0 && d++, s = s.dblp(d), f < 0) break;
          var u = a[f];
          c(0 !== u), s = "affine" === e.type ? u > 0 ? s.mixedAdd(i[u - 1 >> 1]) : s.mixedAdd(i[-u - 1 >> 1].neg()) : u > 0 ? s.add(i[u - 1 >> 1]) : s.add(i[-u - 1 >> 1].neg());
        }

        return "affine" === e.type ? s.toP() : s;
      }, s.prototype._wnafMulAdd = function (e, t, r, n, i) {
        var c,
            s,
            f,
            d = this._wnafT1,
            u = this._wnafT2,
            h = this._wnafT3,
            l = 0;

        for (c = 0; c < n; c++) {
          var p = (f = t[c])._getNAFPoints(e);

          d[c] = p.wnd, u[c] = p.points;
        }

        for (c = n - 1; c >= 1; c -= 2) {
          var m = c - 1,
              b = c;

          if (1 === d[m] && 1 === d[b]) {
            var g = [t[m], null, null, t[b]];
            0 === t[m].y.cmp(t[b].y) ? (g[1] = t[m].add(t[b]), g[2] = t[m].toJ().mixedAdd(t[b].neg())) : 0 === t[m].y.cmp(t[b].y.redNeg()) ? (g[1] = t[m].toJ().mixedAdd(t[b]), g[2] = t[m].add(t[b].neg())) : (g[1] = t[m].toJ().mixedAdd(t[b]), g[2] = t[m].toJ().mixedAdd(t[b].neg()));
            var v = [-3, -1, -5, -7, 0, 7, 5, 1, 3],
                y = a(r[m], r[b]);

            for (l = Math.max(y[0].length, l), h[m] = new Array(l), h[b] = new Array(l), s = 0; s < l; s++) {
              var w = 0 | y[0][s],
                  A = 0 | y[1][s];
              h[m][s] = v[3 * (w + 1) + (A + 1)], h[b][s] = 0, u[m] = g;
            }
          } else h[m] = o(r[m], d[m], this._bitLength), h[b] = o(r[b], d[b], this._bitLength), l = Math.max(h[m].length, l), l = Math.max(h[b].length, l);
        }

        var _ = this.jpoint(null, null, null),
            M = this._wnafT4;

        for (c = l; c >= 0; c--) {
          for (var x = 0; c >= 0;) {
            var k = !0;

            for (s = 0; s < n; s++) {
              M[s] = 0 | h[s][c], 0 !== M[s] && (k = !1);
            }

            if (!k) break;
            x++, c--;
          }

          if (c >= 0 && x++, _ = _.dblp(x), c < 0) break;

          for (s = 0; s < n; s++) {
            var E = M[s];
            0 !== E && (E > 0 ? f = u[s][E - 1 >> 1] : E < 0 && (f = u[s][-E - 1 >> 1].neg()), _ = "affine" === f.type ? _.mixedAdd(f) : _.add(f));
          }
        }

        for (c = 0; c < n; c++) {
          u[c] = null;
        }

        return i ? _ : _.toP();
      }, s.BasePoint = f, f.prototype.eq = function () {
        throw new Error("Not implemented");
      }, f.prototype.validate = function () {
        return this.curve.validate(this);
      }, s.prototype.decodePoint = function (e, t) {
        e = i.toArray(e, t);
        var r = this.p.byteLength();
        if ((4 === e[0] || 6 === e[0] || 7 === e[0]) && e.length - 1 == 2 * r) return 6 === e[0] ? c(e[e.length - 1] % 2 == 0) : 7 === e[0] && c(e[e.length - 1] % 2 == 1), this.point(e.slice(1, 1 + r), e.slice(1 + r, 1 + 2 * r));
        if ((2 === e[0] || 3 === e[0]) && e.length - 1 === r) return this.pointFromX(e.slice(1, 1 + r), 3 === e[0]);
        throw new Error("Unknown point format");
      }, f.prototype.encodeCompressed = function (e) {
        return this.encode(e, !0);
      }, f.prototype._encode = function (e) {
        var t = this.curve.p.byteLength(),
            r = this.getX().toArray("be", t);
        return e ? [this.getY().isEven() ? 2 : 3].concat(r) : [4].concat(r, this.getY().toArray("be", t));
      }, f.prototype.encode = function (e, t) {
        return i.encode(this._encode(t), e);
      }, f.prototype.precompute = function (e) {
        if (this.precomputed) return this;
        var t = {
          doubles: null,
          naf: null,
          beta: null
        };
        return t.naf = this._getNAFPoints(8), t.doubles = this._getDoubles(4, e), t.beta = this._getBeta(), this.precomputed = t, this;
      }, f.prototype._hasDoubles = function (e) {
        if (!this.precomputed) return !1;
        var t = this.precomputed.doubles;
        return !!t && t.points.length >= Math.ceil((e.bitLength() + 1) / t.step);
      }, f.prototype._getDoubles = function (e, t) {
        if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;

        for (var r = [this], n = this, i = 0; i < t; i += e) {
          for (var o = 0; o < e; o++) {
            n = n.dbl();
          }

          r.push(n);
        }

        return {
          step: e,
          points: r
        };
      }, f.prototype._getNAFPoints = function (e) {
        if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;

        for (var t = [this], r = (1 << e) - 1, n = 1 === r ? null : this.dbl(), i = 1; i < r; i++) {
          t[i] = t[i - 1].add(n);
        }

        return {
          wnd: e,
          points: t
        };
      }, f.prototype._getBeta = function () {
        return null;
      }, f.prototype.dblp = function (e) {
        for (var t = this, r = 0; r < e; r++) {
          t = t.dbl();
        }

        return t;
      };
    },
    1138: function _(e, t, r) {
      "use strict";

      var n = r(953),
          i = r(3785),
          o = r(8522),
          a = r(4918),
          c = n.assert;

      function s(e) {
        this.twisted = 1 != (0 | e.a), this.mOneA = this.twisted && -1 == (0 | e.a), this.extended = this.mOneA, a.call(this, "edwards", e), this.a = new i(e.a, 16).umod(this.red.m), this.a = this.a.toRed(this.red), this.c = new i(e.c, 16).toRed(this.red), this.c2 = this.c.redSqr(), this.d = new i(e.d, 16).toRed(this.red), this.dd = this.d.redAdd(this.d), c(!this.twisted || 0 === this.c.fromRed().cmpn(1)), this.oneC = 1 == (0 | e.c);
      }

      function f(e, t, r, n, o) {
        a.BasePoint.call(this, e, "projective"), null === t && null === r && null === n ? (this.x = this.curve.zero, this.y = this.curve.one, this.z = this.curve.one, this.t = this.curve.zero, this.zOne = !0) : (this.x = new i(t, 16), this.y = new i(r, 16), this.z = n ? new i(n, 16) : this.curve.one, this.t = o && new i(o, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.t && !this.t.red && (this.t = this.t.toRed(this.curve.red)), this.zOne = this.z === this.curve.one, this.curve.extended && !this.t && (this.t = this.x.redMul(this.y), this.zOne || (this.t = this.t.redMul(this.z.redInvm()))));
      }

      o(s, a), e.exports = s, s.prototype._mulA = function (e) {
        return this.mOneA ? e.redNeg() : this.a.redMul(e);
      }, s.prototype._mulC = function (e) {
        return this.oneC ? e : this.c.redMul(e);
      }, s.prototype.jpoint = function (e, t, r, n) {
        return this.point(e, t, r, n);
      }, s.prototype.pointFromX = function (e, t) {
        (e = new i(e, 16)).red || (e = e.toRed(this.red));
        var r = e.redSqr(),
            n = this.c2.redSub(this.a.redMul(r)),
            o = this.one.redSub(this.c2.redMul(this.d).redMul(r)),
            a = n.redMul(o.redInvm()),
            c = a.redSqrt();
        if (0 !== c.redSqr().redSub(a).cmp(this.zero)) throw new Error("invalid point");
        var s = c.fromRed().isOdd();
        return (t && !s || !t && s) && (c = c.redNeg()), this.point(e, c);
      }, s.prototype.pointFromY = function (e, t) {
        (e = new i(e, 16)).red || (e = e.toRed(this.red));
        var r = e.redSqr(),
            n = r.redSub(this.c2),
            o = r.redMul(this.d).redMul(this.c2).redSub(this.a),
            a = n.redMul(o.redInvm());

        if (0 === a.cmp(this.zero)) {
          if (t) throw new Error("invalid point");
          return this.point(this.zero, e);
        }

        var c = a.redSqrt();
        if (0 !== c.redSqr().redSub(a).cmp(this.zero)) throw new Error("invalid point");
        return c.fromRed().isOdd() !== t && (c = c.redNeg()), this.point(c, e);
      }, s.prototype.validate = function (e) {
        if (e.isInfinity()) return !0;
        e.normalize();
        var t = e.x.redSqr(),
            r = e.y.redSqr(),
            n = t.redMul(this.a).redAdd(r),
            i = this.c2.redMul(this.one.redAdd(this.d.redMul(t).redMul(r)));
        return 0 === n.cmp(i);
      }, o(f, a.BasePoint), s.prototype.pointFromJSON = function (e) {
        return f.fromJSON(this, e);
      }, s.prototype.point = function (e, t, r, n) {
        return new f(this, e, t, r, n);
      }, f.fromJSON = function (e, t) {
        return new f(e, t[0], t[1], t[2]);
      }, f.prototype.inspect = function () {
        return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
      }, f.prototype.isInfinity = function () {
        return 0 === this.x.cmpn(0) && (0 === this.y.cmp(this.z) || this.zOne && 0 === this.y.cmp(this.curve.c));
      }, f.prototype._extDbl = function () {
        var e = this.x.redSqr(),
            t = this.y.redSqr(),
            r = this.z.redSqr();
        r = r.redIAdd(r);

        var n = this.curve._mulA(e),
            i = this.x.redAdd(this.y).redSqr().redISub(e).redISub(t),
            o = n.redAdd(t),
            a = o.redSub(r),
            c = n.redSub(t),
            s = i.redMul(a),
            f = o.redMul(c),
            d = i.redMul(c),
            u = a.redMul(o);

        return this.curve.point(s, f, u, d);
      }, f.prototype._projDbl = function () {
        var e,
            t,
            r,
            n,
            i,
            o,
            a = this.x.redAdd(this.y).redSqr(),
            c = this.x.redSqr(),
            s = this.y.redSqr();

        if (this.curve.twisted) {
          var f = (n = this.curve._mulA(c)).redAdd(s);

          this.zOne ? (e = a.redSub(c).redSub(s).redMul(f.redSub(this.curve.two)), t = f.redMul(n.redSub(s)), r = f.redSqr().redSub(f).redSub(f)) : (i = this.z.redSqr(), o = f.redSub(i).redISub(i), e = a.redSub(c).redISub(s).redMul(o), t = f.redMul(n.redSub(s)), r = f.redMul(o));
        } else n = c.redAdd(s), i = this.curve._mulC(this.z).redSqr(), o = n.redSub(i).redSub(i), e = this.curve._mulC(a.redISub(n)).redMul(o), t = this.curve._mulC(n).redMul(c.redISub(s)), r = n.redMul(o);

        return this.curve.point(e, t, r);
      }, f.prototype.dbl = function () {
        return this.isInfinity() ? this : this.curve.extended ? this._extDbl() : this._projDbl();
      }, f.prototype._extAdd = function (e) {
        var t = this.y.redSub(this.x).redMul(e.y.redSub(e.x)),
            r = this.y.redAdd(this.x).redMul(e.y.redAdd(e.x)),
            n = this.t.redMul(this.curve.dd).redMul(e.t),
            i = this.z.redMul(e.z.redAdd(e.z)),
            o = r.redSub(t),
            a = i.redSub(n),
            c = i.redAdd(n),
            s = r.redAdd(t),
            f = o.redMul(a),
            d = c.redMul(s),
            u = o.redMul(s),
            h = a.redMul(c);
        return this.curve.point(f, d, h, u);
      }, f.prototype._projAdd = function (e) {
        var t,
            r,
            n = this.z.redMul(e.z),
            i = n.redSqr(),
            o = this.x.redMul(e.x),
            a = this.y.redMul(e.y),
            c = this.curve.d.redMul(o).redMul(a),
            s = i.redSub(c),
            f = i.redAdd(c),
            d = this.x.redAdd(this.y).redMul(e.x.redAdd(e.y)).redISub(o).redISub(a),
            u = n.redMul(s).redMul(d);
        return this.curve.twisted ? (t = n.redMul(f).redMul(a.redSub(this.curve._mulA(o))), r = s.redMul(f)) : (t = n.redMul(f).redMul(a.redSub(o)), r = this.curve._mulC(s).redMul(f)), this.curve.point(u, t, r);
      }, f.prototype.add = function (e) {
        return this.isInfinity() ? e : e.isInfinity() ? this : this.curve.extended ? this._extAdd(e) : this._projAdd(e);
      }, f.prototype.mul = function (e) {
        return this._hasDoubles(e) ? this.curve._fixedNafMul(this, e) : this.curve._wnafMul(this, e);
      }, f.prototype.mulAdd = function (e, t, r) {
        return this.curve._wnafMulAdd(1, [this, t], [e, r], 2, !1);
      }, f.prototype.jmulAdd = function (e, t, r) {
        return this.curve._wnafMulAdd(1, [this, t], [e, r], 2, !0);
      }, f.prototype.normalize = function () {
        if (this.zOne) return this;
        var e = this.z.redInvm();
        return this.x = this.x.redMul(e), this.y = this.y.redMul(e), this.t && (this.t = this.t.redMul(e)), this.z = this.curve.one, this.zOne = !0, this;
      }, f.prototype.neg = function () {
        return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
      }, f.prototype.getX = function () {
        return this.normalize(), this.x.fromRed();
      }, f.prototype.getY = function () {
        return this.normalize(), this.y.fromRed();
      }, f.prototype.eq = function (e) {
        return this === e || 0 === this.getX().cmp(e.getX()) && 0 === this.getY().cmp(e.getY());
      }, f.prototype.eqXToP = function (e) {
        var t = e.toRed(this.curve.red).redMul(this.z);
        if (0 === this.x.cmp(t)) return !0;

        for (var r = e.clone(), n = this.curve.redN.redMul(this.z);;) {
          if (r.iadd(this.curve.n), r.cmp(this.curve.p) >= 0) return !1;
          if (t.redIAdd(n), 0 === this.x.cmp(t)) return !0;
        }
      }, f.prototype.toP = f.prototype.normalize, f.prototype.mixedAdd = f.prototype.add;
    },
    8254: function _(e, t, r) {
      "use strict";

      var n = t;
      n.base = r(4918), n.short = r(6673), n.mont = r(2881), n.edwards = r(1138);
    },
    2881: function _(e, t, r) {
      "use strict";

      var n = r(3785),
          i = r(8522),
          o = r(4918),
          a = r(953);

      function c(e) {
        o.call(this, "mont", e), this.a = new n(e.a, 16).toRed(this.red), this.b = new n(e.b, 16).toRed(this.red), this.i4 = new n(4).toRed(this.red).redInvm(), this.two = new n(2).toRed(this.red), this.a24 = this.i4.redMul(this.a.redAdd(this.two));
      }

      function s(e, t, r) {
        o.BasePoint.call(this, e, "projective"), null === t && null === r ? (this.x = this.curve.one, this.z = this.curve.zero) : (this.x = new n(t, 16), this.z = new n(r, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)));
      }

      i(c, o), e.exports = c, c.prototype.validate = function (e) {
        var t = e.normalize().x,
            r = t.redSqr(),
            n = r.redMul(t).redAdd(r.redMul(this.a)).redAdd(t);
        return 0 === n.redSqrt().redSqr().cmp(n);
      }, i(s, o.BasePoint), c.prototype.decodePoint = function (e, t) {
        return this.point(a.toArray(e, t), 1);
      }, c.prototype.point = function (e, t) {
        return new s(this, e, t);
      }, c.prototype.pointFromJSON = function (e) {
        return s.fromJSON(this, e);
      }, s.prototype.precompute = function () {}, s.prototype._encode = function () {
        return this.getX().toArray("be", this.curve.p.byteLength());
      }, s.fromJSON = function (e, t) {
        return new s(e, t[0], t[1] || e.one);
      }, s.prototype.inspect = function () {
        return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
      }, s.prototype.isInfinity = function () {
        return 0 === this.z.cmpn(0);
      }, s.prototype.dbl = function () {
        var e = this.x.redAdd(this.z).redSqr(),
            t = this.x.redSub(this.z).redSqr(),
            r = e.redSub(t),
            n = e.redMul(t),
            i = r.redMul(t.redAdd(this.curve.a24.redMul(r)));
        return this.curve.point(n, i);
      }, s.prototype.add = function () {
        throw new Error("Not supported on Montgomery curve");
      }, s.prototype.diffAdd = function (e, t) {
        var r = this.x.redAdd(this.z),
            n = this.x.redSub(this.z),
            i = e.x.redAdd(e.z),
            o = e.x.redSub(e.z).redMul(r),
            a = i.redMul(n),
            c = t.z.redMul(o.redAdd(a).redSqr()),
            s = t.x.redMul(o.redISub(a).redSqr());
        return this.curve.point(c, s);
      }, s.prototype.mul = function (e) {
        for (var t = e.clone(), r = this, n = this.curve.point(null, null), i = []; 0 !== t.cmpn(0); t.iushrn(1)) {
          i.push(t.andln(1));
        }

        for (var o = i.length - 1; o >= 0; o--) {
          0 === i[o] ? (r = r.diffAdd(n, this), n = n.dbl()) : (n = r.diffAdd(n, this), r = r.dbl());
        }

        return n;
      }, s.prototype.mulAdd = function () {
        throw new Error("Not supported on Montgomery curve");
      }, s.prototype.jumlAdd = function () {
        throw new Error("Not supported on Montgomery curve");
      }, s.prototype.eq = function (e) {
        return 0 === this.getX().cmp(e.getX());
      }, s.prototype.normalize = function () {
        return this.x = this.x.redMul(this.z.redInvm()), this.z = this.curve.one, this;
      }, s.prototype.getX = function () {
        return this.normalize(), this.x.fromRed();
      };
    },
    6673: function _(e, t, r) {
      "use strict";

      var n = r(953),
          i = r(3785),
          o = r(8522),
          a = r(4918),
          c = n.assert;

      function s(e) {
        a.call(this, "short", e), this.a = new i(e.a, 16).toRed(this.red), this.b = new i(e.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = 0 === this.a.fromRed().cmpn(0), this.threeA = 0 === this.a.fromRed().sub(this.p).cmpn(-3), this.endo = this._getEndomorphism(e), this._endoWnafT1 = new Array(4), this._endoWnafT2 = new Array(4);
      }

      function f(e, t, r, n) {
        a.BasePoint.call(this, e, "affine"), null === t && null === r ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new i(t, 16), this.y = new i(r, 16), n && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
      }

      function d(e, t, r, n) {
        a.BasePoint.call(this, e, "jacobian"), null === t && null === r && null === n ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new i(0)) : (this.x = new i(t, 16), this.y = new i(r, 16), this.z = new i(n, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
      }

      o(s, a), e.exports = s, s.prototype._getEndomorphism = function (e) {
        if (this.zeroA && this.g && this.n && 1 === this.p.modn(3)) {
          var t, r;
          if (e.beta) t = new i(e.beta, 16).toRed(this.red);else {
            var n = this._getEndoRoots(this.p);

            t = (t = n[0].cmp(n[1]) < 0 ? n[0] : n[1]).toRed(this.red);
          }
          if (e.lambda) r = new i(e.lambda, 16);else {
            var o = this._getEndoRoots(this.n);

            0 === this.g.mul(o[0]).x.cmp(this.g.x.redMul(t)) ? r = o[0] : (r = o[1], c(0 === this.g.mul(r).x.cmp(this.g.x.redMul(t))));
          }
          return {
            beta: t,
            lambda: r,
            basis: e.basis ? e.basis.map(function (e) {
              return {
                a: new i(e.a, 16),
                b: new i(e.b, 16)
              };
            }) : this._getEndoBasis(r)
          };
        }
      }, s.prototype._getEndoRoots = function (e) {
        var t = e === this.p ? this.red : i.mont(e),
            r = new i(2).toRed(t).redInvm(),
            n = r.redNeg(),
            o = new i(3).toRed(t).redNeg().redSqrt().redMul(r);
        return [n.redAdd(o).fromRed(), n.redSub(o).fromRed()];
      }, s.prototype._getEndoBasis = function (e) {
        for (var t, r, n, o, a, c, s, f, d, u = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), h = e, l = this.n.clone(), p = new i(1), m = new i(0), b = new i(0), g = new i(1), v = 0; 0 !== h.cmpn(0);) {
          var y = l.div(h);
          f = l.sub(y.mul(h)), d = b.sub(y.mul(p));
          var w = g.sub(y.mul(m));
          if (!n && f.cmp(u) < 0) t = s.neg(), r = p, n = f.neg(), o = d;else if (n && 2 == ++v) break;
          s = f, l = h, h = f, b = p, p = d, g = m, m = w;
        }

        a = f.neg(), c = d;
        var A = n.sqr().add(o.sqr());
        return a.sqr().add(c.sqr()).cmp(A) >= 0 && (a = t, c = r), n.negative && (n = n.neg(), o = o.neg()), a.negative && (a = a.neg(), c = c.neg()), [{
          a: n,
          b: o
        }, {
          a: a,
          b: c
        }];
      }, s.prototype._endoSplit = function (e) {
        var t = this.endo.basis,
            r = t[0],
            n = t[1],
            i = n.b.mul(e).divRound(this.n),
            o = r.b.neg().mul(e).divRound(this.n),
            a = i.mul(r.a),
            c = o.mul(n.a),
            s = i.mul(r.b),
            f = o.mul(n.b);
        return {
          k1: e.sub(a).sub(c),
          k2: s.add(f).neg()
        };
      }, s.prototype.pointFromX = function (e, t) {
        (e = new i(e, 16)).red || (e = e.toRed(this.red));
        var r = e.redSqr().redMul(e).redIAdd(e.redMul(this.a)).redIAdd(this.b),
            n = r.redSqrt();
        if (0 !== n.redSqr().redSub(r).cmp(this.zero)) throw new Error("invalid point");
        var o = n.fromRed().isOdd();
        return (t && !o || !t && o) && (n = n.redNeg()), this.point(e, n);
      }, s.prototype.validate = function (e) {
        if (e.inf) return !0;
        var t = e.x,
            r = e.y,
            n = this.a.redMul(t),
            i = t.redSqr().redMul(t).redIAdd(n).redIAdd(this.b);
        return 0 === r.redSqr().redISub(i).cmpn(0);
      }, s.prototype._endoWnafMulAdd = function (e, t, r) {
        for (var n = this._endoWnafT1, i = this._endoWnafT2, o = 0; o < e.length; o++) {
          var a = this._endoSplit(t[o]),
              c = e[o],
              s = c._getBeta();

          a.k1.negative && (a.k1.ineg(), c = c.neg(!0)), a.k2.negative && (a.k2.ineg(), s = s.neg(!0)), n[2 * o] = c, n[2 * o + 1] = s, i[2 * o] = a.k1, i[2 * o + 1] = a.k2;
        }

        for (var f = this._wnafMulAdd(1, n, i, 2 * o, r), d = 0; d < 2 * o; d++) {
          n[d] = null, i[d] = null;
        }

        return f;
      }, o(f, a.BasePoint), s.prototype.point = function (e, t, r) {
        return new f(this, e, t, r);
      }, s.prototype.pointFromJSON = function (e, t) {
        return f.fromJSON(this, e, t);
      }, f.prototype._getBeta = function () {
        if (this.curve.endo) {
          var e = this.precomputed;
          if (e && e.beta) return e.beta;
          var t = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);

          if (e) {
            var r = this.curve,
                n = function n(e) {
              return r.point(e.x.redMul(r.endo.beta), e.y);
            };

            e.beta = t, t.precomputed = {
              beta: null,
              naf: e.naf && {
                wnd: e.naf.wnd,
                points: e.naf.points.map(n)
              },
              doubles: e.doubles && {
                step: e.doubles.step,
                points: e.doubles.points.map(n)
              }
            };
          }

          return t;
        }
      }, f.prototype.toJSON = function () {
        return this.precomputed ? [this.x, this.y, this.precomputed && {
          doubles: this.precomputed.doubles && {
            step: this.precomputed.doubles.step,
            points: this.precomputed.doubles.points.slice(1)
          },
          naf: this.precomputed.naf && {
            wnd: this.precomputed.naf.wnd,
            points: this.precomputed.naf.points.slice(1)
          }
        }] : [this.x, this.y];
      }, f.fromJSON = function (e, t, r) {
        "string" == typeof t && (t = JSON.parse(t));
        var n = e.point(t[0], t[1], r);
        if (!t[2]) return n;

        function i(t) {
          return e.point(t[0], t[1], r);
        }

        var o = t[2];
        return n.precomputed = {
          beta: null,
          doubles: o.doubles && {
            step: o.doubles.step,
            points: [n].concat(o.doubles.points.map(i))
          },
          naf: o.naf && {
            wnd: o.naf.wnd,
            points: [n].concat(o.naf.points.map(i))
          }
        }, n;
      }, f.prototype.inspect = function () {
        return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
      }, f.prototype.isInfinity = function () {
        return this.inf;
      }, f.prototype.add = function (e) {
        if (this.inf) return e;
        if (e.inf) return this;
        if (this.eq(e)) return this.dbl();
        if (this.neg().eq(e)) return this.curve.point(null, null);
        if (0 === this.x.cmp(e.x)) return this.curve.point(null, null);
        var t = this.y.redSub(e.y);
        0 !== t.cmpn(0) && (t = t.redMul(this.x.redSub(e.x).redInvm()));
        var r = t.redSqr().redISub(this.x).redISub(e.x),
            n = t.redMul(this.x.redSub(r)).redISub(this.y);
        return this.curve.point(r, n);
      }, f.prototype.dbl = function () {
        if (this.inf) return this;
        var e = this.y.redAdd(this.y);
        if (0 === e.cmpn(0)) return this.curve.point(null, null);
        var t = this.curve.a,
            r = this.x.redSqr(),
            n = e.redInvm(),
            i = r.redAdd(r).redIAdd(r).redIAdd(t).redMul(n),
            o = i.redSqr().redISub(this.x.redAdd(this.x)),
            a = i.redMul(this.x.redSub(o)).redISub(this.y);
        return this.curve.point(o, a);
      }, f.prototype.getX = function () {
        return this.x.fromRed();
      }, f.prototype.getY = function () {
        return this.y.fromRed();
      }, f.prototype.mul = function (e) {
        return e = new i(e, 16), this.isInfinity() ? this : this._hasDoubles(e) ? this.curve._fixedNafMul(this, e) : this.curve.endo ? this.curve._endoWnafMulAdd([this], [e]) : this.curve._wnafMul(this, e);
      }, f.prototype.mulAdd = function (e, t, r) {
        var n = [this, t],
            i = [e, r];
        return this.curve.endo ? this.curve._endoWnafMulAdd(n, i) : this.curve._wnafMulAdd(1, n, i, 2);
      }, f.prototype.jmulAdd = function (e, t, r) {
        var n = [this, t],
            i = [e, r];
        return this.curve.endo ? this.curve._endoWnafMulAdd(n, i, !0) : this.curve._wnafMulAdd(1, n, i, 2, !0);
      }, f.prototype.eq = function (e) {
        return this === e || this.inf === e.inf && (this.inf || 0 === this.x.cmp(e.x) && 0 === this.y.cmp(e.y));
      }, f.prototype.neg = function (e) {
        if (this.inf) return this;
        var t = this.curve.point(this.x, this.y.redNeg());

        if (e && this.precomputed) {
          var r = this.precomputed,
              n = function n(e) {
            return e.neg();
          };

          t.precomputed = {
            naf: r.naf && {
              wnd: r.naf.wnd,
              points: r.naf.points.map(n)
            },
            doubles: r.doubles && {
              step: r.doubles.step,
              points: r.doubles.points.map(n)
            }
          };
        }

        return t;
      }, f.prototype.toJ = function () {
        return this.inf ? this.curve.jpoint(null, null, null) : this.curve.jpoint(this.x, this.y, this.curve.one);
      }, o(d, a.BasePoint), s.prototype.jpoint = function (e, t, r) {
        return new d(this, e, t, r);
      }, d.prototype.toP = function () {
        if (this.isInfinity()) return this.curve.point(null, null);
        var e = this.z.redInvm(),
            t = e.redSqr(),
            r = this.x.redMul(t),
            n = this.y.redMul(t).redMul(e);
        return this.curve.point(r, n);
      }, d.prototype.neg = function () {
        return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
      }, d.prototype.add = function (e) {
        if (this.isInfinity()) return e;
        if (e.isInfinity()) return this;
        var t = e.z.redSqr(),
            r = this.z.redSqr(),
            n = this.x.redMul(t),
            i = e.x.redMul(r),
            o = this.y.redMul(t.redMul(e.z)),
            a = e.y.redMul(r.redMul(this.z)),
            c = n.redSub(i),
            s = o.redSub(a);
        if (0 === c.cmpn(0)) return 0 !== s.cmpn(0) ? this.curve.jpoint(null, null, null) : this.dbl();
        var f = c.redSqr(),
            d = f.redMul(c),
            u = n.redMul(f),
            h = s.redSqr().redIAdd(d).redISub(u).redISub(u),
            l = s.redMul(u.redISub(h)).redISub(o.redMul(d)),
            p = this.z.redMul(e.z).redMul(c);
        return this.curve.jpoint(h, l, p);
      }, d.prototype.mixedAdd = function (e) {
        if (this.isInfinity()) return e.toJ();
        if (e.isInfinity()) return this;
        var t = this.z.redSqr(),
            r = this.x,
            n = e.x.redMul(t),
            i = this.y,
            o = e.y.redMul(t).redMul(this.z),
            a = r.redSub(n),
            c = i.redSub(o);
        if (0 === a.cmpn(0)) return 0 !== c.cmpn(0) ? this.curve.jpoint(null, null, null) : this.dbl();
        var s = a.redSqr(),
            f = s.redMul(a),
            d = r.redMul(s),
            u = c.redSqr().redIAdd(f).redISub(d).redISub(d),
            h = c.redMul(d.redISub(u)).redISub(i.redMul(f)),
            l = this.z.redMul(a);
        return this.curve.jpoint(u, h, l);
      }, d.prototype.dblp = function (e) {
        if (0 === e) return this;
        if (this.isInfinity()) return this;
        if (!e) return this.dbl();
        var t;

        if (this.curve.zeroA || this.curve.threeA) {
          var r = this;

          for (t = 0; t < e; t++) {
            r = r.dbl();
          }

          return r;
        }

        var n = this.curve.a,
            i = this.curve.tinv,
            o = this.x,
            a = this.y,
            c = this.z,
            s = c.redSqr().redSqr(),
            f = a.redAdd(a);

        for (t = 0; t < e; t++) {
          var d = o.redSqr(),
              u = f.redSqr(),
              h = u.redSqr(),
              l = d.redAdd(d).redIAdd(d).redIAdd(n.redMul(s)),
              p = o.redMul(u),
              m = l.redSqr().redISub(p.redAdd(p)),
              b = p.redISub(m),
              g = l.redMul(b);
          g = g.redIAdd(g).redISub(h);
          var v = f.redMul(c);
          t + 1 < e && (s = s.redMul(h)), o = m, c = v, f = g;
        }

        return this.curve.jpoint(o, f.redMul(i), c);
      }, d.prototype.dbl = function () {
        return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
      }, d.prototype._zeroDbl = function () {
        var e, t, r;

        if (this.zOne) {
          var n = this.x.redSqr(),
              i = this.y.redSqr(),
              o = i.redSqr(),
              a = this.x.redAdd(i).redSqr().redISub(n).redISub(o);
          a = a.redIAdd(a);
          var c = n.redAdd(n).redIAdd(n),
              s = c.redSqr().redISub(a).redISub(a),
              f = o.redIAdd(o);
          f = (f = f.redIAdd(f)).redIAdd(f), e = s, t = c.redMul(a.redISub(s)).redISub(f), r = this.y.redAdd(this.y);
        } else {
          var d = this.x.redSqr(),
              u = this.y.redSqr(),
              h = u.redSqr(),
              l = this.x.redAdd(u).redSqr().redISub(d).redISub(h);
          l = l.redIAdd(l);
          var p = d.redAdd(d).redIAdd(d),
              m = p.redSqr(),
              b = h.redIAdd(h);
          b = (b = b.redIAdd(b)).redIAdd(b), e = m.redISub(l).redISub(l), t = p.redMul(l.redISub(e)).redISub(b), r = (r = this.y.redMul(this.z)).redIAdd(r);
        }

        return this.curve.jpoint(e, t, r);
      }, d.prototype._threeDbl = function () {
        var e, t, r;

        if (this.zOne) {
          var n = this.x.redSqr(),
              i = this.y.redSqr(),
              o = i.redSqr(),
              a = this.x.redAdd(i).redSqr().redISub(n).redISub(o);
          a = a.redIAdd(a);
          var c = n.redAdd(n).redIAdd(n).redIAdd(this.curve.a),
              s = c.redSqr().redISub(a).redISub(a);
          e = s;
          var f = o.redIAdd(o);
          f = (f = f.redIAdd(f)).redIAdd(f), t = c.redMul(a.redISub(s)).redISub(f), r = this.y.redAdd(this.y);
        } else {
          var d = this.z.redSqr(),
              u = this.y.redSqr(),
              h = this.x.redMul(u),
              l = this.x.redSub(d).redMul(this.x.redAdd(d));
          l = l.redAdd(l).redIAdd(l);
          var p = h.redIAdd(h),
              m = (p = p.redIAdd(p)).redAdd(p);
          e = l.redSqr().redISub(m), r = this.y.redAdd(this.z).redSqr().redISub(u).redISub(d);
          var b = u.redSqr();
          b = (b = (b = b.redIAdd(b)).redIAdd(b)).redIAdd(b), t = l.redMul(p.redISub(e)).redISub(b);
        }

        return this.curve.jpoint(e, t, r);
      }, d.prototype._dbl = function () {
        var e = this.curve.a,
            t = this.x,
            r = this.y,
            n = this.z,
            i = n.redSqr().redSqr(),
            o = t.redSqr(),
            a = r.redSqr(),
            c = o.redAdd(o).redIAdd(o).redIAdd(e.redMul(i)),
            s = t.redAdd(t),
            f = (s = s.redIAdd(s)).redMul(a),
            d = c.redSqr().redISub(f.redAdd(f)),
            u = f.redISub(d),
            h = a.redSqr();
        h = (h = (h = h.redIAdd(h)).redIAdd(h)).redIAdd(h);
        var l = c.redMul(u).redISub(h),
            p = r.redAdd(r).redMul(n);
        return this.curve.jpoint(d, l, p);
      }, d.prototype.trpl = function () {
        if (!this.curve.zeroA) return this.dbl().add(this);
        var e = this.x.redSqr(),
            t = this.y.redSqr(),
            r = this.z.redSqr(),
            n = t.redSqr(),
            i = e.redAdd(e).redIAdd(e),
            o = i.redSqr(),
            a = this.x.redAdd(t).redSqr().redISub(e).redISub(n),
            c = (a = (a = (a = a.redIAdd(a)).redAdd(a).redIAdd(a)).redISub(o)).redSqr(),
            s = n.redIAdd(n);
        s = (s = (s = s.redIAdd(s)).redIAdd(s)).redIAdd(s);
        var f = i.redIAdd(a).redSqr().redISub(o).redISub(c).redISub(s),
            d = t.redMul(f);
        d = (d = d.redIAdd(d)).redIAdd(d);
        var u = this.x.redMul(c).redISub(d);
        u = (u = u.redIAdd(u)).redIAdd(u);
        var h = this.y.redMul(f.redMul(s.redISub(f)).redISub(a.redMul(c)));
        h = (h = (h = h.redIAdd(h)).redIAdd(h)).redIAdd(h);
        var l = this.z.redAdd(a).redSqr().redISub(r).redISub(c);
        return this.curve.jpoint(u, h, l);
      }, d.prototype.mul = function (e, t) {
        return e = new i(e, t), this.curve._wnafMul(this, e);
      }, d.prototype.eq = function (e) {
        if ("affine" === e.type) return this.eq(e.toJ());
        if (this === e) return !0;
        var t = this.z.redSqr(),
            r = e.z.redSqr();
        if (0 !== this.x.redMul(r).redISub(e.x.redMul(t)).cmpn(0)) return !1;
        var n = t.redMul(this.z),
            i = r.redMul(e.z);
        return 0 === this.y.redMul(i).redISub(e.y.redMul(n)).cmpn(0);
      }, d.prototype.eqXToP = function (e) {
        var t = this.z.redSqr(),
            r = e.toRed(this.curve.red).redMul(t);
        if (0 === this.x.cmp(r)) return !0;

        for (var n = e.clone(), i = this.curve.redN.redMul(t);;) {
          if (n.iadd(this.curve.n), n.cmp(this.curve.p) >= 0) return !1;
          if (r.redIAdd(i), 0 === this.x.cmp(r)) return !0;
        }
      }, d.prototype.inspect = function () {
        return this.isInfinity() ? "<EC JPoint Infinity>" : "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
      }, d.prototype.isInfinity = function () {
        return 0 === this.z.cmpn(0);
      };
    },
    5427: function _(e, t, r) {
      "use strict";

      var n,
          i = t,
          o = r(3715),
          a = r(8254),
          c = r(953).assert;

      function s(e) {
        "short" === e.type ? this.curve = new a.short(e) : "edwards" === e.type ? this.curve = new a.edwards(e) : this.curve = new a.mont(e), this.g = this.curve.g, this.n = this.curve.n, this.hash = e.hash, c(this.g.validate(), "Invalid curve"), c(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
      }

      function f(e, t) {
        Object.defineProperty(i, e, {
          configurable: !0,
          enumerable: !0,
          get: function get() {
            var r = new s(t);
            return Object.defineProperty(i, e, {
              configurable: !0,
              enumerable: !0,
              value: r
            }), r;
          }
        });
      }

      i.PresetCurve = s, f("p192", {
        type: "short",
        prime: "p192",
        p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
        a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
        b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
        n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
        hash: o.sha256,
        gRed: !1,
        g: ["188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012", "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"]
      }), f("p224", {
        type: "short",
        prime: "p224",
        p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
        a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
        b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
        n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
        hash: o.sha256,
        gRed: !1,
        g: ["b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21", "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"]
      }), f("p256", {
        type: "short",
        prime: null,
        p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
        a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
        b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
        n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
        hash: o.sha256,
        gRed: !1,
        g: ["6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296", "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"]
      }), f("p384", {
        type: "short",
        prime: null,
        p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
        a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
        b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
        n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
        hash: o.sha384,
        gRed: !1,
        g: ["aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7", "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"]
      }), f("p521", {
        type: "short",
        prime: null,
        p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
        a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
        b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
        n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
        hash: o.sha512,
        gRed: !1,
        g: ["000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66", "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"]
      }), f("curve25519", {
        type: "mont",
        prime: "p25519",
        p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
        a: "76d06",
        b: "1",
        n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
        hash: o.sha256,
        gRed: !1,
        g: ["9"]
      }), f("ed25519", {
        type: "edwards",
        prime: "p25519",
        p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
        a: "-1",
        c: "1",
        d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
        n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
        hash: o.sha256,
        gRed: !1,
        g: ["216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a", "6666666666666666666666666666666666666666666666666666666666666658"]
      });

      try {
        n = r(1037);
      } catch (e) {
        n = void 0;
      }

      f("secp256k1", {
        type: "short",
        prime: "k256",
        p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
        a: "0",
        b: "7",
        n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
        h: "1",
        hash: o.sha256,
        beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
        lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
        basis: [{
          a: "3086d221a7d46bcde86c90e49284eb15",
          b: "-e4437ed6010e88286f547fa90abfe4c3"
        }, {
          a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
          b: "3086d221a7d46bcde86c90e49284eb15"
        }],
        gRed: !1,
        g: ["79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798", "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8", n]
      });
    },
    7954: function _(e, t, r) {
      "use strict";

      var n = r(3785),
          i = r(2156),
          o = r(953),
          a = r(5427),
          c = r(9931),
          s = o.assert,
          f = r(1251),
          d = r(611);

      function u(e) {
        if (!(this instanceof u)) return new u(e);
        "string" == typeof e && (s(Object.prototype.hasOwnProperty.call(a, e), "Unknown curve " + e), e = a[e]), e instanceof a.PresetCurve && (e = {
          curve: e
        }), this.curve = e.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = e.curve.g, this.g.precompute(e.curve.n.bitLength() + 1), this.hash = e.hash || e.curve.hash;
      }

      e.exports = u, u.prototype.keyPair = function (e) {
        return new f(this, e);
      }, u.prototype.keyFromPrivate = function (e, t) {
        return f.fromPrivate(this, e, t);
      }, u.prototype.keyFromPublic = function (e, t) {
        return f.fromPublic(this, e, t);
      }, u.prototype.genKeyPair = function (e) {
        e || (e = {});

        for (var t = new i({
          hash: this.hash,
          pers: e.pers,
          persEnc: e.persEnc || "utf8",
          entropy: e.entropy || c(this.hash.hmacStrength),
          entropyEnc: e.entropy && e.entropyEnc || "utf8",
          nonce: this.n.toArray()
        }), r = this.n.byteLength(), o = this.n.sub(new n(2));;) {
          var a = new n(t.generate(r));
          if (!(a.cmp(o) > 0)) return a.iaddn(1), this.keyFromPrivate(a);
        }
      }, u.prototype._truncateToN = function (e, t) {
        var r = 8 * e.byteLength() - this.n.bitLength();
        return r > 0 && (e = e.ushrn(r)), !t && e.cmp(this.n) >= 0 ? e.sub(this.n) : e;
      }, u.prototype.sign = function (e, t, r, o) {
        "object" == typeof r && (o = r, r = null), o || (o = {}), t = this.keyFromPrivate(t, r), e = this._truncateToN(new n(e, 16));

        for (var a = this.n.byteLength(), c = t.getPrivate().toArray("be", a), s = e.toArray("be", a), f = new i({
          hash: this.hash,
          entropy: c,
          nonce: s,
          pers: o.pers,
          persEnc: o.persEnc || "utf8"
        }), u = this.n.sub(new n(1)), h = 0;; h++) {
          var l = o.k ? o.k(h) : new n(f.generate(this.n.byteLength()));

          if (!((l = this._truncateToN(l, !0)).cmpn(1) <= 0 || l.cmp(u) >= 0)) {
            var p = this.g.mul(l);

            if (!p.isInfinity()) {
              var m = p.getX(),
                  b = m.umod(this.n);

              if (0 !== b.cmpn(0)) {
                var g = l.invm(this.n).mul(b.mul(t.getPrivate()).iadd(e));

                if (0 !== (g = g.umod(this.n)).cmpn(0)) {
                  var v = (p.getY().isOdd() ? 1 : 0) | (0 !== m.cmp(b) ? 2 : 0);
                  return o.canonical && g.cmp(this.nh) > 0 && (g = this.n.sub(g), v ^= 1), new d({
                    r: b,
                    s: g,
                    recoveryParam: v
                  });
                }
              }
            }
          }
        }
      }, u.prototype.verify = function (e, t, r, i) {
        e = this._truncateToN(new n(e, 16)), r = this.keyFromPublic(r, i);
        var o = (t = new d(t, "hex")).r,
            a = t.s;
        if (o.cmpn(1) < 0 || o.cmp(this.n) >= 0) return !1;
        if (a.cmpn(1) < 0 || a.cmp(this.n) >= 0) return !1;
        var c,
            s = a.invm(this.n),
            f = s.mul(e).umod(this.n),
            u = s.mul(o).umod(this.n);
        return this.curve._maxwellTrick ? !(c = this.g.jmulAdd(f, r.getPublic(), u)).isInfinity() && c.eqXToP(o) : !(c = this.g.mulAdd(f, r.getPublic(), u)).isInfinity() && 0 === c.getX().umod(this.n).cmp(o);
      }, u.prototype.recoverPubKey = function (e, t, r, i) {
        s((3 & r) === r, "The recovery param is more than two bits"), t = new d(t, i);
        var o = this.n,
            a = new n(e),
            c = t.r,
            f = t.s,
            u = 1 & r,
            h = r >> 1;
        if (c.cmp(this.curve.p.umod(this.curve.n)) >= 0 && h) throw new Error("Unable to find sencond key candinate");
        c = h ? this.curve.pointFromX(c.add(this.curve.n), u) : this.curve.pointFromX(c, u);
        var l = t.r.invm(o),
            p = o.sub(a).mul(l).umod(o),
            m = f.mul(l).umod(o);
        return this.g.mulAdd(p, c, m);
      }, u.prototype.getKeyRecoveryParam = function (e, t, r, n) {
        if (null !== (t = new d(t, n)).recoveryParam) return t.recoveryParam;

        for (var i = 0; i < 4; i++) {
          var o;

          try {
            o = this.recoverPubKey(e, t, i);
          } catch (e) {
            continue;
          }

          if (o.eq(r)) return i;
        }

        throw new Error("Unable to find valid recovery factor");
      };
    },
    1251: function _(e, t, r) {
      "use strict";

      var n = r(3785),
          i = r(953).assert;

      function o(e, t) {
        this.ec = e, this.priv = null, this.pub = null, t.priv && this._importPrivate(t.priv, t.privEnc), t.pub && this._importPublic(t.pub, t.pubEnc);
      }

      e.exports = o, o.fromPublic = function (e, t, r) {
        return t instanceof o ? t : new o(e, {
          pub: t,
          pubEnc: r
        });
      }, o.fromPrivate = function (e, t, r) {
        return t instanceof o ? t : new o(e, {
          priv: t,
          privEnc: r
        });
      }, o.prototype.validate = function () {
        var e = this.getPublic();
        return e.isInfinity() ? {
          result: !1,
          reason: "Invalid public key"
        } : e.validate() ? e.mul(this.ec.curve.n).isInfinity() ? {
          result: !0,
          reason: null
        } : {
          result: !1,
          reason: "Public key * N != O"
        } : {
          result: !1,
          reason: "Public key is not a point"
        };
      }, o.prototype.getPublic = function (e, t) {
        return "string" == typeof e && (t = e, e = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), t ? this.pub.encode(t, e) : this.pub;
      }, o.prototype.getPrivate = function (e) {
        return "hex" === e ? this.priv.toString(16, 2) : this.priv;
      }, o.prototype._importPrivate = function (e, t) {
        this.priv = new n(e, t || 16), this.priv = this.priv.umod(this.ec.curve.n);
      }, o.prototype._importPublic = function (e, t) {
        if (e.x || e.y) return "mont" === this.ec.curve.type ? i(e.x, "Need x coordinate") : "short" !== this.ec.curve.type && "edwards" !== this.ec.curve.type || i(e.x && e.y, "Need both x and y coordinate"), void (this.pub = this.ec.curve.point(e.x, e.y));
        this.pub = this.ec.curve.decodePoint(e, t);
      }, o.prototype.derive = function (e) {
        return e.validate() || i(e.validate(), "public point not validated"), e.mul(this.priv).getX();
      }, o.prototype.sign = function (e, t, r) {
        return this.ec.sign(e, this, t, r);
      }, o.prototype.verify = function (e, t) {
        return this.ec.verify(e, t, this);
      }, o.prototype.inspect = function () {
        return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
      };
    },
    611: function _(e, t, r) {
      "use strict";

      var n = r(3785),
          i = r(953),
          o = i.assert;

      function a(e, t) {
        if (e instanceof a) return e;
        this._importDER(e, t) || (o(e.r && e.s, "Signature without r or s"), this.r = new n(e.r, 16), this.s = new n(e.s, 16), void 0 === e.recoveryParam ? this.recoveryParam = null : this.recoveryParam = e.recoveryParam);
      }

      function c() {
        this.place = 0;
      }

      function s(e, t) {
        var r = e[t.place++];
        if (!(128 & r)) return r;
        var n = 15 & r;
        if (0 === n || n > 4) return !1;

        for (var i = 0, o = 0, a = t.place; o < n; o++, a++) {
          i <<= 8, i |= e[a], i >>>= 0;
        }

        return !(i <= 127) && (t.place = a, i);
      }

      function f(e) {
        for (var t = 0, r = e.length - 1; !e[t] && !(128 & e[t + 1]) && t < r;) {
          t++;
        }

        return 0 === t ? e : e.slice(t);
      }

      function d(e, t) {
        if (t < 128) e.push(t);else {
          var r = 1 + (Math.log(t) / Math.LN2 >>> 3);

          for (e.push(128 | r); --r;) {
            e.push(t >>> (r << 3) & 255);
          }

          e.push(t);
        }
      }

      e.exports = a, a.prototype._importDER = function (e, t) {
        e = i.toArray(e, t);
        var r = new c();
        if (48 !== e[r.place++]) return !1;
        var o = s(e, r);
        if (!1 === o) return !1;
        if (o + r.place !== e.length) return !1;
        if (2 !== e[r.place++]) return !1;
        var a = s(e, r);
        if (!1 === a) return !1;
        var f = e.slice(r.place, a + r.place);
        if (r.place += a, 2 !== e[r.place++]) return !1;
        var d = s(e, r);
        if (!1 === d) return !1;
        if (e.length !== d + r.place) return !1;
        var u = e.slice(r.place, d + r.place);

        if (0 === f[0]) {
          if (!(128 & f[1])) return !1;
          f = f.slice(1);
        }

        if (0 === u[0]) {
          if (!(128 & u[1])) return !1;
          u = u.slice(1);
        }

        return this.r = new n(f), this.s = new n(u), this.recoveryParam = null, !0;
      }, a.prototype.toDER = function (e) {
        var t = this.r.toArray(),
            r = this.s.toArray();

        for (128 & t[0] && (t = [0].concat(t)), 128 & r[0] && (r = [0].concat(r)), t = f(t), r = f(r); !(r[0] || 128 & r[1]);) {
          r = r.slice(1);
        }

        var n = [2];
        d(n, t.length), (n = n.concat(t)).push(2), d(n, r.length);
        var o = n.concat(r),
            a = [48];
        return d(a, o.length), a = a.concat(o), i.encode(a, e);
      };
    },
    5980: function _(e, t, r) {
      "use strict";

      var n = r(3715),
          i = r(5427),
          o = r(953),
          a = o.assert,
          c = o.parseBytes,
          s = r(9087),
          f = r(3622);

      function d(e) {
        if (a("ed25519" === e, "only tested with ed25519 so far"), !(this instanceof d)) return new d(e);
        e = i[e].curve, this.curve = e, this.g = e.g, this.g.precompute(e.n.bitLength() + 1), this.pointClass = e.point().constructor, this.encodingLength = Math.ceil(e.n.bitLength() / 8), this.hash = n.sha512;
      }

      e.exports = d, d.prototype.sign = function (e, t) {
        e = c(e);
        var r = this.keyFromSecret(t),
            n = this.hashInt(r.messagePrefix(), e),
            i = this.g.mul(n),
            o = this.encodePoint(i),
            a = this.hashInt(o, r.pubBytes(), e).mul(r.priv()),
            s = n.add(a).umod(this.curve.n);
        return this.makeSignature({
          R: i,
          S: s,
          Rencoded: o
        });
      }, d.prototype.verify = function (e, t, r) {
        e = c(e), t = this.makeSignature(t);
        var n = this.keyFromPublic(r),
            i = this.hashInt(t.Rencoded(), n.pubBytes(), e),
            o = this.g.mul(t.S());
        return t.R().add(n.pub().mul(i)).eq(o);
      }, d.prototype.hashInt = function () {
        for (var e = this.hash(), t = 0; t < arguments.length; t++) {
          e.update(arguments[t]);
        }

        return o.intFromLE(e.digest()).umod(this.curve.n);
      }, d.prototype.keyFromPublic = function (e) {
        return s.fromPublic(this, e);
      }, d.prototype.keyFromSecret = function (e) {
        return s.fromSecret(this, e);
      }, d.prototype.makeSignature = function (e) {
        return e instanceof f ? e : new f(this, e);
      }, d.prototype.encodePoint = function (e) {
        var t = e.getY().toArray("le", this.encodingLength);
        return t[this.encodingLength - 1] |= e.getX().isOdd() ? 128 : 0, t;
      }, d.prototype.decodePoint = function (e) {
        var t = (e = o.parseBytes(e)).length - 1,
            r = e.slice(0, t).concat(-129 & e[t]),
            n = 0 != (128 & e[t]),
            i = o.intFromLE(r);
        return this.curve.pointFromY(i, n);
      }, d.prototype.encodeInt = function (e) {
        return e.toArray("le", this.encodingLength);
      }, d.prototype.decodeInt = function (e) {
        return o.intFromLE(e);
      }, d.prototype.isPoint = function (e) {
        return e instanceof this.pointClass;
      };
    },
    9087: function _(e, t, r) {
      "use strict";

      var n = r(953),
          i = n.assert,
          o = n.parseBytes,
          a = n.cachedProperty;

      function c(e, t) {
        this.eddsa = e, this._secret = o(t.secret), e.isPoint(t.pub) ? this._pub = t.pub : this._pubBytes = o(t.pub);
      }

      c.fromPublic = function (e, t) {
        return t instanceof c ? t : new c(e, {
          pub: t
        });
      }, c.fromSecret = function (e, t) {
        return t instanceof c ? t : new c(e, {
          secret: t
        });
      }, c.prototype.secret = function () {
        return this._secret;
      }, a(c, "pubBytes", function () {
        return this.eddsa.encodePoint(this.pub());
      }), a(c, "pub", function () {
        return this._pubBytes ? this.eddsa.decodePoint(this._pubBytes) : this.eddsa.g.mul(this.priv());
      }), a(c, "privBytes", function () {
        var e = this.eddsa,
            t = this.hash(),
            r = e.encodingLength - 1,
            n = t.slice(0, e.encodingLength);
        return n[0] &= 248, n[r] &= 127, n[r] |= 64, n;
      }), a(c, "priv", function () {
        return this.eddsa.decodeInt(this.privBytes());
      }), a(c, "hash", function () {
        return this.eddsa.hash().update(this.secret()).digest();
      }), a(c, "messagePrefix", function () {
        return this.hash().slice(this.eddsa.encodingLength);
      }), c.prototype.sign = function (e) {
        return i(this._secret, "KeyPair can only verify"), this.eddsa.sign(e, this);
      }, c.prototype.verify = function (e, t) {
        return this.eddsa.verify(e, t, this);
      }, c.prototype.getSecret = function (e) {
        return i(this._secret, "KeyPair is public only"), n.encode(this.secret(), e);
      }, c.prototype.getPublic = function (e) {
        return n.encode(this.pubBytes(), e);
      }, e.exports = c;
    },
    3622: function _(e, t, r) {
      "use strict";

      var n = r(3785),
          i = r(953),
          o = i.assert,
          a = i.cachedProperty,
          c = i.parseBytes;

      function s(e, t) {
        this.eddsa = e, "object" != typeof t && (t = c(t)), Array.isArray(t) && (t = {
          R: t.slice(0, e.encodingLength),
          S: t.slice(e.encodingLength)
        }), o(t.R && t.S, "Signature without R or S"), e.isPoint(t.R) && (this._R = t.R), t.S instanceof n && (this._S = t.S), this._Rencoded = Array.isArray(t.R) ? t.R : t.Rencoded, this._Sencoded = Array.isArray(t.S) ? t.S : t.Sencoded;
      }

      a(s, "S", function () {
        return this.eddsa.decodeInt(this.Sencoded());
      }), a(s, "R", function () {
        return this.eddsa.decodePoint(this.Rencoded());
      }), a(s, "Rencoded", function () {
        return this.eddsa.encodePoint(this.R());
      }), a(s, "Sencoded", function () {
        return this.eddsa.encodeInt(this.S());
      }), s.prototype.toBytes = function () {
        return this.Rencoded().concat(this.Sencoded());
      }, s.prototype.toHex = function () {
        return i.encode(this.toBytes(), "hex").toUpperCase();
      }, e.exports = s;
    },
    1037: function _(e) {
      e.exports = {
        doubles: {
          step: 4,
          points: [["e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a", "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"], ["8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508", "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"], ["175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739", "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"], ["363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640", "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"], ["8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c", "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"], ["723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda", "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"], ["eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa", "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"], ["100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0", "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"], ["e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d", "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"], ["feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d", "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"], ["da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1", "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"], ["53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0", "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"], ["8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047", "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"], ["385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862", "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"], ["6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7", "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"], ["3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd", "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"], ["85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83", "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"], ["948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a", "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"], ["6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8", "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"], ["e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d", "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"], ["e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725", "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"], ["213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754", "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"], ["4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c", "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"], ["fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6", "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"], ["76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39", "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"], ["c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891", "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"], ["d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b", "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"], ["b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03", "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"], ["e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d", "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"], ["a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070", "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"], ["90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4", "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"], ["8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da", "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"], ["e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11", "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"], ["8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e", "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"], ["e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41", "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"], ["b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef", "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"], ["d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8", "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"], ["324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d", "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"], ["4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96", "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"], ["9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd", "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"], ["6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5", "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"], ["a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266", "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"], ["7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71", "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"], ["928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac", "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"], ["85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751", "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"], ["ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e", "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"], ["827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241", "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"], ["eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3", "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"], ["e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f", "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"], ["1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19", "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"], ["146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be", "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"], ["fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9", "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"], ["da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2", "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"], ["a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13", "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"], ["174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c", "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"], ["959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba", "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"], ["d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151", "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"], ["64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073", "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"], ["8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458", "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"], ["13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b", "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"], ["bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366", "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"], ["8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa", "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"], ["8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0", "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"], ["dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787", "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"], ["f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e", "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"]]
        },
        naf: {
          wnd: 7,
          points: [["f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9", "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"], ["2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4", "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"], ["5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc", "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"], ["acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe", "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"], ["774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb", "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"], ["f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8", "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"], ["d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e", "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"], ["defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34", "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"], ["2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c", "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"], ["352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5", "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"], ["2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f", "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"], ["9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714", "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"], ["daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729", "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"], ["c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db", "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"], ["6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4", "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"], ["1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5", "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"], ["605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479", "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"], ["62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d", "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"], ["80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f", "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"], ["7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb", "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"], ["d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9", "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"], ["49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963", "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"], ["77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74", "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"], ["f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530", "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"], ["463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b", "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"], ["f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247", "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"], ["caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1", "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"], ["2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120", "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"], ["7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435", "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"], ["754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18", "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"], ["e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8", "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"], ["186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb", "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"], ["df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f", "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"], ["5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143", "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"], ["290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba", "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"], ["af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45", "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"], ["766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a", "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"], ["59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e", "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"], ["f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8", "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"], ["7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c", "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"], ["948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519", "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"], ["7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab", "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"], ["3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca", "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"], ["d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf", "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"], ["1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610", "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"], ["733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4", "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"], ["15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c", "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"], ["a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940", "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"], ["e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980", "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"], ["311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3", "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"], ["34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf", "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"], ["f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63", "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"], ["d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448", "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"], ["32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf", "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"], ["7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5", "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"], ["ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6", "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"], ["16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5", "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"], ["eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99", "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"], ["78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51", "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"], ["494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5", "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"], ["a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5", "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"], ["c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997", "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"], ["841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881", "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"], ["5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5", "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"], ["36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66", "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"], ["336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726", "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"], ["8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede", "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"], ["1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94", "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"], ["85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31", "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"], ["29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51", "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"], ["a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252", "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"], ["4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5", "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"], ["d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b", "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"], ["ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4", "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"], ["af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f", "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"], ["e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889", "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"], ["591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246", "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"], ["11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984", "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"], ["3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a", "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"], ["cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030", "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"], ["c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197", "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"], ["c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593", "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"], ["a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef", "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"], ["347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38", "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"], ["da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a", "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"], ["c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111", "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"], ["4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502", "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"], ["3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea", "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"], ["cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26", "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"], ["b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986", "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"], ["d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e", "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"], ["48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4", "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"], ["dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda", "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"], ["6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859", "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"], ["e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f", "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"], ["eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c", "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"], ["13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942", "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"], ["ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a", "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"], ["b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80", "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"], ["ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d", "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"], ["8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1", "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"], ["52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63", "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"], ["e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352", "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"], ["7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193", "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"], ["5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00", "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"], ["32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58", "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"], ["e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7", "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"], ["8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8", "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"], ["4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e", "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"], ["3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d", "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"], ["674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b", "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"], ["d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f", "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"], ["30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6", "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"], ["be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297", "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"], ["93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a", "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"], ["b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c", "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"], ["d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52", "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"], ["d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb", "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"], ["463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065", "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"], ["7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917", "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"], ["74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9", "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"], ["30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3", "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"], ["9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57", "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"], ["176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66", "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"], ["75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8", "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"], ["809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721", "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"], ["1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180", "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"]]
        }
      };
    },
    953: function _(e, t, r) {
      "use strict";

      var n = t,
          i = r(3785),
          o = r(9746),
          a = r(4504);
      n.assert = o, n.toArray = a.toArray, n.zero2 = a.zero2, n.toHex = a.toHex, n.encode = a.encode, n.getNAF = function (e, t, r) {
        var n = new Array(Math.max(e.bitLength(), r) + 1);
        n.fill(0);

        for (var i = 1 << t + 1, o = e.clone(), a = 0; a < n.length; a++) {
          var c,
              s = o.andln(i - 1);
          o.isOdd() ? (c = s > (i >> 1) - 1 ? (i >> 1) - s : s, o.isubn(c)) : c = 0, n[a] = c, o.iushrn(1);
        }

        return n;
      }, n.getJSF = function (e, t) {
        var r = [[], []];
        e = e.clone(), t = t.clone();

        for (var n, i = 0, o = 0; e.cmpn(-i) > 0 || t.cmpn(-o) > 0;) {
          var a,
              c,
              s = e.andln(3) + i & 3,
              f = t.andln(3) + o & 3;
          3 === s && (s = -1), 3 === f && (f = -1), a = 0 == (1 & s) ? 0 : 3 != (n = e.andln(7) + i & 7) && 5 !== n || 2 !== f ? s : -s, r[0].push(a), c = 0 == (1 & f) ? 0 : 3 != (n = t.andln(7) + o & 7) && 5 !== n || 2 !== s ? f : -f, r[1].push(c), 2 * i === a + 1 && (i = 1 - i), 2 * o === c + 1 && (o = 1 - o), e.iushrn(1), t.iushrn(1);
        }

        return r;
      }, n.cachedProperty = function (e, t, r) {
        var n = "_" + t;

        e.prototype[t] = function () {
          return void 0 !== this[n] ? this[n] : this[n] = r.call(this);
        };
      }, n.parseBytes = function (e) {
        return "string" == typeof e ? n.toArray(e, "hex") : e;
      }, n.intFromLE = function (e) {
        return new i(e, "hex", "le");
      };
    },
    3785: function _(e, t, r) {
      !function (e, t) {
        "use strict";

        function n(e, t) {
          if (!e) throw new Error(t || "Assertion failed");
        }

        function i(e, t) {
          e.super_ = t;

          var r = function r() {};

          r.prototype = t.prototype, e.prototype = new r(), e.prototype.constructor = e;
        }

        function o(e, t, r) {
          if (o.isBN(e)) return e;
          this.negative = 0, this.words = null, this.length = 0, this.red = null, null !== e && ("le" !== t && "be" !== t || (r = t, t = 10), this._init(e || 0, t || 10, r || "be"));
        }

        var a;
        "object" == typeof e ? e.exports = o : t.BN = o, o.BN = o, o.wordSize = 26;

        try {
          a = "undefined" != typeof window && void 0 !== window.Buffer ? window.Buffer : r(4300).Buffer;
        } catch (e) {}

        function c(e, t) {
          var r = e.charCodeAt(t);
          return r >= 65 && r <= 70 ? r - 55 : r >= 97 && r <= 102 ? r - 87 : r - 48 & 15;
        }

        function s(e, t, r) {
          var n = c(e, r);
          return r - 1 >= t && (n |= c(e, r - 1) << 4), n;
        }

        function f(e, t, r, n) {
          for (var i = 0, o = Math.min(e.length, r), a = t; a < o; a++) {
            var c = e.charCodeAt(a) - 48;
            i *= n, i += c >= 49 ? c - 49 + 10 : c >= 17 ? c - 17 + 10 : c;
          }

          return i;
        }

        o.isBN = function (e) {
          return e instanceof o || null !== e && "object" == typeof e && e.constructor.wordSize === o.wordSize && Array.isArray(e.words);
        }, o.max = function (e, t) {
          return e.cmp(t) > 0 ? e : t;
        }, o.min = function (e, t) {
          return e.cmp(t) < 0 ? e : t;
        }, o.prototype._init = function (e, t, r) {
          if ("number" == typeof e) return this._initNumber(e, t, r);
          if ("object" == typeof e) return this._initArray(e, t, r);
          "hex" === t && (t = 16), n(t === (0 | t) && t >= 2 && t <= 36);
          var i = 0;
          "-" === (e = e.toString().replace(/\s+/g, ""))[0] && (i++, this.negative = 1), i < e.length && (16 === t ? this._parseHex(e, i, r) : (this._parseBase(e, t, i), "le" === r && this._initArray(this.toArray(), t, r)));
        }, o.prototype._initNumber = function (e, t, r) {
          e < 0 && (this.negative = 1, e = -e), e < 67108864 ? (this.words = [67108863 & e], this.length = 1) : e < 4503599627370496 ? (this.words = [67108863 & e, e / 67108864 & 67108863], this.length = 2) : (n(e < 9007199254740992), this.words = [67108863 & e, e / 67108864 & 67108863, 1], this.length = 3), "le" === r && this._initArray(this.toArray(), t, r);
        }, o.prototype._initArray = function (e, t, r) {
          if (n("number" == typeof e.length), e.length <= 0) return this.words = [0], this.length = 1, this;
          this.length = Math.ceil(e.length / 3), this.words = new Array(this.length);

          for (var i = 0; i < this.length; i++) {
            this.words[i] = 0;
          }

          var o,
              a,
              c = 0;
          if ("be" === r) for (i = e.length - 1, o = 0; i >= 0; i -= 3) {
            a = e[i] | e[i - 1] << 8 | e[i - 2] << 16, this.words[o] |= a << c & 67108863, this.words[o + 1] = a >>> 26 - c & 67108863, (c += 24) >= 26 && (c -= 26, o++);
          } else if ("le" === r) for (i = 0, o = 0; i < e.length; i += 3) {
            a = e[i] | e[i + 1] << 8 | e[i + 2] << 16, this.words[o] |= a << c & 67108863, this.words[o + 1] = a >>> 26 - c & 67108863, (c += 24) >= 26 && (c -= 26, o++);
          }
          return this.strip();
        }, o.prototype._parseHex = function (e, t, r) {
          this.length = Math.ceil((e.length - t) / 6), this.words = new Array(this.length);

          for (var n = 0; n < this.length; n++) {
            this.words[n] = 0;
          }

          var i,
              o = 0,
              a = 0;
          if ("be" === r) for (n = e.length - 1; n >= t; n -= 2) {
            i = s(e, t, n) << o, this.words[a] |= 67108863 & i, o >= 18 ? (o -= 18, a += 1, this.words[a] |= i >>> 26) : o += 8;
          } else for (n = (e.length - t) % 2 == 0 ? t + 1 : t; n < e.length; n += 2) {
            i = s(e, t, n) << o, this.words[a] |= 67108863 & i, o >= 18 ? (o -= 18, a += 1, this.words[a] |= i >>> 26) : o += 8;
          }
          this.strip();
        }, o.prototype._parseBase = function (e, t, r) {
          this.words = [0], this.length = 1;

          for (var n = 0, i = 1; i <= 67108863; i *= t) {
            n++;
          }

          n--, i = i / t | 0;

          for (var o = e.length - r, a = o % n, c = Math.min(o, o - a) + r, s = 0, d = r; d < c; d += n) {
            s = f(e, d, d + n, t), this.imuln(i), this.words[0] + s < 67108864 ? this.words[0] += s : this._iaddn(s);
          }

          if (0 !== a) {
            var u = 1;

            for (s = f(e, d, e.length, t), d = 0; d < a; d++) {
              u *= t;
            }

            this.imuln(u), this.words[0] + s < 67108864 ? this.words[0] += s : this._iaddn(s);
          }

          this.strip();
        }, o.prototype.copy = function (e) {
          e.words = new Array(this.length);

          for (var t = 0; t < this.length; t++) {
            e.words[t] = this.words[t];
          }

          e.length = this.length, e.negative = this.negative, e.red = this.red;
        }, o.prototype.clone = function () {
          var e = new o(null);
          return this.copy(e), e;
        }, o.prototype._expand = function (e) {
          for (; this.length < e;) {
            this.words[this.length++] = 0;
          }

          return this;
        }, o.prototype.strip = function () {
          for (; this.length > 1 && 0 === this.words[this.length - 1];) {
            this.length--;
          }

          return this._normSign();
        }, o.prototype._normSign = function () {
          return 1 === this.length && 0 === this.words[0] && (this.negative = 0), this;
        }, o.prototype.inspect = function () {
          return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
        };
        var d = ["", "0", "00", "000", "0000", "00000", "000000", "0000000", "00000000", "000000000", "0000000000", "00000000000", "000000000000", "0000000000000", "00000000000000", "000000000000000", "0000000000000000", "00000000000000000", "000000000000000000", "0000000000000000000", "00000000000000000000", "000000000000000000000", "0000000000000000000000", "00000000000000000000000", "000000000000000000000000", "0000000000000000000000000"],
            u = [0, 0, 25, 16, 12, 11, 10, 9, 8, 8, 7, 7, 7, 7, 6, 6, 6, 6, 6, 6, 6, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5],
            h = [0, 0, 33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216, 43046721, 1e7, 19487171, 35831808, 62748517, 7529536, 11390625, 16777216, 24137569, 34012224, 47045881, 64e6, 4084101, 5153632, 6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149, 243e5, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176];

        function l(e, t, r) {
          r.negative = t.negative ^ e.negative;
          var n = e.length + t.length | 0;
          r.length = n, n = n - 1 | 0;
          var i = 0 | e.words[0],
              o = 0 | t.words[0],
              a = i * o,
              c = 67108863 & a,
              s = a / 67108864 | 0;
          r.words[0] = c;

          for (var f = 1; f < n; f++) {
            for (var d = s >>> 26, u = 67108863 & s, h = Math.min(f, t.length - 1), l = Math.max(0, f - e.length + 1); l <= h; l++) {
              var p = f - l | 0;
              d += (a = (i = 0 | e.words[p]) * (o = 0 | t.words[l]) + u) / 67108864 | 0, u = 67108863 & a;
            }

            r.words[f] = 0 | u, s = 0 | d;
          }

          return 0 !== s ? r.words[f] = 0 | s : r.length--, r.strip();
        }

        o.prototype.toString = function (e, t) {
          var r;

          if (t = 0 | t || 1, 16 === (e = e || 10) || "hex" === e) {
            r = "";

            for (var i = 0, o = 0, a = 0; a < this.length; a++) {
              var c = this.words[a],
                  s = (16777215 & (c << i | o)).toString(16);
              r = 0 != (o = c >>> 24 - i & 16777215) || a !== this.length - 1 ? d[6 - s.length] + s + r : s + r, (i += 2) >= 26 && (i -= 26, a--);
            }

            for (0 !== o && (r = o.toString(16) + r); r.length % t != 0;) {
              r = "0" + r;
            }

            return 0 !== this.negative && (r = "-" + r), r;
          }

          if (e === (0 | e) && e >= 2 && e <= 36) {
            var f = u[e],
                l = h[e];
            r = "";
            var p = this.clone();

            for (p.negative = 0; !p.isZero();) {
              var m = p.modn(l).toString(e);
              r = (p = p.idivn(l)).isZero() ? m + r : d[f - m.length] + m + r;
            }

            for (this.isZero() && (r = "0" + r); r.length % t != 0;) {
              r = "0" + r;
            }

            return 0 !== this.negative && (r = "-" + r), r;
          }

          n(!1, "Base should be between 2 and 36");
        }, o.prototype.toNumber = function () {
          var e = this.words[0];
          return 2 === this.length ? e += 67108864 * this.words[1] : 3 === this.length && 1 === this.words[2] ? e += 4503599627370496 + 67108864 * this.words[1] : this.length > 2 && n(!1, "Number can only safely store up to 53 bits"), 0 !== this.negative ? -e : e;
        }, o.prototype.toJSON = function () {
          return this.toString(16);
        }, o.prototype.toBuffer = function (e, t) {
          return n(void 0 !== a), this.toArrayLike(a, e, t);
        }, o.prototype.toArray = function (e, t) {
          return this.toArrayLike(Array, e, t);
        }, o.prototype.toArrayLike = function (e, t, r) {
          var i = this.byteLength(),
              o = r || Math.max(1, i);
          n(i <= o, "byte array longer than desired length"), n(o > 0, "Requested array length <= 0"), this.strip();
          var a,
              c,
              s = "le" === t,
              f = new e(o),
              d = this.clone();

          if (s) {
            for (c = 0; !d.isZero(); c++) {
              a = d.andln(255), d.iushrn(8), f[c] = a;
            }

            for (; c < o; c++) {
              f[c] = 0;
            }
          } else {
            for (c = 0; c < o - i; c++) {
              f[c] = 0;
            }

            for (c = 0; !d.isZero(); c++) {
              a = d.andln(255), d.iushrn(8), f[o - c - 1] = a;
            }
          }

          return f;
        }, Math.clz32 ? o.prototype._countBits = function (e) {
          return 32 - Math.clz32(e);
        } : o.prototype._countBits = function (e) {
          var t = e,
              r = 0;
          return t >= 4096 && (r += 13, t >>>= 13), t >= 64 && (r += 7, t >>>= 7), t >= 8 && (r += 4, t >>>= 4), t >= 2 && (r += 2, t >>>= 2), r + t;
        }, o.prototype._zeroBits = function (e) {
          if (0 === e) return 26;
          var t = e,
              r = 0;
          return 0 == (8191 & t) && (r += 13, t >>>= 13), 0 == (127 & t) && (r += 7, t >>>= 7), 0 == (15 & t) && (r += 4, t >>>= 4), 0 == (3 & t) && (r += 2, t >>>= 2), 0 == (1 & t) && r++, r;
        }, o.prototype.bitLength = function () {
          var e = this.words[this.length - 1],
              t = this._countBits(e);

          return 26 * (this.length - 1) + t;
        }, o.prototype.zeroBits = function () {
          if (this.isZero()) return 0;

          for (var e = 0, t = 0; t < this.length; t++) {
            var r = this._zeroBits(this.words[t]);

            if (e += r, 26 !== r) break;
          }

          return e;
        }, o.prototype.byteLength = function () {
          return Math.ceil(this.bitLength() / 8);
        }, o.prototype.toTwos = function (e) {
          return 0 !== this.negative ? this.abs().inotn(e).iaddn(1) : this.clone();
        }, o.prototype.fromTwos = function (e) {
          return this.testn(e - 1) ? this.notn(e).iaddn(1).ineg() : this.clone();
        }, o.prototype.isNeg = function () {
          return 0 !== this.negative;
        }, o.prototype.neg = function () {
          return this.clone().ineg();
        }, o.prototype.ineg = function () {
          return this.isZero() || (this.negative ^= 1), this;
        }, o.prototype.iuor = function (e) {
          for (; this.length < e.length;) {
            this.words[this.length++] = 0;
          }

          for (var t = 0; t < e.length; t++) {
            this.words[t] = this.words[t] | e.words[t];
          }

          return this.strip();
        }, o.prototype.ior = function (e) {
          return n(0 == (this.negative | e.negative)), this.iuor(e);
        }, o.prototype.or = function (e) {
          return this.length > e.length ? this.clone().ior(e) : e.clone().ior(this);
        }, o.prototype.uor = function (e) {
          return this.length > e.length ? this.clone().iuor(e) : e.clone().iuor(this);
        }, o.prototype.iuand = function (e) {
          var t;
          t = this.length > e.length ? e : this;

          for (var r = 0; r < t.length; r++) {
            this.words[r] = this.words[r] & e.words[r];
          }

          return this.length = t.length, this.strip();
        }, o.prototype.iand = function (e) {
          return n(0 == (this.negative | e.negative)), this.iuand(e);
        }, o.prototype.and = function (e) {
          return this.length > e.length ? this.clone().iand(e) : e.clone().iand(this);
        }, o.prototype.uand = function (e) {
          return this.length > e.length ? this.clone().iuand(e) : e.clone().iuand(this);
        }, o.prototype.iuxor = function (e) {
          var t, r;
          this.length > e.length ? (t = this, r = e) : (t = e, r = this);

          for (var n = 0; n < r.length; n++) {
            this.words[n] = t.words[n] ^ r.words[n];
          }

          if (this !== t) for (; n < t.length; n++) {
            this.words[n] = t.words[n];
          }
          return this.length = t.length, this.strip();
        }, o.prototype.ixor = function (e) {
          return n(0 == (this.negative | e.negative)), this.iuxor(e);
        }, o.prototype.xor = function (e) {
          return this.length > e.length ? this.clone().ixor(e) : e.clone().ixor(this);
        }, o.prototype.uxor = function (e) {
          return this.length > e.length ? this.clone().iuxor(e) : e.clone().iuxor(this);
        }, o.prototype.inotn = function (e) {
          n("number" == typeof e && e >= 0);
          var t = 0 | Math.ceil(e / 26),
              r = e % 26;
          this._expand(t), r > 0 && t--;

          for (var i = 0; i < t; i++) {
            this.words[i] = 67108863 & ~this.words[i];
          }

          return r > 0 && (this.words[i] = ~this.words[i] & 67108863 >> 26 - r), this.strip();
        }, o.prototype.notn = function (e) {
          return this.clone().inotn(e);
        }, o.prototype.setn = function (e, t) {
          n("number" == typeof e && e >= 0);
          var r = e / 26 | 0,
              i = e % 26;
          return this._expand(r + 1), this.words[r] = t ? this.words[r] | 1 << i : this.words[r] & ~(1 << i), this.strip();
        }, o.prototype.iadd = function (e) {
          var t, r, n;
          if (0 !== this.negative && 0 === e.negative) return this.negative = 0, t = this.isub(e), this.negative ^= 1, this._normSign();
          if (0 === this.negative && 0 !== e.negative) return e.negative = 0, t = this.isub(e), e.negative = 1, t._normSign();
          this.length > e.length ? (r = this, n = e) : (r = e, n = this);

          for (var i = 0, o = 0; o < n.length; o++) {
            t = (0 | r.words[o]) + (0 | n.words[o]) + i, this.words[o] = 67108863 & t, i = t >>> 26;
          }

          for (; 0 !== i && o < r.length; o++) {
            t = (0 | r.words[o]) + i, this.words[o] = 67108863 & t, i = t >>> 26;
          }

          if (this.length = r.length, 0 !== i) this.words[this.length] = i, this.length++;else if (r !== this) for (; o < r.length; o++) {
            this.words[o] = r.words[o];
          }
          return this;
        }, o.prototype.add = function (e) {
          var t;
          return 0 !== e.negative && 0 === this.negative ? (e.negative = 0, t = this.sub(e), e.negative ^= 1, t) : 0 === e.negative && 0 !== this.negative ? (this.negative = 0, t = e.sub(this), this.negative = 1, t) : this.length > e.length ? this.clone().iadd(e) : e.clone().iadd(this);
        }, o.prototype.isub = function (e) {
          if (0 !== e.negative) {
            e.negative = 0;
            var t = this.iadd(e);
            return e.negative = 1, t._normSign();
          }

          if (0 !== this.negative) return this.negative = 0, this.iadd(e), this.negative = 1, this._normSign();
          var r,
              n,
              i = this.cmp(e);
          if (0 === i) return this.negative = 0, this.length = 1, this.words[0] = 0, this;
          i > 0 ? (r = this, n = e) : (r = e, n = this);

          for (var o = 0, a = 0; a < n.length; a++) {
            o = (t = (0 | r.words[a]) - (0 | n.words[a]) + o) >> 26, this.words[a] = 67108863 & t;
          }

          for (; 0 !== o && a < r.length; a++) {
            o = (t = (0 | r.words[a]) + o) >> 26, this.words[a] = 67108863 & t;
          }

          if (0 === o && a < r.length && r !== this) for (; a < r.length; a++) {
            this.words[a] = r.words[a];
          }
          return this.length = Math.max(this.length, a), r !== this && (this.negative = 1), this.strip();
        }, o.prototype.sub = function (e) {
          return this.clone().isub(e);
        };

        var p = function p(e, t, r) {
          var n,
              i,
              o,
              a = e.words,
              c = t.words,
              s = r.words,
              f = 0,
              d = 0 | a[0],
              u = 8191 & d,
              h = d >>> 13,
              l = 0 | a[1],
              p = 8191 & l,
              m = l >>> 13,
              b = 0 | a[2],
              g = 8191 & b,
              v = b >>> 13,
              y = 0 | a[3],
              w = 8191 & y,
              A = y >>> 13,
              _ = 0 | a[4],
              M = 8191 & _,
              x = _ >>> 13,
              k = 0 | a[5],
              E = 8191 & k,
              S = k >>> 13,
              I = 0 | a[6],
              C = 8191 & I,
              T = I >>> 13,
              B = 0 | a[7],
              D = 8191 & B,
              N = B >>> 13,
              R = 0 | a[8],
              O = 8191 & R,
              P = R >>> 13,
              F = 0 | a[9],
              L = 8191 & F,
              G = F >>> 13,
              j = 0 | c[0],
              z = 8191 & j,
              q = j >>> 13,
              U = 0 | c[1],
              H = 8191 & U,
              K = U >>> 13,
              V = 0 | c[2],
              W = 8191 & V,
              X = V >>> 13,
              Z = 0 | c[3],
              $ = 8191 & Z,
              Y = Z >>> 13,
              J = 0 | c[4],
              Q = 8191 & J,
              ee = J >>> 13,
              te = 0 | c[5],
              re = 8191 & te,
              ne = te >>> 13,
              ie = 0 | c[6],
              oe = 8191 & ie,
              ae = ie >>> 13,
              ce = 0 | c[7],
              se = 8191 & ce,
              fe = ce >>> 13,
              de = 0 | c[8],
              ue = 8191 & de,
              he = de >>> 13,
              le = 0 | c[9],
              pe = 8191 & le,
              me = le >>> 13;

          r.negative = e.negative ^ t.negative, r.length = 19;
          var be = (f + (n = Math.imul(u, z)) | 0) + ((8191 & (i = (i = Math.imul(u, q)) + Math.imul(h, z) | 0)) << 13) | 0;
          f = ((o = Math.imul(h, q)) + (i >>> 13) | 0) + (be >>> 26) | 0, be &= 67108863, n = Math.imul(p, z), i = (i = Math.imul(p, q)) + Math.imul(m, z) | 0, o = Math.imul(m, q);
          var ge = (f + (n = n + Math.imul(u, H) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(u, K) | 0) + Math.imul(h, H) | 0)) << 13) | 0;
          f = ((o = o + Math.imul(h, K) | 0) + (i >>> 13) | 0) + (ge >>> 26) | 0, ge &= 67108863, n = Math.imul(g, z), i = (i = Math.imul(g, q)) + Math.imul(v, z) | 0, o = Math.imul(v, q), n = n + Math.imul(p, H) | 0, i = (i = i + Math.imul(p, K) | 0) + Math.imul(m, H) | 0, o = o + Math.imul(m, K) | 0;
          var ve = (f + (n = n + Math.imul(u, W) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(u, X) | 0) + Math.imul(h, W) | 0)) << 13) | 0;
          f = ((o = o + Math.imul(h, X) | 0) + (i >>> 13) | 0) + (ve >>> 26) | 0, ve &= 67108863, n = Math.imul(w, z), i = (i = Math.imul(w, q)) + Math.imul(A, z) | 0, o = Math.imul(A, q), n = n + Math.imul(g, H) | 0, i = (i = i + Math.imul(g, K) | 0) + Math.imul(v, H) | 0, o = o + Math.imul(v, K) | 0, n = n + Math.imul(p, W) | 0, i = (i = i + Math.imul(p, X) | 0) + Math.imul(m, W) | 0, o = o + Math.imul(m, X) | 0;
          var ye = (f + (n = n + Math.imul(u, $) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(u, Y) | 0) + Math.imul(h, $) | 0)) << 13) | 0;
          f = ((o = o + Math.imul(h, Y) | 0) + (i >>> 13) | 0) + (ye >>> 26) | 0, ye &= 67108863, n = Math.imul(M, z), i = (i = Math.imul(M, q)) + Math.imul(x, z) | 0, o = Math.imul(x, q), n = n + Math.imul(w, H) | 0, i = (i = i + Math.imul(w, K) | 0) + Math.imul(A, H) | 0, o = o + Math.imul(A, K) | 0, n = n + Math.imul(g, W) | 0, i = (i = i + Math.imul(g, X) | 0) + Math.imul(v, W) | 0, o = o + Math.imul(v, X) | 0, n = n + Math.imul(p, $) | 0, i = (i = i + Math.imul(p, Y) | 0) + Math.imul(m, $) | 0, o = o + Math.imul(m, Y) | 0;
          var we = (f + (n = n + Math.imul(u, Q) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(u, ee) | 0) + Math.imul(h, Q) | 0)) << 13) | 0;
          f = ((o = o + Math.imul(h, ee) | 0) + (i >>> 13) | 0) + (we >>> 26) | 0, we &= 67108863, n = Math.imul(E, z), i = (i = Math.imul(E, q)) + Math.imul(S, z) | 0, o = Math.imul(S, q), n = n + Math.imul(M, H) | 0, i = (i = i + Math.imul(M, K) | 0) + Math.imul(x, H) | 0, o = o + Math.imul(x, K) | 0, n = n + Math.imul(w, W) | 0, i = (i = i + Math.imul(w, X) | 0) + Math.imul(A, W) | 0, o = o + Math.imul(A, X) | 0, n = n + Math.imul(g, $) | 0, i = (i = i + Math.imul(g, Y) | 0) + Math.imul(v, $) | 0, o = o + Math.imul(v, Y) | 0, n = n + Math.imul(p, Q) | 0, i = (i = i + Math.imul(p, ee) | 0) + Math.imul(m, Q) | 0, o = o + Math.imul(m, ee) | 0;
          var Ae = (f + (n = n + Math.imul(u, re) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(u, ne) | 0) + Math.imul(h, re) | 0)) << 13) | 0;
          f = ((o = o + Math.imul(h, ne) | 0) + (i >>> 13) | 0) + (Ae >>> 26) | 0, Ae &= 67108863, n = Math.imul(C, z), i = (i = Math.imul(C, q)) + Math.imul(T, z) | 0, o = Math.imul(T, q), n = n + Math.imul(E, H) | 0, i = (i = i + Math.imul(E, K) | 0) + Math.imul(S, H) | 0, o = o + Math.imul(S, K) | 0, n = n + Math.imul(M, W) | 0, i = (i = i + Math.imul(M, X) | 0) + Math.imul(x, W) | 0, o = o + Math.imul(x, X) | 0, n = n + Math.imul(w, $) | 0, i = (i = i + Math.imul(w, Y) | 0) + Math.imul(A, $) | 0, o = o + Math.imul(A, Y) | 0, n = n + Math.imul(g, Q) | 0, i = (i = i + Math.imul(g, ee) | 0) + Math.imul(v, Q) | 0, o = o + Math.imul(v, ee) | 0, n = n + Math.imul(p, re) | 0, i = (i = i + Math.imul(p, ne) | 0) + Math.imul(m, re) | 0, o = o + Math.imul(m, ne) | 0;

          var _e = (f + (n = n + Math.imul(u, oe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(u, ae) | 0) + Math.imul(h, oe) | 0)) << 13) | 0;

          f = ((o = o + Math.imul(h, ae) | 0) + (i >>> 13) | 0) + (_e >>> 26) | 0, _e &= 67108863, n = Math.imul(D, z), i = (i = Math.imul(D, q)) + Math.imul(N, z) | 0, o = Math.imul(N, q), n = n + Math.imul(C, H) | 0, i = (i = i + Math.imul(C, K) | 0) + Math.imul(T, H) | 0, o = o + Math.imul(T, K) | 0, n = n + Math.imul(E, W) | 0, i = (i = i + Math.imul(E, X) | 0) + Math.imul(S, W) | 0, o = o + Math.imul(S, X) | 0, n = n + Math.imul(M, $) | 0, i = (i = i + Math.imul(M, Y) | 0) + Math.imul(x, $) | 0, o = o + Math.imul(x, Y) | 0, n = n + Math.imul(w, Q) | 0, i = (i = i + Math.imul(w, ee) | 0) + Math.imul(A, Q) | 0, o = o + Math.imul(A, ee) | 0, n = n + Math.imul(g, re) | 0, i = (i = i + Math.imul(g, ne) | 0) + Math.imul(v, re) | 0, o = o + Math.imul(v, ne) | 0, n = n + Math.imul(p, oe) | 0, i = (i = i + Math.imul(p, ae) | 0) + Math.imul(m, oe) | 0, o = o + Math.imul(m, ae) | 0;
          var Me = (f + (n = n + Math.imul(u, se) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(u, fe) | 0) + Math.imul(h, se) | 0)) << 13) | 0;
          f = ((o = o + Math.imul(h, fe) | 0) + (i >>> 13) | 0) + (Me >>> 26) | 0, Me &= 67108863, n = Math.imul(O, z), i = (i = Math.imul(O, q)) + Math.imul(P, z) | 0, o = Math.imul(P, q), n = n + Math.imul(D, H) | 0, i = (i = i + Math.imul(D, K) | 0) + Math.imul(N, H) | 0, o = o + Math.imul(N, K) | 0, n = n + Math.imul(C, W) | 0, i = (i = i + Math.imul(C, X) | 0) + Math.imul(T, W) | 0, o = o + Math.imul(T, X) | 0, n = n + Math.imul(E, $) | 0, i = (i = i + Math.imul(E, Y) | 0) + Math.imul(S, $) | 0, o = o + Math.imul(S, Y) | 0, n = n + Math.imul(M, Q) | 0, i = (i = i + Math.imul(M, ee) | 0) + Math.imul(x, Q) | 0, o = o + Math.imul(x, ee) | 0, n = n + Math.imul(w, re) | 0, i = (i = i + Math.imul(w, ne) | 0) + Math.imul(A, re) | 0, o = o + Math.imul(A, ne) | 0, n = n + Math.imul(g, oe) | 0, i = (i = i + Math.imul(g, ae) | 0) + Math.imul(v, oe) | 0, o = o + Math.imul(v, ae) | 0, n = n + Math.imul(p, se) | 0, i = (i = i + Math.imul(p, fe) | 0) + Math.imul(m, se) | 0, o = o + Math.imul(m, fe) | 0;
          var xe = (f + (n = n + Math.imul(u, ue) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(u, he) | 0) + Math.imul(h, ue) | 0)) << 13) | 0;
          f = ((o = o + Math.imul(h, he) | 0) + (i >>> 13) | 0) + (xe >>> 26) | 0, xe &= 67108863, n = Math.imul(L, z), i = (i = Math.imul(L, q)) + Math.imul(G, z) | 0, o = Math.imul(G, q), n = n + Math.imul(O, H) | 0, i = (i = i + Math.imul(O, K) | 0) + Math.imul(P, H) | 0, o = o + Math.imul(P, K) | 0, n = n + Math.imul(D, W) | 0, i = (i = i + Math.imul(D, X) | 0) + Math.imul(N, W) | 0, o = o + Math.imul(N, X) | 0, n = n + Math.imul(C, $) | 0, i = (i = i + Math.imul(C, Y) | 0) + Math.imul(T, $) | 0, o = o + Math.imul(T, Y) | 0, n = n + Math.imul(E, Q) | 0, i = (i = i + Math.imul(E, ee) | 0) + Math.imul(S, Q) | 0, o = o + Math.imul(S, ee) | 0, n = n + Math.imul(M, re) | 0, i = (i = i + Math.imul(M, ne) | 0) + Math.imul(x, re) | 0, o = o + Math.imul(x, ne) | 0, n = n + Math.imul(w, oe) | 0, i = (i = i + Math.imul(w, ae) | 0) + Math.imul(A, oe) | 0, o = o + Math.imul(A, ae) | 0, n = n + Math.imul(g, se) | 0, i = (i = i + Math.imul(g, fe) | 0) + Math.imul(v, se) | 0, o = o + Math.imul(v, fe) | 0, n = n + Math.imul(p, ue) | 0, i = (i = i + Math.imul(p, he) | 0) + Math.imul(m, ue) | 0, o = o + Math.imul(m, he) | 0;
          var ke = (f + (n = n + Math.imul(u, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(u, me) | 0) + Math.imul(h, pe) | 0)) << 13) | 0;
          f = ((o = o + Math.imul(h, me) | 0) + (i >>> 13) | 0) + (ke >>> 26) | 0, ke &= 67108863, n = Math.imul(L, H), i = (i = Math.imul(L, K)) + Math.imul(G, H) | 0, o = Math.imul(G, K), n = n + Math.imul(O, W) | 0, i = (i = i + Math.imul(O, X) | 0) + Math.imul(P, W) | 0, o = o + Math.imul(P, X) | 0, n = n + Math.imul(D, $) | 0, i = (i = i + Math.imul(D, Y) | 0) + Math.imul(N, $) | 0, o = o + Math.imul(N, Y) | 0, n = n + Math.imul(C, Q) | 0, i = (i = i + Math.imul(C, ee) | 0) + Math.imul(T, Q) | 0, o = o + Math.imul(T, ee) | 0, n = n + Math.imul(E, re) | 0, i = (i = i + Math.imul(E, ne) | 0) + Math.imul(S, re) | 0, o = o + Math.imul(S, ne) | 0, n = n + Math.imul(M, oe) | 0, i = (i = i + Math.imul(M, ae) | 0) + Math.imul(x, oe) | 0, o = o + Math.imul(x, ae) | 0, n = n + Math.imul(w, se) | 0, i = (i = i + Math.imul(w, fe) | 0) + Math.imul(A, se) | 0, o = o + Math.imul(A, fe) | 0, n = n + Math.imul(g, ue) | 0, i = (i = i + Math.imul(g, he) | 0) + Math.imul(v, ue) | 0, o = o + Math.imul(v, he) | 0;
          var Ee = (f + (n = n + Math.imul(p, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(p, me) | 0) + Math.imul(m, pe) | 0)) << 13) | 0;
          f = ((o = o + Math.imul(m, me) | 0) + (i >>> 13) | 0) + (Ee >>> 26) | 0, Ee &= 67108863, n = Math.imul(L, W), i = (i = Math.imul(L, X)) + Math.imul(G, W) | 0, o = Math.imul(G, X), n = n + Math.imul(O, $) | 0, i = (i = i + Math.imul(O, Y) | 0) + Math.imul(P, $) | 0, o = o + Math.imul(P, Y) | 0, n = n + Math.imul(D, Q) | 0, i = (i = i + Math.imul(D, ee) | 0) + Math.imul(N, Q) | 0, o = o + Math.imul(N, ee) | 0, n = n + Math.imul(C, re) | 0, i = (i = i + Math.imul(C, ne) | 0) + Math.imul(T, re) | 0, o = o + Math.imul(T, ne) | 0, n = n + Math.imul(E, oe) | 0, i = (i = i + Math.imul(E, ae) | 0) + Math.imul(S, oe) | 0, o = o + Math.imul(S, ae) | 0, n = n + Math.imul(M, se) | 0, i = (i = i + Math.imul(M, fe) | 0) + Math.imul(x, se) | 0, o = o + Math.imul(x, fe) | 0, n = n + Math.imul(w, ue) | 0, i = (i = i + Math.imul(w, he) | 0) + Math.imul(A, ue) | 0, o = o + Math.imul(A, he) | 0;
          var Se = (f + (n = n + Math.imul(g, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(g, me) | 0) + Math.imul(v, pe) | 0)) << 13) | 0;
          f = ((o = o + Math.imul(v, me) | 0) + (i >>> 13) | 0) + (Se >>> 26) | 0, Se &= 67108863, n = Math.imul(L, $), i = (i = Math.imul(L, Y)) + Math.imul(G, $) | 0, o = Math.imul(G, Y), n = n + Math.imul(O, Q) | 0, i = (i = i + Math.imul(O, ee) | 0) + Math.imul(P, Q) | 0, o = o + Math.imul(P, ee) | 0, n = n + Math.imul(D, re) | 0, i = (i = i + Math.imul(D, ne) | 0) + Math.imul(N, re) | 0, o = o + Math.imul(N, ne) | 0, n = n + Math.imul(C, oe) | 0, i = (i = i + Math.imul(C, ae) | 0) + Math.imul(T, oe) | 0, o = o + Math.imul(T, ae) | 0, n = n + Math.imul(E, se) | 0, i = (i = i + Math.imul(E, fe) | 0) + Math.imul(S, se) | 0, o = o + Math.imul(S, fe) | 0, n = n + Math.imul(M, ue) | 0, i = (i = i + Math.imul(M, he) | 0) + Math.imul(x, ue) | 0, o = o + Math.imul(x, he) | 0;
          var Ie = (f + (n = n + Math.imul(w, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(w, me) | 0) + Math.imul(A, pe) | 0)) << 13) | 0;
          f = ((o = o + Math.imul(A, me) | 0) + (i >>> 13) | 0) + (Ie >>> 26) | 0, Ie &= 67108863, n = Math.imul(L, Q), i = (i = Math.imul(L, ee)) + Math.imul(G, Q) | 0, o = Math.imul(G, ee), n = n + Math.imul(O, re) | 0, i = (i = i + Math.imul(O, ne) | 0) + Math.imul(P, re) | 0, o = o + Math.imul(P, ne) | 0, n = n + Math.imul(D, oe) | 0, i = (i = i + Math.imul(D, ae) | 0) + Math.imul(N, oe) | 0, o = o + Math.imul(N, ae) | 0, n = n + Math.imul(C, se) | 0, i = (i = i + Math.imul(C, fe) | 0) + Math.imul(T, se) | 0, o = o + Math.imul(T, fe) | 0, n = n + Math.imul(E, ue) | 0, i = (i = i + Math.imul(E, he) | 0) + Math.imul(S, ue) | 0, o = o + Math.imul(S, he) | 0;
          var Ce = (f + (n = n + Math.imul(M, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(M, me) | 0) + Math.imul(x, pe) | 0)) << 13) | 0;
          f = ((o = o + Math.imul(x, me) | 0) + (i >>> 13) | 0) + (Ce >>> 26) | 0, Ce &= 67108863, n = Math.imul(L, re), i = (i = Math.imul(L, ne)) + Math.imul(G, re) | 0, o = Math.imul(G, ne), n = n + Math.imul(O, oe) | 0, i = (i = i + Math.imul(O, ae) | 0) + Math.imul(P, oe) | 0, o = o + Math.imul(P, ae) | 0, n = n + Math.imul(D, se) | 0, i = (i = i + Math.imul(D, fe) | 0) + Math.imul(N, se) | 0, o = o + Math.imul(N, fe) | 0, n = n + Math.imul(C, ue) | 0, i = (i = i + Math.imul(C, he) | 0) + Math.imul(T, ue) | 0, o = o + Math.imul(T, he) | 0;
          var Te = (f + (n = n + Math.imul(E, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(E, me) | 0) + Math.imul(S, pe) | 0)) << 13) | 0;
          f = ((o = o + Math.imul(S, me) | 0) + (i >>> 13) | 0) + (Te >>> 26) | 0, Te &= 67108863, n = Math.imul(L, oe), i = (i = Math.imul(L, ae)) + Math.imul(G, oe) | 0, o = Math.imul(G, ae), n = n + Math.imul(O, se) | 0, i = (i = i + Math.imul(O, fe) | 0) + Math.imul(P, se) | 0, o = o + Math.imul(P, fe) | 0, n = n + Math.imul(D, ue) | 0, i = (i = i + Math.imul(D, he) | 0) + Math.imul(N, ue) | 0, o = o + Math.imul(N, he) | 0;
          var Be = (f + (n = n + Math.imul(C, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(C, me) | 0) + Math.imul(T, pe) | 0)) << 13) | 0;
          f = ((o = o + Math.imul(T, me) | 0) + (i >>> 13) | 0) + (Be >>> 26) | 0, Be &= 67108863, n = Math.imul(L, se), i = (i = Math.imul(L, fe)) + Math.imul(G, se) | 0, o = Math.imul(G, fe), n = n + Math.imul(O, ue) | 0, i = (i = i + Math.imul(O, he) | 0) + Math.imul(P, ue) | 0, o = o + Math.imul(P, he) | 0;
          var De = (f + (n = n + Math.imul(D, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(D, me) | 0) + Math.imul(N, pe) | 0)) << 13) | 0;
          f = ((o = o + Math.imul(N, me) | 0) + (i >>> 13) | 0) + (De >>> 26) | 0, De &= 67108863, n = Math.imul(L, ue), i = (i = Math.imul(L, he)) + Math.imul(G, ue) | 0, o = Math.imul(G, he);
          var Ne = (f + (n = n + Math.imul(O, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(O, me) | 0) + Math.imul(P, pe) | 0)) << 13) | 0;
          f = ((o = o + Math.imul(P, me) | 0) + (i >>> 13) | 0) + (Ne >>> 26) | 0, Ne &= 67108863;
          var Re = (f + (n = Math.imul(L, pe)) | 0) + ((8191 & (i = (i = Math.imul(L, me)) + Math.imul(G, pe) | 0)) << 13) | 0;
          return f = ((o = Math.imul(G, me)) + (i >>> 13) | 0) + (Re >>> 26) | 0, Re &= 67108863, s[0] = be, s[1] = ge, s[2] = ve, s[3] = ye, s[4] = we, s[5] = Ae, s[6] = _e, s[7] = Me, s[8] = xe, s[9] = ke, s[10] = Ee, s[11] = Se, s[12] = Ie, s[13] = Ce, s[14] = Te, s[15] = Be, s[16] = De, s[17] = Ne, s[18] = Re, 0 !== f && (s[19] = f, r.length++), r;
        };

        function m(e, t, r) {
          return new b().mulp(e, t, r);
        }

        function b(e, t) {
          this.x = e, this.y = t;
        }

        Math.imul || (p = l), o.prototype.mulTo = function (e, t) {
          var r,
              n = this.length + e.length;
          return r = 10 === this.length && 10 === e.length ? p(this, e, t) : n < 63 ? l(this, e, t) : n < 1024 ? function (e, t, r) {
            r.negative = t.negative ^ e.negative, r.length = e.length + t.length;

            for (var n = 0, i = 0, o = 0; o < r.length - 1; o++) {
              var a = i;
              i = 0;

              for (var c = 67108863 & n, s = Math.min(o, t.length - 1), f = Math.max(0, o - e.length + 1); f <= s; f++) {
                var d = o - f,
                    u = (0 | e.words[d]) * (0 | t.words[f]),
                    h = 67108863 & u;
                c = 67108863 & (h = h + c | 0), i += (a = (a = a + (u / 67108864 | 0) | 0) + (h >>> 26) | 0) >>> 26, a &= 67108863;
              }

              r.words[o] = c, n = a, a = i;
            }

            return 0 !== n ? r.words[o] = n : r.length--, r.strip();
          }(this, e, t) : m(this, e, t), r;
        }, b.prototype.makeRBT = function (e) {
          for (var t = new Array(e), r = o.prototype._countBits(e) - 1, n = 0; n < e; n++) {
            t[n] = this.revBin(n, r, e);
          }

          return t;
        }, b.prototype.revBin = function (e, t, r) {
          if (0 === e || e === r - 1) return e;

          for (var n = 0, i = 0; i < t; i++) {
            n |= (1 & e) << t - i - 1, e >>= 1;
          }

          return n;
        }, b.prototype.permute = function (e, t, r, n, i, o) {
          for (var a = 0; a < o; a++) {
            n[a] = t[e[a]], i[a] = r[e[a]];
          }
        }, b.prototype.transform = function (e, t, r, n, i, o) {
          this.permute(o, e, t, r, n, i);

          for (var a = 1; a < i; a <<= 1) {
            for (var c = a << 1, s = Math.cos(2 * Math.PI / c), f = Math.sin(2 * Math.PI / c), d = 0; d < i; d += c) {
              for (var u = s, h = f, l = 0; l < a; l++) {
                var p = r[d + l],
                    m = n[d + l],
                    b = r[d + l + a],
                    g = n[d + l + a],
                    v = u * b - h * g;
                g = u * g + h * b, b = v, r[d + l] = p + b, n[d + l] = m + g, r[d + l + a] = p - b, n[d + l + a] = m - g, l !== c && (v = s * u - f * h, h = s * h + f * u, u = v);
              }
            }
          }
        }, b.prototype.guessLen13b = function (e, t) {
          var r = 1 | Math.max(t, e),
              n = 1 & r,
              i = 0;

          for (r = r / 2 | 0; r; r >>>= 1) {
            i++;
          }

          return 1 << i + 1 + n;
        }, b.prototype.conjugate = function (e, t, r) {
          if (!(r <= 1)) for (var n = 0; n < r / 2; n++) {
            var i = e[n];
            e[n] = e[r - n - 1], e[r - n - 1] = i, i = t[n], t[n] = -t[r - n - 1], t[r - n - 1] = -i;
          }
        }, b.prototype.normalize13b = function (e, t) {
          for (var r = 0, n = 0; n < t / 2; n++) {
            var i = 8192 * Math.round(e[2 * n + 1] / t) + Math.round(e[2 * n] / t) + r;
            e[n] = 67108863 & i, r = i < 67108864 ? 0 : i / 67108864 | 0;
          }

          return e;
        }, b.prototype.convert13b = function (e, t, r, i) {
          for (var o = 0, a = 0; a < t; a++) {
            o += 0 | e[a], r[2 * a] = 8191 & o, o >>>= 13, r[2 * a + 1] = 8191 & o, o >>>= 13;
          }

          for (a = 2 * t; a < i; ++a) {
            r[a] = 0;
          }

          n(0 === o), n(0 == (-8192 & o));
        }, b.prototype.stub = function (e) {
          for (var t = new Array(e), r = 0; r < e; r++) {
            t[r] = 0;
          }

          return t;
        }, b.prototype.mulp = function (e, t, r) {
          var n = 2 * this.guessLen13b(e.length, t.length),
              i = this.makeRBT(n),
              o = this.stub(n),
              a = new Array(n),
              c = new Array(n),
              s = new Array(n),
              f = new Array(n),
              d = new Array(n),
              u = new Array(n),
              h = r.words;
          h.length = n, this.convert13b(e.words, e.length, a, n), this.convert13b(t.words, t.length, f, n), this.transform(a, o, c, s, n, i), this.transform(f, o, d, u, n, i);

          for (var l = 0; l < n; l++) {
            var p = c[l] * d[l] - s[l] * u[l];
            s[l] = c[l] * u[l] + s[l] * d[l], c[l] = p;
          }

          return this.conjugate(c, s, n), this.transform(c, s, h, o, n, i), this.conjugate(h, o, n), this.normalize13b(h, n), r.negative = e.negative ^ t.negative, r.length = e.length + t.length, r.strip();
        }, o.prototype.mul = function (e) {
          var t = new o(null);
          return t.words = new Array(this.length + e.length), this.mulTo(e, t);
        }, o.prototype.mulf = function (e) {
          var t = new o(null);
          return t.words = new Array(this.length + e.length), m(this, e, t);
        }, o.prototype.imul = function (e) {
          return this.clone().mulTo(e, this);
        }, o.prototype.imuln = function (e) {
          n("number" == typeof e), n(e < 67108864);

          for (var t = 0, r = 0; r < this.length; r++) {
            var i = (0 | this.words[r]) * e,
                o = (67108863 & i) + (67108863 & t);
            t >>= 26, t += i / 67108864 | 0, t += o >>> 26, this.words[r] = 67108863 & o;
          }

          return 0 !== t && (this.words[r] = t, this.length++), this;
        }, o.prototype.muln = function (e) {
          return this.clone().imuln(e);
        }, o.prototype.sqr = function () {
          return this.mul(this);
        }, o.prototype.isqr = function () {
          return this.imul(this.clone());
        }, o.prototype.pow = function (e) {
          var t = function (e) {
            for (var t = new Array(e.bitLength()), r = 0; r < t.length; r++) {
              var n = r / 26 | 0,
                  i = r % 26;
              t[r] = (e.words[n] & 1 << i) >>> i;
            }

            return t;
          }(e);

          if (0 === t.length) return new o(1);

          for (var r = this, n = 0; n < t.length && 0 === t[n]; n++, r = r.sqr()) {
            ;
          }

          if (++n < t.length) for (var i = r.sqr(); n < t.length; n++, i = i.sqr()) {
            0 !== t[n] && (r = r.mul(i));
          }
          return r;
        }, o.prototype.iushln = function (e) {
          n("number" == typeof e && e >= 0);
          var t,
              r = e % 26,
              i = (e - r) / 26,
              o = 67108863 >>> 26 - r << 26 - r;

          if (0 !== r) {
            var a = 0;

            for (t = 0; t < this.length; t++) {
              var c = this.words[t] & o,
                  s = (0 | this.words[t]) - c << r;
              this.words[t] = s | a, a = c >>> 26 - r;
            }

            a && (this.words[t] = a, this.length++);
          }

          if (0 !== i) {
            for (t = this.length - 1; t >= 0; t--) {
              this.words[t + i] = this.words[t];
            }

            for (t = 0; t < i; t++) {
              this.words[t] = 0;
            }

            this.length += i;
          }

          return this.strip();
        }, o.prototype.ishln = function (e) {
          return n(0 === this.negative), this.iushln(e);
        }, o.prototype.iushrn = function (e, t, r) {
          var i;
          n("number" == typeof e && e >= 0), i = t ? (t - t % 26) / 26 : 0;
          var o = e % 26,
              a = Math.min((e - o) / 26, this.length),
              c = 67108863 ^ 67108863 >>> o << o,
              s = r;

          if (i -= a, i = Math.max(0, i), s) {
            for (var f = 0; f < a; f++) {
              s.words[f] = this.words[f];
            }

            s.length = a;
          }

          if (0 === a) ;else if (this.length > a) for (this.length -= a, f = 0; f < this.length; f++) {
            this.words[f] = this.words[f + a];
          } else this.words[0] = 0, this.length = 1;
          var d = 0;

          for (f = this.length - 1; f >= 0 && (0 !== d || f >= i); f--) {
            var u = 0 | this.words[f];
            this.words[f] = d << 26 - o | u >>> o, d = u & c;
          }

          return s && 0 !== d && (s.words[s.length++] = d), 0 === this.length && (this.words[0] = 0, this.length = 1), this.strip();
        }, o.prototype.ishrn = function (e, t, r) {
          return n(0 === this.negative), this.iushrn(e, t, r);
        }, o.prototype.shln = function (e) {
          return this.clone().ishln(e);
        }, o.prototype.ushln = function (e) {
          return this.clone().iushln(e);
        }, o.prototype.shrn = function (e) {
          return this.clone().ishrn(e);
        }, o.prototype.ushrn = function (e) {
          return this.clone().iushrn(e);
        }, o.prototype.testn = function (e) {
          n("number" == typeof e && e >= 0);
          var t = e % 26,
              r = (e - t) / 26,
              i = 1 << t;
          return !(this.length <= r || !(this.words[r] & i));
        }, o.prototype.imaskn = function (e) {
          n("number" == typeof e && e >= 0);
          var t = e % 26,
              r = (e - t) / 26;
          if (n(0 === this.negative, "imaskn works only with positive numbers"), this.length <= r) return this;

          if (0 !== t && r++, this.length = Math.min(r, this.length), 0 !== t) {
            var i = 67108863 ^ 67108863 >>> t << t;
            this.words[this.length - 1] &= i;
          }

          return this.strip();
        }, o.prototype.maskn = function (e) {
          return this.clone().imaskn(e);
        }, o.prototype.iaddn = function (e) {
          return n("number" == typeof e), n(e < 67108864), e < 0 ? this.isubn(-e) : 0 !== this.negative ? 1 === this.length && (0 | this.words[0]) < e ? (this.words[0] = e - (0 | this.words[0]), this.negative = 0, this) : (this.negative = 0, this.isubn(e), this.negative = 1, this) : this._iaddn(e);
        }, o.prototype._iaddn = function (e) {
          this.words[0] += e;

          for (var t = 0; t < this.length && this.words[t] >= 67108864; t++) {
            this.words[t] -= 67108864, t === this.length - 1 ? this.words[t + 1] = 1 : this.words[t + 1]++;
          }

          return this.length = Math.max(this.length, t + 1), this;
        }, o.prototype.isubn = function (e) {
          if (n("number" == typeof e), n(e < 67108864), e < 0) return this.iaddn(-e);
          if (0 !== this.negative) return this.negative = 0, this.iaddn(e), this.negative = 1, this;
          if (this.words[0] -= e, 1 === this.length && this.words[0] < 0) this.words[0] = -this.words[0], this.negative = 1;else for (var t = 0; t < this.length && this.words[t] < 0; t++) {
            this.words[t] += 67108864, this.words[t + 1] -= 1;
          }
          return this.strip();
        }, o.prototype.addn = function (e) {
          return this.clone().iaddn(e);
        }, o.prototype.subn = function (e) {
          return this.clone().isubn(e);
        }, o.prototype.iabs = function () {
          return this.negative = 0, this;
        }, o.prototype.abs = function () {
          return this.clone().iabs();
        }, o.prototype._ishlnsubmul = function (e, t, r) {
          var i,
              o,
              a = e.length + r;

          this._expand(a);

          var c = 0;

          for (i = 0; i < e.length; i++) {
            o = (0 | this.words[i + r]) + c;
            var s = (0 | e.words[i]) * t;
            c = ((o -= 67108863 & s) >> 26) - (s / 67108864 | 0), this.words[i + r] = 67108863 & o;
          }

          for (; i < this.length - r; i++) {
            c = (o = (0 | this.words[i + r]) + c) >> 26, this.words[i + r] = 67108863 & o;
          }

          if (0 === c) return this.strip();

          for (n(-1 === c), c = 0, i = 0; i < this.length; i++) {
            c = (o = -(0 | this.words[i]) + c) >> 26, this.words[i] = 67108863 & o;
          }

          return this.negative = 1, this.strip();
        }, o.prototype._wordDiv = function (e, t) {
          var r = (this.length, e.length),
              n = this.clone(),
              i = e,
              a = 0 | i.words[i.length - 1];
          0 != (r = 26 - this._countBits(a)) && (i = i.ushln(r), n.iushln(r), a = 0 | i.words[i.length - 1]);
          var c,
              s = n.length - i.length;

          if ("mod" !== t) {
            (c = new o(null)).length = s + 1, c.words = new Array(c.length);

            for (var f = 0; f < c.length; f++) {
              c.words[f] = 0;
            }
          }

          var d = n.clone()._ishlnsubmul(i, 1, s);

          0 === d.negative && (n = d, c && (c.words[s] = 1));

          for (var u = s - 1; u >= 0; u--) {
            var h = 67108864 * (0 | n.words[i.length + u]) + (0 | n.words[i.length + u - 1]);

            for (h = Math.min(h / a | 0, 67108863), n._ishlnsubmul(i, h, u); 0 !== n.negative;) {
              h--, n.negative = 0, n._ishlnsubmul(i, 1, u), n.isZero() || (n.negative ^= 1);
            }

            c && (c.words[u] = h);
          }

          return c && c.strip(), n.strip(), "div" !== t && 0 !== r && n.iushrn(r), {
            div: c || null,
            mod: n
          };
        }, o.prototype.divmod = function (e, t, r) {
          return n(!e.isZero()), this.isZero() ? {
            div: new o(0),
            mod: new o(0)
          } : 0 !== this.negative && 0 === e.negative ? (c = this.neg().divmod(e, t), "mod" !== t && (i = c.div.neg()), "div" !== t && (a = c.mod.neg(), r && 0 !== a.negative && a.iadd(e)), {
            div: i,
            mod: a
          }) : 0 === this.negative && 0 !== e.negative ? (c = this.divmod(e.neg(), t), "mod" !== t && (i = c.div.neg()), {
            div: i,
            mod: c.mod
          }) : 0 != (this.negative & e.negative) ? (c = this.neg().divmod(e.neg(), t), "div" !== t && (a = c.mod.neg(), r && 0 !== a.negative && a.isub(e)), {
            div: c.div,
            mod: a
          }) : e.length > this.length || this.cmp(e) < 0 ? {
            div: new o(0),
            mod: this
          } : 1 === e.length ? "div" === t ? {
            div: this.divn(e.words[0]),
            mod: null
          } : "mod" === t ? {
            div: null,
            mod: new o(this.modn(e.words[0]))
          } : {
            div: this.divn(e.words[0]),
            mod: new o(this.modn(e.words[0]))
          } : this._wordDiv(e, t);
          var i, a, c;
        }, o.prototype.div = function (e) {
          return this.divmod(e, "div", !1).div;
        }, o.prototype.mod = function (e) {
          return this.divmod(e, "mod", !1).mod;
        }, o.prototype.umod = function (e) {
          return this.divmod(e, "mod", !0).mod;
        }, o.prototype.divRound = function (e) {
          var t = this.divmod(e);
          if (t.mod.isZero()) return t.div;
          var r = 0 !== t.div.negative ? t.mod.isub(e) : t.mod,
              n = e.ushrn(1),
              i = e.andln(1),
              o = r.cmp(n);
          return o < 0 || 1 === i && 0 === o ? t.div : 0 !== t.div.negative ? t.div.isubn(1) : t.div.iaddn(1);
        }, o.prototype.modn = function (e) {
          n(e <= 67108863);

          for (var t = (1 << 26) % e, r = 0, i = this.length - 1; i >= 0; i--) {
            r = (t * r + (0 | this.words[i])) % e;
          }

          return r;
        }, o.prototype.idivn = function (e) {
          n(e <= 67108863);

          for (var t = 0, r = this.length - 1; r >= 0; r--) {
            var i = (0 | this.words[r]) + 67108864 * t;
            this.words[r] = i / e | 0, t = i % e;
          }

          return this.strip();
        }, o.prototype.divn = function (e) {
          return this.clone().idivn(e);
        }, o.prototype.egcd = function (e) {
          n(0 === e.negative), n(!e.isZero());
          var t = this,
              r = e.clone();
          t = 0 !== t.negative ? t.umod(e) : t.clone();

          for (var i = new o(1), a = new o(0), c = new o(0), s = new o(1), f = 0; t.isEven() && r.isEven();) {
            t.iushrn(1), r.iushrn(1), ++f;
          }

          for (var d = r.clone(), u = t.clone(); !t.isZero();) {
            for (var h = 0, l = 1; 0 == (t.words[0] & l) && h < 26; ++h, l <<= 1) {
              ;
            }

            if (h > 0) for (t.iushrn(h); h-- > 0;) {
              (i.isOdd() || a.isOdd()) && (i.iadd(d), a.isub(u)), i.iushrn(1), a.iushrn(1);
            }

            for (var p = 0, m = 1; 0 == (r.words[0] & m) && p < 26; ++p, m <<= 1) {
              ;
            }

            if (p > 0) for (r.iushrn(p); p-- > 0;) {
              (c.isOdd() || s.isOdd()) && (c.iadd(d), s.isub(u)), c.iushrn(1), s.iushrn(1);
            }
            t.cmp(r) >= 0 ? (t.isub(r), i.isub(c), a.isub(s)) : (r.isub(t), c.isub(i), s.isub(a));
          }

          return {
            a: c,
            b: s,
            gcd: r.iushln(f)
          };
        }, o.prototype._invmp = function (e) {
          n(0 === e.negative), n(!e.isZero());
          var t = this,
              r = e.clone();
          t = 0 !== t.negative ? t.umod(e) : t.clone();

          for (var i, a = new o(1), c = new o(0), s = r.clone(); t.cmpn(1) > 0 && r.cmpn(1) > 0;) {
            for (var f = 0, d = 1; 0 == (t.words[0] & d) && f < 26; ++f, d <<= 1) {
              ;
            }

            if (f > 0) for (t.iushrn(f); f-- > 0;) {
              a.isOdd() && a.iadd(s), a.iushrn(1);
            }

            for (var u = 0, h = 1; 0 == (r.words[0] & h) && u < 26; ++u, h <<= 1) {
              ;
            }

            if (u > 0) for (r.iushrn(u); u-- > 0;) {
              c.isOdd() && c.iadd(s), c.iushrn(1);
            }
            t.cmp(r) >= 0 ? (t.isub(r), a.isub(c)) : (r.isub(t), c.isub(a));
          }

          return (i = 0 === t.cmpn(1) ? a : c).cmpn(0) < 0 && i.iadd(e), i;
        }, o.prototype.gcd = function (e) {
          if (this.isZero()) return e.abs();
          if (e.isZero()) return this.abs();
          var t = this.clone(),
              r = e.clone();
          t.negative = 0, r.negative = 0;

          for (var n = 0; t.isEven() && r.isEven(); n++) {
            t.iushrn(1), r.iushrn(1);
          }

          for (;;) {
            for (; t.isEven();) {
              t.iushrn(1);
            }

            for (; r.isEven();) {
              r.iushrn(1);
            }

            var i = t.cmp(r);

            if (i < 0) {
              var o = t;
              t = r, r = o;
            } else if (0 === i || 0 === r.cmpn(1)) break;

            t.isub(r);
          }

          return r.iushln(n);
        }, o.prototype.invm = function (e) {
          return this.egcd(e).a.umod(e);
        }, o.prototype.isEven = function () {
          return 0 == (1 & this.words[0]);
        }, o.prototype.isOdd = function () {
          return 1 == (1 & this.words[0]);
        }, o.prototype.andln = function (e) {
          return this.words[0] & e;
        }, o.prototype.bincn = function (e) {
          n("number" == typeof e);
          var t = e % 26,
              r = (e - t) / 26,
              i = 1 << t;
          if (this.length <= r) return this._expand(r + 1), this.words[r] |= i, this;

          for (var o = i, a = r; 0 !== o && a < this.length; a++) {
            var c = 0 | this.words[a];
            o = (c += o) >>> 26, c &= 67108863, this.words[a] = c;
          }

          return 0 !== o && (this.words[a] = o, this.length++), this;
        }, o.prototype.isZero = function () {
          return 1 === this.length && 0 === this.words[0];
        }, o.prototype.cmpn = function (e) {
          var t,
              r = e < 0;
          if (0 !== this.negative && !r) return -1;
          if (0 === this.negative && r) return 1;
          if (this.strip(), this.length > 1) t = 1;else {
            r && (e = -e), n(e <= 67108863, "Number is too big");
            var i = 0 | this.words[0];
            t = i === e ? 0 : i < e ? -1 : 1;
          }
          return 0 !== this.negative ? 0 | -t : t;
        }, o.prototype.cmp = function (e) {
          if (0 !== this.negative && 0 === e.negative) return -1;
          if (0 === this.negative && 0 !== e.negative) return 1;
          var t = this.ucmp(e);
          return 0 !== this.negative ? 0 | -t : t;
        }, o.prototype.ucmp = function (e) {
          if (this.length > e.length) return 1;
          if (this.length < e.length) return -1;

          for (var t = 0, r = this.length - 1; r >= 0; r--) {
            var n = 0 | this.words[r],
                i = 0 | e.words[r];

            if (n !== i) {
              n < i ? t = -1 : n > i && (t = 1);
              break;
            }
          }

          return t;
        }, o.prototype.gtn = function (e) {
          return 1 === this.cmpn(e);
        }, o.prototype.gt = function (e) {
          return 1 === this.cmp(e);
        }, o.prototype.gten = function (e) {
          return this.cmpn(e) >= 0;
        }, o.prototype.gte = function (e) {
          return this.cmp(e) >= 0;
        }, o.prototype.ltn = function (e) {
          return -1 === this.cmpn(e);
        }, o.prototype.lt = function (e) {
          return -1 === this.cmp(e);
        }, o.prototype.lten = function (e) {
          return this.cmpn(e) <= 0;
        }, o.prototype.lte = function (e) {
          return this.cmp(e) <= 0;
        }, o.prototype.eqn = function (e) {
          return 0 === this.cmpn(e);
        }, o.prototype.eq = function (e) {
          return 0 === this.cmp(e);
        }, o.red = function (e) {
          return new M(e);
        }, o.prototype.toRed = function (e) {
          return n(!this.red, "Already a number in reduction context"), n(0 === this.negative, "red works only with positives"), e.convertTo(this)._forceRed(e);
        }, o.prototype.fromRed = function () {
          return n(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
        }, o.prototype._forceRed = function (e) {
          return this.red = e, this;
        }, o.prototype.forceRed = function (e) {
          return n(!this.red, "Already a number in reduction context"), this._forceRed(e);
        }, o.prototype.redAdd = function (e) {
          return n(this.red, "redAdd works only with red numbers"), this.red.add(this, e);
        }, o.prototype.redIAdd = function (e) {
          return n(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, e);
        }, o.prototype.redSub = function (e) {
          return n(this.red, "redSub works only with red numbers"), this.red.sub(this, e);
        }, o.prototype.redISub = function (e) {
          return n(this.red, "redISub works only with red numbers"), this.red.isub(this, e);
        }, o.prototype.redShl = function (e) {
          return n(this.red, "redShl works only with red numbers"), this.red.shl(this, e);
        }, o.prototype.redMul = function (e) {
          return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.mul(this, e);
        }, o.prototype.redIMul = function (e) {
          return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.imul(this, e);
        }, o.prototype.redSqr = function () {
          return n(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
        }, o.prototype.redISqr = function () {
          return n(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
        }, o.prototype.redSqrt = function () {
          return n(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
        }, o.prototype.redInvm = function () {
          return n(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
        }, o.prototype.redNeg = function () {
          return n(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
        }, o.prototype.redPow = function (e) {
          return n(this.red && !e.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, e);
        };
        var g = {
          k256: null,
          p224: null,
          p192: null,
          p25519: null
        };

        function v(e, t) {
          this.name = e, this.p = new o(t, 16), this.n = this.p.bitLength(), this.k = new o(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
        }

        function y() {
          v.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
        }

        function w() {
          v.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
        }

        function A() {
          v.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
        }

        function _() {
          v.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
        }

        function M(e) {
          if ("string" == typeof e) {
            var t = o._prime(e);

            this.m = t.p, this.prime = t;
          } else n(e.gtn(1), "modulus must be greater than 1"), this.m = e, this.prime = null;
        }

        function x(e) {
          M.call(this, e), this.shift = this.m.bitLength(), this.shift % 26 != 0 && (this.shift += 26 - this.shift % 26), this.r = new o(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
        }

        v.prototype._tmp = function () {
          var e = new o(null);
          return e.words = new Array(Math.ceil(this.n / 13)), e;
        }, v.prototype.ireduce = function (e) {
          var t,
              r = e;

          do {
            this.split(r, this.tmp), t = (r = (r = this.imulK(r)).iadd(this.tmp)).bitLength();
          } while (t > this.n);

          var n = t < this.n ? -1 : r.ucmp(this.p);
          return 0 === n ? (r.words[0] = 0, r.length = 1) : n > 0 ? r.isub(this.p) : void 0 !== r.strip ? r.strip() : r._strip(), r;
        }, v.prototype.split = function (e, t) {
          e.iushrn(this.n, 0, t);
        }, v.prototype.imulK = function (e) {
          return e.imul(this.k);
        }, i(y, v), y.prototype.split = function (e, t) {
          for (var r = 4194303, n = Math.min(e.length, 9), i = 0; i < n; i++) {
            t.words[i] = e.words[i];
          }

          if (t.length = n, e.length <= 9) return e.words[0] = 0, void (e.length = 1);
          var o = e.words[9];

          for (t.words[t.length++] = o & r, i = 10; i < e.length; i++) {
            var a = 0 | e.words[i];
            e.words[i - 10] = (a & r) << 4 | o >>> 22, o = a;
          }

          o >>>= 22, e.words[i - 10] = o, 0 === o && e.length > 10 ? e.length -= 10 : e.length -= 9;
        }, y.prototype.imulK = function (e) {
          e.words[e.length] = 0, e.words[e.length + 1] = 0, e.length += 2;

          for (var t = 0, r = 0; r < e.length; r++) {
            var n = 0 | e.words[r];
            t += 977 * n, e.words[r] = 67108863 & t, t = 64 * n + (t / 67108864 | 0);
          }

          return 0 === e.words[e.length - 1] && (e.length--, 0 === e.words[e.length - 1] && e.length--), e;
        }, i(w, v), i(A, v), i(_, v), _.prototype.imulK = function (e) {
          for (var t = 0, r = 0; r < e.length; r++) {
            var n = 19 * (0 | e.words[r]) + t,
                i = 67108863 & n;
            n >>>= 26, e.words[r] = i, t = n;
          }

          return 0 !== t && (e.words[e.length++] = t), e;
        }, o._prime = function (e) {
          if (g[e]) return g[e];
          var t;
          if ("k256" === e) t = new y();else if ("p224" === e) t = new w();else if ("p192" === e) t = new A();else {
            if ("p25519" !== e) throw new Error("Unknown prime " + e);
            t = new _();
          }
          return g[e] = t, t;
        }, M.prototype._verify1 = function (e) {
          n(0 === e.negative, "red works only with positives"), n(e.red, "red works only with red numbers");
        }, M.prototype._verify2 = function (e, t) {
          n(0 == (e.negative | t.negative), "red works only with positives"), n(e.red && e.red === t.red, "red works only with red numbers");
        }, M.prototype.imod = function (e) {
          return this.prime ? this.prime.ireduce(e)._forceRed(this) : e.umod(this.m)._forceRed(this);
        }, M.prototype.neg = function (e) {
          return e.isZero() ? e.clone() : this.m.sub(e)._forceRed(this);
        }, M.prototype.add = function (e, t) {
          this._verify2(e, t);

          var r = e.add(t);
          return r.cmp(this.m) >= 0 && r.isub(this.m), r._forceRed(this);
        }, M.prototype.iadd = function (e, t) {
          this._verify2(e, t);

          var r = e.iadd(t);
          return r.cmp(this.m) >= 0 && r.isub(this.m), r;
        }, M.prototype.sub = function (e, t) {
          this._verify2(e, t);

          var r = e.sub(t);
          return r.cmpn(0) < 0 && r.iadd(this.m), r._forceRed(this);
        }, M.prototype.isub = function (e, t) {
          this._verify2(e, t);

          var r = e.isub(t);
          return r.cmpn(0) < 0 && r.iadd(this.m), r;
        }, M.prototype.shl = function (e, t) {
          return this._verify1(e), this.imod(e.ushln(t));
        }, M.prototype.imul = function (e, t) {
          return this._verify2(e, t), this.imod(e.imul(t));
        }, M.prototype.mul = function (e, t) {
          return this._verify2(e, t), this.imod(e.mul(t));
        }, M.prototype.isqr = function (e) {
          return this.imul(e, e.clone());
        }, M.prototype.sqr = function (e) {
          return this.mul(e, e);
        }, M.prototype.sqrt = function (e) {
          if (e.isZero()) return e.clone();
          var t = this.m.andln(3);

          if (n(t % 2 == 1), 3 === t) {
            var r = this.m.add(new o(1)).iushrn(2);
            return this.pow(e, r);
          }

          for (var i = this.m.subn(1), a = 0; !i.isZero() && 0 === i.andln(1);) {
            a++, i.iushrn(1);
          }

          n(!i.isZero());
          var c = new o(1).toRed(this),
              s = c.redNeg(),
              f = this.m.subn(1).iushrn(1),
              d = this.m.bitLength();

          for (d = new o(2 * d * d).toRed(this); 0 !== this.pow(d, f).cmp(s);) {
            d.redIAdd(s);
          }

          for (var u = this.pow(d, i), h = this.pow(e, i.addn(1).iushrn(1)), l = this.pow(e, i), p = a; 0 !== l.cmp(c);) {
            for (var m = l, b = 0; 0 !== m.cmp(c); b++) {
              m = m.redSqr();
            }

            n(b < p);
            var g = this.pow(u, new o(1).iushln(p - b - 1));
            h = h.redMul(g), u = g.redSqr(), l = l.redMul(u), p = b;
          }

          return h;
        }, M.prototype.invm = function (e) {
          var t = e._invmp(this.m);

          return 0 !== t.negative ? (t.negative = 0, this.imod(t).redNeg()) : this.imod(t);
        }, M.prototype.pow = function (e, t) {
          if (t.isZero()) return new o(1).toRed(this);
          if (0 === t.cmpn(1)) return e.clone();
          var r = new Array(16);
          r[0] = new o(1).toRed(this), r[1] = e;

          for (var n = 2; n < r.length; n++) {
            r[n] = this.mul(r[n - 1], e);
          }

          var i = r[0],
              a = 0,
              c = 0,
              s = t.bitLength() % 26;

          for (0 === s && (s = 26), n = t.length - 1; n >= 0; n--) {
            for (var f = t.words[n], d = s - 1; d >= 0; d--) {
              var u = f >> d & 1;
              i !== r[0] && (i = this.sqr(i)), 0 !== u || 0 !== a ? (a <<= 1, a |= u, (4 == ++c || 0 === n && 0 === d) && (i = this.mul(i, r[a]), c = 0, a = 0)) : c = 0;
            }

            s = 26;
          }

          return i;
        }, M.prototype.convertTo = function (e) {
          var t = e.umod(this.m);
          return t === e ? t.clone() : t;
        }, M.prototype.convertFrom = function (e) {
          var t = e.clone();
          return t.red = null, t;
        }, o.mont = function (e) {
          return new x(e);
        }, i(x, M), x.prototype.convertTo = function (e) {
          return this.imod(e.ushln(this.shift));
        }, x.prototype.convertFrom = function (e) {
          var t = this.imod(e.mul(this.rinv));
          return t.red = null, t;
        }, x.prototype.imul = function (e, t) {
          if (e.isZero() || t.isZero()) return e.words[0] = 0, e.length = 1, e;
          var r = e.imul(t),
              n = r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
              i = r.isub(n).iushrn(this.shift),
              o = i;
          return i.cmp(this.m) >= 0 ? o = i.isub(this.m) : i.cmpn(0) < 0 && (o = i.iadd(this.m)), o._forceRed(this);
        }, x.prototype.mul = function (e, t) {
          if (e.isZero() || t.isZero()) return new o(0)._forceRed(this);
          var r = e.mul(t),
              n = r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
              i = r.isub(n).iushrn(this.shift),
              a = i;
          return i.cmp(this.m) >= 0 ? a = i.isub(this.m) : i.cmpn(0) < 0 && (a = i.iadd(this.m)), a._forceRed(this);
        }, x.prototype.invm = function (e) {
          return this.imod(e._invmp(this.m).mul(this.r2))._forceRed(this);
        };
      }(e = r.nmd(e), this);
    },
    8522: function _(e, t, r) {
      try {
        var n = r(3837);
        if ("function" != typeof n.inherits) throw "";
        e.exports = n.inherits;
      } catch (t) {
        e.exports = r(9610);
      }
    },
    9610: function _(e) {
      "function" == typeof Object.create ? e.exports = function (e, t) {
        t && (e.super_ = t, e.prototype = Object.create(t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }));
      } : e.exports = function (e, t) {
        if (t) {
          e.super_ = t;

          var r = function r() {};

          r.prototype = t.prototype, e.prototype = new r(), e.prototype.constructor = e;
        }
      };
    },
    5443: function _(e, t) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.createHashFunction = function (e) {
        return function (t) {
          var r = e();
          return r.update(t), Buffer.from(r.digest());
        };
      };
    },
    2192: function _(e, t, r) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var n = r(5443),
          i = r(5221);
      t.keccak224 = n.createHashFunction(function () {
        return i("keccak224");
      }), t.keccak256 = n.createHashFunction(function () {
        return i("keccak256");
      }), t.keccak384 = n.createHashFunction(function () {
        return i("keccak384");
      }), t.keccak512 = n.createHashFunction(function () {
        return i("keccak512");
      });
    },
    472: function _(e, t, r) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var n = r(1353);
      t.getRandomBytes = function (e) {
        return new Promise(function (t, r) {
          n(e, function (e, n) {
            e ? r(e) : t(n);
          });
        });
      }, t.getRandomBytesSync = function (e) {
        return n(e);
      };
    },
    5053: function _(e, t, r) {
      "use strict";

      var n = this && this.__awaiter || function (e, t, r, n) {
        return new (r || (r = Promise))(function (i, o) {
          function a(e) {
            try {
              s(n.next(e));
            } catch (e) {
              o(e);
            }
          }

          function c(e) {
            try {
              s(n.throw(e));
            } catch (e) {
              o(e);
            }
          }

          function s(e) {
            var t;
            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function (e) {
              e(t);
            })).then(a, c);
          }

          s((n = n.apply(e, t || [])).next());
        });
      },
          i = this && this.__generator || function (e, t) {
        var r,
            n,
            i,
            o,
            a = {
          label: 0,
          sent: function sent() {
            if (1 & i[0]) throw i[1];
            return i[1];
          },
          trys: [],
          ops: []
        };
        return o = {
          next: c(0),
          throw: c(1),
          return: c(2)
        }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
          return this;
        }), o;

        function c(o) {
          return function (c) {
            return function (o) {
              if (r) throw new TypeError("Generator is already executing.");

              for (; a;) {
                try {
                  if (r = 1, n && (i = 2 & o[0] ? n.return : o[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, o[1])).done) return i;

                  switch (n = 0, i && (o = [2 & o[0], i.value]), o[0]) {
                    case 0:
                    case 1:
                      i = o;
                      break;

                    case 4:
                      return a.label++, {
                        value: o[1],
                        done: !1
                      };

                    case 5:
                      a.label++, n = o[1], o = [0];
                      continue;

                    case 7:
                      o = a.ops.pop(), a.trys.pop();
                      continue;

                    default:
                      if (!((i = (i = a.trys).length > 0 && i[i.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                        a = 0;
                        continue;
                      }

                      if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                        a.label = o[1];
                        break;
                      }

                      if (6 === o[0] && a.label < i[1]) {
                        a.label = i[1], i = o;
                        break;
                      }

                      if (i && a.label < i[2]) {
                        a.label = i[2], a.ops.push(o);
                        break;
                      }

                      i[2] && a.ops.pop(), a.trys.pop();
                      continue;
                  }

                  o = t.call(e, a);
                } catch (e) {
                  o = [6, e], n = 0;
                } finally {
                  r = i = 0;
                }
              }

              if (5 & o[0]) throw o[1];
              return {
                value: o[0] ? o[1] : void 0,
                done: !0
              };
            }([o, c]);
          };
        }
      };

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var o = r(7972),
          a = r(472);
      t.createPrivateKey = function () {
        return n(this, void 0, void 0, function () {
          var e;
          return i(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, a.getRandomBytes(32)];

              case 1:
                return e = t.sent(), o.privateKeyVerify(e) ? [2, e] : [3, 0];

              case 2:
                return [2];
            }
          });
        });
      }, t.createPrivateKeySync = function () {
        for (;;) {
          var e = a.getRandomBytesSync(32);
          if (o.privateKeyVerify(e)) return e;
        }
      }, function (e) {
        for (var r in e) {
          t.hasOwnProperty(r) || (t[r] = e[r]);
        }
      }(r(7972));
    },
    8604: function _(e, t, r) {
      "use strict";

      var n = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.isZeroAddress = t.zeroAddress = t.importPublic = t.privateToAddress = t.privateToPublic = t.publicToAddress = t.pubToAddress = t.isValidPublic = t.isValidPrivate = t.generateAddress2 = t.generateAddress = t.isValidChecksumAddress = t.toChecksumAddress = t.isValidAddress = t.Account = void 0;
      var i = n(r(9491)),
          o = r(4668),
          a = r(5053),
          c = r(6865),
          s = r(4964),
          f = r(277),
          d = r(1440),
          u = r(2343),
          h = r(1988);

      var l = /*#__PURE__*/function () {
        function l() {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new o.BN(0);
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new o.BN(0);
          var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : s.KECCAK256_RLP;
          var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : s.KECCAK256_NULL;

          _classCallCheck(this, l);

          this.nonce = e, this.balance = t, this.stateRoot = r, this.codeHash = n, this._validate();
        }

        _createClass(l, [{
          key: "_validate",
          value: function _validate() {
            if (this.nonce.lt(new o.BN(0))) throw new Error("nonce must be greater than zero");
            if (this.balance.lt(new o.BN(0))) throw new Error("balance must be greater than zero");
            if (32 !== this.stateRoot.length) throw new Error("stateRoot must have a length of 32");
            if (32 !== this.codeHash.length) throw new Error("codeHash must have a length of 32");
          }
        }, {
          key: "raw",
          value: function raw() {
            return [(0, h.bnToUnpaddedBuffer)(this.nonce), (0, h.bnToUnpaddedBuffer)(this.balance), this.stateRoot, this.codeHash];
          }
        }, {
          key: "serialize",
          value: function serialize() {
            return o.rlp.encode(this.raw());
          }
        }, {
          key: "isContract",
          value: function isContract() {
            return !this.codeHash.equals(s.KECCAK256_NULL);
          }
        }, {
          key: "isEmpty",
          value: function isEmpty() {
            return this.balance.isZero() && this.nonce.isZero() && this.codeHash.equals(s.KECCAK256_NULL);
          }
        }], [{
          key: "fromAccountData",
          value: function fromAccountData(e) {
            var t = e.nonce,
                r = e.balance,
                n = e.stateRoot,
                i = e.codeHash;
            return new l(t ? new o.BN((0, f.toBuffer)(t)) : void 0, r ? new o.BN((0, f.toBuffer)(r)) : void 0, n ? (0, f.toBuffer)(n) : void 0, i ? (0, f.toBuffer)(i) : void 0);
          }
        }, {
          key: "fromRlpSerializedAccount",
          value: function fromRlpSerializedAccount(e) {
            var t = o.rlp.decode(e);
            if (!Array.isArray(t)) throw new Error("Invalid serialized account input. Must be array");
            return this.fromValuesArray(t);
          }
        }, {
          key: "fromValuesArray",
          value: function fromValuesArray(e) {
            var _e8 = _slicedToArray(e, 4),
                t = _e8[0],
                r = _e8[1],
                n = _e8[2],
                i = _e8[3];

            return new l(new o.BN(t), new o.BN(r), n, i);
          }
        }]);

        return l;
      }();

      t.Account = l, t.isValidAddress = function (e) {
        try {
          (0, u.assertIsString)(e);
        } catch (e) {
          return !1;
        }

        return /^0x[0-9a-fA-F]{40}$/.test(e);
      }, t.toChecksumAddress = function (e, t) {
        (0, u.assertIsHexString)(e);
        var r = (0, c.stripHexPrefix)(e).toLowerCase();
        var n = "";
        t && (n = (0, h.toType)(t, h.TypeOutput.BN).toString() + "0x");
        var i = (0, d.keccakFromString)(n + r).toString("hex");
        var o = "0x";

        for (var _e9 = 0; _e9 < r.length; _e9++) {
          parseInt(i[_e9], 16) >= 8 ? o += r[_e9].toUpperCase() : o += r[_e9];
        }

        return o;
      }, t.isValidChecksumAddress = function (e, r) {
        return (0, t.isValidAddress)(e) && (0, t.toChecksumAddress)(e, r) === e;
      }, t.generateAddress = function (e, t) {
        (0, u.assertIsBuffer)(e), (0, u.assertIsBuffer)(t);
        var r = new o.BN(t);
        return r.isZero() ? (0, d.rlphash)([e, null]).slice(-20) : (0, d.rlphash)([e, Buffer.from(r.toArray())]).slice(-20);
      }, t.generateAddress2 = function (e, t, r) {
        return (0, u.assertIsBuffer)(e), (0, u.assertIsBuffer)(t), (0, u.assertIsBuffer)(r), (0, i.default)(20 === e.length), (0, i.default)(32 === t.length), (0, d.keccak256)(Buffer.concat([Buffer.from("ff", "hex"), e, t, (0, d.keccak256)(r)])).slice(-20);
      }, t.isValidPrivate = function (e) {
        return (0, a.privateKeyVerify)(e);
      }, t.isValidPublic = function (e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
        return (0, u.assertIsBuffer)(e), 64 === e.length ? (0, a.publicKeyVerify)(Buffer.concat([Buffer.from([4]), e])) : !!t && (0, a.publicKeyVerify)(e);
      }, t.pubToAddress = function (e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
        return (0, u.assertIsBuffer)(e), t && 64 !== e.length && (e = Buffer.from((0, a.publicKeyConvert)(e, !1).slice(1))), (0, i.default)(64 === e.length), (0, d.keccak)(e).slice(-20);
      }, t.publicToAddress = t.pubToAddress, t.privateToPublic = function (e) {
        return (0, u.assertIsBuffer)(e), Buffer.from((0, a.publicKeyCreate)(e, !1)).slice(1);
      }, t.privateToAddress = function (e) {
        return (0, t.publicToAddress)((0, t.privateToPublic)(e));
      }, t.importPublic = function (e) {
        return (0, u.assertIsBuffer)(e), 64 !== e.length && (e = Buffer.from((0, a.publicKeyConvert)(e, !1).slice(1))), e;
      }, t.zeroAddress = function () {
        var e = (0, f.zeros)(20);
        return (0, f.bufferToHex)(e);
      }, t.isZeroAddress = function (e) {
        try {
          (0, u.assertIsString)(e);
        } catch (e) {
          return !1;
        }

        return (0, t.zeroAddress)() === e;
      };
    },
    3653: function _(e, t, r) {
      "use strict";

      var n = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.Address = void 0;
      var i = n(r(9491)),
          o = r(4668),
          a = r(277),
          c = r(8604);

      var s = /*#__PURE__*/function () {
        function s(e) {
          _classCallCheck(this, s);

          (0, i.default)(20 === e.length, "Invalid address length"), this.buf = e;
        }

        _createClass(s, [{
          key: "equals",
          value: function equals(e) {
            return this.buf.equals(e.buf);
          }
        }, {
          key: "isZero",
          value: function isZero() {
            return this.equals(s.zero());
          }
        }, {
          key: "isPrecompileOrSystemAddress",
          value: function isPrecompileOrSystemAddress() {
            var e = new o.BN(this.buf),
                t = new o.BN(0),
                r = new o.BN("ffff", "hex");
            return e.gte(t) && e.lte(r);
          }
        }, {
          key: "toString",
          value: function toString() {
            return "0x" + this.buf.toString("hex");
          }
        }, {
          key: "toBuffer",
          value: function toBuffer() {
            return Buffer.from(this.buf);
          }
        }], [{
          key: "zero",
          value: function zero() {
            return new s((0, a.zeros)(20));
          }
        }, {
          key: "fromString",
          value: function fromString(e) {
            return (0, i.default)((0, c.isValidAddress)(e), "Invalid address"), new s((0, a.toBuffer)(e));
          }
        }, {
          key: "fromPublicKey",
          value: function fromPublicKey(e) {
            (0, i.default)(Buffer.isBuffer(e), "Public key should be Buffer");
            var t = (0, c.pubToAddress)(e);
            return new s(t);
          }
        }, {
          key: "fromPrivateKey",
          value: function fromPrivateKey(e) {
            (0, i.default)(Buffer.isBuffer(e), "Private key should be Buffer");
            var t = (0, c.privateToAddress)(e);
            return new s(t);
          }
        }, {
          key: "generate",
          value: function generate(e, t) {
            return (0, i.default)(o.BN.isBN(t)), new s((0, c.generateAddress)(e.buf, t.toArrayLike(Buffer)));
          }
        }, {
          key: "generate2",
          value: function generate2(e, t, r) {
            return (0, i.default)(Buffer.isBuffer(t)), (0, i.default)(Buffer.isBuffer(r)), new s((0, c.generateAddress2)(e.buf, t, r));
          }
        }]);

        return s;
      }();

      t.Address = s;
    },
    277: function _(e, t, r) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.bufArrToArr = t.arrToBufArr = t.validateNoLeadingZeroes = t.baToJSON = t.toUtf8 = t.addHexPrefix = t.toUnsigned = t.fromSigned = t.bufferToHex = t.bufferToInt = t.toBuffer = t.unpadHexString = t.unpadArray = t.unpadBuffer = t.setLengthRight = t.setLengthLeft = t.zeros = t.intToBuffer = t.intToHex = void 0;
      var n = r(4668),
          i = r(6865),
          o = r(2343);
      t.intToHex = function (e) {
        if (!Number.isSafeInteger(e) || e < 0) throw new Error("Received an invalid integer type: ".concat(e));
        return "0x".concat(e.toString(16));
      }, t.intToBuffer = function (e) {
        var r = (0, t.intToHex)(e);
        return Buffer.from((0, i.padToEven)(r.slice(2)), "hex");
      }, t.zeros = function (e) {
        return Buffer.allocUnsafe(e).fill(0);
      };

      var a = function a(e, r, n) {
        var i = (0, t.zeros)(r);
        return n ? e.length < r ? (e.copy(i), i) : e.slice(0, r) : e.length < r ? (e.copy(i, r - e.length), i) : e.slice(-r);
      };

      t.setLengthLeft = function (e, t) {
        return (0, o.assertIsBuffer)(e), a(e, t, !1);
      }, t.setLengthRight = function (e, t) {
        return (0, o.assertIsBuffer)(e), a(e, t, !0);
      };

      var c = function c(e) {
        var t = e[0];

        for (; e.length > 0 && "0" === t.toString();) {
          t = (e = e.slice(1))[0];
        }

        return e;
      };

      t.unpadBuffer = function (e) {
        return (0, o.assertIsBuffer)(e), c(e);
      }, t.unpadArray = function (e) {
        return (0, o.assertIsArray)(e), c(e);
      }, t.unpadHexString = function (e) {
        return (0, o.assertIsHexString)(e), e = (0, i.stripHexPrefix)(e), c(e);
      }, t.toBuffer = function (e) {
        if (null == e) return Buffer.allocUnsafe(0);
        if (Buffer.isBuffer(e)) return Buffer.from(e);
        if (Array.isArray(e) || e instanceof Uint8Array) return Buffer.from(e);

        if ("string" == typeof e) {
          if (!(0, i.isHexString)(e)) throw new Error("Cannot convert string to buffer. toBuffer only supports 0x-prefixed hex strings and this string was given: ".concat(e));
          return Buffer.from((0, i.padToEven)((0, i.stripHexPrefix)(e)), "hex");
        }

        if ("number" == typeof e) return (0, t.intToBuffer)(e);

        if (n.BN.isBN(e)) {
          if (e.isNeg()) throw new Error("Cannot convert negative BN to buffer. Given: ".concat(e));
          return e.toArrayLike(Buffer);
        }

        if (e.toArray) return Buffer.from(e.toArray());
        if (e.toBuffer) return Buffer.from(e.toBuffer());
        throw new Error("invalid type");
      }, t.bufferToInt = function (e) {
        return new n.BN((0, t.toBuffer)(e)).toNumber();
      }, t.bufferToHex = function (e) {
        return "0x" + (e = (0, t.toBuffer)(e)).toString("hex");
      }, t.fromSigned = function (e) {
        return new n.BN(e).fromTwos(256);
      }, t.toUnsigned = function (e) {
        return Buffer.from(e.toTwos(256).toArray());
      }, t.addHexPrefix = function (e) {
        return "string" != typeof e || (0, i.isHexPrefixed)(e) ? e : "0x" + e;
      }, t.toUtf8 = function (e) {
        if ((e = (0, i.stripHexPrefix)(e)).length % 2 != 0) throw new Error("Invalid non-even hex string input for toUtf8() provided");
        return Buffer.from(e.replace(/^(00)+|(00)+$/g, ""), "hex").toString("utf8");
      }, t.baToJSON = function (e) {
        if (Buffer.isBuffer(e)) return "0x".concat(e.toString("hex"));

        if (e instanceof Array) {
          var _r7 = [];

          for (var _n7 = 0; _n7 < e.length; _n7++) {
            _r7.push((0, t.baToJSON)(e[_n7]));
          }

          return _r7;
        }
      }, t.validateNoLeadingZeroes = function (e) {
        for (var _i2 = 0, _Object$entries = Object.entries(e); _i2 < _Object$entries.length; _i2++) {
          var _Object$entries$_i = _slicedToArray(_Object$entries[_i2], 2),
              _t7 = _Object$entries$_i[0],
              _r8 = _Object$entries$_i[1];

          if (void 0 !== _r8 && _r8.length > 0 && 0 === _r8[0]) throw new Error("".concat(_t7, " cannot have leading zeroes, received: ").concat(_r8.toString("hex")));
        }
      }, t.arrToBufArr = function e(t) {
        return Array.isArray(t) ? t.map(function (t) {
          return e(t);
        }) : Buffer.from(t);
      }, t.bufArrToArr = function e(t) {
        return Array.isArray(t) ? t.map(function (t) {
          return e(t);
        }) : Uint8Array.from(null != t ? t : []);
      };
    },
    4964: function _(e, t, r) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.KECCAK256_RLP = t.KECCAK256_RLP_S = t.KECCAK256_RLP_ARRAY = t.KECCAK256_RLP_ARRAY_S = t.KECCAK256_NULL = t.KECCAK256_NULL_S = t.TWO_POW256 = t.MAX_INTEGER = t.MAX_UINT64 = void 0;
      var n = r(4300),
          i = r(4668);
      t.MAX_UINT64 = new i.BN("ffffffffffffffff", 16), t.MAX_INTEGER = new i.BN("ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff", 16), t.TWO_POW256 = new i.BN("10000000000000000000000000000000000000000000000000000000000000000", 16), t.KECCAK256_NULL_S = "c5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470", t.KECCAK256_NULL = n.Buffer.from(t.KECCAK256_NULL_S, "hex"), t.KECCAK256_RLP_ARRAY_S = "1dcc4de8dec75d7aab85b567b6ccd41ad312451b948a7413f0a142fd40d49347", t.KECCAK256_RLP_ARRAY = n.Buffer.from(t.KECCAK256_RLP_ARRAY_S, "hex"), t.KECCAK256_RLP_S = "56e81f171bcc55a6ff8345e692c0f86e5b48e01b996cadc001622fb5e363b421", t.KECCAK256_RLP = n.Buffer.from(t.KECCAK256_RLP_S, "hex");
    },
    4668: function _(e, t, r) {
      "use strict";

      var n = this && this.__createBinding || (Object.create ? function (e, t, r, n) {
        void 0 === n && (n = r), Object.defineProperty(e, n, {
          enumerable: !0,
          get: function get() {
            return t[r];
          }
        });
      } : function (e, t, r, n) {
        void 0 === n && (n = r), e[n] = t[r];
      }),
          i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
          o = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var r in e) {
          "default" !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
        }
        return i(t, e), t;
      },
          a = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.rlp = t.BN = void 0;
      var c = a(r(3550));
      t.BN = c.default;
      var s = o(r(6636));
      t.rlp = s;
    },
    1440: function _(e, t, r) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.rlphash = t.ripemd160FromArray = t.ripemd160FromString = t.ripemd160 = t.sha256FromArray = t.sha256FromString = t.sha256 = t.keccakFromArray = t.keccakFromHexString = t.keccakFromString = t.keccak256 = t.keccak = void 0;
      var n = r(2192),
          i = r(9913),
          o = r(4668),
          a = r(277),
          c = r(2343);
      t.keccak = function (e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 256;

        switch ((0, c.assertIsBuffer)(e), t) {
          case 224:
            return (0, n.keccak224)(e);

          case 256:
            return (0, n.keccak256)(e);

          case 384:
            return (0, n.keccak384)(e);

          case 512:
            return (0, n.keccak512)(e);

          default:
            throw new Error("Invald algorithm: keccak".concat(t));
        }
      }, t.keccak256 = function (e) {
        return (0, t.keccak)(e);
      }, t.keccakFromString = function (e) {
        var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 256;
        (0, c.assertIsString)(e);
        var n = Buffer.from(e, "utf8");
        return (0, t.keccak)(n, r);
      }, t.keccakFromHexString = function (e) {
        var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 256;
        return (0, c.assertIsHexString)(e), (0, t.keccak)((0, a.toBuffer)(e), r);
      }, t.keccakFromArray = function (e) {
        var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 256;
        return (0, c.assertIsArray)(e), (0, t.keccak)((0, a.toBuffer)(e), r);
      };

      var s = function s(e) {
        return e = (0, a.toBuffer)(e), i("sha256").update(e).digest();
      };

      t.sha256 = function (e) {
        return (0, c.assertIsBuffer)(e), s(e);
      }, t.sha256FromString = function (e) {
        return (0, c.assertIsString)(e), s(e);
      }, t.sha256FromArray = function (e) {
        return (0, c.assertIsArray)(e), s(e);
      };

      var f = function f(e, t) {
        e = (0, a.toBuffer)(e);
        var r = i("rmd160").update(e).digest();
        return !0 === t ? (0, a.setLengthLeft)(r, 32) : r;
      };

      t.ripemd160 = function (e, t) {
        return (0, c.assertIsBuffer)(e), f(e, t);
      }, t.ripemd160FromString = function (e, t) {
        return (0, c.assertIsString)(e), f(e, t);
      }, t.ripemd160FromArray = function (e, t) {
        return (0, c.assertIsArray)(e), f(e, t);
      }, t.rlphash = function (e) {
        return (0, t.keccak)(o.rlp.encode(e));
      };
    },
    2343: function _(e, t, r) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.assertIsString = t.assertIsArray = t.assertIsBuffer = t.assertIsHexString = void 0;
      var n = r(6865);
      t.assertIsHexString = function (e) {
        if (!(0, n.isHexString)(e)) throw new Error("This method only supports 0x-prefixed hex strings but input was: ".concat(e));
      }, t.assertIsBuffer = function (e) {
        if (!Buffer.isBuffer(e)) throw new Error("This method only supports Buffer but input was: ".concat(e));
      }, t.assertIsArray = function (e) {
        if (!Array.isArray(e)) throw new Error("This method only supports number arrays but input was: ".concat(e));
      }, t.assertIsString = function (e) {
        if ("string" != typeof e) throw new Error("This method only supports strings but input was: ".concat(e));
      };
    },
    1964: function _(e, t, r) {
      "use strict";

      var n = this && this.__createBinding || (Object.create ? function (e, t, r, n) {
        void 0 === n && (n = r), Object.defineProperty(e, n, {
          enumerable: !0,
          get: function get() {
            return t[r];
          }
        });
      } : function (e, t, r, n) {
        void 0 === n && (n = r), e[n] = t[r];
      }),
          i = this && this.__exportStar || function (e, t) {
        for (var r in e) {
          "default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
        }
      };

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.isHexString = t.getKeys = t.fromAscii = t.fromUtf8 = t.toAscii = t.arrayContainsArray = t.getBinarySize = t.padToEven = t.stripHexPrefix = t.isHexPrefixed = void 0, i(r(4964), t), i(r(8604), t), i(r(3653), t), i(r(1440), t), i(r(6346), t), i(r(277), t), i(r(9810), t), i(r(4668), t), i(r(1988), t);
      var o = r(6865);
      Object.defineProperty(t, "isHexPrefixed", {
        enumerable: !0,
        get: function get() {
          return o.isHexPrefixed;
        }
      }), Object.defineProperty(t, "stripHexPrefix", {
        enumerable: !0,
        get: function get() {
          return o.stripHexPrefix;
        }
      }), Object.defineProperty(t, "padToEven", {
        enumerable: !0,
        get: function get() {
          return o.padToEven;
        }
      }), Object.defineProperty(t, "getBinarySize", {
        enumerable: !0,
        get: function get() {
          return o.getBinarySize;
        }
      }), Object.defineProperty(t, "arrayContainsArray", {
        enumerable: !0,
        get: function get() {
          return o.arrayContainsArray;
        }
      }), Object.defineProperty(t, "toAscii", {
        enumerable: !0,
        get: function get() {
          return o.toAscii;
        }
      }), Object.defineProperty(t, "fromUtf8", {
        enumerable: !0,
        get: function get() {
          return o.fromUtf8;
        }
      }), Object.defineProperty(t, "fromAscii", {
        enumerable: !0,
        get: function get() {
          return o.fromAscii;
        }
      }), Object.defineProperty(t, "getKeys", {
        enumerable: !0,
        get: function get() {
          return o.getKeys;
        }
      }), Object.defineProperty(t, "isHexString", {
        enumerable: !0,
        get: function get() {
          return o.isHexString;
        }
      });
    },
    6865: function _(e, t) {
      "use strict";

      function r(e) {
        if ("string" != typeof e) throw new Error("[isHexPrefixed] input must be type 'string', received type " + typeof e);
        return "0" === e[0] && "x" === e[1];
      }

      function n(e) {
        var t = e;
        if ("string" != typeof t) throw new Error("[padToEven] value must be type 'string', received " + typeof t);
        return t.length % 2 && (t = "0".concat(t)), t;
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.isHexString = t.getKeys = t.fromAscii = t.fromUtf8 = t.toAscii = t.arrayContainsArray = t.getBinarySize = t.padToEven = t.stripHexPrefix = t.isHexPrefixed = void 0, t.isHexPrefixed = r, t.stripHexPrefix = function (e) {
        if ("string" != typeof e) throw new Error("[stripHexPrefix] input must be type 'string', received " + typeof e);
        return r(e) ? e.slice(2) : e;
      }, t.padToEven = n, t.getBinarySize = function (e) {
        if ("string" != typeof e) throw new Error("[getBinarySize] method requires input type 'string', recieved " + typeof e);
        return Buffer.byteLength(e, "utf8");
      }, t.arrayContainsArray = function (e, t, r) {
        if (!0 !== Array.isArray(e)) throw new Error("[arrayContainsArray] method requires input 'superset' to be an array, got type '".concat(typeof e, "'"));
        if (!0 !== Array.isArray(t)) throw new Error("[arrayContainsArray] method requires input 'subset' to be an array, got type '".concat(typeof t, "'"));
        return t[r ? "some" : "every"](function (t) {
          return e.indexOf(t) >= 0;
        });
      }, t.toAscii = function (e) {
        var t = "",
            r = 0;
        var n = e.length;

        for ("0x" === e.substring(0, 2) && (r = 2); r < n; r += 2) {
          var _n8 = parseInt(e.substr(r, 2), 16);

          t += String.fromCharCode(_n8);
        }

        return t;
      }, t.fromUtf8 = function (e) {
        return "0x".concat(n(Buffer.from(e, "utf8").toString("hex")).replace(/^0+|0+$/g, ""));
      }, t.fromAscii = function (e) {
        var t = "";

        for (var _r9 = 0; _r9 < e.length; _r9++) {
          var _n9 = e.charCodeAt(_r9).toString(16);

          t += _n9.length < 2 ? "0".concat(_n9) : _n9;
        }

        return "0x".concat(t);
      }, t.getKeys = function (e, t, r) {
        if (!Array.isArray(e)) throw new Error("[getKeys] method expects input 'params' to be an array, got " + typeof e);
        if ("string" != typeof t) throw new Error("[getKeys] method expects input 'key' to be type 'string', got " + typeof e);
        var n = [];

        for (var i = 0; i < e.length; i++) {
          var o = e[i][t];
          if (r && !o) o = "";else if ("string" != typeof o) throw new Error("invalid abi - expected type 'string', received " + typeof o);
          n.push(o);
        }

        return n;
      }, t.isHexString = function (e, t) {
        return !("string" != typeof e || !e.match(/^0x[0-9A-Fa-f]*$/) || t && e.length !== 2 + 2 * t);
      };
    },
    9810: function _(e, t, r) {
      "use strict";

      var n = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.defineProperties = void 0;
      var i = n(r(9491)),
          o = r(6865),
          a = r(4668),
          c = r(277);

      t.defineProperties = function (e, t, r) {
        if (e.raw = [], e._fields = [], e.toJSON = function () {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;

          if (t) {
            var _t8 = {};
            return e._fields.forEach(function (r) {
              _t8[r] = "0x".concat(e[r].toString("hex"));
            }), _t8;
          }

          return (0, c.baToJSON)(e.raw);
        }, e.serialize = function () {
          return a.rlp.encode(e.raw);
        }, t.forEach(function (t, r) {
          function n() {
            return e.raw[r];
          }

          function o(n) {
            "00" !== (n = (0, c.toBuffer)(n)).toString("hex") || t.allowZero || (n = Buffer.allocUnsafe(0)), t.allowLess && t.length ? (n = (0, c.unpadBuffer)(n), (0, i.default)(t.length >= n.length, "The field ".concat(t.name, " must not have more ").concat(t.length, " bytes"))) : t.allowZero && 0 === n.length || !t.length || (0, i.default)(t.length === n.length, "The field ".concat(t.name, " must have byte length of ").concat(t.length)), e.raw[r] = n;
          }

          e._fields.push(t.name), Object.defineProperty(e, t.name, {
            enumerable: !0,
            configurable: !0,
            get: n,
            set: o
          }), t.default && (e[t.name] = t.default), t.alias && Object.defineProperty(e, t.alias, {
            enumerable: !1,
            configurable: !0,
            set: o,
            get: n
          });
        }), r) if ("string" == typeof r && (r = Buffer.from((0, o.stripHexPrefix)(r), "hex")), Buffer.isBuffer(r) && (r = a.rlp.decode(r)), Array.isArray(r)) {
          if (r.length > e._fields.length) throw new Error("wrong number of fields in data");
          r.forEach(function (t, r) {
            e[e._fields[r]] = (0, c.toBuffer)(t);
          });
        } else {
          if ("object" != typeof r) throw new Error("invalid data");
          {
            var _n10 = Object.keys(r);

            t.forEach(function (t) {
              -1 !== _n10.indexOf(t.name) && (e[t.name] = r[t.name]), -1 !== _n10.indexOf(t.alias) && (e[t.alias] = r[t.alias]);
            });
          }
        }
      };
    },
    6346: function _(e, t, r) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.hashPersonalMessage = t.isValidSignature = t.fromRpcSig = t.toCompactSig = t.toRpcSig = t.ecrecover = t.ecsign = void 0;
      var n = r(5053),
          i = r(4668),
          o = r(277),
          a = r(1440),
          c = r(2343),
          s = r(1988);

      function f(e, t) {
        var r = (0, s.toType)(e, s.TypeOutput.BN);
        if (!t) return r.subn(27);
        var n = (0, s.toType)(t, s.TypeOutput.BN);
        return r.sub(n.muln(2).addn(35));
      }

      function d(e) {
        var t = new i.BN(e);
        return t.eqn(0) || t.eqn(1);
      }

      t.ecsign = function (e, t, r) {
        var _ref = (0, n.ecdsaSign)(e, t),
            i = _ref.signature,
            o = _ref.recid,
            a = Buffer.from(i.slice(0, 32)),
            c = Buffer.from(i.slice(32, 64));

        if (!r || "number" == typeof r) {
          if (r && !Number.isSafeInteger(r)) throw new Error("The provided number is greater than MAX_SAFE_INTEGER (please use an alternative input type)");
          return {
            r: a,
            s: c,
            v: r ? o + (2 * r + 35) : o + 27
          };
        }

        return {
          r: a,
          s: c,
          v: (0, s.toType)(r, s.TypeOutput.BN).muln(2).addn(35).addn(o).toArrayLike(Buffer)
        };
      }, t.ecrecover = function (e, t, r, i, a) {
        var c = Buffer.concat([(0, o.setLengthLeft)(r, 32), (0, o.setLengthLeft)(i, 32)], 64),
            s = f(t, a);
        if (!d(s)) throw new Error("Invalid signature v value");
        var u = (0, n.ecdsaRecover)(c, s.toNumber(), e);
        return Buffer.from((0, n.publicKeyConvert)(u, !1).slice(1));
      }, t.toRpcSig = function (e, t, r, n) {
        if (!d(f(e, n))) throw new Error("Invalid signature v value");
        return (0, o.bufferToHex)(Buffer.concat([(0, o.setLengthLeft)(t, 32), (0, o.setLengthLeft)(r, 32), (0, o.toBuffer)(e)]));
      }, t.toCompactSig = function (e, t, r, n) {
        if (!d(f(e, n))) throw new Error("Invalid signature v value");
        var i = (0, s.toType)(e, s.TypeOutput.Number);
        var a = r;
        return (i > 28 && i % 2 == 1 || 1 === i || 28 === i) && (a = Buffer.from(r), a[0] |= 128), (0, o.bufferToHex)(Buffer.concat([(0, o.setLengthLeft)(t, 32), (0, o.setLengthLeft)(a, 32)]));
      }, t.fromRpcSig = function (e) {
        var t = (0, o.toBuffer)(e);
        var r, n, i;
        if (t.length >= 65) r = t.slice(0, 32), n = t.slice(32, 64), i = (0, o.bufferToInt)(t.slice(64));else {
          if (64 !== t.length) throw new Error("Invalid signature length");
          r = t.slice(0, 32), n = t.slice(32, 64), i = (0, o.bufferToInt)(t.slice(32, 33)) >> 7, n[0] &= 127;
        }
        return i < 27 && (i += 27), {
          v: i,
          r: r,
          s: n
        };
      }, t.isValidSignature = function (e, t, r) {
        var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !0;
        var o = arguments.length > 4 ? arguments[4] : undefined;
        var a = new i.BN("7fffffffffffffffffffffffffffffff5d576e7357a4501ddfe92f46681b20a0", 16),
            c = new i.BN("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141", 16);
        if (32 !== t.length || 32 !== r.length) return !1;
        if (!d(f(e, o))) return !1;
        var s = new i.BN(t),
            u = new i.BN(r);
        return !(s.isZero() || s.gt(c) || u.isZero() || u.gt(c) || n && 1 === u.cmp(a));
      }, t.hashPersonalMessage = function (e) {
        (0, c.assertIsBuffer)(e);
        var t = Buffer.from("\x19Ethereum Signed Message:\n".concat(e.length), "utf-8");
        return (0, a.keccak)(Buffer.concat([t, e]));
      };
    },
    1988: function _(e, t, r) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.toType = t.TypeOutput = t.bnToRlp = t.bnToUnpaddedBuffer = t.bnToHex = void 0;
      var n = r(4668),
          i = r(6865),
          o = r(277);

      function a(e) {
        return (0, o.unpadBuffer)(e.toArrayLike(Buffer));
      }

      var c;
      t.bnToHex = function (e) {
        return "0x".concat(e.toString(16));
      }, t.bnToUnpaddedBuffer = a, t.bnToRlp = function (e) {
        return a(e);
      }, function (e) {
        e[e.Number = 0] = "Number", e[e.BN = 1] = "BN", e[e.Buffer = 2] = "Buffer", e[e.PrefixedHexString = 3] = "PrefixedHexString";
      }(c = t.TypeOutput || (t.TypeOutput = {})), t.toType = function (e, t) {
        if (null === e) return null;
        if (void 0 === e) return;
        if ("string" == typeof e && !(0, i.isHexString)(e)) throw new Error("A string must be provided with a 0x-prefix, given: ".concat(e));
        if ("number" == typeof e && !Number.isSafeInteger(e)) throw new Error("The provided number is greater than MAX_SAFE_INTEGER (please use an alternative input type)");
        var r = (0, o.toBuffer)(e);
        if (t === c.Buffer) return r;
        if (t === c.BN) return new n.BN(r);

        if (t === c.Number) {
          var _e10 = new n.BN(r),
              _t9 = new n.BN(Number.MAX_SAFE_INTEGER.toString());

          if (_e10.gt(_t9)) throw new Error("The provided number is greater than MAX_SAFE_INTEGER (please use an alternative output type)");
          return _e10.toNumber();
        }

        return "0x".concat(r.toString("hex"));
      };
    },
    3715: function _(e, t, r) {
      var n = t;
      n.utils = r(6436), n.common = r(5772), n.sha = r(9041), n.ripemd = r(2949), n.hmac = r(2344), n.sha1 = n.sha.sha1, n.sha256 = n.sha.sha256, n.sha224 = n.sha.sha224, n.sha384 = n.sha.sha384, n.sha512 = n.sha.sha512, n.ripemd160 = n.ripemd.ripemd160;
    },
    5772: function _(e, t, r) {
      "use strict";

      var n = r(6436),
          i = r(9746);

      function o() {
        this.pending = null, this.pendingTotal = 0, this.blockSize = this.constructor.blockSize, this.outSize = this.constructor.outSize, this.hmacStrength = this.constructor.hmacStrength, this.padLength = this.constructor.padLength / 8, this.endian = "big", this._delta8 = this.blockSize / 8, this._delta32 = this.blockSize / 32;
      }

      t.BlockHash = o, o.prototype.update = function (e, t) {
        if (e = n.toArray(e, t), this.pending ? this.pending = this.pending.concat(e) : this.pending = e, this.pendingTotal += e.length, this.pending.length >= this._delta8) {
          var r = (e = this.pending).length % this._delta8;
          this.pending = e.slice(e.length - r, e.length), 0 === this.pending.length && (this.pending = null), e = n.join32(e, 0, e.length - r, this.endian);

          for (var i = 0; i < e.length; i += this._delta32) {
            this._update(e, i, i + this._delta32);
          }
        }

        return this;
      }, o.prototype.digest = function (e) {
        return this.update(this._pad()), i(null === this.pending), this._digest(e);
      }, o.prototype._pad = function () {
        var e = this.pendingTotal,
            t = this._delta8,
            r = t - (e + this.padLength) % t,
            n = new Array(r + this.padLength);
        n[0] = 128;

        for (var i = 1; i < r; i++) {
          n[i] = 0;
        }

        if (e <<= 3, "big" === this.endian) {
          for (var o = 8; o < this.padLength; o++) {
            n[i++] = 0;
          }

          n[i++] = 0, n[i++] = 0, n[i++] = 0, n[i++] = 0, n[i++] = e >>> 24 & 255, n[i++] = e >>> 16 & 255, n[i++] = e >>> 8 & 255, n[i++] = 255 & e;
        } else for (n[i++] = 255 & e, n[i++] = e >>> 8 & 255, n[i++] = e >>> 16 & 255, n[i++] = e >>> 24 & 255, n[i++] = 0, n[i++] = 0, n[i++] = 0, n[i++] = 0, o = 8; o < this.padLength; o++) {
          n[i++] = 0;
        }

        return n;
      };
    },
    2344: function _(e, t, r) {
      "use strict";

      var n = r(6436),
          i = r(9746);

      function o(e, t, r) {
        if (!(this instanceof o)) return new o(e, t, r);
        this.Hash = e, this.blockSize = e.blockSize / 8, this.outSize = e.outSize / 8, this.inner = null, this.outer = null, this._init(n.toArray(t, r));
      }

      e.exports = o, o.prototype._init = function (e) {
        e.length > this.blockSize && (e = new this.Hash().update(e).digest()), i(e.length <= this.blockSize);

        for (var t = e.length; t < this.blockSize; t++) {
          e.push(0);
        }

        for (t = 0; t < e.length; t++) {
          e[t] ^= 54;
        }

        for (this.inner = new this.Hash().update(e), t = 0; t < e.length; t++) {
          e[t] ^= 106;
        }

        this.outer = new this.Hash().update(e);
      }, o.prototype.update = function (e, t) {
        return this.inner.update(e, t), this;
      }, o.prototype.digest = function (e) {
        return this.outer.update(this.inner.digest()), this.outer.digest(e);
      };
    },
    2949: function _(e, t, r) {
      "use strict";

      var n = r(6436),
          i = r(5772),
          o = n.rotl32,
          a = n.sum32,
          c = n.sum32_3,
          s = n.sum32_4,
          f = i.BlockHash;

      function d() {
        if (!(this instanceof d)) return new d();
        f.call(this), this.h = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], this.endian = "little";
      }

      function u(e, t, r, n) {
        return e <= 15 ? t ^ r ^ n : e <= 31 ? t & r | ~t & n : e <= 47 ? (t | ~r) ^ n : e <= 63 ? t & n | r & ~n : t ^ (r | ~n);
      }

      function h(e) {
        return e <= 15 ? 0 : e <= 31 ? 1518500249 : e <= 47 ? 1859775393 : e <= 63 ? 2400959708 : 2840853838;
      }

      function l(e) {
        return e <= 15 ? 1352829926 : e <= 31 ? 1548603684 : e <= 47 ? 1836072691 : e <= 63 ? 2053994217 : 0;
      }

      n.inherits(d, f), t.ripemd160 = d, d.blockSize = 512, d.outSize = 160, d.hmacStrength = 192, d.padLength = 64, d.prototype._update = function (e, t) {
        for (var r = this.h[0], n = this.h[1], i = this.h[2], f = this.h[3], d = this.h[4], v = r, y = n, w = i, A = f, _ = d, M = 0; M < 80; M++) {
          var x = a(o(s(r, u(M, n, i, f), e[p[M] + t], h(M)), b[M]), d);
          r = d, d = f, f = o(i, 10), i = n, n = x, x = a(o(s(v, u(79 - M, y, w, A), e[m[M] + t], l(M)), g[M]), _), v = _, _ = A, A = o(w, 10), w = y, y = x;
        }

        x = c(this.h[1], i, A), this.h[1] = c(this.h[2], f, _), this.h[2] = c(this.h[3], d, v), this.h[3] = c(this.h[4], r, y), this.h[4] = c(this.h[0], n, w), this.h[0] = x;
      }, d.prototype._digest = function (e) {
        return "hex" === e ? n.toHex32(this.h, "little") : n.split32(this.h, "little");
      };
      var p = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8, 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12, 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2, 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13],
          m = [5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12, 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2, 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13, 8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14, 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11],
          b = [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8, 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12, 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5, 11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12, 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6],
          g = [8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6, 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11, 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5, 15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8, 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11];
    },
    9041: function _(e, t, r) {
      "use strict";

      t.sha1 = r(4761), t.sha224 = r(799), t.sha256 = r(9344), t.sha384 = r(772), t.sha512 = r(5900);
    },
    4761: function _(e, t, r) {
      "use strict";

      var n = r(6436),
          i = r(5772),
          o = r(7038),
          a = n.rotl32,
          c = n.sum32,
          s = n.sum32_5,
          f = o.ft_1,
          d = i.BlockHash,
          u = [1518500249, 1859775393, 2400959708, 3395469782];

      function h() {
        if (!(this instanceof h)) return new h();
        d.call(this), this.h = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], this.W = new Array(80);
      }

      n.inherits(h, d), e.exports = h, h.blockSize = 512, h.outSize = 160, h.hmacStrength = 80, h.padLength = 64, h.prototype._update = function (e, t) {
        for (var r = this.W, n = 0; n < 16; n++) {
          r[n] = e[t + n];
        }

        for (; n < r.length; n++) {
          r[n] = a(r[n - 3] ^ r[n - 8] ^ r[n - 14] ^ r[n - 16], 1);
        }

        var i = this.h[0],
            o = this.h[1],
            d = this.h[2],
            h = this.h[3],
            l = this.h[4];

        for (n = 0; n < r.length; n++) {
          var p = ~~(n / 20),
              m = s(a(i, 5), f(p, o, d, h), l, r[n], u[p]);
          l = h, h = d, d = a(o, 30), o = i, i = m;
        }

        this.h[0] = c(this.h[0], i), this.h[1] = c(this.h[1], o), this.h[2] = c(this.h[2], d), this.h[3] = c(this.h[3], h), this.h[4] = c(this.h[4], l);
      }, h.prototype._digest = function (e) {
        return "hex" === e ? n.toHex32(this.h, "big") : n.split32(this.h, "big");
      };
    },
    799: function _(e, t, r) {
      "use strict";

      var n = r(6436),
          i = r(9344);

      function o() {
        if (!(this instanceof o)) return new o();
        i.call(this), this.h = [3238371032, 914150663, 812702999, 4144912697, 4290775857, 1750603025, 1694076839, 3204075428];
      }

      n.inherits(o, i), e.exports = o, o.blockSize = 512, o.outSize = 224, o.hmacStrength = 192, o.padLength = 64, o.prototype._digest = function (e) {
        return "hex" === e ? n.toHex32(this.h.slice(0, 7), "big") : n.split32(this.h.slice(0, 7), "big");
      };
    },
    9344: function _(e, t, r) {
      "use strict";

      var n = r(6436),
          i = r(5772),
          o = r(7038),
          a = r(9746),
          c = n.sum32,
          s = n.sum32_4,
          f = n.sum32_5,
          d = o.ch32,
          u = o.maj32,
          h = o.s0_256,
          l = o.s1_256,
          p = o.g0_256,
          m = o.g1_256,
          b = i.BlockHash,
          g = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298];

      function v() {
        if (!(this instanceof v)) return new v();
        b.call(this), this.h = [1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225], this.k = g, this.W = new Array(64);
      }

      n.inherits(v, b), e.exports = v, v.blockSize = 512, v.outSize = 256, v.hmacStrength = 192, v.padLength = 64, v.prototype._update = function (e, t) {
        for (var r = this.W, n = 0; n < 16; n++) {
          r[n] = e[t + n];
        }

        for (; n < r.length; n++) {
          r[n] = s(m(r[n - 2]), r[n - 7], p(r[n - 15]), r[n - 16]);
        }

        var i = this.h[0],
            o = this.h[1],
            b = this.h[2],
            g = this.h[3],
            v = this.h[4],
            y = this.h[5],
            w = this.h[6],
            A = this.h[7];

        for (a(this.k.length === r.length), n = 0; n < r.length; n++) {
          var _ = f(A, l(v), d(v, y, w), this.k[n], r[n]),
              M = c(h(i), u(i, o, b));

          A = w, w = y, y = v, v = c(g, _), g = b, b = o, o = i, i = c(_, M);
        }

        this.h[0] = c(this.h[0], i), this.h[1] = c(this.h[1], o), this.h[2] = c(this.h[2], b), this.h[3] = c(this.h[3], g), this.h[4] = c(this.h[4], v), this.h[5] = c(this.h[5], y), this.h[6] = c(this.h[6], w), this.h[7] = c(this.h[7], A);
      }, v.prototype._digest = function (e) {
        return "hex" === e ? n.toHex32(this.h, "big") : n.split32(this.h, "big");
      };
    },
    772: function _(e, t, r) {
      "use strict";

      var n = r(6436),
          i = r(5900);

      function o() {
        if (!(this instanceof o)) return new o();
        i.call(this), this.h = [3418070365, 3238371032, 1654270250, 914150663, 2438529370, 812702999, 355462360, 4144912697, 1731405415, 4290775857, 2394180231, 1750603025, 3675008525, 1694076839, 1203062813, 3204075428];
      }

      n.inherits(o, i), e.exports = o, o.blockSize = 1024, o.outSize = 384, o.hmacStrength = 192, o.padLength = 128, o.prototype._digest = function (e) {
        return "hex" === e ? n.toHex32(this.h.slice(0, 12), "big") : n.split32(this.h.slice(0, 12), "big");
      };
    },
    5900: function _(e, t, r) {
      "use strict";

      var n = r(6436),
          i = r(5772),
          o = r(9746),
          a = n.rotr64_hi,
          c = n.rotr64_lo,
          s = n.shr64_hi,
          f = n.shr64_lo,
          d = n.sum64,
          u = n.sum64_hi,
          h = n.sum64_lo,
          l = n.sum64_4_hi,
          p = n.sum64_4_lo,
          m = n.sum64_5_hi,
          b = n.sum64_5_lo,
          g = i.BlockHash,
          v = [1116352408, 3609767458, 1899447441, 602891725, 3049323471, 3964484399, 3921009573, 2173295548, 961987163, 4081628472, 1508970993, 3053834265, 2453635748, 2937671579, 2870763221, 3664609560, 3624381080, 2734883394, 310598401, 1164996542, 607225278, 1323610764, 1426881987, 3590304994, 1925078388, 4068182383, 2162078206, 991336113, 2614888103, 633803317, 3248222580, 3479774868, 3835390401, 2666613458, 4022224774, 944711139, 264347078, 2341262773, 604807628, 2007800933, 770255983, 1495990901, 1249150122, 1856431235, 1555081692, 3175218132, 1996064986, 2198950837, 2554220882, 3999719339, 2821834349, 766784016, 2952996808, 2566594879, 3210313671, 3203337956, 3336571891, 1034457026, 3584528711, 2466948901, 113926993, 3758326383, 338241895, 168717936, 666307205, 1188179964, 773529912, 1546045734, 1294757372, 1522805485, 1396182291, 2643833823, 1695183700, 2343527390, 1986661051, 1014477480, 2177026350, 1206759142, 2456956037, 344077627, 2730485921, 1290863460, 2820302411, 3158454273, 3259730800, 3505952657, 3345764771, 106217008, 3516065817, 3606008344, 3600352804, 1432725776, 4094571909, 1467031594, 275423344, 851169720, 430227734, 3100823752, 506948616, 1363258195, 659060556, 3750685593, 883997877, 3785050280, 958139571, 3318307427, 1322822218, 3812723403, 1537002063, 2003034995, 1747873779, 3602036899, 1955562222, 1575990012, 2024104815, 1125592928, 2227730452, 2716904306, 2361852424, 442776044, 2428436474, 593698344, 2756734187, 3733110249, 3204031479, 2999351573, 3329325298, 3815920427, 3391569614, 3928383900, 3515267271, 566280711, 3940187606, 3454069534, 4118630271, 4000239992, 116418474, 1914138554, 174292421, 2731055270, 289380356, 3203993006, 460393269, 320620315, 685471733, 587496836, 852142971, 1086792851, 1017036298, 365543100, 1126000580, 2618297676, 1288033470, 3409855158, 1501505948, 4234509866, 1607167915, 987167468, 1816402316, 1246189591];

      function y() {
        if (!(this instanceof y)) return new y();
        g.call(this), this.h = [1779033703, 4089235720, 3144134277, 2227873595, 1013904242, 4271175723, 2773480762, 1595750129, 1359893119, 2917565137, 2600822924, 725511199, 528734635, 4215389547, 1541459225, 327033209], this.k = v, this.W = new Array(160);
      }

      function w(e, t, r, n, i) {
        var o = e & r ^ ~e & i;
        return o < 0 && (o += 4294967296), o;
      }

      function A(e, t, r, n, i, o) {
        var a = t & n ^ ~t & o;
        return a < 0 && (a += 4294967296), a;
      }

      function _(e, t, r, n, i) {
        var o = e & r ^ e & i ^ r & i;
        return o < 0 && (o += 4294967296), o;
      }

      function M(e, t, r, n, i, o) {
        var a = t & n ^ t & o ^ n & o;
        return a < 0 && (a += 4294967296), a;
      }

      function x(e, t) {
        var r = a(e, t, 28) ^ a(t, e, 2) ^ a(t, e, 7);
        return r < 0 && (r += 4294967296), r;
      }

      function k(e, t) {
        var r = c(e, t, 28) ^ c(t, e, 2) ^ c(t, e, 7);
        return r < 0 && (r += 4294967296), r;
      }

      function E(e, t) {
        var r = c(e, t, 14) ^ c(e, t, 18) ^ c(t, e, 9);
        return r < 0 && (r += 4294967296), r;
      }

      function S(e, t) {
        var r = a(e, t, 1) ^ a(e, t, 8) ^ s(e, t, 7);
        return r < 0 && (r += 4294967296), r;
      }

      function I(e, t) {
        var r = c(e, t, 1) ^ c(e, t, 8) ^ f(e, t, 7);
        return r < 0 && (r += 4294967296), r;
      }

      function C(e, t) {
        var r = c(e, t, 19) ^ c(t, e, 29) ^ f(e, t, 6);
        return r < 0 && (r += 4294967296), r;
      }

      n.inherits(y, g), e.exports = y, y.blockSize = 1024, y.outSize = 512, y.hmacStrength = 192, y.padLength = 128, y.prototype._prepareBlock = function (e, t) {
        for (var r = this.W, n = 0; n < 32; n++) {
          r[n] = e[t + n];
        }

        for (; n < r.length; n += 2) {
          var i = (b = r[n - 4], g = r[n - 3], v = void 0, (v = a(b, g, 19) ^ a(g, b, 29) ^ s(b, g, 6)) < 0 && (v += 4294967296), v),
              o = C(r[n - 4], r[n - 3]),
              c = r[n - 14],
              f = r[n - 13],
              d = S(r[n - 30], r[n - 29]),
              u = I(r[n - 30], r[n - 29]),
              h = r[n - 32],
              m = r[n - 31];
          r[n] = l(i, o, c, f, d, u, h, m), r[n + 1] = p(i, o, c, f, d, u, h, m);
        }

        var b, g, v;
      }, y.prototype._update = function (e, t) {
        this._prepareBlock(e, t);

        var r,
            n,
            i,
            c = this.W,
            s = this.h[0],
            f = this.h[1],
            l = this.h[2],
            p = this.h[3],
            g = this.h[4],
            v = this.h[5],
            y = this.h[6],
            S = this.h[7],
            I = this.h[8],
            C = this.h[9],
            T = this.h[10],
            B = this.h[11],
            D = this.h[12],
            N = this.h[13],
            R = this.h[14],
            O = this.h[15];
        o(this.k.length === c.length);

        for (var P = 0; P < c.length; P += 2) {
          var F = R,
              L = O,
              G = (i = void 0, (i = a(r = I, n = C, 14) ^ a(r, n, 18) ^ a(n, r, 9)) < 0 && (i += 4294967296), i),
              j = E(I, C),
              z = w(I, 0, T, 0, D),
              q = A(0, C, 0, B, 0, N),
              U = this.k[P],
              H = this.k[P + 1],
              K = c[P],
              V = c[P + 1],
              W = m(F, L, G, j, z, q, U, H, K, V),
              X = b(F, L, G, j, z, q, U, H, K, V);
          F = x(s, f), L = k(s, f), G = _(s, 0, l, 0, g), j = M(0, f, 0, p, 0, v);
          var Z = u(F, L, G, j),
              $ = h(F, L, G, j);
          R = D, O = N, D = T, N = B, T = I, B = C, I = u(y, S, W, X), C = h(S, S, W, X), y = g, S = v, g = l, v = p, l = s, p = f, s = u(W, X, Z, $), f = h(W, X, Z, $);
        }

        d(this.h, 0, s, f), d(this.h, 2, l, p), d(this.h, 4, g, v), d(this.h, 6, y, S), d(this.h, 8, I, C), d(this.h, 10, T, B), d(this.h, 12, D, N), d(this.h, 14, R, O);
      }, y.prototype._digest = function (e) {
        return "hex" === e ? n.toHex32(this.h, "big") : n.split32(this.h, "big");
      };
    },
    7038: function _(e, t, r) {
      "use strict";

      var n = r(6436).rotr32;

      function i(e, t, r) {
        return e & t ^ ~e & r;
      }

      function o(e, t, r) {
        return e & t ^ e & r ^ t & r;
      }

      function a(e, t, r) {
        return e ^ t ^ r;
      }

      t.ft_1 = function (e, t, r, n) {
        return 0 === e ? i(t, r, n) : 1 === e || 3 === e ? a(t, r, n) : 2 === e ? o(t, r, n) : void 0;
      }, t.ch32 = i, t.maj32 = o, t.p32 = a, t.s0_256 = function (e) {
        return n(e, 2) ^ n(e, 13) ^ n(e, 22);
      }, t.s1_256 = function (e) {
        return n(e, 6) ^ n(e, 11) ^ n(e, 25);
      }, t.g0_256 = function (e) {
        return n(e, 7) ^ n(e, 18) ^ e >>> 3;
      }, t.g1_256 = function (e) {
        return n(e, 17) ^ n(e, 19) ^ e >>> 10;
      };
    },
    6436: function _(e, t, r) {
      "use strict";

      var n = r(9746),
          i = r(4378);

      function o(e, t) {
        return 55296 == (64512 & e.charCodeAt(t)) && !(t < 0 || t + 1 >= e.length) && 56320 == (64512 & e.charCodeAt(t + 1));
      }

      function a(e) {
        return (e >>> 24 | e >>> 8 & 65280 | e << 8 & 16711680 | (255 & e) << 24) >>> 0;
      }

      function c(e) {
        return 1 === e.length ? "0" + e : e;
      }

      function s(e) {
        return 7 === e.length ? "0" + e : 6 === e.length ? "00" + e : 5 === e.length ? "000" + e : 4 === e.length ? "0000" + e : 3 === e.length ? "00000" + e : 2 === e.length ? "000000" + e : 1 === e.length ? "0000000" + e : e;
      }

      t.inherits = i, t.toArray = function (e, t) {
        if (Array.isArray(e)) return e.slice();
        if (!e) return [];
        var r = [];
        if ("string" == typeof e) {
          if (t) {
            if ("hex" === t) for ((e = e.replace(/[^a-z0-9]+/gi, "")).length % 2 != 0 && (e = "0" + e), i = 0; i < e.length; i += 2) {
              r.push(parseInt(e[i] + e[i + 1], 16));
            }
          } else for (var n = 0, i = 0; i < e.length; i++) {
            var a = e.charCodeAt(i);
            a < 128 ? r[n++] = a : a < 2048 ? (r[n++] = a >> 6 | 192, r[n++] = 63 & a | 128) : o(e, i) ? (a = 65536 + ((1023 & a) << 10) + (1023 & e.charCodeAt(++i)), r[n++] = a >> 18 | 240, r[n++] = a >> 12 & 63 | 128, r[n++] = a >> 6 & 63 | 128, r[n++] = 63 & a | 128) : (r[n++] = a >> 12 | 224, r[n++] = a >> 6 & 63 | 128, r[n++] = 63 & a | 128);
          }
        } else for (i = 0; i < e.length; i++) {
          r[i] = 0 | e[i];
        }
        return r;
      }, t.toHex = function (e) {
        for (var t = "", r = 0; r < e.length; r++) {
          t += c(e[r].toString(16));
        }

        return t;
      }, t.htonl = a, t.toHex32 = function (e, t) {
        for (var r = "", n = 0; n < e.length; n++) {
          var i = e[n];
          "little" === t && (i = a(i)), r += s(i.toString(16));
        }

        return r;
      }, t.zero2 = c, t.zero8 = s, t.join32 = function (e, t, r, i) {
        var o = r - t;
        n(o % 4 == 0);

        for (var a = new Array(o / 4), c = 0, s = t; c < a.length; c++, s += 4) {
          var f;
          f = "big" === i ? e[s] << 24 | e[s + 1] << 16 | e[s + 2] << 8 | e[s + 3] : e[s + 3] << 24 | e[s + 2] << 16 | e[s + 1] << 8 | e[s], a[c] = f >>> 0;
        }

        return a;
      }, t.split32 = function (e, t) {
        for (var r = new Array(4 * e.length), n = 0, i = 0; n < e.length; n++, i += 4) {
          var o = e[n];
          "big" === t ? (r[i] = o >>> 24, r[i + 1] = o >>> 16 & 255, r[i + 2] = o >>> 8 & 255, r[i + 3] = 255 & o) : (r[i + 3] = o >>> 24, r[i + 2] = o >>> 16 & 255, r[i + 1] = o >>> 8 & 255, r[i] = 255 & o);
        }

        return r;
      }, t.rotr32 = function (e, t) {
        return e >>> t | e << 32 - t;
      }, t.rotl32 = function (e, t) {
        return e << t | e >>> 32 - t;
      }, t.sum32 = function (e, t) {
        return e + t >>> 0;
      }, t.sum32_3 = function (e, t, r) {
        return e + t + r >>> 0;
      }, t.sum32_4 = function (e, t, r, n) {
        return e + t + r + n >>> 0;
      }, t.sum32_5 = function (e, t, r, n, i) {
        return e + t + r + n + i >>> 0;
      }, t.sum64 = function (e, t, r, n) {
        var i = e[t],
            o = n + e[t + 1] >>> 0,
            a = (o < n ? 1 : 0) + r + i;
        e[t] = a >>> 0, e[t + 1] = o;
      }, t.sum64_hi = function (e, t, r, n) {
        return (t + n >>> 0 < t ? 1 : 0) + e + r >>> 0;
      }, t.sum64_lo = function (e, t, r, n) {
        return t + n >>> 0;
      }, t.sum64_4_hi = function (e, t, r, n, i, o, a, c) {
        var s = 0,
            f = t;
        return s += (f = f + n >>> 0) < t ? 1 : 0, s += (f = f + o >>> 0) < o ? 1 : 0, e + r + i + a + (s += (f = f + c >>> 0) < c ? 1 : 0) >>> 0;
      }, t.sum64_4_lo = function (e, t, r, n, i, o, a, c) {
        return t + n + o + c >>> 0;
      }, t.sum64_5_hi = function (e, t, r, n, i, o, a, c, s, f) {
        var d = 0,
            u = t;
        return d += (u = u + n >>> 0) < t ? 1 : 0, d += (u = u + o >>> 0) < o ? 1 : 0, d += (u = u + c >>> 0) < c ? 1 : 0, e + r + i + a + s + (d += (u = u + f >>> 0) < f ? 1 : 0) >>> 0;
      }, t.sum64_5_lo = function (e, t, r, n, i, o, a, c, s, f) {
        return t + n + o + c + f >>> 0;
      }, t.rotr64_hi = function (e, t, r) {
        return (t << 32 - r | e >>> r) >>> 0;
      }, t.rotr64_lo = function (e, t, r) {
        return (e << 32 - r | t >>> r) >>> 0;
      }, t.shr64_hi = function (e, t, r) {
        return e >>> r;
      }, t.shr64_lo = function (e, t, r) {
        return (e << 32 - r | t >>> r) >>> 0;
      };
    },
    2156: function _(e, t, r) {
      "use strict";

      var n = r(3715),
          i = r(4504),
          o = r(9746);

      function a(e) {
        if (!(this instanceof a)) return new a(e);
        this.hash = e.hash, this.predResist = !!e.predResist, this.outLen = this.hash.outSize, this.minEntropy = e.minEntropy || this.hash.hmacStrength, this._reseed = null, this.reseedInterval = null, this.K = null, this.V = null;
        var t = i.toArray(e.entropy, e.entropyEnc || "hex"),
            r = i.toArray(e.nonce, e.nonceEnc || "hex"),
            n = i.toArray(e.pers, e.persEnc || "hex");
        o(t.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits"), this._init(t, r, n);
      }

      e.exports = a, a.prototype._init = function (e, t, r) {
        var n = e.concat(t).concat(r);
        this.K = new Array(this.outLen / 8), this.V = new Array(this.outLen / 8);

        for (var i = 0; i < this.V.length; i++) {
          this.K[i] = 0, this.V[i] = 1;
        }

        this._update(n), this._reseed = 1, this.reseedInterval = 281474976710656;
      }, a.prototype._hmac = function () {
        return new n.hmac(this.hash, this.K);
      }, a.prototype._update = function (e) {
        var t = this._hmac().update(this.V).update([0]);

        e && (t = t.update(e)), this.K = t.digest(), this.V = this._hmac().update(this.V).digest(), e && (this.K = this._hmac().update(this.V).update([1]).update(e).digest(), this.V = this._hmac().update(this.V).digest());
      }, a.prototype.reseed = function (e, t, r, n) {
        "string" != typeof t && (n = r, r = t, t = null), e = i.toArray(e, t), r = i.toArray(r, n), o(e.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits"), this._update(e.concat(r || [])), this._reseed = 1;
      }, a.prototype.generate = function (e, t, r, n) {
        if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
        "string" != typeof t && (n = r, r = t, t = null), r && (r = i.toArray(r, n || "hex"), this._update(r));

        for (var o = []; o.length < e;) {
          this.V = this._hmac().update(this.V).digest(), o = o.concat(this.V);
        }

        var a = o.slice(0, e);
        return this._update(r), this._reseed++, i.encode(a, t);
      };
    },
    4378: function _(e, t, r) {
      try {
        var n = r(3837);
        if ("function" != typeof n.inherits) throw "";
        e.exports = n.inherits;
      } catch (t) {
        e.exports = r(5717);
      }
    },
    5717: function _(e) {
      "function" == typeof Object.create ? e.exports = function (e, t) {
        e.super_ = t, e.prototype = Object.create(t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        });
      } : e.exports = function (e, t) {
        e.super_ = t;

        var r = function r() {};

        r.prototype = t.prototype, e.prototype = new r(), e.prototype.constructor = e;
      };
    },
    300: function _(e, t, r) {
      e.exports = r(6066)(r(9516)(__dirname));
    },
    5221: function _(e, t, r) {
      try {
        e.exports = r(300);
      } catch (t) {
        e.exports = r(5811);
      }
    },
    5811: function _(e, t, r) {
      e.exports = r(6066)(r(9653));
    },
    6066: function _(e, t, r) {
      var n = r(7016),
          i = r(5675);

      e.exports = function (e) {
        var t = n(e),
            r = i(e);
        return function (e, n) {
          switch ("string" == typeof e ? e.toLowerCase() : e) {
            case "keccak224":
              return new t(1152, 448, null, 224, n);

            case "keccak256":
              return new t(1088, 512, null, 256, n);

            case "keccak384":
              return new t(832, 768, null, 384, n);

            case "keccak512":
              return new t(576, 1024, null, 512, n);

            case "sha3-224":
              return new t(1152, 448, 6, 224, n);

            case "sha3-256":
              return new t(1088, 512, 6, 256, n);

            case "sha3-384":
              return new t(832, 768, 6, 384, n);

            case "sha3-512":
              return new t(576, 1024, 6, 512, n);

            case "shake128":
              return new r(1344, 256, 31, n);

            case "shake256":
              return new r(1088, 512, 31, n);

            default:
              throw new Error("Invald algorithm: " + e);
          }
        };
      };
    },
    7016: function _(e, t, r) {
      var _r10 = r(4409),
          n = _r10.Transform;

      e.exports = function (e) {
        return /*#__PURE__*/function (_n11) {
          "use strict";

          _inherits(t, _n11);

          function t(_t10, r, n, i, o) {
            var _this;

            _classCallCheck(this, t);

            _this = _possibleConstructorReturn(this, _getPrototypeOf(t).call(this, o)), _this._rate = _t10, _this._capacity = r, _this._delimitedSuffix = n, _this._hashBitLength = i, _this._options = o, _this._state = new e(), _this._state.initialize(_t10, r), _this._finalized = !1;
            return _this;
          }

          _createClass(t, [{
            key: "_transform",
            value: function _transform(e, t, r) {
              var n = null;

              try {
                this.update(e, t);
              } catch (e) {
                n = e;
              }

              r(n);
            }
          }, {
            key: "_flush",
            value: function _flush(e) {
              var t = null;

              try {
                this.push(this.digest());
              } catch (e) {
                t = e;
              }

              e(t);
            }
          }, {
            key: "update",
            value: function update(e, t) {
              if (!Buffer.isBuffer(e) && "string" != typeof e) throw new TypeError("Data must be a string or a buffer");
              if (this._finalized) throw new Error("Digest already called");
              return Buffer.isBuffer(e) || (e = Buffer.from(e, t)), this._state.absorb(e), this;
            }
          }, {
            key: "digest",
            value: function digest(e) {
              if (this._finalized) throw new Error("Digest already called");
              this._finalized = !0, this._delimitedSuffix && this._state.absorbLastFewBits(this._delimitedSuffix);

              var t = this._state.squeeze(this._hashBitLength / 8);

              return void 0 !== e && (t = t.toString(e)), this._resetState(), t;
            }
          }, {
            key: "_resetState",
            value: function _resetState() {
              return this._state.initialize(this._rate, this._capacity), this;
            }
          }, {
            key: "_clone",
            value: function _clone() {
              var e = new t(this._rate, this._capacity, this._delimitedSuffix, this._hashBitLength, this._options);
              return this._state.copy(e._state), e._finalized = this._finalized, e;
            }
          }]);

          return t;
        }(n);
      };
    },
    5675: function _(e, t, r) {
      var _r11 = r(4409),
          n = _r11.Transform;

      e.exports = function (e) {
        return /*#__PURE__*/function (_n12) {
          "use strict";

          _inherits(t, _n12);

          function t(_t11, r, n, i) {
            var _this2;

            _classCallCheck(this, t);

            _this2 = _possibleConstructorReturn(this, _getPrototypeOf(t).call(this, i)), _this2._rate = _t11, _this2._capacity = r, _this2._delimitedSuffix = n, _this2._options = i, _this2._state = new e(), _this2._state.initialize(_t11, r), _this2._finalized = !1;
            return _this2;
          }

          _createClass(t, [{
            key: "_transform",
            value: function _transform(e, t, r) {
              var n = null;

              try {
                this.update(e, t);
              } catch (e) {
                n = e;
              }

              r(n);
            }
          }, {
            key: "_flush",
            value: function _flush() {}
          }, {
            key: "_read",
            value: function _read(e) {
              this.push(this.squeeze(e));
            }
          }, {
            key: "update",
            value: function update(e, t) {
              if (!Buffer.isBuffer(e) && "string" != typeof e) throw new TypeError("Data must be a string or a buffer");
              if (this._finalized) throw new Error("Squeeze already called");
              return Buffer.isBuffer(e) || (e = Buffer.from(e, t)), this._state.absorb(e), this;
            }
          }, {
            key: "squeeze",
            value: function squeeze(e, t) {
              this._finalized || (this._finalized = !0, this._state.absorbLastFewBits(this._delimitedSuffix));

              var r = this._state.squeeze(e);

              return void 0 !== t && (r = r.toString(t)), r;
            }
          }, {
            key: "_resetState",
            value: function _resetState() {
              return this._state.initialize(this._rate, this._capacity), this;
            }
          }, {
            key: "_clone",
            value: function _clone() {
              var e = new t(this._rate, this._capacity, this._delimitedSuffix, this._options);
              return this._state.copy(e._state), e._finalized = this._finalized, e;
            }
          }]);

          return t;
        }(n);
      };
    },
    4040: function _(e, t) {
      var r = [1, 0, 32898, 0, 32906, 2147483648, 2147516416, 2147483648, 32907, 0, 2147483649, 0, 2147516545, 2147483648, 32777, 2147483648, 138, 0, 136, 0, 2147516425, 0, 2147483658, 0, 2147516555, 0, 139, 2147483648, 32905, 2147483648, 32771, 2147483648, 32770, 2147483648, 128, 2147483648, 32778, 0, 2147483658, 2147483648, 2147516545, 2147483648, 32896, 2147483648, 2147483649, 0, 2147516424, 2147483648];

      t.p1600 = function (e) {
        for (var _t12 = 0; _t12 < 24; ++_t12) {
          var _n13 = e[0] ^ e[10] ^ e[20] ^ e[30] ^ e[40],
              i = e[1] ^ e[11] ^ e[21] ^ e[31] ^ e[41],
              o = e[2] ^ e[12] ^ e[22] ^ e[32] ^ e[42],
              a = e[3] ^ e[13] ^ e[23] ^ e[33] ^ e[43],
              c = e[4] ^ e[14] ^ e[24] ^ e[34] ^ e[44],
              s = e[5] ^ e[15] ^ e[25] ^ e[35] ^ e[45],
              f = e[6] ^ e[16] ^ e[26] ^ e[36] ^ e[46],
              d = e[7] ^ e[17] ^ e[27] ^ e[37] ^ e[47],
              u = e[8] ^ e[18] ^ e[28] ^ e[38] ^ e[48],
              h = e[9] ^ e[19] ^ e[29] ^ e[39] ^ e[49];

          var l = u ^ (o << 1 | a >>> 31),
              p = h ^ (a << 1 | o >>> 31);

          var m = e[0] ^ l,
              b = e[1] ^ p,
              g = e[10] ^ l,
              v = e[11] ^ p,
              y = e[20] ^ l,
              w = e[21] ^ p,
              A = e[30] ^ l,
              _ = e[31] ^ p,
              M = e[40] ^ l,
              x = e[41] ^ p;

          l = _n13 ^ (c << 1 | s >>> 31), p = i ^ (s << 1 | c >>> 31);
          var k = e[2] ^ l,
              E = e[3] ^ p,
              S = e[12] ^ l,
              I = e[13] ^ p,
              C = e[22] ^ l,
              T = e[23] ^ p,
              B = e[32] ^ l,
              D = e[33] ^ p,
              N = e[42] ^ l,
              R = e[43] ^ p;
          l = o ^ (f << 1 | d >>> 31), p = a ^ (d << 1 | f >>> 31);
          var O = e[4] ^ l,
              P = e[5] ^ p,
              F = e[14] ^ l,
              L = e[15] ^ p,
              G = e[24] ^ l,
              j = e[25] ^ p,
              z = e[34] ^ l,
              q = e[35] ^ p,
              U = e[44] ^ l,
              H = e[45] ^ p;
          l = c ^ (u << 1 | h >>> 31), p = s ^ (h << 1 | u >>> 31);
          var K = e[6] ^ l,
              V = e[7] ^ p,
              W = e[16] ^ l,
              X = e[17] ^ p,
              Z = e[26] ^ l,
              $ = e[27] ^ p,
              Y = e[36] ^ l,
              J = e[37] ^ p,
              Q = e[46] ^ l,
              ee = e[47] ^ p;
          l = f ^ (_n13 << 1 | i >>> 31), p = d ^ (i << 1 | _n13 >>> 31);

          var te = e[8] ^ l,
              re = e[9] ^ p,
              ne = e[18] ^ l,
              ie = e[19] ^ p,
              oe = e[28] ^ l,
              ae = e[29] ^ p,
              ce = e[38] ^ l,
              se = e[39] ^ p,
              fe = e[48] ^ l,
              de = e[49] ^ p,
              ue = m,
              he = b,
              le = v << 4 | g >>> 28,
              pe = g << 4 | v >>> 28,
              me = y << 3 | w >>> 29,
              be = w << 3 | y >>> 29,
              ge = _ << 9 | A >>> 23,
              ve = A << 9 | _ >>> 23,
              ye = M << 18 | x >>> 14,
              we = x << 18 | M >>> 14,
              Ae = k << 1 | E >>> 31,
              _e = E << 1 | k >>> 31,
              Me = I << 12 | S >>> 20,
              xe = S << 12 | I >>> 20,
              ke = C << 10 | T >>> 22,
              Ee = T << 10 | C >>> 22,
              Se = D << 13 | B >>> 19,
              Ie = B << 13 | D >>> 19,
              Ce = N << 2 | R >>> 30,
              Te = R << 2 | N >>> 30,
              Be = P << 30 | O >>> 2,
              De = O << 30 | P >>> 2,
              Ne = F << 6 | L >>> 26,
              Re = L << 6 | F >>> 26,
              Oe = j << 11 | G >>> 21,
              Pe = G << 11 | j >>> 21,
              Fe = z << 15 | q >>> 17,
              Le = q << 15 | z >>> 17,
              Ge = H << 29 | U >>> 3,
              je = U << 29 | H >>> 3,
              ze = K << 28 | V >>> 4,
              qe = V << 28 | K >>> 4,
              Ue = X << 23 | W >>> 9,
              He = W << 23 | X >>> 9,
              Ke = Z << 25 | $ >>> 7,
              Ve = $ << 25 | Z >>> 7,
              We = Y << 21 | J >>> 11,
              Xe = J << 21 | Y >>> 11,
              Ze = ee << 24 | Q >>> 8,
              $e = Q << 24 | ee >>> 8,
              Ye = te << 27 | re >>> 5,
              Je = re << 27 | te >>> 5,
              Qe = ne << 20 | ie >>> 12,
              et = ie << 20 | ne >>> 12,
              tt = ae << 7 | oe >>> 25,
              rt = oe << 7 | ae >>> 25,
              nt = ce << 8 | se >>> 24,
              it = se << 8 | ce >>> 24,
              ot = fe << 14 | de >>> 18,
              at = de << 14 | fe >>> 18;

          e[0] = ue ^ ~Me & Oe, e[1] = he ^ ~xe & Pe, e[10] = ze ^ ~Qe & me, e[11] = qe ^ ~et & be, e[20] = Ae ^ ~Ne & Ke, e[21] = _e ^ ~Re & Ve, e[30] = Ye ^ ~le & ke, e[31] = Je ^ ~pe & Ee, e[40] = Be ^ ~Ue & tt, e[41] = De ^ ~He & rt, e[2] = Me ^ ~Oe & We, e[3] = xe ^ ~Pe & Xe, e[12] = Qe ^ ~me & Se, e[13] = et ^ ~be & Ie, e[22] = Ne ^ ~Ke & nt, e[23] = Re ^ ~Ve & it, e[32] = le ^ ~ke & Fe, e[33] = pe ^ ~Ee & Le, e[42] = Ue ^ ~tt & ge, e[43] = He ^ ~rt & ve, e[4] = Oe ^ ~We & ot, e[5] = Pe ^ ~Xe & at, e[14] = me ^ ~Se & Ge, e[15] = be ^ ~Ie & je, e[24] = Ke ^ ~nt & ye, e[25] = Ve ^ ~it & we, e[34] = ke ^ ~Fe & Ze, e[35] = Ee ^ ~Le & $e, e[44] = tt ^ ~ge & Ce, e[45] = rt ^ ~ve & Te, e[6] = We ^ ~ot & ue, e[7] = Xe ^ ~at & he, e[16] = Se ^ ~Ge & ze, e[17] = Ie ^ ~je & qe, e[26] = nt ^ ~ye & Ae, e[27] = it ^ ~we & _e, e[36] = Fe ^ ~Ze & Ye, e[37] = Le ^ ~$e & Je, e[46] = ge ^ ~Ce & Be, e[47] = ve ^ ~Te & De, e[8] = ot ^ ~ue & Me, e[9] = at ^ ~he & xe, e[18] = Ge ^ ~ze & Qe, e[19] = je ^ ~qe & et, e[28] = ye ^ ~Ae & Ne, e[29] = we ^ ~_e & Re, e[38] = Ze ^ ~Ye & le, e[39] = $e ^ ~Je & pe, e[48] = Ce ^ ~Be & Ue, e[49] = Te ^ ~De & He, e[0] ^= r[2 * _t12], e[1] ^= r[2 * _t12 + 1];
        }
      };
    },
    9653: function _(e, t, r) {
      var n = r(4040);

      function i() {
        this.state = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], this.blockSize = null, this.count = 0, this.squeezing = !1;
      }

      i.prototype.initialize = function (e, t) {
        for (var _e11 = 0; _e11 < 50; ++_e11) {
          this.state[_e11] = 0;
        }

        this.blockSize = e / 8, this.count = 0, this.squeezing = !1;
      }, i.prototype.absorb = function (e) {
        for (var _t13 = 0; _t13 < e.length; ++_t13) {
          this.state[~~(this.count / 4)] ^= e[_t13] << this.count % 4 * 8, this.count += 1, this.count === this.blockSize && (n.p1600(this.state), this.count = 0);
        }
      }, i.prototype.absorbLastFewBits = function (e) {
        this.state[~~(this.count / 4)] ^= e << this.count % 4 * 8, 0 != (128 & e) && this.count === this.blockSize - 1 && n.p1600(this.state), this.state[~~((this.blockSize - 1) / 4)] ^= 128 << (this.blockSize - 1) % 4 * 8, n.p1600(this.state), this.count = 0, this.squeezing = !0;
      }, i.prototype.squeeze = function (e) {
        this.squeezing || this.absorbLastFewBits(1);
        var t = Buffer.alloc(e);

        for (var _r12 = 0; _r12 < e; ++_r12) {
          t[_r12] = this.state[~~(this.count / 4)] >>> this.count % 4 * 8 & 255, this.count += 1, this.count === this.blockSize && (n.p1600(this.state), this.count = 0);
        }

        return t;
      }, i.prototype.copy = function (e) {
        for (var _t14 = 0; _t14 < 50; ++_t14) {
          e.state[_t14] = this.state[_t14];
        }

        e.blockSize = this.blockSize, e.count = this.count, e.squeezing = this.squeezing;
      }, e.exports = i;
    },
    5694: function _(e) {
      "use strict";

      var t = {};

      function r(e, r, n) {
        n || (n = Error);

        var i = /*#__PURE__*/function (_n14) {
          _inherits(i, _n14);

          function i(e, t, n) {
            _classCallCheck(this, i);

            return _possibleConstructorReturn(this, _getPrototypeOf(i).call(this, function (e, t, n) {
              return "string" == typeof r ? r : r(e, t, n);
            }(e, t, n)));
          }

          return i;
        }(n);

        i.prototype.name = n.name, i.prototype.code = e, t[e] = i;
      }

      function n(e, t) {
        if (Array.isArray(e)) {
          var _r13 = e.length;
          return e = e.map(function (e) {
            return String(e);
          }), _r13 > 2 ? "one of ".concat(t, " ").concat(e.slice(0, _r13 - 1).join(", "), ", or ") + e[_r13 - 1] : 2 === _r13 ? "one of ".concat(t, " ").concat(e[0], " or ").concat(e[1]) : "of ".concat(t, " ").concat(e[0]);
        }

        return "of ".concat(t, " ").concat(String(e));
      }

      r("ERR_INVALID_OPT_VALUE", function (e, t) {
        return 'The value "' + t + '" is invalid for option "' + e + '"';
      }, TypeError), r("ERR_INVALID_ARG_TYPE", function (e, t, r) {
        var i;
        var o;
        var a;
        if ("string" == typeof t && (o = "not ", t.substr(0, o.length) === o) ? (i = "must not be", t = t.replace(/^not /, "")) : i = "must be", function (e, t, r) {
          return (void 0 === r || r > e.length) && (r = e.length), e.substring(r - t.length, r) === t;
        }(e, " argument")) a = "The ".concat(e, " ").concat(i, " ").concat(n(t, "type"));else {
          a = "The \"".concat(e, "\" ").concat(("number" != typeof s && (s = 0), s + ".".length > (c = e).length || -1 === c.indexOf(".", s) ? "argument" : "property"), " ").concat(i, " ").concat(n(t, "type"));
        }
        var c, s;
        return a += ". Received type " + typeof r, a;
      }, TypeError), r("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF"), r("ERR_METHOD_NOT_IMPLEMENTED", function (e) {
        return "The " + e + " method is not implemented";
      }), r("ERR_STREAM_PREMATURE_CLOSE", "Premature close"), r("ERR_STREAM_DESTROYED", function (e) {
        return "Cannot call " + e + " after a stream was destroyed";
      }), r("ERR_MULTIPLE_CALLBACK", "Callback called multiple times"), r("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable"), r("ERR_STREAM_WRITE_AFTER_END", "write after end"), r("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError), r("ERR_UNKNOWN_ENCODING", function (e) {
        return "Unknown encoding: " + e;
      }, TypeError), r("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event"), e.exports.q = t;
    },
    7735: function _(e, t, r) {
      "use strict";

      var n = Object.keys || function (e) {
        var t = [];

        for (var r in e) {
          t.push(r);
        }

        return t;
      };

      e.exports = f;
      var i = r(3875),
          o = r(9843);
      r(4378)(f, i);

      for (var a = n(o.prototype), c = 0; c < a.length; c++) {
        var s = a[c];
        f.prototype[s] || (f.prototype[s] = o.prototype[s]);
      }

      function f(e) {
        if (!(this instanceof f)) return new f(e);
        i.call(this, e), o.call(this, e), this.allowHalfOpen = !0, e && (!1 === e.readable && (this.readable = !1), !1 === e.writable && (this.writable = !1), !1 === e.allowHalfOpen && (this.allowHalfOpen = !1, this.once("end", d)));
      }

      function d() {
        this._writableState.ended || process.nextTick(u, this);
      }

      function u(e) {
        e.end();
      }

      Object.defineProperty(f.prototype, "writableHighWaterMark", {
        enumerable: !1,
        get: function get() {
          return this._writableState.highWaterMark;
        }
      }), Object.defineProperty(f.prototype, "writableBuffer", {
        enumerable: !1,
        get: function get() {
          return this._writableState && this._writableState.getBuffer();
        }
      }), Object.defineProperty(f.prototype, "writableLength", {
        enumerable: !1,
        get: function get() {
          return this._writableState.length;
        }
      }), Object.defineProperty(f.prototype, "destroyed", {
        enumerable: !1,
        get: function get() {
          return void 0 !== this._readableState && void 0 !== this._writableState && this._readableState.destroyed && this._writableState.destroyed;
        },
        set: function set(e) {
          void 0 !== this._readableState && void 0 !== this._writableState && (this._readableState.destroyed = e, this._writableState.destroyed = e);
        }
      });
    },
    6485: function _(e, t, r) {
      "use strict";

      e.exports = i;
      var n = r(6311);

      function i(e) {
        if (!(this instanceof i)) return new i(e);
        n.call(this, e);
      }

      r(4378)(i, n), i.prototype._transform = function (e, t, r) {
        r(null, e);
      };
    },
    3875: function _(e, t, r) {
      "use strict";

      var n;
      e.exports = x, x.ReadableState = M, r(2361).EventEmitter;

      var i,
          o = function o(e, t) {
        return e.listeners(t).length;
      },
          a = r(3287),
          c = r(4300).Buffer,
          s = global.Uint8Array || function () {},
          f = r(3837);

      i = f && f.debuglog ? f.debuglog("stream") : function () {};
      var d,
          u,
          h,
          l = r(7983),
          p = r(3505),
          m = r(5482).getHighWaterMark,
          b = r(5694).q,
          g = b.ERR_INVALID_ARG_TYPE,
          v = b.ERR_STREAM_PUSH_AFTER_EOF,
          y = b.ERR_METHOD_NOT_IMPLEMENTED,
          w = b.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
      r(4378)(x, a);
      var A = p.errorOrDestroy,
          _ = ["error", "close", "destroy", "pause", "resume"];

      function M(e, t, i) {
        n = n || r(7735), e = e || {}, "boolean" != typeof i && (i = t instanceof n), this.objectMode = !!e.objectMode, i && (this.objectMode = this.objectMode || !!e.readableObjectMode), this.highWaterMark = m(this, e, "readableHighWaterMark", i), this.buffer = new l(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = !1 !== e.emitClose, this.autoDestroy = !!e.autoDestroy, this.destroyed = !1, this.defaultEncoding = e.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, e.encoding && (d || (d = r(2553).s), this.decoder = new d(e.encoding), this.encoding = e.encoding);
      }

      function x(e) {
        if (n = n || r(7735), !(this instanceof x)) return new x(e);
        var t = this instanceof n;
        this._readableState = new M(e, this, t), this.readable = !0, e && ("function" == typeof e.read && (this._read = e.read), "function" == typeof e.destroy && (this._destroy = e.destroy)), a.call(this);
      }

      function k(e, t, r, n, o) {
        i("readableAddChunk", t);
        var a,
            f = e._readableState;
        if (null === t) f.reading = !1, function (e, t) {
          if (i("onEofChunk"), !t.ended) {
            if (t.decoder) {
              var r = t.decoder.end();
              r && r.length && (t.buffer.push(r), t.length += t.objectMode ? 1 : r.length);
            }

            t.ended = !0, t.sync ? C(e) : (t.needReadable = !1, t.emittedReadable || (t.emittedReadable = !0, T(e)));
          }
        }(e, f);else if (o || (a = function (e, t) {
          var r, n;
          return n = t, c.isBuffer(n) || n instanceof s || "string" == typeof t || void 0 === t || e.objectMode || (r = new g("chunk", ["string", "Buffer", "Uint8Array"], t)), r;
        }(f, t)), a) A(e, a);else if (f.objectMode || t && t.length > 0) {
          if ("string" == typeof t || f.objectMode || Object.getPrototypeOf(t) === c.prototype || (t = function (e) {
            return c.from(e);
          }(t)), n) f.endEmitted ? A(e, new w()) : E(e, f, t, !0);else if (f.ended) A(e, new v());else {
            if (f.destroyed) return !1;
            f.reading = !1, f.decoder && !r ? (t = f.decoder.write(t), f.objectMode || 0 !== t.length ? E(e, f, t, !1) : B(e, f)) : E(e, f, t, !1);
          }
        } else n || (f.reading = !1, B(e, f));
        return !f.ended && (f.length < f.highWaterMark || 0 === f.length);
      }

      function E(e, t, r, n) {
        t.flowing && 0 === t.length && !t.sync ? (t.awaitDrain = 0, e.emit("data", r)) : (t.length += t.objectMode ? 1 : r.length, n ? t.buffer.unshift(r) : t.buffer.push(r), t.needReadable && C(e)), B(e, t);
      }

      Object.defineProperty(x.prototype, "destroyed", {
        enumerable: !1,
        get: function get() {
          return void 0 !== this._readableState && this._readableState.destroyed;
        },
        set: function set(e) {
          this._readableState && (this._readableState.destroyed = e);
        }
      }), x.prototype.destroy = p.destroy, x.prototype._undestroy = p.undestroy, x.prototype._destroy = function (e, t) {
        t(e);
      }, x.prototype.push = function (e, t) {
        var r,
            n = this._readableState;
        return n.objectMode ? r = !0 : "string" == typeof e && ((t = t || n.defaultEncoding) !== n.encoding && (e = c.from(e, t), t = ""), r = !0), k(this, e, t, !1, r);
      }, x.prototype.unshift = function (e) {
        return k(this, e, null, !0, !1);
      }, x.prototype.isPaused = function () {
        return !1 === this._readableState.flowing;
      }, x.prototype.setEncoding = function (e) {
        d || (d = r(2553).s);
        var t = new d(e);
        this._readableState.decoder = t, this._readableState.encoding = this._readableState.decoder.encoding;

        for (var n = this._readableState.buffer.head, i = ""; null !== n;) {
          i += t.write(n.data), n = n.next;
        }

        return this._readableState.buffer.clear(), "" !== i && this._readableState.buffer.push(i), this._readableState.length = i.length, this;
      };
      var S = 1073741824;

      function I(e, t) {
        return e <= 0 || 0 === t.length && t.ended ? 0 : t.objectMode ? 1 : e != e ? t.flowing && t.length ? t.buffer.head.data.length : t.length : (e > t.highWaterMark && (t.highWaterMark = function (e) {
          return e >= S ? e = S : (e--, e |= e >>> 1, e |= e >>> 2, e |= e >>> 4, e |= e >>> 8, e |= e >>> 16, e++), e;
        }(e)), e <= t.length ? e : t.ended ? t.length : (t.needReadable = !0, 0));
      }

      function C(e) {
        var t = e._readableState;
        i("emitReadable", t.needReadable, t.emittedReadable), t.needReadable = !1, t.emittedReadable || (i("emitReadable", t.flowing), t.emittedReadable = !0, process.nextTick(T, e));
      }

      function T(e) {
        var t = e._readableState;
        i("emitReadable_", t.destroyed, t.length, t.ended), t.destroyed || !t.length && !t.ended || (e.emit("readable"), t.emittedReadable = !1), t.needReadable = !t.flowing && !t.ended && t.length <= t.highWaterMark, P(e);
      }

      function B(e, t) {
        t.readingMore || (t.readingMore = !0, process.nextTick(D, e, t));
      }

      function D(e, t) {
        for (; !t.reading && !t.ended && (t.length < t.highWaterMark || t.flowing && 0 === t.length);) {
          var r = t.length;
          if (i("maybeReadMore read 0"), e.read(0), r === t.length) break;
        }

        t.readingMore = !1;
      }

      function N(e) {
        var t = e._readableState;
        t.readableListening = e.listenerCount("readable") > 0, t.resumeScheduled && !t.paused ? t.flowing = !0 : e.listenerCount("data") > 0 && e.resume();
      }

      function R(e) {
        i("readable nexttick read 0"), e.read(0);
      }

      function O(e, t) {
        i("resume", t.reading), t.reading || e.read(0), t.resumeScheduled = !1, e.emit("resume"), P(e), t.flowing && !t.reading && e.read(0);
      }

      function P(e) {
        var t = e._readableState;

        for (i("flow", t.flowing); t.flowing && null !== e.read();) {
          ;
        }
      }

      function F(e, t) {
        return 0 === t.length ? null : (t.objectMode ? r = t.buffer.shift() : !e || e >= t.length ? (r = t.decoder ? t.buffer.join("") : 1 === t.buffer.length ? t.buffer.first() : t.buffer.concat(t.length), t.buffer.clear()) : r = t.buffer.consume(e, t.decoder), r);
        var r;
      }

      function L(e) {
        var t = e._readableState;
        i("endReadable", t.endEmitted), t.endEmitted || (t.ended = !0, process.nextTick(G, t, e));
      }

      function G(e, t) {
        if (i("endReadableNT", e.endEmitted, e.length), !e.endEmitted && 0 === e.length && (e.endEmitted = !0, t.readable = !1, t.emit("end"), e.autoDestroy)) {
          var r = t._writableState;
          (!r || r.autoDestroy && r.finished) && t.destroy();
        }
      }

      function j(e, t) {
        for (var r = 0, n = e.length; r < n; r++) {
          if (e[r] === t) return r;
        }

        return -1;
      }

      x.prototype.read = function (e) {
        i("read", e), e = parseInt(e, 10);
        var t = this._readableState,
            r = e;
        if (0 !== e && (t.emittedReadable = !1), 0 === e && t.needReadable && ((0 !== t.highWaterMark ? t.length >= t.highWaterMark : t.length > 0) || t.ended)) return i("read: emitReadable", t.length, t.ended), 0 === t.length && t.ended ? L(this) : C(this), null;
        if (0 === (e = I(e, t)) && t.ended) return 0 === t.length && L(this), null;
        var n,
            o = t.needReadable;
        return i("need readable", o), (0 === t.length || t.length - e < t.highWaterMark) && i("length less than watermark", o = !0), t.ended || t.reading ? i("reading or ended", o = !1) : o && (i("do read"), t.reading = !0, t.sync = !0, 0 === t.length && (t.needReadable = !0), this._read(t.highWaterMark), t.sync = !1, t.reading || (e = I(r, t))), null === (n = e > 0 ? F(e, t) : null) ? (t.needReadable = t.length <= t.highWaterMark, e = 0) : (t.length -= e, t.awaitDrain = 0), 0 === t.length && (t.ended || (t.needReadable = !0), r !== e && t.ended && L(this)), null !== n && this.emit("data", n), n;
      }, x.prototype._read = function (e) {
        A(this, new y("_read()"));
      }, x.prototype.pipe = function (e, t) {
        var r = this,
            n = this._readableState;

        switch (n.pipesCount) {
          case 0:
            n.pipes = e;
            break;

          case 1:
            n.pipes = [n.pipes, e];
            break;

          default:
            n.pipes.push(e);
        }

        n.pipesCount += 1, i("pipe count=%d opts=%j", n.pipesCount, t);
        var a = t && !1 === t.end || e === process.stdout || e === process.stderr ? p : c;

        function c() {
          i("onend"), e.end();
        }

        n.endEmitted ? process.nextTick(a) : r.once("end", a), e.on("unpipe", function t(o, a) {
          i("onunpipe"), o === r && a && !1 === a.hasUnpiped && (a.hasUnpiped = !0, i("cleanup"), e.removeListener("close", h), e.removeListener("finish", l), e.removeListener("drain", s), e.removeListener("error", u), e.removeListener("unpipe", t), r.removeListener("end", c), r.removeListener("end", p), r.removeListener("data", d), f = !0, !n.awaitDrain || e._writableState && !e._writableState.needDrain || s());
        });

        var s = function (e) {
          return function () {
            var t = e._readableState;
            i("pipeOnDrain", t.awaitDrain), t.awaitDrain && t.awaitDrain--, 0 === t.awaitDrain && o(e, "data") && (t.flowing = !0, P(e));
          };
        }(r);

        e.on("drain", s);
        var f = !1;

        function d(t) {
          i("ondata");
          var o = e.write(t);
          i("dest.write", o), !1 === o && ((1 === n.pipesCount && n.pipes === e || n.pipesCount > 1 && -1 !== j(n.pipes, e)) && !f && (i("false write response, pause", n.awaitDrain), n.awaitDrain++), r.pause());
        }

        function u(t) {
          i("onerror", t), p(), e.removeListener("error", u), 0 === o(e, "error") && A(e, t);
        }

        function h() {
          e.removeListener("finish", l), p();
        }

        function l() {
          i("onfinish"), e.removeListener("close", h), p();
        }

        function p() {
          i("unpipe"), r.unpipe(e);
        }

        return r.on("data", d), function (e, t, r) {
          if ("function" == typeof e.prependListener) return e.prependListener(t, r);
          e._events && e._events.error ? Array.isArray(e._events.error) ? e._events.error.unshift(r) : e._events.error = [r, e._events.error] : e.on(t, r);
        }(e, "error", u), e.once("close", h), e.once("finish", l), e.emit("pipe", r), n.flowing || (i("pipe resume"), r.resume()), e;
      }, x.prototype.unpipe = function (e) {
        var t = this._readableState,
            r = {
          hasUnpiped: !1
        };
        if (0 === t.pipesCount) return this;
        if (1 === t.pipesCount) return e && e !== t.pipes || (e || (e = t.pipes), t.pipes = null, t.pipesCount = 0, t.flowing = !1, e && e.emit("unpipe", this, r)), this;

        if (!e) {
          var n = t.pipes,
              i = t.pipesCount;
          t.pipes = null, t.pipesCount = 0, t.flowing = !1;

          for (var o = 0; o < i; o++) {
            n[o].emit("unpipe", this, {
              hasUnpiped: !1
            });
          }

          return this;
        }

        var a = j(t.pipes, e);
        return -1 === a || (t.pipes.splice(a, 1), t.pipesCount -= 1, 1 === t.pipesCount && (t.pipes = t.pipes[0]), e.emit("unpipe", this, r)), this;
      }, x.prototype.on = function (e, t) {
        var r = a.prototype.on.call(this, e, t),
            n = this._readableState;
        return "data" === e ? (n.readableListening = this.listenerCount("readable") > 0, !1 !== n.flowing && this.resume()) : "readable" === e && (n.endEmitted || n.readableListening || (n.readableListening = n.needReadable = !0, n.flowing = !1, n.emittedReadable = !1, i("on readable", n.length, n.reading), n.length ? C(this) : n.reading || process.nextTick(R, this))), r;
      }, x.prototype.addListener = x.prototype.on, x.prototype.removeListener = function (e, t) {
        var r = a.prototype.removeListener.call(this, e, t);
        return "readable" === e && process.nextTick(N, this), r;
      }, x.prototype.removeAllListeners = function (e) {
        var t = a.prototype.removeAllListeners.apply(this, arguments);
        return "readable" !== e && void 0 !== e || process.nextTick(N, this), t;
      }, x.prototype.resume = function () {
        var e = this._readableState;
        return e.flowing || (i("resume"), e.flowing = !e.readableListening, function (e, t) {
          t.resumeScheduled || (t.resumeScheduled = !0, process.nextTick(O, e, t));
        }(this, e)), e.paused = !1, this;
      }, x.prototype.pause = function () {
        return i("call pause flowing=%j", this._readableState.flowing), !1 !== this._readableState.flowing && (i("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
      }, x.prototype.wrap = function (e) {
        var t = this,
            r = this._readableState,
            n = !1;

        for (var o in e.on("end", function () {
          if (i("wrapped end"), r.decoder && !r.ended) {
            var e = r.decoder.end();
            e && e.length && t.push(e);
          }

          t.push(null);
        }), e.on("data", function (o) {
          i("wrapped data"), r.decoder && (o = r.decoder.write(o)), r.objectMode && null == o || (r.objectMode || o && o.length) && (t.push(o) || (n = !0, e.pause()));
        }), e) {
          void 0 === this[o] && "function" == typeof e[o] && (this[o] = function (t) {
            return function () {
              return e[t].apply(e, arguments);
            };
          }(o));
        }

        for (var a = 0; a < _.length; a++) {
          e.on(_[a], this.emit.bind(this, _[a]));
        }

        return this._read = function (t) {
          i("wrapped _read", t), n && (n = !1, e.resume());
        }, this;
      }, "function" == typeof Symbol && (x.prototype[Symbol.asyncIterator] = function () {
        return void 0 === u && (u = r(3471)), u(this);
      }), Object.defineProperty(x.prototype, "readableHighWaterMark", {
        enumerable: !1,
        get: function get() {
          return this._readableState.highWaterMark;
        }
      }), Object.defineProperty(x.prototype, "readableBuffer", {
        enumerable: !1,
        get: function get() {
          return this._readableState && this._readableState.buffer;
        }
      }), Object.defineProperty(x.prototype, "readableFlowing", {
        enumerable: !1,
        get: function get() {
          return this._readableState.flowing;
        },
        set: function set(e) {
          this._readableState && (this._readableState.flowing = e);
        }
      }), x._fromList = F, Object.defineProperty(x.prototype, "readableLength", {
        enumerable: !1,
        get: function get() {
          return this._readableState.length;
        }
      }), "function" == typeof Symbol && (x.from = function (e, t) {
        return void 0 === h && (h = r(1656)), h(x, e, t);
      });
    },
    6311: function _(e, t, r) {
      "use strict";

      e.exports = d;
      var n = r(5694).q,
          i = n.ERR_METHOD_NOT_IMPLEMENTED,
          o = n.ERR_MULTIPLE_CALLBACK,
          a = n.ERR_TRANSFORM_ALREADY_TRANSFORMING,
          c = n.ERR_TRANSFORM_WITH_LENGTH_0,
          s = r(7735);

      function f(e, t) {
        var r = this._transformState;
        r.transforming = !1;
        var n = r.writecb;
        if (null === n) return this.emit("error", new o());
        r.writechunk = null, r.writecb = null, null != t && this.push(t), n(e);
        var i = this._readableState;
        i.reading = !1, (i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
      }

      function d(e) {
        if (!(this instanceof d)) return new d(e);
        s.call(this, e), this._transformState = {
          afterTransform: f.bind(this),
          needTransform: !1,
          transforming: !1,
          writecb: null,
          writechunk: null,
          writeencoding: null
        }, this._readableState.needReadable = !0, this._readableState.sync = !1, e && ("function" == typeof e.transform && (this._transform = e.transform), "function" == typeof e.flush && (this._flush = e.flush)), this.on("prefinish", u);
      }

      function u() {
        var e = this;
        "function" != typeof this._flush || this._readableState.destroyed ? h(this, null, null) : this._flush(function (t, r) {
          h(e, t, r);
        });
      }

      function h(e, t, r) {
        if (t) return e.emit("error", t);
        if (null != r && e.push(r), e._writableState.length) throw new c();
        if (e._transformState.transforming) throw new a();
        return e.push(null);
      }

      r(4378)(d, s), d.prototype.push = function (e, t) {
        return this._transformState.needTransform = !1, s.prototype.push.call(this, e, t);
      }, d.prototype._transform = function (e, t, r) {
        r(new i("_transform()"));
      }, d.prototype._write = function (e, t, r) {
        var n = this._transformState;

        if (n.writecb = r, n.writechunk = e, n.writeencoding = t, !n.transforming) {
          var i = this._readableState;
          (n.needTransform || i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
        }
      }, d.prototype._read = function (e) {
        var t = this._transformState;
        null === t.writechunk || t.transforming ? t.needTransform = !0 : (t.transforming = !0, this._transform(t.writechunk, t.writeencoding, t.afterTransform));
      }, d.prototype._destroy = function (e, t) {
        s.prototype._destroy.call(this, e, function (e) {
          t(e);
        });
      };
    },
    9843: function _(e, t, r) {
      "use strict";

      function n(e) {
        var t = this;
        this.next = null, this.entry = null, this.finish = function () {
          !function (e, t, r) {
            var n = e.entry;

            for (e.entry = null; n;) {
              var i = n.callback;
              t.pendingcb--, i(undefined), n = n.next;
            }

            t.corkedRequestsFree.next = e;
          }(t, e);
        };
      }

      var i;
      e.exports = x, x.WritableState = M;

      var o,
          a = {
        deprecate: r(1159)
      },
          c = r(3287),
          s = r(4300).Buffer,
          f = global.Uint8Array || function () {},
          d = r(3505),
          u = r(5482).getHighWaterMark,
          h = r(5694).q,
          l = h.ERR_INVALID_ARG_TYPE,
          p = h.ERR_METHOD_NOT_IMPLEMENTED,
          m = h.ERR_MULTIPLE_CALLBACK,
          b = h.ERR_STREAM_CANNOT_PIPE,
          g = h.ERR_STREAM_DESTROYED,
          v = h.ERR_STREAM_NULL_VALUES,
          y = h.ERR_STREAM_WRITE_AFTER_END,
          w = h.ERR_UNKNOWN_ENCODING,
          A = d.errorOrDestroy;

      function _() {}

      function M(e, t, o) {
        i = i || r(7735), e = e || {}, "boolean" != typeof o && (o = t instanceof i), this.objectMode = !!e.objectMode, o && (this.objectMode = this.objectMode || !!e.writableObjectMode), this.highWaterMark = u(this, e, "writableHighWaterMark", o), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
        var a = !1 === e.decodeStrings;
        this.decodeStrings = !a, this.defaultEncoding = e.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function (e) {
          !function (e, t) {
            var r = e._writableState,
                n = r.sync,
                i = r.writecb;
            if ("function" != typeof i) throw new m();
            if (function (e) {
              e.writing = !1, e.writecb = null, e.length -= e.writelen, e.writelen = 0;
            }(r), t) !function (e, t, r, n, i) {
              --t.pendingcb, r ? (process.nextTick(i, n), process.nextTick(T, e, t), e._writableState.errorEmitted = !0, A(e, n)) : (i(n), e._writableState.errorEmitted = !0, A(e, n), T(e, t));
            }(e, r, n, t, i);else {
              var o = I(r) || e.destroyed;
              o || r.corked || r.bufferProcessing || !r.bufferedRequest || S(e, r), n ? process.nextTick(E, e, r, o, i) : E(e, r, o, i);
            }
          }(t, e);
        }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = !1 !== e.emitClose, this.autoDestroy = !!e.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new n(this);
      }

      function x(e) {
        var t = this instanceof (i = i || r(7735));
        if (!t && !o.call(x, this)) return new x(e);
        this._writableState = new M(e, this, t), this.writable = !0, e && ("function" == typeof e.write && (this._write = e.write), "function" == typeof e.writev && (this._writev = e.writev), "function" == typeof e.destroy && (this._destroy = e.destroy), "function" == typeof e.final && (this._final = e.final)), c.call(this);
      }

      function k(e, t, r, n, i, o, a) {
        t.writelen = n, t.writecb = a, t.writing = !0, t.sync = !0, t.destroyed ? t.onwrite(new g("write")) : r ? e._writev(i, t.onwrite) : e._write(i, o, t.onwrite), t.sync = !1;
      }

      function E(e, t, r, n) {
        r || function (e, t) {
          0 === t.length && t.needDrain && (t.needDrain = !1, e.emit("drain"));
        }(e, t), t.pendingcb--, n(), T(e, t);
      }

      function S(e, t) {
        t.bufferProcessing = !0;
        var r = t.bufferedRequest;

        if (e._writev && r && r.next) {
          var i = t.bufferedRequestCount,
              o = new Array(i),
              a = t.corkedRequestsFree;
          a.entry = r;

          for (var c = 0, s = !0; r;) {
            o[c] = r, r.isBuf || (s = !1), r = r.next, c += 1;
          }

          o.allBuffers = s, k(e, t, !0, t.length, o, "", a.finish), t.pendingcb++, t.lastBufferedRequest = null, a.next ? (t.corkedRequestsFree = a.next, a.next = null) : t.corkedRequestsFree = new n(t), t.bufferedRequestCount = 0;
        } else {
          for (; r;) {
            var f = r.chunk,
                d = r.encoding,
                u = r.callback;
            if (k(e, t, !1, t.objectMode ? 1 : f.length, f, d, u), r = r.next, t.bufferedRequestCount--, t.writing) break;
          }

          null === r && (t.lastBufferedRequest = null);
        }

        t.bufferedRequest = r, t.bufferProcessing = !1;
      }

      function I(e) {
        return e.ending && 0 === e.length && null === e.bufferedRequest && !e.finished && !e.writing;
      }

      function C(e, t) {
        e._final(function (r) {
          t.pendingcb--, r && A(e, r), t.prefinished = !0, e.emit("prefinish"), T(e, t);
        });
      }

      function T(e, t) {
        var r = I(t);

        if (r && (function (e, t) {
          t.prefinished || t.finalCalled || ("function" != typeof e._final || t.destroyed ? (t.prefinished = !0, e.emit("prefinish")) : (t.pendingcb++, t.finalCalled = !0, process.nextTick(C, e, t)));
        }(e, t), 0 === t.pendingcb && (t.finished = !0, e.emit("finish"), t.autoDestroy))) {
          var n = e._readableState;
          (!n || n.autoDestroy && n.endEmitted) && e.destroy();
        }

        return r;
      }

      r(4378)(x, c), M.prototype.getBuffer = function () {
        for (var e = this.bufferedRequest, t = []; e;) {
          t.push(e), e = e.next;
        }

        return t;
      }, function () {
        try {
          Object.defineProperty(M.prototype, "buffer", {
            get: a.deprecate(function () {
              return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
          });
        } catch (e) {}
      }(), "function" == typeof Symbol && Symbol.hasInstance && "function" == typeof Function.prototype[Symbol.hasInstance] ? (o = Function.prototype[Symbol.hasInstance], Object.defineProperty(x, Symbol.hasInstance, {
        value: function value(e) {
          return !!o.call(this, e) || this === x && e && e._writableState instanceof M;
        }
      })) : o = function o(e) {
        return e instanceof this;
      }, x.prototype.pipe = function () {
        A(this, new b());
      }, x.prototype.write = function (e, t, r) {
        var n,
            i = this._writableState,
            o = !1,
            a = !i.objectMode && (n = e, s.isBuffer(n) || n instanceof f);
        return a && !s.isBuffer(e) && (e = function (e) {
          return s.from(e);
        }(e)), "function" == typeof t && (r = t, t = null), a ? t = "buffer" : t || (t = i.defaultEncoding), "function" != typeof r && (r = _), i.ending ? function (e, t) {
          var r = new y();
          A(e, r), process.nextTick(t, r);
        }(this, r) : (a || function (e, t, r, n) {
          var i;
          return null === r ? i = new v() : "string" == typeof r || t.objectMode || (i = new l("chunk", ["string", "Buffer"], r)), !i || (A(e, i), process.nextTick(n, i), !1);
        }(this, i, e, r)) && (i.pendingcb++, o = function (e, t, r, n, i, o) {
          if (!r) {
            var a = function (e, t, r) {
              return e.objectMode || !1 === e.decodeStrings || "string" != typeof t || (t = s.from(t, r)), t;
            }(t, n, i);

            n !== a && (r = !0, i = "buffer", n = a);
          }

          var c = t.objectMode ? 1 : n.length;
          t.length += c;
          var f = t.length < t.highWaterMark;

          if (f || (t.needDrain = !0), t.writing || t.corked) {
            var d = t.lastBufferedRequest;
            t.lastBufferedRequest = {
              chunk: n,
              encoding: i,
              isBuf: r,
              callback: o,
              next: null
            }, d ? d.next = t.lastBufferedRequest : t.bufferedRequest = t.lastBufferedRequest, t.bufferedRequestCount += 1;
          } else k(e, t, !1, c, n, i, o);

          return f;
        }(this, i, a, e, t, r)), o;
      }, x.prototype.cork = function () {
        this._writableState.corked++;
      }, x.prototype.uncork = function () {
        var e = this._writableState;
        e.corked && (e.corked--, e.writing || e.corked || e.bufferProcessing || !e.bufferedRequest || S(this, e));
      }, x.prototype.setDefaultEncoding = function (e) {
        if ("string" == typeof e && (e = e.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((e + "").toLowerCase()) > -1)) throw new w(e);
        return this._writableState.defaultEncoding = e, this;
      }, Object.defineProperty(x.prototype, "writableBuffer", {
        enumerable: !1,
        get: function get() {
          return this._writableState && this._writableState.getBuffer();
        }
      }), Object.defineProperty(x.prototype, "writableHighWaterMark", {
        enumerable: !1,
        get: function get() {
          return this._writableState.highWaterMark;
        }
      }), x.prototype._write = function (e, t, r) {
        r(new p("_write()"));
      }, x.prototype._writev = null, x.prototype.end = function (e, t, r) {
        var n = this._writableState;
        return "function" == typeof e ? (r = e, e = null, t = null) : "function" == typeof t && (r = t, t = null), null != e && this.write(e, t), n.corked && (n.corked = 1, this.uncork()), n.ending || function (e, t, r) {
          t.ending = !0, T(e, t), r && (t.finished ? process.nextTick(r) : e.once("finish", r)), t.ended = !0, e.writable = !1;
        }(this, n, r), this;
      }, Object.defineProperty(x.prototype, "writableLength", {
        enumerable: !1,
        get: function get() {
          return this._writableState.length;
        }
      }), Object.defineProperty(x.prototype, "destroyed", {
        enumerable: !1,
        get: function get() {
          return void 0 !== this._writableState && this._writableState.destroyed;
        },
        set: function set(e) {
          this._writableState && (this._writableState.destroyed = e);
        }
      }), x.prototype.destroy = d.destroy, x.prototype._undestroy = d.undestroy, x.prototype._destroy = function (e, t) {
        t(e);
      };
    },
    3471: function _(e, t, r) {
      "use strict";

      var n;

      function i(e, t, r) {
        return t in e ? Object.defineProperty(e, t, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = r, e;
      }

      var o = r(8186),
          a = Symbol("lastResolve"),
          c = Symbol("lastReject"),
          s = Symbol("error"),
          f = Symbol("ended"),
          d = Symbol("lastPromise"),
          u = Symbol("handlePromise"),
          h = Symbol("stream");

      function l(e, t) {
        return {
          value: e,
          done: t
        };
      }

      function p(e) {
        var t = e[a];

        if (null !== t) {
          var r = e[h].read();
          null !== r && (e[d] = null, e[a] = null, e[c] = null, t(l(r, !1)));
        }
      }

      function m(e) {
        process.nextTick(p, e);
      }

      var b = Object.getPrototypeOf(function () {}),
          g = Object.setPrototypeOf((i(n = {
        get stream() {
          return this[h];
        },

        next: function next() {
          var e = this,
              t = this[s];
          if (null !== t) return Promise.reject(t);
          if (this[f]) return Promise.resolve(l(void 0, !0));
          if (this[h].destroyed) return new Promise(function (t, r) {
            process.nextTick(function () {
              e[s] ? r(e[s]) : t(l(void 0, !0));
            });
          });
          var r,
              n = this[d];
          if (n) r = new Promise(function (e, t) {
            return function (r, n) {
              e.then(function () {
                t[f] ? r(l(void 0, !0)) : t[u](r, n);
              }, n);
            };
          }(n, this));else {
            var i = this[h].read();
            if (null !== i) return Promise.resolve(l(i, !1));
            r = new Promise(this[u]);
          }
          return this[d] = r, r;
        }
      }, Symbol.asyncIterator, function () {
        return this;
      }), i(n, "return", function () {
        var e = this;
        return new Promise(function (t, r) {
          e[h].destroy(null, function (e) {
            e ? r(e) : t(l(void 0, !0));
          });
        });
      }), n), b);

      e.exports = function (e) {
        var t,
            r = Object.create(g, (i(t = {}, h, {
          value: e,
          writable: !0
        }), i(t, a, {
          value: null,
          writable: !0
        }), i(t, c, {
          value: null,
          writable: !0
        }), i(t, s, {
          value: null,
          writable: !0
        }), i(t, f, {
          value: e._readableState.endEmitted,
          writable: !0
        }), i(t, u, {
          value: function value(e, t) {
            var n = r[h].read();
            n ? (r[d] = null, r[a] = null, r[c] = null, e(l(n, !1))) : (r[a] = e, r[c] = t);
          },
          writable: !0
        }), t));
        return r[d] = null, o(e, function (e) {
          if (e && "ERR_STREAM_PREMATURE_CLOSE" !== e.code) {
            var t = r[c];
            return null !== t && (r[d] = null, r[a] = null, r[c] = null, t(e)), void (r[s] = e);
          }

          var n = r[a];
          null !== n && (r[d] = null, r[a] = null, r[c] = null, n(l(void 0, !0))), r[f] = !0;
        }), e.on("readable", m.bind(null, r)), r;
      };
    },
    7983: function _(e, t, r) {
      "use strict";

      function n(e, t) {
        var r = Object.keys(e);

        if (Object.getOwnPropertySymbols) {
          var n = Object.getOwnPropertySymbols(e);
          t && (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), r.push.apply(r, n);
        }

        return r;
      }

      function i(e, t, r) {
        return t in e ? Object.defineProperty(e, t, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = r, e;
      }

      function o(e, t) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }

      var a = r(4300).Buffer,
          c = r(3837).inspect,
          s = c && c.custom || "inspect";

      e.exports = function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this.head = null, this.tail = null, this.length = 0;
        }

        var t, r;
        return t = e, r = [{
          key: "push",
          value: function value(e) {
            var t = {
              data: e,
              next: null
            };
            this.length > 0 ? this.tail.next = t : this.head = t, this.tail = t, ++this.length;
          }
        }, {
          key: "unshift",
          value: function value(e) {
            var t = {
              data: e,
              next: this.head
            };
            0 === this.length && (this.tail = t), this.head = t, ++this.length;
          }
        }, {
          key: "shift",
          value: function value() {
            if (0 !== this.length) {
              var e = this.head.data;
              return 1 === this.length ? this.head = this.tail = null : this.head = this.head.next, --this.length, e;
            }
          }
        }, {
          key: "clear",
          value: function value() {
            this.head = this.tail = null, this.length = 0;
          }
        }, {
          key: "join",
          value: function value(e) {
            if (0 === this.length) return "";

            for (var t = this.head, r = "" + t.data; t = t.next;) {
              r += e + t.data;
            }

            return r;
          }
        }, {
          key: "concat",
          value: function value(e) {
            if (0 === this.length) return a.alloc(0);

            for (var t, r, n, i = a.allocUnsafe(e >>> 0), o = this.head, c = 0; o;) {
              t = o.data, r = i, n = c, a.prototype.copy.call(t, r, n), c += o.data.length, o = o.next;
            }

            return i;
          }
        }, {
          key: "consume",
          value: function value(e, t) {
            var r;
            return e < this.head.data.length ? (r = this.head.data.slice(0, e), this.head.data = this.head.data.slice(e)) : r = e === this.head.data.length ? this.shift() : t ? this._getString(e) : this._getBuffer(e), r;
          }
        }, {
          key: "first",
          value: function value() {
            return this.head.data;
          }
        }, {
          key: "_getString",
          value: function value(e) {
            var t = this.head,
                r = 1,
                n = t.data;

            for (e -= n.length; t = t.next;) {
              var i = t.data,
                  o = e > i.length ? i.length : e;

              if (o === i.length ? n += i : n += i.slice(0, e), 0 == (e -= o)) {
                o === i.length ? (++r, t.next ? this.head = t.next : this.head = this.tail = null) : (this.head = t, t.data = i.slice(o));
                break;
              }

              ++r;
            }

            return this.length -= r, n;
          }
        }, {
          key: "_getBuffer",
          value: function value(e) {
            var t = a.allocUnsafe(e),
                r = this.head,
                n = 1;

            for (r.data.copy(t), e -= r.data.length; r = r.next;) {
              var i = r.data,
                  o = e > i.length ? i.length : e;

              if (i.copy(t, t.length - e, 0, o), 0 == (e -= o)) {
                o === i.length ? (++n, r.next ? this.head = r.next : this.head = this.tail = null) : (this.head = r, r.data = i.slice(o));
                break;
              }

              ++n;
            }

            return this.length -= n, t;
          }
        }, {
          key: s,
          value: function value(e, t) {
            return c(this, function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? n(Object(r), !0).forEach(function (t) {
                  i(e, t, r[t]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : n(Object(r)).forEach(function (t) {
                  Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                });
              }

              return e;
            }({}, t, {
              depth: 0,
              customInspect: !1
            }));
          }
        }], r && o(t.prototype, r), e;
      }();
    },
    3505: function _(e) {
      "use strict";

      function t(e, t) {
        n(e, t), r(e);
      }

      function r(e) {
        e._writableState && !e._writableState.emitClose || e._readableState && !e._readableState.emitClose || e.emit("close");
      }

      function n(e, t) {
        e.emit("error", t);
      }

      e.exports = {
        destroy: function destroy(e, i) {
          var o = this,
              a = this._readableState && this._readableState.destroyed,
              c = this._writableState && this._writableState.destroyed;
          return a || c ? (i ? i(e) : e && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, process.nextTick(n, this, e)) : process.nextTick(n, this, e)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(e || null, function (e) {
            !i && e ? o._writableState ? o._writableState.errorEmitted ? process.nextTick(r, o) : (o._writableState.errorEmitted = !0, process.nextTick(t, o, e)) : process.nextTick(t, o, e) : i ? (process.nextTick(r, o), i(e)) : process.nextTick(r, o);
          }), this);
        },
        undestroy: function undestroy() {
          this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
        },
        errorOrDestroy: function errorOrDestroy(e, t) {
          var r = e._readableState,
              n = e._writableState;
          r && r.autoDestroy || n && n.autoDestroy ? e.destroy(t) : e.emit("error", t);
        }
      };
    },
    8186: function _(e, t, r) {
      "use strict";

      var n = r(5694).q.ERR_STREAM_PREMATURE_CLOSE;

      function i() {}

      e.exports = function e(t, r, o) {
        if ("function" == typeof r) return e(t, null, r);
        r || (r = {}), o = function (e) {
          var t = !1;
          return function () {
            if (!t) {
              t = !0;

              for (var r = arguments.length, n = new Array(r), i = 0; i < r; i++) {
                n[i] = arguments[i];
              }

              e.apply(this, n);
            }
          };
        }(o || i);

        var a = r.readable || !1 !== r.readable && t.readable,
            c = r.writable || !1 !== r.writable && t.writable,
            s = function s() {
          t.writable || d();
        },
            f = t._writableState && t._writableState.finished,
            d = function d() {
          c = !1, f = !0, a || o.call(t);
        },
            u = t._readableState && t._readableState.endEmitted,
            h = function h() {
          a = !1, u = !0, c || o.call(t);
        },
            l = function l(e) {
          o.call(t, e);
        },
            p = function p() {
          var e;
          return a && !u ? (t._readableState && t._readableState.ended || (e = new n()), o.call(t, e)) : c && !f ? (t._writableState && t._writableState.ended || (e = new n()), o.call(t, e)) : void 0;
        },
            m = function m() {
          t.req.on("finish", d);
        };

        return function (e) {
          return e.setHeader && "function" == typeof e.abort;
        }(t) ? (t.on("complete", d), t.on("abort", p), t.req ? m() : t.on("request", m)) : c && !t._writableState && (t.on("end", s), t.on("close", s)), t.on("end", h), t.on("finish", d), !1 !== r.error && t.on("error", l), t.on("close", p), function () {
          t.removeListener("complete", d), t.removeListener("abort", p), t.removeListener("request", m), t.req && t.req.removeListener("finish", d), t.removeListener("end", s), t.removeListener("close", s), t.removeListener("finish", d), t.removeListener("end", h), t.removeListener("error", l), t.removeListener("close", p);
        };
      };
    },
    1656: function _(e, t, r) {
      "use strict";

      function n(e, t, r, n, i, o, a) {
        try {
          var c = e[o](a),
              s = c.value;
        } catch (e) {
          return void r(e);
        }

        c.done ? t(s) : Promise.resolve(s).then(n, i);
      }

      function i(e) {
        return function () {
          var t = this,
              r = arguments;
          return new Promise(function (i, o) {
            var a = e.apply(t, r);

            function c(e) {
              n(a, i, o, c, s, "next", e);
            }

            function s(e) {
              n(a, i, o, c, s, "throw", e);
            }

            c(void 0);
          });
        };
      }

      function o(e, t) {
        var r = Object.keys(e);

        if (Object.getOwnPropertySymbols) {
          var n = Object.getOwnPropertySymbols(e);
          t && (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), r.push.apply(r, n);
        }

        return r;
      }

      function a(e, t, r) {
        return t in e ? Object.defineProperty(e, t, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = r, e;
      }

      var c = r(5694).q.ERR_INVALID_ARG_TYPE;

      e.exports = function (e, t, r) {
        var n;
        if (t && "function" == typeof t.next) n = t;else if (t && t[Symbol.asyncIterator]) n = t[Symbol.asyncIterator]();else {
          if (!t || !t[Symbol.iterator]) throw new c("iterable", ["Iterable"], t);
          n = t[Symbol.iterator]();
        }
        var s = new e(function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? o(Object(r), !0).forEach(function (t) {
              a(e, t, r[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : o(Object(r)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
            });
          }

          return e;
        }({
          objectMode: !0
        }, r)),
            f = !1;

        function d() {
          return u.apply(this, arguments);
        }

        function u() {
          return (u = i( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
            var e, t;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.prev = 0;
                    _context.next = 3;
                    return n.next();

                  case 3:
                    e = _context.sent;
                    t = e.value;

                    if (!e.done) {
                      _context.next = 9;
                      break;
                    }

                    s.push(null);
                    _context.next = 18;
                    break;

                  case 9:
                    _context.t0 = s;
                    _context.next = 12;
                    return t;

                  case 12:
                    _context.t1 = _context.sent;

                    if (!_context.t0.push.call(_context.t0, _context.t1)) {
                      _context.next = 17;
                      break;
                    }

                    d();
                    _context.next = 18;
                    break;

                  case 17:
                    f = !1;

                  case 18:
                    _context.next = 23;
                    break;

                  case 20:
                    _context.prev = 20;
                    _context.t2 = _context["catch"](0);
                    s.destroy(_context.t2);

                  case 23:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, null, [[0, 20]]);
          }))).apply(this, arguments);
        }

        return s._read = function () {
          f || (f = !0, d());
        }, s;
      };
    },
    9619: function _(e, t, r) {
      "use strict";

      var n,
          i = r(5694).q,
          o = i.ERR_MISSING_ARGS,
          a = i.ERR_STREAM_DESTROYED;

      function c(e) {
        if (e) throw e;
      }

      function s(e, t, i, o) {
        o = function (e) {
          var t = !1;
          return function () {
            t || (t = !0, e.apply(void 0, arguments));
          };
        }(o);

        var c = !1;
        e.on("close", function () {
          c = !0;
        }), void 0 === n && (n = r(8186)), n(e, {
          readable: t,
          writable: i
        }, function (e) {
          if (e) return o(e);
          c = !0, o();
        });
        var s = !1;
        return function (t) {
          if (!c && !s) return s = !0, function (e) {
            return e.setHeader && "function" == typeof e.abort;
          }(e) ? e.abort() : "function" == typeof e.destroy ? e.destroy() : void o(t || new a("pipe"));
        };
      }

      function f(e) {
        e();
      }

      function d(e, t) {
        return e.pipe(t);
      }

      function u(e) {
        return e.length ? "function" != typeof e[e.length - 1] ? c : e.pop() : c;
      }

      e.exports = function () {
        for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) {
          t[r] = arguments[r];
        }

        var n,
            i = u(t);
        if (Array.isArray(t[0]) && (t = t[0]), t.length < 2) throw new o("streams");
        var a = t.map(function (e, r) {
          var o = r < t.length - 1;
          return s(e, o, r > 0, function (e) {
            n || (n = e), e && a.forEach(f), o || (a.forEach(f), i(n));
          });
        });
        return t.reduce(d);
      };
    },
    5482: function _(e, t, r) {
      "use strict";

      var n = r(5694).q.ERR_INVALID_OPT_VALUE;
      e.exports = {
        getHighWaterMark: function getHighWaterMark(e, t, r, i) {
          var o = function (e, t, r) {
            return null != e.highWaterMark ? e.highWaterMark : t ? e[r] : null;
          }(t, i, r);

          if (null != o) {
            if (!isFinite(o) || Math.floor(o) !== o || o < 0) throw new n(i ? r : "highWaterMark", o);
            return Math.floor(o);
          }

          return e.objectMode ? 16 : 16384;
        }
      };
    },
    3287: function _(e, t, r) {
      e.exports = r(2781);
    },
    4409: function _(e, t, r) {
      var n = r(2781);
      "disable" === process.env.READABLE_STREAM && n ? (e.exports = n.Readable, Object.assign(e.exports, n), e.exports.Stream = n) : ((t = e.exports = r(3875)).Stream = n || t, t.Readable = t, t.Writable = r(9843), t.Duplex = r(7735), t.Transform = r(6311), t.PassThrough = r(6485), t.finished = r(8186), t.pipeline = r(9619));
    },
    6486: function _(e, t, r) {
      var n;
      e = r.nmd(e), function () {
        var i,
            o = "Expected a function",
            a = "__lodash_hash_undefined__",
            c = "__lodash_placeholder__",
            s = 32,
            f = 128,
            d = 1 / 0,
            u = 9007199254740991,
            h = NaN,
            l = 4294967295,
            p = [["ary", f], ["bind", 1], ["bindKey", 2], ["curry", 8], ["curryRight", 16], ["flip", 512], ["partial", s], ["partialRight", 64], ["rearg", 256]],
            m = "[object Arguments]",
            b = "[object Array]",
            g = "[object Boolean]",
            v = "[object Date]",
            y = "[object Error]",
            w = "[object Function]",
            A = "[object GeneratorFunction]",
            _ = "[object Map]",
            M = "[object Number]",
            x = "[object Object]",
            k = "[object Promise]",
            E = "[object RegExp]",
            S = "[object Set]",
            I = "[object String]",
            C = "[object Symbol]",
            T = "[object WeakMap]",
            B = "[object ArrayBuffer]",
            D = "[object DataView]",
            N = "[object Float32Array]",
            R = "[object Float64Array]",
            O = "[object Int8Array]",
            P = "[object Int16Array]",
            F = "[object Int32Array]",
            L = "[object Uint8Array]",
            G = "[object Uint8ClampedArray]",
            j = "[object Uint16Array]",
            z = "[object Uint32Array]",
            q = /\b__p \+= '';/g,
            U = /\b(__p \+=) '' \+/g,
            H = /(__e\(.*?\)|\b__t\)) \+\n'';/g,
            K = /&(?:amp|lt|gt|quot|#39);/g,
            V = /[&<>"']/g,
            W = RegExp(K.source),
            X = RegExp(V.source),
            Z = /<%-([\s\S]+?)%>/g,
            $ = /<%([\s\S]+?)%>/g,
            Y = /<%=([\s\S]+?)%>/g,
            J = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
            Q = /^\w*$/,
            ee = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
            te = /[\\^$.*+?()[\]{}|]/g,
            re = RegExp(te.source),
            ne = /^\s+/,
            ie = /\s/,
            oe = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
            ae = /\{\n\/\* \[wrapped with (.+)\] \*/,
            ce = /,? & /,
            se = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g,
            fe = /[()=,{}\[\]\/\s]/,
            de = /\\(\\)?/g,
            ue = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,
            he = /\w*$/,
            le = /^[-+]0x[0-9a-f]+$/i,
            pe = /^0b[01]+$/i,
            me = /^\[object .+?Constructor\]$/,
            be = /^0o[0-7]+$/i,
            ge = /^(?:0|[1-9]\d*)$/,
            ve = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,
            ye = /($^)/,
            we = /['\n\r\u2028\u2029\\]/g,
            Ae = "\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff",
            _e = "a-z\\xdf-\\xf6\\xf8-\\xff",
            Me = "A-Z\\xc0-\\xd6\\xd8-\\xde",
            xe = "\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",
            ke = "[" + xe + "]",
            Ee = "[" + Ae + "]",
            Se = "\\d+",
            Ie = "[" + _e + "]",
            Ce = "[^\\ud800-\\udfff" + xe + Se + "\\u2700-\\u27bf" + _e + Me + "]",
            Te = "\\ud83c[\\udffb-\\udfff]",
            Be = "[^\\ud800-\\udfff]",
            De = "(?:\\ud83c[\\udde6-\\uddff]){2}",
            Ne = "[\\ud800-\\udbff][\\udc00-\\udfff]",
            Re = "[" + Me + "]",
            Oe = "(?:" + Ie + "|" + Ce + ")",
            Pe = "(?:" + Re + "|" + Ce + ")",
            Fe = "(?:['’](?:d|ll|m|re|s|t|ve))?",
            Le = "(?:['’](?:D|LL|M|RE|S|T|VE))?",
            Ge = "(?:" + Ee + "|" + Te + ")?",
            je = "[\\ufe0e\\ufe0f]?",
            ze = je + Ge + "(?:\\u200d(?:" + [Be, De, Ne].join("|") + ")" + je + Ge + ")*",
            qe = "(?:" + ["[\\u2700-\\u27bf]", De, Ne].join("|") + ")" + ze,
            Ue = "(?:" + [Be + Ee + "?", Ee, De, Ne, "[\\ud800-\\udfff]"].join("|") + ")",
            He = RegExp("['’]", "g"),
            Ke = RegExp(Ee, "g"),
            Ve = RegExp(Te + "(?=" + Te + ")|" + Ue + ze, "g"),
            We = RegExp([Re + "?" + Ie + "+" + Fe + "(?=" + [ke, Re, "$"].join("|") + ")", Pe + "+" + Le + "(?=" + [ke, Re + Oe, "$"].join("|") + ")", Re + "?" + Oe + "+" + Fe, Re + "+" + Le, "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Se, qe].join("|"), "g"),
            Xe = RegExp("[\\u200d\\ud800-\\udfff" + Ae + "\\ufe0e\\ufe0f]"),
            Ze = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/,
            $e = ["Array", "Buffer", "DataView", "Date", "Error", "Float32Array", "Float64Array", "Function", "Int8Array", "Int16Array", "Int32Array", "Map", "Math", "Object", "Promise", "RegExp", "Set", "String", "Symbol", "TypeError", "Uint8Array", "Uint8ClampedArray", "Uint16Array", "Uint32Array", "WeakMap", "_", "clearTimeout", "isFinite", "parseInt", "setTimeout"],
            Ye = -1,
            Je = {};
        Je[N] = Je[R] = Je[O] = Je[P] = Je[F] = Je[L] = Je[G] = Je[j] = Je[z] = !0, Je[m] = Je[b] = Je[B] = Je[g] = Je[D] = Je[v] = Je[y] = Je[w] = Je[_] = Je[M] = Je[x] = Je[E] = Je[S] = Je[I] = Je[T] = !1;
        var Qe = {};
        Qe[m] = Qe[b] = Qe[B] = Qe[D] = Qe[g] = Qe[v] = Qe[N] = Qe[R] = Qe[O] = Qe[P] = Qe[F] = Qe[_] = Qe[M] = Qe[x] = Qe[E] = Qe[S] = Qe[I] = Qe[C] = Qe[L] = Qe[G] = Qe[j] = Qe[z] = !0, Qe[y] = Qe[w] = Qe[T] = !1;

        var et = {
          "\\": "\\",
          "'": "'",
          "\n": "n",
          "\r": "r",
          "\u2028": "u2028",
          "\u2029": "u2029"
        },
            tt = parseFloat,
            rt = parseInt,
            nt = "object" == typeof global && global && global.Object === Object && global,
            it = "object" == typeof self && self && self.Object === Object && self,
            ot = nt || it || Function("return this")(),
            at = t && !t.nodeType && t,
            ct = at && e && !e.nodeType && e,
            st = ct && ct.exports === at,
            ft = st && nt.process,
            dt = function () {
          try {
            return ct && ct.require && ct.require("util").types || ft && ft.binding && ft.binding("util");
          } catch (e) {}
        }(),
            ut = dt && dt.isArrayBuffer,
            ht = dt && dt.isDate,
            lt = dt && dt.isMap,
            pt = dt && dt.isRegExp,
            mt = dt && dt.isSet,
            bt = dt && dt.isTypedArray;

        function gt(e, t, r) {
          switch (r.length) {
            case 0:
              return e.call(t);

            case 1:
              return e.call(t, r[0]);

            case 2:
              return e.call(t, r[0], r[1]);

            case 3:
              return e.call(t, r[0], r[1], r[2]);
          }

          return e.apply(t, r);
        }

        function vt(e, t, r, n) {
          for (var i = -1, o = null == e ? 0 : e.length; ++i < o;) {
            var a = e[i];
            t(n, a, r(a), e);
          }

          return n;
        }

        function yt(e, t) {
          for (var r = -1, n = null == e ? 0 : e.length; ++r < n && !1 !== t(e[r], r, e);) {
            ;
          }

          return e;
        }

        function wt(e, t) {
          for (var r = null == e ? 0 : e.length; r-- && !1 !== t(e[r], r, e);) {
            ;
          }

          return e;
        }

        function At(e, t) {
          for (var r = -1, n = null == e ? 0 : e.length; ++r < n;) {
            if (!t(e[r], r, e)) return !1;
          }

          return !0;
        }

        function _t(e, t) {
          for (var r = -1, n = null == e ? 0 : e.length, i = 0, o = []; ++r < n;) {
            var a = e[r];
            t(a, r, e) && (o[i++] = a);
          }

          return o;
        }

        function Mt(e, t) {
          return !(null == e || !e.length) && Nt(e, t, 0) > -1;
        }

        function xt(e, t, r) {
          for (var n = -1, i = null == e ? 0 : e.length; ++n < i;) {
            if (r(t, e[n])) return !0;
          }

          return !1;
        }

        function kt(e, t) {
          for (var r = -1, n = null == e ? 0 : e.length, i = Array(n); ++r < n;) {
            i[r] = t(e[r], r, e);
          }

          return i;
        }

        function Et(e, t) {
          for (var r = -1, n = t.length, i = e.length; ++r < n;) {
            e[i + r] = t[r];
          }

          return e;
        }

        function St(e, t, r, n) {
          var i = -1,
              o = null == e ? 0 : e.length;

          for (n && o && (r = e[++i]); ++i < o;) {
            r = t(r, e[i], i, e);
          }

          return r;
        }

        function It(e, t, r, n) {
          var i = null == e ? 0 : e.length;

          for (n && i && (r = e[--i]); i--;) {
            r = t(r, e[i], i, e);
          }

          return r;
        }

        function Ct(e, t) {
          for (var r = -1, n = null == e ? 0 : e.length; ++r < n;) {
            if (t(e[r], r, e)) return !0;
          }

          return !1;
        }

        var Tt = Ft("length");

        function Bt(e, t, r) {
          var n;
          return r(e, function (e, r, i) {
            if (t(e, r, i)) return n = r, !1;
          }), n;
        }

        function Dt(e, t, r, n) {
          for (var i = e.length, o = r + (n ? 1 : -1); n ? o-- : ++o < i;) {
            if (t(e[o], o, e)) return o;
          }

          return -1;
        }

        function Nt(e, t, r) {
          return t == t ? function (e, t, r) {
            for (var n = r - 1, i = e.length; ++n < i;) {
              if (e[n] === t) return n;
            }

            return -1;
          }(e, t, r) : Dt(e, Ot, r);
        }

        function Rt(e, t, r, n) {
          for (var i = r - 1, o = e.length; ++i < o;) {
            if (n(e[i], t)) return i;
          }

          return -1;
        }

        function Ot(e) {
          return e != e;
        }

        function Pt(e, t) {
          var r = null == e ? 0 : e.length;
          return r ? jt(e, t) / r : h;
        }

        function Ft(e) {
          return function (t) {
            return null == t ? i : t[e];
          };
        }

        function Lt(e) {
          return function (t) {
            return null == e ? i : e[t];
          };
        }

        function Gt(e, t, r, n, i) {
          return i(e, function (e, i, o) {
            r = n ? (n = !1, e) : t(r, e, i, o);
          }), r;
        }

        function jt(e, t) {
          for (var r, n = -1, o = e.length; ++n < o;) {
            var a = t(e[n]);
            a !== i && (r = r === i ? a : r + a);
          }

          return r;
        }

        function zt(e, t) {
          for (var r = -1, n = Array(e); ++r < e;) {
            n[r] = t(r);
          }

          return n;
        }

        function qt(e) {
          return e ? e.slice(0, ar(e) + 1).replace(ne, "") : e;
        }

        function Ut(e) {
          return function (t) {
            return e(t);
          };
        }

        function Ht(e, t) {
          return kt(t, function (t) {
            return e[t];
          });
        }

        function Kt(e, t) {
          return e.has(t);
        }

        function Vt(e, t) {
          for (var r = -1, n = e.length; ++r < n && Nt(t, e[r], 0) > -1;) {
            ;
          }

          return r;
        }

        function Wt(e, t) {
          for (var r = e.length; r-- && Nt(t, e[r], 0) > -1;) {
            ;
          }

          return r;
        }

        function Xt(e, t) {
          for (var r = e.length, n = 0; r--;) {
            e[r] === t && ++n;
          }

          return n;
        }

        var Zt = Lt({
          À: "A",
          Á: "A",
          Â: "A",
          Ã: "A",
          Ä: "A",
          Å: "A",
          à: "a",
          á: "a",
          â: "a",
          ã: "a",
          ä: "a",
          å: "a",
          Ç: "C",
          ç: "c",
          Ð: "D",
          ð: "d",
          È: "E",
          É: "E",
          Ê: "E",
          Ë: "E",
          è: "e",
          é: "e",
          ê: "e",
          ë: "e",
          Ì: "I",
          Í: "I",
          Î: "I",
          Ï: "I",
          ì: "i",
          í: "i",
          î: "i",
          ï: "i",
          Ñ: "N",
          ñ: "n",
          Ò: "O",
          Ó: "O",
          Ô: "O",
          Õ: "O",
          Ö: "O",
          Ø: "O",
          ò: "o",
          ó: "o",
          ô: "o",
          õ: "o",
          ö: "o",
          ø: "o",
          Ù: "U",
          Ú: "U",
          Û: "U",
          Ü: "U",
          ù: "u",
          ú: "u",
          û: "u",
          ü: "u",
          Ý: "Y",
          ý: "y",
          ÿ: "y",
          Æ: "Ae",
          æ: "ae",
          Þ: "Th",
          þ: "th",
          ß: "ss",
          Ā: "A",
          Ă: "A",
          Ą: "A",
          ā: "a",
          ă: "a",
          ą: "a",
          Ć: "C",
          Ĉ: "C",
          Ċ: "C",
          Č: "C",
          ć: "c",
          ĉ: "c",
          ċ: "c",
          č: "c",
          Ď: "D",
          Đ: "D",
          ď: "d",
          đ: "d",
          Ē: "E",
          Ĕ: "E",
          Ė: "E",
          Ę: "E",
          Ě: "E",
          ē: "e",
          ĕ: "e",
          ė: "e",
          ę: "e",
          ě: "e",
          Ĝ: "G",
          Ğ: "G",
          Ġ: "G",
          Ģ: "G",
          ĝ: "g",
          ğ: "g",
          ġ: "g",
          ģ: "g",
          Ĥ: "H",
          Ħ: "H",
          ĥ: "h",
          ħ: "h",
          Ĩ: "I",
          Ī: "I",
          Ĭ: "I",
          Į: "I",
          İ: "I",
          ĩ: "i",
          ī: "i",
          ĭ: "i",
          į: "i",
          ı: "i",
          Ĵ: "J",
          ĵ: "j",
          Ķ: "K",
          ķ: "k",
          ĸ: "k",
          Ĺ: "L",
          Ļ: "L",
          Ľ: "L",
          Ŀ: "L",
          Ł: "L",
          ĺ: "l",
          ļ: "l",
          ľ: "l",
          ŀ: "l",
          ł: "l",
          Ń: "N",
          Ņ: "N",
          Ň: "N",
          Ŋ: "N",
          ń: "n",
          ņ: "n",
          ň: "n",
          ŋ: "n",
          Ō: "O",
          Ŏ: "O",
          Ő: "O",
          ō: "o",
          ŏ: "o",
          ő: "o",
          Ŕ: "R",
          Ŗ: "R",
          Ř: "R",
          ŕ: "r",
          ŗ: "r",
          ř: "r",
          Ś: "S",
          Ŝ: "S",
          Ş: "S",
          Š: "S",
          ś: "s",
          ŝ: "s",
          ş: "s",
          š: "s",
          Ţ: "T",
          Ť: "T",
          Ŧ: "T",
          ţ: "t",
          ť: "t",
          ŧ: "t",
          Ũ: "U",
          Ū: "U",
          Ŭ: "U",
          Ů: "U",
          Ű: "U",
          Ų: "U",
          ũ: "u",
          ū: "u",
          ŭ: "u",
          ů: "u",
          ű: "u",
          ų: "u",
          Ŵ: "W",
          ŵ: "w",
          Ŷ: "Y",
          ŷ: "y",
          Ÿ: "Y",
          Ź: "Z",
          Ż: "Z",
          Ž: "Z",
          ź: "z",
          ż: "z",
          ž: "z",
          Ĳ: "IJ",
          ĳ: "ij",
          Œ: "Oe",
          œ: "oe",
          ŉ: "'n",
          ſ: "s"
        }),
            $t = Lt({
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#39;"
        });

        function Yt(e) {
          return "\\" + et[e];
        }

        function Jt(e) {
          return Xe.test(e);
        }

        function Qt(e) {
          var t = -1,
              r = Array(e.size);
          return e.forEach(function (e, n) {
            r[++t] = [n, e];
          }), r;
        }

        function er(e, t) {
          return function (r) {
            return e(t(r));
          };
        }

        function tr(e, t) {
          for (var r = -1, n = e.length, i = 0, o = []; ++r < n;) {
            var a = e[r];
            a !== t && a !== c || (e[r] = c, o[i++] = r);
          }

          return o;
        }

        function rr(e) {
          var t = -1,
              r = Array(e.size);
          return e.forEach(function (e) {
            r[++t] = e;
          }), r;
        }

        function nr(e) {
          var t = -1,
              r = Array(e.size);
          return e.forEach(function (e) {
            r[++t] = [e, e];
          }), r;
        }

        function ir(e) {
          return Jt(e) ? function (e) {
            for (var t = Ve.lastIndex = 0; Ve.test(e);) {
              ++t;
            }

            return t;
          }(e) : Tt(e);
        }

        function or(e) {
          return Jt(e) ? function (e) {
            return e.match(Ve) || [];
          }(e) : function (e) {
            return e.split("");
          }(e);
        }

        function ar(e) {
          for (var t = e.length; t-- && ie.test(e.charAt(t));) {
            ;
          }

          return t;
        }

        var cr = Lt({
          "&amp;": "&",
          "&lt;": "<",
          "&gt;": ">",
          "&quot;": '"',
          "&#39;": "'"
        }),
            sr = function e(t) {
          var r,
              n = (t = null == t ? ot : sr.defaults(ot.Object(), t, sr.pick(ot, $e))).Array,
              ie = t.Date,
              Ae = t.Error,
              _e = t.Function,
              Me = t.Math,
              xe = t.Object,
              ke = t.RegExp,
              Ee = t.String,
              Se = t.TypeError,
              Ie = n.prototype,
              Ce = _e.prototype,
              Te = xe.prototype,
              Be = t["__core-js_shared__"],
              De = Ce.toString,
              Ne = Te.hasOwnProperty,
              Re = 0,
              Oe = (r = /[^.]+$/.exec(Be && Be.keys && Be.keys.IE_PROTO || "")) ? "Symbol(src)_1." + r : "",
              Pe = Te.toString,
              Fe = De.call(xe),
              Le = ot._,
              Ge = ke("^" + De.call(Ne).replace(te, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"),
              je = st ? t.Buffer : i,
              ze = t.Symbol,
              qe = t.Uint8Array,
              Ue = je ? je.allocUnsafe : i,
              Ve = er(xe.getPrototypeOf, xe),
              Xe = xe.create,
              et = Te.propertyIsEnumerable,
              nt = Ie.splice,
              it = ze ? ze.isConcatSpreadable : i,
              at = ze ? ze.iterator : i,
              ct = ze ? ze.toStringTag : i,
              ft = function () {
            try {
              var e = fo(xe, "defineProperty");
              return e({}, "", {}), e;
            } catch (e) {}
          }(),
              dt = t.clearTimeout !== ot.clearTimeout && t.clearTimeout,
              Tt = ie && ie.now !== ot.Date.now && ie.now,
              Lt = t.setTimeout !== ot.setTimeout && t.setTimeout,
              fr = Me.ceil,
              dr = Me.floor,
              ur = xe.getOwnPropertySymbols,
              hr = je ? je.isBuffer : i,
              lr = t.isFinite,
              pr = Ie.join,
              mr = er(xe.keys, xe),
              br = Me.max,
              gr = Me.min,
              vr = ie.now,
              yr = t.parseInt,
              wr = Me.random,
              Ar = Ie.reverse,
              _r = fo(t, "DataView"),
              Mr = fo(t, "Map"),
              xr = fo(t, "Promise"),
              kr = fo(t, "Set"),
              Er = fo(t, "WeakMap"),
              Sr = fo(xe, "create"),
              Ir = Er && new Er(),
              Cr = {},
              Tr = Go(_r),
              Br = Go(Mr),
              Dr = Go(xr),
              Nr = Go(kr),
              Rr = Go(Er),
              Or = ze ? ze.prototype : i,
              Pr = Or ? Or.valueOf : i,
              Fr = Or ? Or.toString : i;

          function Lr(e) {
            if (rc(e) && !Ka(e) && !(e instanceof qr)) {
              if (e instanceof zr) return e;
              if (Ne.call(e, "__wrapped__")) return jo(e);
            }

            return new zr(e);
          }

          var Gr = function () {
            function e() {}

            return function (t) {
              if (!tc(t)) return {};
              if (Xe) return Xe(t);
              e.prototype = t;
              var r = new e();
              return e.prototype = i, r;
            };
          }();

          function jr() {}

          function zr(e, t) {
            this.__wrapped__ = e, this.__actions__ = [], this.__chain__ = !!t, this.__index__ = 0, this.__values__ = i;
          }

          function qr(e) {
            this.__wrapped__ = e, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = l, this.__views__ = [];
          }

          function Ur(e) {
            var t = -1,
                r = null == e ? 0 : e.length;

            for (this.clear(); ++t < r;) {
              var n = e[t];
              this.set(n[0], n[1]);
            }
          }

          function Hr(e) {
            var t = -1,
                r = null == e ? 0 : e.length;

            for (this.clear(); ++t < r;) {
              var n = e[t];
              this.set(n[0], n[1]);
            }
          }

          function Kr(e) {
            var t = -1,
                r = null == e ? 0 : e.length;

            for (this.clear(); ++t < r;) {
              var n = e[t];
              this.set(n[0], n[1]);
            }
          }

          function Vr(e) {
            var t = -1,
                r = null == e ? 0 : e.length;

            for (this.__data__ = new Kr(); ++t < r;) {
              this.add(e[t]);
            }
          }

          function Wr(e) {
            var t = this.__data__ = new Hr(e);
            this.size = t.size;
          }

          function Xr(e, t) {
            var r = Ka(e),
                n = !r && Ha(e),
                i = !r && !n && Za(e),
                o = !r && !n && !i && dc(e),
                a = r || n || i || o,
                c = a ? zt(e.length, Ee) : [],
                s = c.length;

            for (var f in e) {
              !t && !Ne.call(e, f) || a && ("length" == f || i && ("offset" == f || "parent" == f) || o && ("buffer" == f || "byteLength" == f || "byteOffset" == f) || go(f, s)) || c.push(f);
            }

            return c;
          }

          function Zr(e) {
            var t = e.length;
            return t ? e[Vn(0, t - 1)] : i;
          }

          function $r(e, t) {
            return Ro(Si(e), an(t, 0, e.length));
          }

          function Yr(e) {
            return Ro(Si(e));
          }

          function Jr(e, t, r) {
            (r !== i && !za(e[t], r) || r === i && !(t in e)) && nn(e, t, r);
          }

          function Qr(e, t, r) {
            var n = e[t];
            Ne.call(e, t) && za(n, r) && (r !== i || t in e) || nn(e, t, r);
          }

          function en(e, t) {
            for (var r = e.length; r--;) {
              if (za(e[r][0], t)) return r;
            }

            return -1;
          }

          function tn(e, t, r, n) {
            return un(e, function (e, i, o) {
              t(n, e, r(e), o);
            }), n;
          }

          function rn(e, t) {
            return e && Ii(t, Dc(t), e);
          }

          function nn(e, t, r) {
            "__proto__" == t && ft ? ft(e, t, {
              configurable: !0,
              enumerable: !0,
              value: r,
              writable: !0
            }) : e[t] = r;
          }

          function on(e, t) {
            for (var r = -1, o = t.length, a = n(o), c = null == e; ++r < o;) {
              a[r] = c ? i : Sc(e, t[r]);
            }

            return a;
          }

          function an(e, t, r) {
            return e == e && (r !== i && (e = e <= r ? e : r), t !== i && (e = e >= t ? e : t)), e;
          }

          function cn(e, t, r, n, o, a) {
            var c,
                s = 1 & t,
                f = 2 & t,
                d = 4 & t;
            if (r && (c = o ? r(e, n, o, a) : r(e)), c !== i) return c;
            if (!tc(e)) return e;
            var u = Ka(e);

            if (u) {
              if (c = function (e) {
                var t = e.length,
                    r = new e.constructor(t);
                return t && "string" == typeof e[0] && Ne.call(e, "index") && (r.index = e.index, r.input = e.input), r;
              }(e), !s) return Si(e, c);
            } else {
              var h = lo(e),
                  l = h == w || h == A;
              if (Za(e)) return Ai(e, s);

              if (h == x || h == m || l && !o) {
                if (c = f || l ? {} : mo(e), !s) return f ? function (e, t) {
                  return Ii(e, ho(e), t);
                }(e, function (e, t) {
                  return e && Ii(t, Nc(t), e);
                }(c, e)) : function (e, t) {
                  return Ii(e, uo(e), t);
                }(e, rn(c, e));
              } else {
                if (!Qe[h]) return o ? e : {};

                c = function (e, t, r) {
                  var n,
                      i = e.constructor;

                  switch (t) {
                    case B:
                      return _i(e);

                    case g:
                    case v:
                      return new i(+e);

                    case D:
                      return function (e, t) {
                        var r = t ? _i(e.buffer) : e.buffer;
                        return new e.constructor(r, e.byteOffset, e.byteLength);
                      }(e, r);

                    case N:
                    case R:
                    case O:
                    case P:
                    case F:
                    case L:
                    case G:
                    case j:
                    case z:
                      return Mi(e, r);

                    case _:
                      return new i();

                    case M:
                    case I:
                      return new i(e);

                    case E:
                      return function (e) {
                        var t = new e.constructor(e.source, he.exec(e));
                        return t.lastIndex = e.lastIndex, t;
                      }(e);

                    case S:
                      return new i();

                    case C:
                      return n = e, Pr ? xe(Pr.call(n)) : {};
                  }
                }(e, h, s);
              }
            }

            a || (a = new Wr());
            var p = a.get(e);
            if (p) return p;
            a.set(e, c), cc(e) ? e.forEach(function (n) {
              c.add(cn(n, t, r, n, e, a));
            }) : nc(e) && e.forEach(function (n, i) {
              c.set(i, cn(n, t, r, i, e, a));
            });
            var b = u ? i : (d ? f ? ro : to : f ? Nc : Dc)(e);
            return yt(b || e, function (n, i) {
              b && (n = e[i = n]), Qr(c, i, cn(n, t, r, i, e, a));
            }), c;
          }

          function sn(e, t, r) {
            var n = r.length;
            if (null == e) return !n;

            for (e = xe(e); n--;) {
              var o = r[n],
                  a = t[o],
                  c = e[o];
              if (c === i && !(o in e) || !a(c)) return !1;
            }

            return !0;
          }

          function fn(e, t, r) {
            if ("function" != typeof e) throw new Se(o);
            return To(function () {
              e.apply(i, r);
            }, t);
          }

          function dn(e, t, r, n) {
            var i = -1,
                o = Mt,
                a = !0,
                c = e.length,
                s = [],
                f = t.length;
            if (!c) return s;
            r && (t = kt(t, Ut(r))), n ? (o = xt, a = !1) : t.length >= 200 && (o = Kt, a = !1, t = new Vr(t));

            e: for (; ++i < c;) {
              var d = e[i],
                  u = null == r ? d : r(d);

              if (d = n || 0 !== d ? d : 0, a && u == u) {
                for (var h = f; h--;) {
                  if (t[h] === u) continue e;
                }

                s.push(d);
              } else o(t, u, n) || s.push(d);
            }

            return s;
          }

          Lr.templateSettings = {
            escape: Z,
            evaluate: $,
            interpolate: Y,
            variable: "",
            imports: {
              _: Lr
            }
          }, Lr.prototype = jr.prototype, Lr.prototype.constructor = Lr, zr.prototype = Gr(jr.prototype), zr.prototype.constructor = zr, qr.prototype = Gr(jr.prototype), qr.prototype.constructor = qr, Ur.prototype.clear = function () {
            this.__data__ = Sr ? Sr(null) : {}, this.size = 0;
          }, Ur.prototype.delete = function (e) {
            var t = this.has(e) && delete this.__data__[e];
            return this.size -= t ? 1 : 0, t;
          }, Ur.prototype.get = function (e) {
            var t = this.__data__;

            if (Sr) {
              var r = t[e];
              return r === a ? i : r;
            }

            return Ne.call(t, e) ? t[e] : i;
          }, Ur.prototype.has = function (e) {
            var t = this.__data__;
            return Sr ? t[e] !== i : Ne.call(t, e);
          }, Ur.prototype.set = function (e, t) {
            var r = this.__data__;
            return this.size += this.has(e) ? 0 : 1, r[e] = Sr && t === i ? a : t, this;
          }, Hr.prototype.clear = function () {
            this.__data__ = [], this.size = 0;
          }, Hr.prototype.delete = function (e) {
            var t = this.__data__,
                r = en(t, e);
            return !(r < 0 || (r == t.length - 1 ? t.pop() : nt.call(t, r, 1), --this.size, 0));
          }, Hr.prototype.get = function (e) {
            var t = this.__data__,
                r = en(t, e);
            return r < 0 ? i : t[r][1];
          }, Hr.prototype.has = function (e) {
            return en(this.__data__, e) > -1;
          }, Hr.prototype.set = function (e, t) {
            var r = this.__data__,
                n = en(r, e);
            return n < 0 ? (++this.size, r.push([e, t])) : r[n][1] = t, this;
          }, Kr.prototype.clear = function () {
            this.size = 0, this.__data__ = {
              hash: new Ur(),
              map: new (Mr || Hr)(),
              string: new Ur()
            };
          }, Kr.prototype.delete = function (e) {
            var t = co(this, e).delete(e);
            return this.size -= t ? 1 : 0, t;
          }, Kr.prototype.get = function (e) {
            return co(this, e).get(e);
          }, Kr.prototype.has = function (e) {
            return co(this, e).has(e);
          }, Kr.prototype.set = function (e, t) {
            var r = co(this, e),
                n = r.size;
            return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
          }, Vr.prototype.add = Vr.prototype.push = function (e) {
            return this.__data__.set(e, a), this;
          }, Vr.prototype.has = function (e) {
            return this.__data__.has(e);
          }, Wr.prototype.clear = function () {
            this.__data__ = new Hr(), this.size = 0;
          }, Wr.prototype.delete = function (e) {
            var t = this.__data__,
                r = t.delete(e);
            return this.size = t.size, r;
          }, Wr.prototype.get = function (e) {
            return this.__data__.get(e);
          }, Wr.prototype.has = function (e) {
            return this.__data__.has(e);
          }, Wr.prototype.set = function (e, t) {
            var r = this.__data__;

            if (r instanceof Hr) {
              var n = r.__data__;
              if (!Mr || n.length < 199) return n.push([e, t]), this.size = ++r.size, this;
              r = this.__data__ = new Kr(n);
            }

            return r.set(e, t), this.size = r.size, this;
          };
          var un = Bi(yn),
              hn = Bi(wn, !0);

          function ln(e, t) {
            var r = !0;
            return un(e, function (e, n, i) {
              return r = !!t(e, n, i);
            }), r;
          }

          function pn(e, t, r) {
            for (var n = -1, o = e.length; ++n < o;) {
              var a = e[n],
                  c = t(a);
              if (null != c && (s === i ? c == c && !fc(c) : r(c, s))) var s = c,
                  f = a;
            }

            return f;
          }

          function mn(e, t) {
            var r = [];
            return un(e, function (e, n, i) {
              t(e, n, i) && r.push(e);
            }), r;
          }

          function bn(e, t, r, n, i) {
            var o = -1,
                a = e.length;

            for (r || (r = bo), i || (i = []); ++o < a;) {
              var c = e[o];
              t > 0 && r(c) ? t > 1 ? bn(c, t - 1, r, n, i) : Et(i, c) : n || (i[i.length] = c);
            }

            return i;
          }

          var gn = Di(),
              vn = Di(!0);

          function yn(e, t) {
            return e && gn(e, t, Dc);
          }

          function wn(e, t) {
            return e && vn(e, t, Dc);
          }

          function An(e, t) {
            return _t(t, function (t) {
              return Ja(e[t]);
            });
          }

          function _n(e, t) {
            for (var r = 0, n = (t = gi(t, e)).length; null != e && r < n;) {
              e = e[Lo(t[r++])];
            }

            return r && r == n ? e : i;
          }

          function Mn(e, t, r) {
            var n = t(e);
            return Ka(e) ? n : Et(n, r(e));
          }

          function xn(e) {
            return null == e ? e === i ? "[object Undefined]" : "[object Null]" : ct && ct in xe(e) ? function (e) {
              var t = Ne.call(e, ct),
                  r = e[ct];

              try {
                e[ct] = i;
                var n = !0;
              } catch (e) {}

              var o = Pe.call(e);
              return n && (t ? e[ct] = r : delete e[ct]), o;
            }(e) : function (e) {
              return Pe.call(e);
            }(e);
          }

          function kn(e, t) {
            return e > t;
          }

          function En(e, t) {
            return null != e && Ne.call(e, t);
          }

          function Sn(e, t) {
            return null != e && t in xe(e);
          }

          function In(e, t, r) {
            for (var o = r ? xt : Mt, a = e[0].length, c = e.length, s = c, f = n(c), d = 1 / 0, u = []; s--;) {
              var h = e[s];
              s && t && (h = kt(h, Ut(t))), d = gr(h.length, d), f[s] = !r && (t || a >= 120 && h.length >= 120) ? new Vr(s && h) : i;
            }

            h = e[0];
            var l = -1,
                p = f[0];

            e: for (; ++l < a && u.length < d;) {
              var m = h[l],
                  b = t ? t(m) : m;

              if (m = r || 0 !== m ? m : 0, !(p ? Kt(p, b) : o(u, b, r))) {
                for (s = c; --s;) {
                  var g = f[s];
                  if (!(g ? Kt(g, b) : o(e[s], b, r))) continue e;
                }

                p && p.push(b), u.push(m);
              }
            }

            return u;
          }

          function Cn(e, t, r) {
            var n = null == (e = Eo(e, t = gi(t, e))) ? e : e[Lo(Yo(t))];
            return null == n ? i : gt(n, e, r);
          }

          function Tn(e) {
            return rc(e) && xn(e) == m;
          }

          function Bn(e, t, r, n, o) {
            return e === t || (null == e || null == t || !rc(e) && !rc(t) ? e != e && t != t : function (e, t, r, n, o, a) {
              var c = Ka(e),
                  s = Ka(t),
                  f = c ? b : lo(e),
                  d = s ? b : lo(t),
                  u = (f = f == m ? x : f) == x,
                  h = (d = d == m ? x : d) == x,
                  l = f == d;

              if (l && Za(e)) {
                if (!Za(t)) return !1;
                c = !0, u = !1;
              }

              if (l && !u) return a || (a = new Wr()), c || dc(e) ? Qi(e, t, r, n, o, a) : function (e, t, r, n, i, o, a) {
                switch (r) {
                  case D:
                    if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
                    e = e.buffer, t = t.buffer;

                  case B:
                    return !(e.byteLength != t.byteLength || !o(new qe(e), new qe(t)));

                  case g:
                  case v:
                  case M:
                    return za(+e, +t);

                  case y:
                    return e.name == t.name && e.message == t.message;

                  case E:
                  case I:
                    return e == t + "";

                  case _:
                    var c = Qt;

                  case S:
                    var s = 1 & n;
                    if (c || (c = rr), e.size != t.size && !s) return !1;
                    var f = a.get(e);
                    if (f) return f == t;
                    n |= 2, a.set(e, t);
                    var d = Qi(c(e), c(t), n, i, o, a);
                    return a.delete(e), d;

                  case C:
                    if (Pr) return Pr.call(e) == Pr.call(t);
                }

                return !1;
              }(e, t, f, r, n, o, a);

              if (!(1 & r)) {
                var p = u && Ne.call(e, "__wrapped__"),
                    w = h && Ne.call(t, "__wrapped__");

                if (p || w) {
                  var A = p ? e.value() : e,
                      k = w ? t.value() : t;
                  return a || (a = new Wr()), o(A, k, r, n, a);
                }
              }

              return !!l && (a || (a = new Wr()), function (e, t, r, n, o, a) {
                var c = 1 & r,
                    s = to(e),
                    f = s.length;
                if (f != to(t).length && !c) return !1;

                for (var d = f; d--;) {
                  var u = s[d];
                  if (!(c ? u in t : Ne.call(t, u))) return !1;
                }

                var h = a.get(e),
                    l = a.get(t);
                if (h && l) return h == t && l == e;
                var p = !0;
                a.set(e, t), a.set(t, e);

                for (var m = c; ++d < f;) {
                  var b = e[u = s[d]],
                      g = t[u];
                  if (n) var v = c ? n(g, b, u, t, e, a) : n(b, g, u, e, t, a);

                  if (!(v === i ? b === g || o(b, g, r, n, a) : v)) {
                    p = !1;
                    break;
                  }

                  m || (m = "constructor" == u);
                }

                if (p && !m) {
                  var y = e.constructor,
                      w = t.constructor;
                  y == w || !("constructor" in e) || !("constructor" in t) || "function" == typeof y && y instanceof y && "function" == typeof w && w instanceof w || (p = !1);
                }

                return a.delete(e), a.delete(t), p;
              }(e, t, r, n, o, a));
            }(e, t, r, n, Bn, o));
          }

          function Dn(e, t, r, n) {
            var o = r.length,
                a = o,
                c = !n;
            if (null == e) return !a;

            for (e = xe(e); o--;) {
              var s = r[o];
              if (c && s[2] ? s[1] !== e[s[0]] : !(s[0] in e)) return !1;
            }

            for (; ++o < a;) {
              var f = (s = r[o])[0],
                  d = e[f],
                  u = s[1];

              if (c && s[2]) {
                if (d === i && !(f in e)) return !1;
              } else {
                var h = new Wr();
                if (n) var l = n(d, u, f, e, t, h);
                if (!(l === i ? Bn(u, d, 3, n, h) : l)) return !1;
              }
            }

            return !0;
          }

          function Nn(e) {
            return !(!tc(e) || (t = e, Oe && Oe in t)) && (Ja(e) ? Ge : me).test(Go(e));
            var t;
          }

          function Rn(e) {
            return "function" == typeof e ? e : null == e ? is : "object" == typeof e ? Ka(e) ? Gn(e[0], e[1]) : Ln(e) : ls(e);
          }

          function On(e) {
            if (!_o(e)) return mr(e);
            var t = [];

            for (var r in xe(e)) {
              Ne.call(e, r) && "constructor" != r && t.push(r);
            }

            return t;
          }

          function Pn(e, t) {
            return e < t;
          }

          function Fn(e, t) {
            var r = -1,
                i = Wa(e) ? n(e.length) : [];
            return un(e, function (e, n, o) {
              i[++r] = t(e, n, o);
            }), i;
          }

          function Ln(e) {
            var t = so(e);
            return 1 == t.length && t[0][2] ? xo(t[0][0], t[0][1]) : function (r) {
              return r === e || Dn(r, e, t);
            };
          }

          function Gn(e, t) {
            return yo(e) && Mo(t) ? xo(Lo(e), t) : function (r) {
              var n = Sc(r, e);
              return n === i && n === t ? Ic(r, e) : Bn(t, n, 3);
            };
          }

          function jn(e, t, r, n, o) {
            e !== t && gn(t, function (a, c) {
              if (o || (o = new Wr()), tc(a)) !function (e, t, r, n, o, a, c) {
                var s = Io(e, r),
                    f = Io(t, r),
                    d = c.get(f);
                if (d) Jr(e, r, d);else {
                  var u = a ? a(s, f, r + "", e, t, c) : i,
                      h = u === i;

                  if (h) {
                    var l = Ka(f),
                        p = !l && Za(f),
                        m = !l && !p && dc(f);
                    u = f, l || p || m ? Ka(s) ? u = s : Xa(s) ? u = Si(s) : p ? (h = !1, u = Ai(f, !0)) : m ? (h = !1, u = Mi(f, !0)) : u = [] : oc(f) || Ha(f) ? (u = s, Ha(s) ? u = vc(s) : tc(s) && !Ja(s) || (u = mo(f))) : h = !1;
                  }

                  h && (c.set(f, u), o(u, f, n, a, c), c.delete(f)), Jr(e, r, u);
                }
              }(e, t, c, r, jn, n, o);else {
                var s = n ? n(Io(e, c), a, c + "", e, t, o) : i;
                s === i && (s = a), Jr(e, c, s);
              }
            }, Nc);
          }

          function zn(e, t) {
            var r = e.length;
            if (r) return go(t += t < 0 ? r : 0, r) ? e[t] : i;
          }

          function qn(e, t, r) {
            t = t.length ? kt(t, function (e) {
              return Ka(e) ? function (t) {
                return _n(t, 1 === e.length ? e[0] : e);
              } : e;
            }) : [is];
            var n = -1;
            t = kt(t, Ut(ao()));
            var i = Fn(e, function (e, r, i) {
              var o = kt(t, function (t) {
                return t(e);
              });
              return {
                criteria: o,
                index: ++n,
                value: e
              };
            });
            return function (e, t) {
              var n = e.length;

              for (e.sort(function (e, t) {
                return function (e, t, r) {
                  for (var n = -1, i = e.criteria, o = t.criteria, a = i.length, c = r.length; ++n < a;) {
                    var s = xi(i[n], o[n]);
                    if (s) return n >= c ? s : s * ("desc" == r[n] ? -1 : 1);
                  }

                  return e.index - t.index;
                }(e, t, r);
              }); n--;) {
                e[n] = e[n].value;
              }

              return e;
            }(i);
          }

          function Un(e, t, r) {
            for (var n = -1, i = t.length, o = {}; ++n < i;) {
              var a = t[n],
                  c = _n(e, a);

              r(c, a) && Yn(o, gi(a, e), c);
            }

            return o;
          }

          function Hn(e, t, r, n) {
            var i = n ? Rt : Nt,
                o = -1,
                a = t.length,
                c = e;

            for (e === t && (t = Si(t)), r && (c = kt(e, Ut(r))); ++o < a;) {
              for (var s = 0, f = t[o], d = r ? r(f) : f; (s = i(c, d, s, n)) > -1;) {
                c !== e && nt.call(c, s, 1), nt.call(e, s, 1);
              }
            }

            return e;
          }

          function Kn(e, t) {
            for (var r = e ? t.length : 0, n = r - 1; r--;) {
              var i = t[r];

              if (r == n || i !== o) {
                var o = i;
                go(i) ? nt.call(e, i, 1) : fi(e, i);
              }
            }

            return e;
          }

          function Vn(e, t) {
            return e + dr(wr() * (t - e + 1));
          }

          function Wn(e, t) {
            var r = "";
            if (!e || t < 1 || t > u) return r;

            do {
              t % 2 && (r += e), (t = dr(t / 2)) && (e += e);
            } while (t);

            return r;
          }

          function Xn(e, t) {
            return Bo(ko(e, t, is), e + "");
          }

          function Zn(e) {
            return Zr(zc(e));
          }

          function $n(e, t) {
            var r = zc(e);
            return Ro(r, an(t, 0, r.length));
          }

          function Yn(e, t, r, n) {
            if (!tc(e)) return e;

            for (var o = -1, a = (t = gi(t, e)).length, c = a - 1, s = e; null != s && ++o < a;) {
              var f = Lo(t[o]),
                  d = r;
              if ("__proto__" === f || "constructor" === f || "prototype" === f) return e;

              if (o != c) {
                var u = s[f];
                (d = n ? n(u, f, s) : i) === i && (d = tc(u) ? u : go(t[o + 1]) ? [] : {});
              }

              Qr(s, f, d), s = s[f];
            }

            return e;
          }

          var Jn = Ir ? function (e, t) {
            return Ir.set(e, t), e;
          } : is,
              Qn = ft ? function (e, t) {
            return ft(e, "toString", {
              configurable: !0,
              enumerable: !1,
              value: ts(t),
              writable: !0
            });
          } : is;

          function ei(e) {
            return Ro(zc(e));
          }

          function ti(e, t, r) {
            var i = -1,
                o = e.length;
            t < 0 && (t = -t > o ? 0 : o + t), (r = r > o ? o : r) < 0 && (r += o), o = t > r ? 0 : r - t >>> 0, t >>>= 0;

            for (var a = n(o); ++i < o;) {
              a[i] = e[i + t];
            }

            return a;
          }

          function ri(e, t) {
            var r;
            return un(e, function (e, n, i) {
              return !(r = t(e, n, i));
            }), !!r;
          }

          function ni(e, t, r) {
            var n = 0,
                i = null == e ? n : e.length;

            if ("number" == typeof t && t == t && i <= 2147483647) {
              for (; n < i;) {
                var o = n + i >>> 1,
                    a = e[o];
                null !== a && !fc(a) && (r ? a <= t : a < t) ? n = o + 1 : i = o;
              }

              return i;
            }

            return ii(e, t, is, r);
          }

          function ii(e, t, r, n) {
            var o = 0,
                a = null == e ? 0 : e.length;
            if (0 === a) return 0;

            for (var c = (t = r(t)) != t, s = null === t, f = fc(t), d = t === i; o < a;) {
              var u = dr((o + a) / 2),
                  h = r(e[u]),
                  l = h !== i,
                  p = null === h,
                  m = h == h,
                  b = fc(h);
              if (c) var g = n || m;else g = d ? m && (n || l) : s ? m && l && (n || !p) : f ? m && l && !p && (n || !b) : !p && !b && (n ? h <= t : h < t);
              g ? o = u + 1 : a = u;
            }

            return gr(a, 4294967294);
          }

          function oi(e, t) {
            for (var r = -1, n = e.length, i = 0, o = []; ++r < n;) {
              var a = e[r],
                  c = t ? t(a) : a;

              if (!r || !za(c, s)) {
                var s = c;
                o[i++] = 0 === a ? 0 : a;
              }
            }

            return o;
          }

          function ai(e) {
            return "number" == typeof e ? e : fc(e) ? h : +e;
          }

          function ci(e) {
            if ("string" == typeof e) return e;
            if (Ka(e)) return kt(e, ci) + "";
            if (fc(e)) return Fr ? Fr.call(e) : "";
            var t = e + "";
            return "0" == t && 1 / e == -1 / 0 ? "-0" : t;
          }

          function si(e, t, r) {
            var n = -1,
                i = Mt,
                o = e.length,
                a = !0,
                c = [],
                s = c;
            if (r) a = !1, i = xt;else if (o >= 200) {
              var f = t ? null : Wi(e);
              if (f) return rr(f);
              a = !1, i = Kt, s = new Vr();
            } else s = t ? [] : c;

            e: for (; ++n < o;) {
              var d = e[n],
                  u = t ? t(d) : d;

              if (d = r || 0 !== d ? d : 0, a && u == u) {
                for (var h = s.length; h--;) {
                  if (s[h] === u) continue e;
                }

                t && s.push(u), c.push(d);
              } else i(s, u, r) || (s !== c && s.push(u), c.push(d));
            }

            return c;
          }

          function fi(e, t) {
            return null == (e = Eo(e, t = gi(t, e))) || delete e[Lo(Yo(t))];
          }

          function di(e, t, r, n) {
            return Yn(e, t, r(_n(e, t)), n);
          }

          function ui(e, t, r, n) {
            for (var i = e.length, o = n ? i : -1; (n ? o-- : ++o < i) && t(e[o], o, e);) {
              ;
            }

            return r ? ti(e, n ? 0 : o, n ? o + 1 : i) : ti(e, n ? o + 1 : 0, n ? i : o);
          }

          function hi(e, t) {
            var r = e;
            return r instanceof qr && (r = r.value()), St(t, function (e, t) {
              return t.func.apply(t.thisArg, Et([e], t.args));
            }, r);
          }

          function li(e, t, r) {
            var i = e.length;
            if (i < 2) return i ? si(e[0]) : [];

            for (var o = -1, a = n(i); ++o < i;) {
              for (var c = e[o], s = -1; ++s < i;) {
                s != o && (a[o] = dn(a[o] || c, e[s], t, r));
              }
            }

            return si(bn(a, 1), t, r);
          }

          function pi(e, t, r) {
            for (var n = -1, o = e.length, a = t.length, c = {}; ++n < o;) {
              var s = n < a ? t[n] : i;
              r(c, e[n], s);
            }

            return c;
          }

          function mi(e) {
            return Xa(e) ? e : [];
          }

          function bi(e) {
            return "function" == typeof e ? e : is;
          }

          function gi(e, t) {
            return Ka(e) ? e : yo(e, t) ? [e] : Fo(yc(e));
          }

          var vi = Xn;

          function yi(e, t, r) {
            var n = e.length;
            return r = r === i ? n : r, !t && r >= n ? e : ti(e, t, r);
          }

          var wi = dt || function (e) {
            return ot.clearTimeout(e);
          };

          function Ai(e, t) {
            if (t) return e.slice();
            var r = e.length,
                n = Ue ? Ue(r) : new e.constructor(r);
            return e.copy(n), n;
          }

          function _i(e) {
            var t = new e.constructor(e.byteLength);
            return new qe(t).set(new qe(e)), t;
          }

          function Mi(e, t) {
            var r = t ? _i(e.buffer) : e.buffer;
            return new e.constructor(r, e.byteOffset, e.length);
          }

          function xi(e, t) {
            if (e !== t) {
              var r = e !== i,
                  n = null === e,
                  o = e == e,
                  a = fc(e),
                  c = t !== i,
                  s = null === t,
                  f = t == t,
                  d = fc(t);
              if (!s && !d && !a && e > t || a && c && f && !s && !d || n && c && f || !r && f || !o) return 1;
              if (!n && !a && !d && e < t || d && r && o && !n && !a || s && r && o || !c && o || !f) return -1;
            }

            return 0;
          }

          function ki(e, t, r, i) {
            for (var o = -1, a = e.length, c = r.length, s = -1, f = t.length, d = br(a - c, 0), u = n(f + d), h = !i; ++s < f;) {
              u[s] = t[s];
            }

            for (; ++o < c;) {
              (h || o < a) && (u[r[o]] = e[o]);
            }

            for (; d--;) {
              u[s++] = e[o++];
            }

            return u;
          }

          function Ei(e, t, r, i) {
            for (var o = -1, a = e.length, c = -1, s = r.length, f = -1, d = t.length, u = br(a - s, 0), h = n(u + d), l = !i; ++o < u;) {
              h[o] = e[o];
            }

            for (var p = o; ++f < d;) {
              h[p + f] = t[f];
            }

            for (; ++c < s;) {
              (l || o < a) && (h[p + r[c]] = e[o++]);
            }

            return h;
          }

          function Si(e, t) {
            var r = -1,
                i = e.length;

            for (t || (t = n(i)); ++r < i;) {
              t[r] = e[r];
            }

            return t;
          }

          function Ii(e, t, r, n) {
            var o = !r;
            r || (r = {});

            for (var a = -1, c = t.length; ++a < c;) {
              var s = t[a],
                  f = n ? n(r[s], e[s], s, r, e) : i;
              f === i && (f = e[s]), o ? nn(r, s, f) : Qr(r, s, f);
            }

            return r;
          }

          function Ci(e, t) {
            return function (r, n) {
              var i = Ka(r) ? vt : tn,
                  o = t ? t() : {};
              return i(r, e, ao(n, 2), o);
            };
          }

          function Ti(e) {
            return Xn(function (t, r) {
              var n = -1,
                  o = r.length,
                  a = o > 1 ? r[o - 1] : i,
                  c = o > 2 ? r[2] : i;

              for (a = e.length > 3 && "function" == typeof a ? (o--, a) : i, c && vo(r[0], r[1], c) && (a = o < 3 ? i : a, o = 1), t = xe(t); ++n < o;) {
                var s = r[n];
                s && e(t, s, n, a);
              }

              return t;
            });
          }

          function Bi(e, t) {
            return function (r, n) {
              if (null == r) return r;
              if (!Wa(r)) return e(r, n);

              for (var i = r.length, o = t ? i : -1, a = xe(r); (t ? o-- : ++o < i) && !1 !== n(a[o], o, a);) {
                ;
              }

              return r;
            };
          }

          function Di(e) {
            return function (t, r, n) {
              for (var i = -1, o = xe(t), a = n(t), c = a.length; c--;) {
                var s = a[e ? c : ++i];
                if (!1 === r(o[s], s, o)) break;
              }

              return t;
            };
          }

          function Ni(e) {
            return function (t) {
              var r = Jt(t = yc(t)) ? or(t) : i,
                  n = r ? r[0] : t.charAt(0),
                  o = r ? yi(r, 1).join("") : t.slice(1);
              return n[e]() + o;
            };
          }

          function Ri(e) {
            return function (t) {
              return St(Jc(Hc(t).replace(He, "")), e, "");
            };
          }

          function Oi(e) {
            return function () {
              var t = arguments;

              switch (t.length) {
                case 0:
                  return new e();

                case 1:
                  return new e(t[0]);

                case 2:
                  return new e(t[0], t[1]);

                case 3:
                  return new e(t[0], t[1], t[2]);

                case 4:
                  return new e(t[0], t[1], t[2], t[3]);

                case 5:
                  return new e(t[0], t[1], t[2], t[3], t[4]);

                case 6:
                  return new e(t[0], t[1], t[2], t[3], t[4], t[5]);

                case 7:
                  return new e(t[0], t[1], t[2], t[3], t[4], t[5], t[6]);
              }

              var r = Gr(e.prototype),
                  n = e.apply(r, t);
              return tc(n) ? n : r;
            };
          }

          function Pi(e) {
            return function (t, r, n) {
              var o = xe(t);

              if (!Wa(t)) {
                var a = ao(r, 3);
                t = Dc(t), r = function r(e) {
                  return a(o[e], e, o);
                };
              }

              var c = e(t, r, n);
              return c > -1 ? o[a ? t[c] : c] : i;
            };
          }

          function Fi(e) {
            return eo(function (t) {
              var r = t.length,
                  n = r,
                  a = zr.prototype.thru;

              for (e && t.reverse(); n--;) {
                var c = t[n];
                if ("function" != typeof c) throw new Se(o);
                if (a && !s && "wrapper" == io(c)) var s = new zr([], !0);
              }

              for (n = s ? n : r; ++n < r;) {
                var f = io(c = t[n]),
                    d = "wrapper" == f ? no(c) : i;
                s = d && wo(d[0]) && 424 == d[1] && !d[4].length && 1 == d[9] ? s[io(d[0])].apply(s, d[3]) : 1 == c.length && wo(c) ? s[f]() : s.thru(c);
              }

              return function () {
                var e = arguments,
                    n = e[0];
                if (s && 1 == e.length && Ka(n)) return s.plant(n).value();

                for (var i = 0, o = r ? t[i].apply(this, e) : n; ++i < r;) {
                  o = t[i].call(this, o);
                }

                return o;
              };
            });
          }

          function Li(e, t, r, o, a, c, s, d, u, h) {
            var l = t & f,
                p = 1 & t,
                m = 2 & t,
                b = 24 & t,
                g = 512 & t,
                v = m ? i : Oi(e);
            return function i() {
              for (var f = arguments.length, y = n(f), w = f; w--;) {
                y[w] = arguments[w];
              }

              if (b) var A = oo(i),
                  _ = Xt(y, A);

              if (o && (y = ki(y, o, a, b)), c && (y = Ei(y, c, s, b)), f -= _, b && f < h) {
                var M = tr(y, A);
                return Ki(e, t, Li, i.placeholder, r, y, M, d, u, h - f);
              }

              var x = p ? r : this,
                  k = m ? x[e] : e;
              return f = y.length, d ? y = So(y, d) : g && f > 1 && y.reverse(), l && u < f && (y.length = u), this && this !== ot && this instanceof i && (k = v || Oi(k)), k.apply(x, y);
            };
          }

          function Gi(e, t) {
            return function (r, n) {
              return function (e, t, r, n) {
                return yn(e, function (e, i, o) {
                  t(n, r(e), i, o);
                }), n;
              }(r, e, t(n), {});
            };
          }

          function ji(e, t) {
            return function (r, n) {
              var o;
              if (r === i && n === i) return t;

              if (r !== i && (o = r), n !== i) {
                if (o === i) return n;
                "string" == typeof r || "string" == typeof n ? (r = ci(r), n = ci(n)) : (r = ai(r), n = ai(n)), o = e(r, n);
              }

              return o;
            };
          }

          function zi(e) {
            return eo(function (t) {
              return t = kt(t, Ut(ao())), Xn(function (r) {
                var n = this;
                return e(t, function (e) {
                  return gt(e, n, r);
                });
              });
            });
          }

          function qi(e, t) {
            var r = (t = t === i ? " " : ci(t)).length;
            if (r < 2) return r ? Wn(t, e) : t;
            var n = Wn(t, fr(e / ir(t)));
            return Jt(t) ? yi(or(n), 0, e).join("") : n.slice(0, e);
          }

          function Ui(e) {
            return function (t, r, o) {
              return o && "number" != typeof o && vo(t, r, o) && (r = o = i), t = pc(t), r === i ? (r = t, t = 0) : r = pc(r), function (e, t, r, i) {
                for (var o = -1, a = br(fr((t - e) / (r || 1)), 0), c = n(a); a--;) {
                  c[i ? a : ++o] = e, e += r;
                }

                return c;
              }(t, r, o = o === i ? t < r ? 1 : -1 : pc(o), e);
            };
          }

          function Hi(e) {
            return function (t, r) {
              return "string" == typeof t && "string" == typeof r || (t = gc(t), r = gc(r)), e(t, r);
            };
          }

          function Ki(e, t, r, n, o, a, c, f, d, u) {
            var h = 8 & t;
            t |= h ? s : 64, 4 & (t &= ~(h ? 64 : s)) || (t &= -4);
            var l = [e, t, o, h ? a : i, h ? c : i, h ? i : a, h ? i : c, f, d, u],
                p = r.apply(i, l);
            return wo(e) && Co(p, l), p.placeholder = n, Do(p, e, t);
          }

          function Vi(e) {
            var t = Me[e];
            return function (e, r) {
              if (e = gc(e), (r = null == r ? 0 : gr(mc(r), 292)) && lr(e)) {
                var n = (yc(e) + "e").split("e");
                return +((n = (yc(t(n[0] + "e" + (+n[1] + r))) + "e").split("e"))[0] + "e" + (+n[1] - r));
              }

              return t(e);
            };
          }

          var Wi = kr && 1 / rr(new kr([, -0]))[1] == d ? function (e) {
            return new kr(e);
          } : fs;

          function Xi(e) {
            return function (t) {
              var r = lo(t);
              return r == _ ? Qt(t) : r == S ? nr(t) : function (e, t) {
                return kt(t, function (t) {
                  return [t, e[t]];
                });
              }(t, e(t));
            };
          }

          function Zi(e, t, r, a, d, u, h, l) {
            var p = 2 & t;
            if (!p && "function" != typeof e) throw new Se(o);
            var m = a ? a.length : 0;

            if (m || (t &= -97, a = d = i), h = h === i ? h : br(mc(h), 0), l = l === i ? l : mc(l), m -= d ? d.length : 0, 64 & t) {
              var b = a,
                  g = d;
              a = d = i;
            }

            var v = p ? i : no(e),
                y = [e, t, r, a, d, b, g, u, h, l];
            if (v && function (e, t) {
              var r = e[1],
                  n = t[1],
                  i = r | n,
                  o = i < 131,
                  a = n == f && 8 == r || n == f && 256 == r && e[7].length <= t[8] || 384 == n && t[7].length <= t[8] && 8 == r;
              if (!o && !a) return e;
              1 & n && (e[2] = t[2], i |= 1 & r ? 0 : 4);
              var s = t[3];

              if (s) {
                var d = e[3];
                e[3] = d ? ki(d, s, t[4]) : s, e[4] = d ? tr(e[3], c) : t[4];
              }

              (s = t[5]) && (d = e[5], e[5] = d ? Ei(d, s, t[6]) : s, e[6] = d ? tr(e[5], c) : t[6]), (s = t[7]) && (e[7] = s), n & f && (e[8] = null == e[8] ? t[8] : gr(e[8], t[8])), null == e[9] && (e[9] = t[9]), e[0] = t[0], e[1] = i;
            }(y, v), e = y[0], t = y[1], r = y[2], a = y[3], d = y[4], !(l = y[9] = y[9] === i ? p ? 0 : e.length : br(y[9] - m, 0)) && 24 & t && (t &= -25), t && 1 != t) w = 8 == t || 16 == t ? function (e, t, r) {
              var o = Oi(e);
              return function a() {
                for (var c = arguments.length, s = n(c), f = c, d = oo(a); f--;) {
                  s[f] = arguments[f];
                }

                var u = c < 3 && s[0] !== d && s[c - 1] !== d ? [] : tr(s, d);
                return (c -= u.length) < r ? Ki(e, t, Li, a.placeholder, i, s, u, i, i, r - c) : gt(this && this !== ot && this instanceof a ? o : e, this, s);
              };
            }(e, t, l) : t != s && 33 != t || d.length ? Li.apply(i, y) : function (e, t, r, i) {
              var o = 1 & t,
                  a = Oi(e);
              return function t() {
                for (var c = -1, s = arguments.length, f = -1, d = i.length, u = n(d + s), h = this && this !== ot && this instanceof t ? a : e; ++f < d;) {
                  u[f] = i[f];
                }

                for (; s--;) {
                  u[f++] = arguments[++c];
                }

                return gt(h, o ? r : this, u);
              };
            }(e, t, r, a);else var w = function (e, t, r) {
              var n = 1 & t,
                  i = Oi(e);
              return function t() {
                return (this && this !== ot && this instanceof t ? i : e).apply(n ? r : this, arguments);
              };
            }(e, t, r);
            return Do((v ? Jn : Co)(w, y), e, t);
          }

          function $i(e, t, r, n) {
            return e === i || za(e, Te[r]) && !Ne.call(n, r) ? t : e;
          }

          function Yi(e, t, r, n, o, a) {
            return tc(e) && tc(t) && (a.set(t, e), jn(e, t, i, Yi, a), a.delete(t)), e;
          }

          function Ji(e) {
            return oc(e) ? i : e;
          }

          function Qi(e, t, r, n, o, a) {
            var c = 1 & r,
                s = e.length,
                f = t.length;
            if (s != f && !(c && f > s)) return !1;
            var d = a.get(e),
                u = a.get(t);
            if (d && u) return d == t && u == e;
            var h = -1,
                l = !0,
                p = 2 & r ? new Vr() : i;

            for (a.set(e, t), a.set(t, e); ++h < s;) {
              var m = e[h],
                  b = t[h];
              if (n) var g = c ? n(b, m, h, t, e, a) : n(m, b, h, e, t, a);

              if (g !== i) {
                if (g) continue;
                l = !1;
                break;
              }

              if (p) {
                if (!Ct(t, function (e, t) {
                  if (!Kt(p, t) && (m === e || o(m, e, r, n, a))) return p.push(t);
                })) {
                  l = !1;
                  break;
                }
              } else if (m !== b && !o(m, b, r, n, a)) {
                l = !1;
                break;
              }
            }

            return a.delete(e), a.delete(t), l;
          }

          function eo(e) {
            return Bo(ko(e, i, Vo), e + "");
          }

          function to(e) {
            return Mn(e, Dc, uo);
          }

          function ro(e) {
            return Mn(e, Nc, ho);
          }

          var no = Ir ? function (e) {
            return Ir.get(e);
          } : fs;

          function io(e) {
            for (var t = e.name + "", r = Cr[t], n = Ne.call(Cr, t) ? r.length : 0; n--;) {
              var i = r[n],
                  o = i.func;
              if (null == o || o == e) return i.name;
            }

            return t;
          }

          function oo(e) {
            return (Ne.call(Lr, "placeholder") ? Lr : e).placeholder;
          }

          function ao() {
            var e = Lr.iteratee || os;
            return e = e === os ? Rn : e, arguments.length ? e(arguments[0], arguments[1]) : e;
          }

          function co(e, t) {
            var r,
                n,
                i = e.__data__;
            return ("string" == (n = typeof (r = t)) || "number" == n || "symbol" == n || "boolean" == n ? "__proto__" !== r : null === r) ? i["string" == typeof t ? "string" : "hash"] : i.map;
          }

          function so(e) {
            for (var t = Dc(e), r = t.length; r--;) {
              var n = t[r],
                  i = e[n];
              t[r] = [n, i, Mo(i)];
            }

            return t;
          }

          function fo(e, t) {
            var r = function (e, t) {
              return null == e ? i : e[t];
            }(e, t);

            return Nn(r) ? r : i;
          }

          var uo = ur ? function (e) {
            return null == e ? [] : (e = xe(e), _t(ur(e), function (t) {
              return et.call(e, t);
            }));
          } : bs,
              ho = ur ? function (e) {
            for (var t = []; e;) {
              Et(t, uo(e)), e = Ve(e);
            }

            return t;
          } : bs,
              lo = xn;

          function po(e, t, r) {
            for (var n = -1, i = (t = gi(t, e)).length, o = !1; ++n < i;) {
              var a = Lo(t[n]);
              if (!(o = null != e && r(e, a))) break;
              e = e[a];
            }

            return o || ++n != i ? o : !!(i = null == e ? 0 : e.length) && ec(i) && go(a, i) && (Ka(e) || Ha(e));
          }

          function mo(e) {
            return "function" != typeof e.constructor || _o(e) ? {} : Gr(Ve(e));
          }

          function bo(e) {
            return Ka(e) || Ha(e) || !!(it && e && e[it]);
          }

          function go(e, t) {
            var r = typeof e;
            return !!(t = null == t ? u : t) && ("number" == r || "symbol" != r && ge.test(e)) && e > -1 && e % 1 == 0 && e < t;
          }

          function vo(e, t, r) {
            if (!tc(r)) return !1;
            var n = typeof t;
            return !!("number" == n ? Wa(r) && go(t, r.length) : "string" == n && t in r) && za(r[t], e);
          }

          function yo(e, t) {
            if (Ka(e)) return !1;
            var r = typeof e;
            return !("number" != r && "symbol" != r && "boolean" != r && null != e && !fc(e)) || Q.test(e) || !J.test(e) || null != t && e in xe(t);
          }

          function wo(e) {
            var t = io(e),
                r = Lr[t];
            if ("function" != typeof r || !(t in qr.prototype)) return !1;
            if (e === r) return !0;
            var n = no(r);
            return !!n && e === n[0];
          }

          (_r && lo(new _r(new ArrayBuffer(1))) != D || Mr && lo(new Mr()) != _ || xr && lo(xr.resolve()) != k || kr && lo(new kr()) != S || Er && lo(new Er()) != T) && (lo = function lo(e) {
            var t = xn(e),
                r = t == x ? e.constructor : i,
                n = r ? Go(r) : "";
            if (n) switch (n) {
              case Tr:
                return D;

              case Br:
                return _;

              case Dr:
                return k;

              case Nr:
                return S;

              case Rr:
                return T;
            }
            return t;
          });
          var Ao = Be ? Ja : gs;

          function _o(e) {
            var t = e && e.constructor;
            return e === ("function" == typeof t && t.prototype || Te);
          }

          function Mo(e) {
            return e == e && !tc(e);
          }

          function xo(e, t) {
            return function (r) {
              return null != r && r[e] === t && (t !== i || e in xe(r));
            };
          }

          function ko(e, t, r) {
            return t = br(t === i ? e.length - 1 : t, 0), function () {
              for (var i = arguments, o = -1, a = br(i.length - t, 0), c = n(a); ++o < a;) {
                c[o] = i[t + o];
              }

              o = -1;

              for (var s = n(t + 1); ++o < t;) {
                s[o] = i[o];
              }

              return s[t] = r(c), gt(e, this, s);
            };
          }

          function Eo(e, t) {
            return t.length < 2 ? e : _n(e, ti(t, 0, -1));
          }

          function So(e, t) {
            for (var r = e.length, n = gr(t.length, r), o = Si(e); n--;) {
              var a = t[n];
              e[n] = go(a, r) ? o[a] : i;
            }

            return e;
          }

          function Io(e, t) {
            if (("constructor" !== t || "function" != typeof e[t]) && "__proto__" != t) return e[t];
          }

          var Co = No(Jn),
              To = Lt || function (e, t) {
            return ot.setTimeout(e, t);
          },
              Bo = No(Qn);

          function Do(e, t, r) {
            var n = t + "";
            return Bo(e, function (e, t) {
              var r = t.length;
              if (!r) return e;
              var n = r - 1;
              return t[n] = (r > 1 ? "& " : "") + t[n], t = t.join(r > 2 ? ", " : " "), e.replace(oe, "{\n/* [wrapped with " + t + "] */\n");
            }(n, function (e, t) {
              return yt(p, function (r) {
                var n = "_." + r[0];
                t & r[1] && !Mt(e, n) && e.push(n);
              }), e.sort();
            }(function (e) {
              var t = e.match(ae);
              return t ? t[1].split(ce) : [];
            }(n), r)));
          }

          function No(e) {
            var t = 0,
                r = 0;
            return function () {
              var n = vr(),
                  o = 16 - (n - r);

              if (r = n, o > 0) {
                if (++t >= 800) return arguments[0];
              } else t = 0;

              return e.apply(i, arguments);
            };
          }

          function Ro(e, t) {
            var r = -1,
                n = e.length,
                o = n - 1;

            for (t = t === i ? n : t; ++r < t;) {
              var a = Vn(r, o),
                  c = e[a];
              e[a] = e[r], e[r] = c;
            }

            return e.length = t, e;
          }

          var Oo,
              Po,
              Fo = (Oo = Oa(function (e) {
            var t = [];
            return 46 === e.charCodeAt(0) && t.push(""), e.replace(ee, function (e, r, n, i) {
              t.push(n ? i.replace(de, "$1") : r || e);
            }), t;
          }, function (e) {
            return 500 === Po.size && Po.clear(), e;
          }), Po = Oo.cache, Oo);

          function Lo(e) {
            if ("string" == typeof e || fc(e)) return e;
            var t = e + "";
            return "0" == t && 1 / e == -1 / 0 ? "-0" : t;
          }

          function Go(e) {
            if (null != e) {
              try {
                return De.call(e);
              } catch (e) {}

              try {
                return e + "";
              } catch (e) {}
            }

            return "";
          }

          function jo(e) {
            if (e instanceof qr) return e.clone();
            var t = new zr(e.__wrapped__, e.__chain__);
            return t.__actions__ = Si(e.__actions__), t.__index__ = e.__index__, t.__values__ = e.__values__, t;
          }

          var zo = Xn(function (e, t) {
            return Xa(e) ? dn(e, bn(t, 1, Xa, !0)) : [];
          }),
              qo = Xn(function (e, t) {
            var r = Yo(t);
            return Xa(r) && (r = i), Xa(e) ? dn(e, bn(t, 1, Xa, !0), ao(r, 2)) : [];
          }),
              Uo = Xn(function (e, t) {
            var r = Yo(t);
            return Xa(r) && (r = i), Xa(e) ? dn(e, bn(t, 1, Xa, !0), i, r) : [];
          });

          function Ho(e, t, r) {
            var n = null == e ? 0 : e.length;
            if (!n) return -1;
            var i = null == r ? 0 : mc(r);
            return i < 0 && (i = br(n + i, 0)), Dt(e, ao(t, 3), i);
          }

          function Ko(e, t, r) {
            var n = null == e ? 0 : e.length;
            if (!n) return -1;
            var o = n - 1;
            return r !== i && (o = mc(r), o = r < 0 ? br(n + o, 0) : gr(o, n - 1)), Dt(e, ao(t, 3), o, !0);
          }

          function Vo(e) {
            return null != e && e.length ? bn(e, 1) : [];
          }

          function Wo(e) {
            return e && e.length ? e[0] : i;
          }

          var Xo = Xn(function (e) {
            var t = kt(e, mi);
            return t.length && t[0] === e[0] ? In(t) : [];
          }),
              Zo = Xn(function (e) {
            var t = Yo(e),
                r = kt(e, mi);
            return t === Yo(r) ? t = i : r.pop(), r.length && r[0] === e[0] ? In(r, ao(t, 2)) : [];
          }),
              $o = Xn(function (e) {
            var t = Yo(e),
                r = kt(e, mi);
            return (t = "function" == typeof t ? t : i) && r.pop(), r.length && r[0] === e[0] ? In(r, i, t) : [];
          });

          function Yo(e) {
            var t = null == e ? 0 : e.length;
            return t ? e[t - 1] : i;
          }

          var Jo = Xn(Qo);

          function Qo(e, t) {
            return e && e.length && t && t.length ? Hn(e, t) : e;
          }

          var ea = eo(function (e, t) {
            var r = null == e ? 0 : e.length,
                n = on(e, t);
            return Kn(e, kt(t, function (e) {
              return go(e, r) ? +e : e;
            }).sort(xi)), n;
          });

          function ta(e) {
            return null == e ? e : Ar.call(e);
          }

          var ra = Xn(function (e) {
            return si(bn(e, 1, Xa, !0));
          }),
              na = Xn(function (e) {
            var t = Yo(e);
            return Xa(t) && (t = i), si(bn(e, 1, Xa, !0), ao(t, 2));
          }),
              ia = Xn(function (e) {
            var t = Yo(e);
            return t = "function" == typeof t ? t : i, si(bn(e, 1, Xa, !0), i, t);
          });

          function oa(e) {
            if (!e || !e.length) return [];
            var t = 0;
            return e = _t(e, function (e) {
              if (Xa(e)) return t = br(e.length, t), !0;
            }), zt(t, function (t) {
              return kt(e, Ft(t));
            });
          }

          function aa(e, t) {
            if (!e || !e.length) return [];
            var r = oa(e);
            return null == t ? r : kt(r, function (e) {
              return gt(t, i, e);
            });
          }

          var ca = Xn(function (e, t) {
            return Xa(e) ? dn(e, t) : [];
          }),
              sa = Xn(function (e) {
            return li(_t(e, Xa));
          }),
              fa = Xn(function (e) {
            var t = Yo(e);
            return Xa(t) && (t = i), li(_t(e, Xa), ao(t, 2));
          }),
              da = Xn(function (e) {
            var t = Yo(e);
            return t = "function" == typeof t ? t : i, li(_t(e, Xa), i, t);
          }),
              ua = Xn(oa),
              ha = Xn(function (e) {
            var t = e.length,
                r = t > 1 ? e[t - 1] : i;
            return r = "function" == typeof r ? (e.pop(), r) : i, aa(e, r);
          });

          function la(e) {
            var t = Lr(e);
            return t.__chain__ = !0, t;
          }

          function pa(e, t) {
            return t(e);
          }

          var ma = eo(function (e) {
            var t = e.length,
                r = t ? e[0] : 0,
                n = this.__wrapped__,
                o = function o(t) {
              return on(t, e);
            };

            return !(t > 1 || this.__actions__.length) && n instanceof qr && go(r) ? ((n = n.slice(r, +r + (t ? 1 : 0))).__actions__.push({
              func: pa,
              args: [o],
              thisArg: i
            }), new zr(n, this.__chain__).thru(function (e) {
              return t && !e.length && e.push(i), e;
            })) : this.thru(o);
          }),
              ba = Ci(function (e, t, r) {
            Ne.call(e, r) ? ++e[r] : nn(e, r, 1);
          }),
              ga = Pi(Ho),
              va = Pi(Ko);

          function ya(e, t) {
            return (Ka(e) ? yt : un)(e, ao(t, 3));
          }

          function wa(e, t) {
            return (Ka(e) ? wt : hn)(e, ao(t, 3));
          }

          var Aa = Ci(function (e, t, r) {
            Ne.call(e, r) ? e[r].push(t) : nn(e, r, [t]);
          }),
              _a = Xn(function (e, t, r) {
            var i = -1,
                o = "function" == typeof t,
                a = Wa(e) ? n(e.length) : [];
            return un(e, function (e) {
              a[++i] = o ? gt(t, e, r) : Cn(e, t, r);
            }), a;
          }),
              Ma = Ci(function (e, t, r) {
            nn(e, r, t);
          });

          function xa(e, t) {
            return (Ka(e) ? kt : Fn)(e, ao(t, 3));
          }

          var ka = Ci(function (e, t, r) {
            e[r ? 0 : 1].push(t);
          }, function () {
            return [[], []];
          }),
              Ea = Xn(function (e, t) {
            if (null == e) return [];
            var r = t.length;
            return r > 1 && vo(e, t[0], t[1]) ? t = [] : r > 2 && vo(t[0], t[1], t[2]) && (t = [t[0]]), qn(e, bn(t, 1), []);
          }),
              Sa = Tt || function () {
            return ot.Date.now();
          };

          function Ia(e, t, r) {
            return t = r ? i : t, t = e && null == t ? e.length : t, Zi(e, f, i, i, i, i, t);
          }

          function Ca(e, t) {
            var r;
            if ("function" != typeof t) throw new Se(o);
            return e = mc(e), function () {
              return --e > 0 && (r = t.apply(this, arguments)), e <= 1 && (t = i), r;
            };
          }

          var Ta = Xn(function (e, t, r) {
            var n = 1;

            if (r.length) {
              var i = tr(r, oo(Ta));
              n |= s;
            }

            return Zi(e, n, t, r, i);
          }),
              Ba = Xn(function (e, t, r) {
            var n = 3;

            if (r.length) {
              var i = tr(r, oo(Ba));
              n |= s;
            }

            return Zi(t, n, e, r, i);
          });

          function Da(e, t, r) {
            var n,
                a,
                c,
                s,
                f,
                d,
                u = 0,
                h = !1,
                l = !1,
                p = !0;
            if ("function" != typeof e) throw new Se(o);

            function m(t) {
              var r = n,
                  o = a;
              return n = a = i, u = t, s = e.apply(o, r);
            }

            function b(e) {
              return u = e, f = To(v, t), h ? m(e) : s;
            }

            function g(e) {
              var r = e - d;
              return d === i || r >= t || r < 0 || l && e - u >= c;
            }

            function v() {
              var e = Sa();
              if (g(e)) return y(e);
              f = To(v, function (e) {
                var r = t - (e - d);
                return l ? gr(r, c - (e - u)) : r;
              }(e));
            }

            function y(e) {
              return f = i, p && n ? m(e) : (n = a = i, s);
            }

            function w() {
              var e = Sa(),
                  r = g(e);

              if (n = arguments, a = this, d = e, r) {
                if (f === i) return b(d);
                if (l) return wi(f), f = To(v, t), m(d);
              }

              return f === i && (f = To(v, t)), s;
            }

            return t = gc(t) || 0, tc(r) && (h = !!r.leading, c = (l = "maxWait" in r) ? br(gc(r.maxWait) || 0, t) : c, p = "trailing" in r ? !!r.trailing : p), w.cancel = function () {
              f !== i && wi(f), u = 0, n = d = a = f = i;
            }, w.flush = function () {
              return f === i ? s : y(Sa());
            }, w;
          }

          var Na = Xn(function (e, t) {
            return fn(e, 1, t);
          }),
              Ra = Xn(function (e, t, r) {
            return fn(e, gc(t) || 0, r);
          });

          function Oa(e, t) {
            if ("function" != typeof e || null != t && "function" != typeof t) throw new Se(o);

            var r = function r() {
              var n = arguments,
                  i = t ? t.apply(this, n) : n[0],
                  o = r.cache;
              if (o.has(i)) return o.get(i);
              var a = e.apply(this, n);
              return r.cache = o.set(i, a) || o, a;
            };

            return r.cache = new (Oa.Cache || Kr)(), r;
          }

          function Pa(e) {
            if ("function" != typeof e) throw new Se(o);
            return function () {
              var t = arguments;

              switch (t.length) {
                case 0:
                  return !e.call(this);

                case 1:
                  return !e.call(this, t[0]);

                case 2:
                  return !e.call(this, t[0], t[1]);

                case 3:
                  return !e.call(this, t[0], t[1], t[2]);
              }

              return !e.apply(this, t);
            };
          }

          Oa.Cache = Kr;
          var Fa = vi(function (e, t) {
            var r = (t = 1 == t.length && Ka(t[0]) ? kt(t[0], Ut(ao())) : kt(bn(t, 1), Ut(ao()))).length;
            return Xn(function (n) {
              for (var i = -1, o = gr(n.length, r); ++i < o;) {
                n[i] = t[i].call(this, n[i]);
              }

              return gt(e, this, n);
            });
          }),
              La = Xn(function (e, t) {
            var r = tr(t, oo(La));
            return Zi(e, s, i, t, r);
          }),
              Ga = Xn(function (e, t) {
            var r = tr(t, oo(Ga));
            return Zi(e, 64, i, t, r);
          }),
              ja = eo(function (e, t) {
            return Zi(e, 256, i, i, i, t);
          });

          function za(e, t) {
            return e === t || e != e && t != t;
          }

          var qa = Hi(kn),
              Ua = Hi(function (e, t) {
            return e >= t;
          }),
              Ha = Tn(function () {
            return arguments;
          }()) ? Tn : function (e) {
            return rc(e) && Ne.call(e, "callee") && !et.call(e, "callee");
          },
              Ka = n.isArray,
              Va = ut ? Ut(ut) : function (e) {
            return rc(e) && xn(e) == B;
          };

          function Wa(e) {
            return null != e && ec(e.length) && !Ja(e);
          }

          function Xa(e) {
            return rc(e) && Wa(e);
          }

          var Za = hr || gs,
              $a = ht ? Ut(ht) : function (e) {
            return rc(e) && xn(e) == v;
          };

          function Ya(e) {
            if (!rc(e)) return !1;
            var t = xn(e);
            return t == y || "[object DOMException]" == t || "string" == typeof e.message && "string" == typeof e.name && !oc(e);
          }

          function Ja(e) {
            if (!tc(e)) return !1;
            var t = xn(e);
            return t == w || t == A || "[object AsyncFunction]" == t || "[object Proxy]" == t;
          }

          function Qa(e) {
            return "number" == typeof e && e == mc(e);
          }

          function ec(e) {
            return "number" == typeof e && e > -1 && e % 1 == 0 && e <= u;
          }

          function tc(e) {
            var t = typeof e;
            return null != e && ("object" == t || "function" == t);
          }

          function rc(e) {
            return null != e && "object" == typeof e;
          }

          var nc = lt ? Ut(lt) : function (e) {
            return rc(e) && lo(e) == _;
          };

          function ic(e) {
            return "number" == typeof e || rc(e) && xn(e) == M;
          }

          function oc(e) {
            if (!rc(e) || xn(e) != x) return !1;
            var t = Ve(e);
            if (null === t) return !0;
            var r = Ne.call(t, "constructor") && t.constructor;
            return "function" == typeof r && r instanceof r && De.call(r) == Fe;
          }

          var ac = pt ? Ut(pt) : function (e) {
            return rc(e) && xn(e) == E;
          },
              cc = mt ? Ut(mt) : function (e) {
            return rc(e) && lo(e) == S;
          };

          function sc(e) {
            return "string" == typeof e || !Ka(e) && rc(e) && xn(e) == I;
          }

          function fc(e) {
            return "symbol" == typeof e || rc(e) && xn(e) == C;
          }

          var dc = bt ? Ut(bt) : function (e) {
            return rc(e) && ec(e.length) && !!Je[xn(e)];
          },
              uc = Hi(Pn),
              hc = Hi(function (e, t) {
            return e <= t;
          });

          function lc(e) {
            if (!e) return [];
            if (Wa(e)) return sc(e) ? or(e) : Si(e);
            if (at && e[at]) return function (e) {
              for (var t, r = []; !(t = e.next()).done;) {
                r.push(t.value);
              }

              return r;
            }(e[at]());
            var t = lo(e);
            return (t == _ ? Qt : t == S ? rr : zc)(e);
          }

          function pc(e) {
            return e ? (e = gc(e)) === d || e === -1 / 0 ? 17976931348623157e292 * (e < 0 ? -1 : 1) : e == e ? e : 0 : 0 === e ? e : 0;
          }

          function mc(e) {
            var t = pc(e),
                r = t % 1;
            return t == t ? r ? t - r : t : 0;
          }

          function bc(e) {
            return e ? an(mc(e), 0, l) : 0;
          }

          function gc(e) {
            if ("number" == typeof e) return e;
            if (fc(e)) return h;

            if (tc(e)) {
              var t = "function" == typeof e.valueOf ? e.valueOf() : e;
              e = tc(t) ? t + "" : t;
            }

            if ("string" != typeof e) return 0 === e ? e : +e;
            e = qt(e);
            var r = pe.test(e);
            return r || be.test(e) ? rt(e.slice(2), r ? 2 : 8) : le.test(e) ? h : +e;
          }

          function vc(e) {
            return Ii(e, Nc(e));
          }

          function yc(e) {
            return null == e ? "" : ci(e);
          }

          var wc = Ti(function (e, t) {
            if (_o(t) || Wa(t)) Ii(t, Dc(t), e);else for (var r in t) {
              Ne.call(t, r) && Qr(e, r, t[r]);
            }
          }),
              Ac = Ti(function (e, t) {
            Ii(t, Nc(t), e);
          }),
              _c = Ti(function (e, t, r, n) {
            Ii(t, Nc(t), e, n);
          }),
              Mc = Ti(function (e, t, r, n) {
            Ii(t, Dc(t), e, n);
          }),
              xc = eo(on),
              kc = Xn(function (e, t) {
            e = xe(e);
            var r = -1,
                n = t.length,
                o = n > 2 ? t[2] : i;

            for (o && vo(t[0], t[1], o) && (n = 1); ++r < n;) {
              for (var a = t[r], c = Nc(a), s = -1, f = c.length; ++s < f;) {
                var d = c[s],
                    u = e[d];
                (u === i || za(u, Te[d]) && !Ne.call(e, d)) && (e[d] = a[d]);
              }
            }

            return e;
          }),
              Ec = Xn(function (e) {
            return e.push(i, Yi), gt(Oc, i, e);
          });

          function Sc(e, t, r) {
            var n = null == e ? i : _n(e, t);
            return n === i ? r : n;
          }

          function Ic(e, t) {
            return null != e && po(e, t, Sn);
          }

          var Cc = Gi(function (e, t, r) {
            null != t && "function" != typeof t.toString && (t = Pe.call(t)), e[t] = r;
          }, ts(is)),
              Tc = Gi(function (e, t, r) {
            null != t && "function" != typeof t.toString && (t = Pe.call(t)), Ne.call(e, t) ? e[t].push(r) : e[t] = [r];
          }, ao),
              Bc = Xn(Cn);

          function Dc(e) {
            return Wa(e) ? Xr(e) : On(e);
          }

          function Nc(e) {
            return Wa(e) ? Xr(e, !0) : function (e) {
              if (!tc(e)) return function (e) {
                var t = [];
                if (null != e) for (var r in xe(e)) {
                  t.push(r);
                }
                return t;
              }(e);

              var t = _o(e),
                  r = [];

              for (var n in e) {
                ("constructor" != n || !t && Ne.call(e, n)) && r.push(n);
              }

              return r;
            }(e);
          }

          var Rc = Ti(function (e, t, r) {
            jn(e, t, r);
          }),
              Oc = Ti(function (e, t, r, n) {
            jn(e, t, r, n);
          }),
              Pc = eo(function (e, t) {
            var r = {};
            if (null == e) return r;
            var n = !1;
            t = kt(t, function (t) {
              return t = gi(t, e), n || (n = t.length > 1), t;
            }), Ii(e, ro(e), r), n && (r = cn(r, 7, Ji));

            for (var i = t.length; i--;) {
              fi(r, t[i]);
            }

            return r;
          }),
              Fc = eo(function (e, t) {
            return null == e ? {} : function (e, t) {
              return Un(e, t, function (t, r) {
                return Ic(e, r);
              });
            }(e, t);
          });

          function Lc(e, t) {
            if (null == e) return {};
            var r = kt(ro(e), function (e) {
              return [e];
            });
            return t = ao(t), Un(e, r, function (e, r) {
              return t(e, r[0]);
            });
          }

          var Gc = Xi(Dc),
              jc = Xi(Nc);

          function zc(e) {
            return null == e ? [] : Ht(e, Dc(e));
          }

          var qc = Ri(function (e, t, r) {
            return t = t.toLowerCase(), e + (r ? Uc(t) : t);
          });

          function Uc(e) {
            return Yc(yc(e).toLowerCase());
          }

          function Hc(e) {
            return (e = yc(e)) && e.replace(ve, Zt).replace(Ke, "");
          }

          var Kc = Ri(function (e, t, r) {
            return e + (r ? "-" : "") + t.toLowerCase();
          }),
              Vc = Ri(function (e, t, r) {
            return e + (r ? " " : "") + t.toLowerCase();
          }),
              Wc = Ni("toLowerCase"),
              Xc = Ri(function (e, t, r) {
            return e + (r ? "_" : "") + t.toLowerCase();
          }),
              Zc = Ri(function (e, t, r) {
            return e + (r ? " " : "") + Yc(t);
          }),
              $c = Ri(function (e, t, r) {
            return e + (r ? " " : "") + t.toUpperCase();
          }),
              Yc = Ni("toUpperCase");

          function Jc(e, t, r) {
            return e = yc(e), (t = r ? i : t) === i ? function (e) {
              return Ze.test(e);
            }(e) ? function (e) {
              return e.match(We) || [];
            }(e) : function (e) {
              return e.match(se) || [];
            }(e) : e.match(t) || [];
          }

          var Qc = Xn(function (e, t) {
            try {
              return gt(e, i, t);
            } catch (e) {
              return Ya(e) ? e : new Ae(e);
            }
          }),
              es = eo(function (e, t) {
            return yt(t, function (t) {
              t = Lo(t), nn(e, t, Ta(e[t], e));
            }), e;
          });

          function ts(e) {
            return function () {
              return e;
            };
          }

          var rs = Fi(),
              ns = Fi(!0);

          function is(e) {
            return e;
          }

          function os(e) {
            return Rn("function" == typeof e ? e : cn(e, 1));
          }

          var as = Xn(function (e, t) {
            return function (r) {
              return Cn(r, e, t);
            };
          }),
              cs = Xn(function (e, t) {
            return function (r) {
              return Cn(e, r, t);
            };
          });

          function ss(e, t, r) {
            var n = Dc(t),
                i = An(t, n);
            null != r || tc(t) && (i.length || !n.length) || (r = t, t = e, e = this, i = An(t, Dc(t)));
            var o = !(tc(r) && "chain" in r && !r.chain),
                a = Ja(e);
            return yt(i, function (r) {
              var n = t[r];
              e[r] = n, a && (e.prototype[r] = function () {
                var t = this.__chain__;

                if (o || t) {
                  var r = e(this.__wrapped__),
                      i = r.__actions__ = Si(this.__actions__);
                  return i.push({
                    func: n,
                    args: arguments,
                    thisArg: e
                  }), r.__chain__ = t, r;
                }

                return n.apply(e, Et([this.value()], arguments));
              });
            }), e;
          }

          function fs() {}

          var ds = zi(kt),
              us = zi(At),
              hs = zi(Ct);

          function ls(e) {
            return yo(e) ? Ft(Lo(e)) : function (e) {
              return function (t) {
                return _n(t, e);
              };
            }(e);
          }

          var ps = Ui(),
              ms = Ui(!0);

          function bs() {
            return [];
          }

          function gs() {
            return !1;
          }

          var vs,
              ys = ji(function (e, t) {
            return e + t;
          }, 0),
              ws = Vi("ceil"),
              As = ji(function (e, t) {
            return e / t;
          }, 1),
              _s = Vi("floor"),
              Ms = ji(function (e, t) {
            return e * t;
          }, 1),
              xs = Vi("round"),
              ks = ji(function (e, t) {
            return e - t;
          }, 0);

          return Lr.after = function (e, t) {
            if ("function" != typeof t) throw new Se(o);
            return e = mc(e), function () {
              if (--e < 1) return t.apply(this, arguments);
            };
          }, Lr.ary = Ia, Lr.assign = wc, Lr.assignIn = Ac, Lr.assignInWith = _c, Lr.assignWith = Mc, Lr.at = xc, Lr.before = Ca, Lr.bind = Ta, Lr.bindAll = es, Lr.bindKey = Ba, Lr.castArray = function () {
            if (!arguments.length) return [];
            var e = arguments[0];
            return Ka(e) ? e : [e];
          }, Lr.chain = la, Lr.chunk = function (e, t, r) {
            t = (r ? vo(e, t, r) : t === i) ? 1 : br(mc(t), 0);
            var o = null == e ? 0 : e.length;
            if (!o || t < 1) return [];

            for (var a = 0, c = 0, s = n(fr(o / t)); a < o;) {
              s[c++] = ti(e, a, a += t);
            }

            return s;
          }, Lr.compact = function (e) {
            for (var t = -1, r = null == e ? 0 : e.length, n = 0, i = []; ++t < r;) {
              var o = e[t];
              o && (i[n++] = o);
            }

            return i;
          }, Lr.concat = function () {
            var e = arguments.length;
            if (!e) return [];

            for (var t = n(e - 1), r = arguments[0], i = e; i--;) {
              t[i - 1] = arguments[i];
            }

            return Et(Ka(r) ? Si(r) : [r], bn(t, 1));
          }, Lr.cond = function (e) {
            var t = null == e ? 0 : e.length,
                r = ao();
            return e = t ? kt(e, function (e) {
              if ("function" != typeof e[1]) throw new Se(o);
              return [r(e[0]), e[1]];
            }) : [], Xn(function (r) {
              for (var n = -1; ++n < t;) {
                var i = e[n];
                if (gt(i[0], this, r)) return gt(i[1], this, r);
              }
            });
          }, Lr.conforms = function (e) {
            return function (e) {
              var t = Dc(e);
              return function (r) {
                return sn(r, e, t);
              };
            }(cn(e, 1));
          }, Lr.constant = ts, Lr.countBy = ba, Lr.create = function (e, t) {
            var r = Gr(e);
            return null == t ? r : rn(r, t);
          }, Lr.curry = function e(t, r, n) {
            var o = Zi(t, 8, i, i, i, i, i, r = n ? i : r);
            return o.placeholder = e.placeholder, o;
          }, Lr.curryRight = function e(t, r, n) {
            var o = Zi(t, 16, i, i, i, i, i, r = n ? i : r);
            return o.placeholder = e.placeholder, o;
          }, Lr.debounce = Da, Lr.defaults = kc, Lr.defaultsDeep = Ec, Lr.defer = Na, Lr.delay = Ra, Lr.difference = zo, Lr.differenceBy = qo, Lr.differenceWith = Uo, Lr.drop = function (e, t, r) {
            var n = null == e ? 0 : e.length;
            return n ? ti(e, (t = r || t === i ? 1 : mc(t)) < 0 ? 0 : t, n) : [];
          }, Lr.dropRight = function (e, t, r) {
            var n = null == e ? 0 : e.length;
            return n ? ti(e, 0, (t = n - (t = r || t === i ? 1 : mc(t))) < 0 ? 0 : t) : [];
          }, Lr.dropRightWhile = function (e, t) {
            return e && e.length ? ui(e, ao(t, 3), !0, !0) : [];
          }, Lr.dropWhile = function (e, t) {
            return e && e.length ? ui(e, ao(t, 3), !0) : [];
          }, Lr.fill = function (e, t, r, n) {
            var o = null == e ? 0 : e.length;
            return o ? (r && "number" != typeof r && vo(e, t, r) && (r = 0, n = o), function (e, t, r, n) {
              var o = e.length;

              for ((r = mc(r)) < 0 && (r = -r > o ? 0 : o + r), (n = n === i || n > o ? o : mc(n)) < 0 && (n += o), n = r > n ? 0 : bc(n); r < n;) {
                e[r++] = t;
              }

              return e;
            }(e, t, r, n)) : [];
          }, Lr.filter = function (e, t) {
            return (Ka(e) ? _t : mn)(e, ao(t, 3));
          }, Lr.flatMap = function (e, t) {
            return bn(xa(e, t), 1);
          }, Lr.flatMapDeep = function (e, t) {
            return bn(xa(e, t), d);
          }, Lr.flatMapDepth = function (e, t, r) {
            return r = r === i ? 1 : mc(r), bn(xa(e, t), r);
          }, Lr.flatten = Vo, Lr.flattenDeep = function (e) {
            return null != e && e.length ? bn(e, d) : [];
          }, Lr.flattenDepth = function (e, t) {
            return null != e && e.length ? bn(e, t = t === i ? 1 : mc(t)) : [];
          }, Lr.flip = function (e) {
            return Zi(e, 512);
          }, Lr.flow = rs, Lr.flowRight = ns, Lr.fromPairs = function (e) {
            for (var t = -1, r = null == e ? 0 : e.length, n = {}; ++t < r;) {
              var i = e[t];
              n[i[0]] = i[1];
            }

            return n;
          }, Lr.functions = function (e) {
            return null == e ? [] : An(e, Dc(e));
          }, Lr.functionsIn = function (e) {
            return null == e ? [] : An(e, Nc(e));
          }, Lr.groupBy = Aa, Lr.initial = function (e) {
            return null != e && e.length ? ti(e, 0, -1) : [];
          }, Lr.intersection = Xo, Lr.intersectionBy = Zo, Lr.intersectionWith = $o, Lr.invert = Cc, Lr.invertBy = Tc, Lr.invokeMap = _a, Lr.iteratee = os, Lr.keyBy = Ma, Lr.keys = Dc, Lr.keysIn = Nc, Lr.map = xa, Lr.mapKeys = function (e, t) {
            var r = {};
            return t = ao(t, 3), yn(e, function (e, n, i) {
              nn(r, t(e, n, i), e);
            }), r;
          }, Lr.mapValues = function (e, t) {
            var r = {};
            return t = ao(t, 3), yn(e, function (e, n, i) {
              nn(r, n, t(e, n, i));
            }), r;
          }, Lr.matches = function (e) {
            return Ln(cn(e, 1));
          }, Lr.matchesProperty = function (e, t) {
            return Gn(e, cn(t, 1));
          }, Lr.memoize = Oa, Lr.merge = Rc, Lr.mergeWith = Oc, Lr.method = as, Lr.methodOf = cs, Lr.mixin = ss, Lr.negate = Pa, Lr.nthArg = function (e) {
            return e = mc(e), Xn(function (t) {
              return zn(t, e);
            });
          }, Lr.omit = Pc, Lr.omitBy = function (e, t) {
            return Lc(e, Pa(ao(t)));
          }, Lr.once = function (e) {
            return Ca(2, e);
          }, Lr.orderBy = function (e, t, r, n) {
            return null == e ? [] : (Ka(t) || (t = null == t ? [] : [t]), Ka(r = n ? i : r) || (r = null == r ? [] : [r]), qn(e, t, r));
          }, Lr.over = ds, Lr.overArgs = Fa, Lr.overEvery = us, Lr.overSome = hs, Lr.partial = La, Lr.partialRight = Ga, Lr.partition = ka, Lr.pick = Fc, Lr.pickBy = Lc, Lr.property = ls, Lr.propertyOf = function (e) {
            return function (t) {
              return null == e ? i : _n(e, t);
            };
          }, Lr.pull = Jo, Lr.pullAll = Qo, Lr.pullAllBy = function (e, t, r) {
            return e && e.length && t && t.length ? Hn(e, t, ao(r, 2)) : e;
          }, Lr.pullAllWith = function (e, t, r) {
            return e && e.length && t && t.length ? Hn(e, t, i, r) : e;
          }, Lr.pullAt = ea, Lr.range = ps, Lr.rangeRight = ms, Lr.rearg = ja, Lr.reject = function (e, t) {
            return (Ka(e) ? _t : mn)(e, Pa(ao(t, 3)));
          }, Lr.remove = function (e, t) {
            var r = [];
            if (!e || !e.length) return r;
            var n = -1,
                i = [],
                o = e.length;

            for (t = ao(t, 3); ++n < o;) {
              var a = e[n];
              t(a, n, e) && (r.push(a), i.push(n));
            }

            return Kn(e, i), r;
          }, Lr.rest = function (e, t) {
            if ("function" != typeof e) throw new Se(o);
            return Xn(e, t = t === i ? t : mc(t));
          }, Lr.reverse = ta, Lr.sampleSize = function (e, t, r) {
            return t = (r ? vo(e, t, r) : t === i) ? 1 : mc(t), (Ka(e) ? $r : $n)(e, t);
          }, Lr.set = function (e, t, r) {
            return null == e ? e : Yn(e, t, r);
          }, Lr.setWith = function (e, t, r, n) {
            return n = "function" == typeof n ? n : i, null == e ? e : Yn(e, t, r, n);
          }, Lr.shuffle = function (e) {
            return (Ka(e) ? Yr : ei)(e);
          }, Lr.slice = function (e, t, r) {
            var n = null == e ? 0 : e.length;
            return n ? (r && "number" != typeof r && vo(e, t, r) ? (t = 0, r = n) : (t = null == t ? 0 : mc(t), r = r === i ? n : mc(r)), ti(e, t, r)) : [];
          }, Lr.sortBy = Ea, Lr.sortedUniq = function (e) {
            return e && e.length ? oi(e) : [];
          }, Lr.sortedUniqBy = function (e, t) {
            return e && e.length ? oi(e, ao(t, 2)) : [];
          }, Lr.split = function (e, t, r) {
            return r && "number" != typeof r && vo(e, t, r) && (t = r = i), (r = r === i ? l : r >>> 0) ? (e = yc(e)) && ("string" == typeof t || null != t && !ac(t)) && !(t = ci(t)) && Jt(e) ? yi(or(e), 0, r) : e.split(t, r) : [];
          }, Lr.spread = function (e, t) {
            if ("function" != typeof e) throw new Se(o);
            return t = null == t ? 0 : br(mc(t), 0), Xn(function (r) {
              var n = r[t],
                  i = yi(r, 0, t);
              return n && Et(i, n), gt(e, this, i);
            });
          }, Lr.tail = function (e) {
            var t = null == e ? 0 : e.length;
            return t ? ti(e, 1, t) : [];
          }, Lr.take = function (e, t, r) {
            return e && e.length ? ti(e, 0, (t = r || t === i ? 1 : mc(t)) < 0 ? 0 : t) : [];
          }, Lr.takeRight = function (e, t, r) {
            var n = null == e ? 0 : e.length;
            return n ? ti(e, (t = n - (t = r || t === i ? 1 : mc(t))) < 0 ? 0 : t, n) : [];
          }, Lr.takeRightWhile = function (e, t) {
            return e && e.length ? ui(e, ao(t, 3), !1, !0) : [];
          }, Lr.takeWhile = function (e, t) {
            return e && e.length ? ui(e, ao(t, 3)) : [];
          }, Lr.tap = function (e, t) {
            return t(e), e;
          }, Lr.throttle = function (e, t, r) {
            var n = !0,
                i = !0;
            if ("function" != typeof e) throw new Se(o);
            return tc(r) && (n = "leading" in r ? !!r.leading : n, i = "trailing" in r ? !!r.trailing : i), Da(e, t, {
              leading: n,
              maxWait: t,
              trailing: i
            });
          }, Lr.thru = pa, Lr.toArray = lc, Lr.toPairs = Gc, Lr.toPairsIn = jc, Lr.toPath = function (e) {
            return Ka(e) ? kt(e, Lo) : fc(e) ? [e] : Si(Fo(yc(e)));
          }, Lr.toPlainObject = vc, Lr.transform = function (e, t, r) {
            var n = Ka(e),
                i = n || Za(e) || dc(e);

            if (t = ao(t, 4), null == r) {
              var o = e && e.constructor;
              r = i ? n ? new o() : [] : tc(e) && Ja(o) ? Gr(Ve(e)) : {};
            }

            return (i ? yt : yn)(e, function (e, n, i) {
              return t(r, e, n, i);
            }), r;
          }, Lr.unary = function (e) {
            return Ia(e, 1);
          }, Lr.union = ra, Lr.unionBy = na, Lr.unionWith = ia, Lr.uniq = function (e) {
            return e && e.length ? si(e) : [];
          }, Lr.uniqBy = function (e, t) {
            return e && e.length ? si(e, ao(t, 2)) : [];
          }, Lr.uniqWith = function (e, t) {
            return t = "function" == typeof t ? t : i, e && e.length ? si(e, i, t) : [];
          }, Lr.unset = function (e, t) {
            return null == e || fi(e, t);
          }, Lr.unzip = oa, Lr.unzipWith = aa, Lr.update = function (e, t, r) {
            return null == e ? e : di(e, t, bi(r));
          }, Lr.updateWith = function (e, t, r, n) {
            return n = "function" == typeof n ? n : i, null == e ? e : di(e, t, bi(r), n);
          }, Lr.values = zc, Lr.valuesIn = function (e) {
            return null == e ? [] : Ht(e, Nc(e));
          }, Lr.without = ca, Lr.words = Jc, Lr.wrap = function (e, t) {
            return La(bi(t), e);
          }, Lr.xor = sa, Lr.xorBy = fa, Lr.xorWith = da, Lr.zip = ua, Lr.zipObject = function (e, t) {
            return pi(e || [], t || [], Qr);
          }, Lr.zipObjectDeep = function (e, t) {
            return pi(e || [], t || [], Yn);
          }, Lr.zipWith = ha, Lr.entries = Gc, Lr.entriesIn = jc, Lr.extend = Ac, Lr.extendWith = _c, ss(Lr, Lr), Lr.add = ys, Lr.attempt = Qc, Lr.camelCase = qc, Lr.capitalize = Uc, Lr.ceil = ws, Lr.clamp = function (e, t, r) {
            return r === i && (r = t, t = i), r !== i && (r = (r = gc(r)) == r ? r : 0), t !== i && (t = (t = gc(t)) == t ? t : 0), an(gc(e), t, r);
          }, Lr.clone = function (e) {
            return cn(e, 4);
          }, Lr.cloneDeep = function (e) {
            return cn(e, 5);
          }, Lr.cloneDeepWith = function (e, t) {
            return cn(e, 5, t = "function" == typeof t ? t : i);
          }, Lr.cloneWith = function (e, t) {
            return cn(e, 4, t = "function" == typeof t ? t : i);
          }, Lr.conformsTo = function (e, t) {
            return null == t || sn(e, t, Dc(t));
          }, Lr.deburr = Hc, Lr.defaultTo = function (e, t) {
            return null == e || e != e ? t : e;
          }, Lr.divide = As, Lr.endsWith = function (e, t, r) {
            e = yc(e), t = ci(t);
            var n = e.length,
                o = r = r === i ? n : an(mc(r), 0, n);
            return (r -= t.length) >= 0 && e.slice(r, o) == t;
          }, Lr.eq = za, Lr.escape = function (e) {
            return (e = yc(e)) && X.test(e) ? e.replace(V, $t) : e;
          }, Lr.escapeRegExp = function (e) {
            return (e = yc(e)) && re.test(e) ? e.replace(te, "\\$&") : e;
          }, Lr.every = function (e, t, r) {
            var n = Ka(e) ? At : ln;
            return r && vo(e, t, r) && (t = i), n(e, ao(t, 3));
          }, Lr.find = ga, Lr.findIndex = Ho, Lr.findKey = function (e, t) {
            return Bt(e, ao(t, 3), yn);
          }, Lr.findLast = va, Lr.findLastIndex = Ko, Lr.findLastKey = function (e, t) {
            return Bt(e, ao(t, 3), wn);
          }, Lr.floor = _s, Lr.forEach = ya, Lr.forEachRight = wa, Lr.forIn = function (e, t) {
            return null == e ? e : gn(e, ao(t, 3), Nc);
          }, Lr.forInRight = function (e, t) {
            return null == e ? e : vn(e, ao(t, 3), Nc);
          }, Lr.forOwn = function (e, t) {
            return e && yn(e, ao(t, 3));
          }, Lr.forOwnRight = function (e, t) {
            return e && wn(e, ao(t, 3));
          }, Lr.get = Sc, Lr.gt = qa, Lr.gte = Ua, Lr.has = function (e, t) {
            return null != e && po(e, t, En);
          }, Lr.hasIn = Ic, Lr.head = Wo, Lr.identity = is, Lr.includes = function (e, t, r, n) {
            e = Wa(e) ? e : zc(e), r = r && !n ? mc(r) : 0;
            var i = e.length;
            return r < 0 && (r = br(i + r, 0)), sc(e) ? r <= i && e.indexOf(t, r) > -1 : !!i && Nt(e, t, r) > -1;
          }, Lr.indexOf = function (e, t, r) {
            var n = null == e ? 0 : e.length;
            if (!n) return -1;
            var i = null == r ? 0 : mc(r);
            return i < 0 && (i = br(n + i, 0)), Nt(e, t, i);
          }, Lr.inRange = function (e, t, r) {
            return t = pc(t), r === i ? (r = t, t = 0) : r = pc(r), function (e, t, r) {
              return e >= gr(t, r) && e < br(t, r);
            }(e = gc(e), t, r);
          }, Lr.invoke = Bc, Lr.isArguments = Ha, Lr.isArray = Ka, Lr.isArrayBuffer = Va, Lr.isArrayLike = Wa, Lr.isArrayLikeObject = Xa, Lr.isBoolean = function (e) {
            return !0 === e || !1 === e || rc(e) && xn(e) == g;
          }, Lr.isBuffer = Za, Lr.isDate = $a, Lr.isElement = function (e) {
            return rc(e) && 1 === e.nodeType && !oc(e);
          }, Lr.isEmpty = function (e) {
            if (null == e) return !0;
            if (Wa(e) && (Ka(e) || "string" == typeof e || "function" == typeof e.splice || Za(e) || dc(e) || Ha(e))) return !e.length;
            var t = lo(e);
            if (t == _ || t == S) return !e.size;
            if (_o(e)) return !On(e).length;

            for (var r in e) {
              if (Ne.call(e, r)) return !1;
            }

            return !0;
          }, Lr.isEqual = function (e, t) {
            return Bn(e, t);
          }, Lr.isEqualWith = function (e, t, r) {
            var n = (r = "function" == typeof r ? r : i) ? r(e, t) : i;
            return n === i ? Bn(e, t, i, r) : !!n;
          }, Lr.isError = Ya, Lr.isFinite = function (e) {
            return "number" == typeof e && lr(e);
          }, Lr.isFunction = Ja, Lr.isInteger = Qa, Lr.isLength = ec, Lr.isMap = nc, Lr.isMatch = function (e, t) {
            return e === t || Dn(e, t, so(t));
          }, Lr.isMatchWith = function (e, t, r) {
            return r = "function" == typeof r ? r : i, Dn(e, t, so(t), r);
          }, Lr.isNaN = function (e) {
            return ic(e) && e != +e;
          }, Lr.isNative = function (e) {
            if (Ao(e)) throw new Ae("Unsupported core-js use. Try https://npms.io/search?q=ponyfill.");
            return Nn(e);
          }, Lr.isNil = function (e) {
            return null == e;
          }, Lr.isNull = function (e) {
            return null === e;
          }, Lr.isNumber = ic, Lr.isObject = tc, Lr.isObjectLike = rc, Lr.isPlainObject = oc, Lr.isRegExp = ac, Lr.isSafeInteger = function (e) {
            return Qa(e) && e >= -9007199254740991 && e <= u;
          }, Lr.isSet = cc, Lr.isString = sc, Lr.isSymbol = fc, Lr.isTypedArray = dc, Lr.isUndefined = function (e) {
            return e === i;
          }, Lr.isWeakMap = function (e) {
            return rc(e) && lo(e) == T;
          }, Lr.isWeakSet = function (e) {
            return rc(e) && "[object WeakSet]" == xn(e);
          }, Lr.join = function (e, t) {
            return null == e ? "" : pr.call(e, t);
          }, Lr.kebabCase = Kc, Lr.last = Yo, Lr.lastIndexOf = function (e, t, r) {
            var n = null == e ? 0 : e.length;
            if (!n) return -1;
            var o = n;
            return r !== i && (o = (o = mc(r)) < 0 ? br(n + o, 0) : gr(o, n - 1)), t == t ? function (e, t, r) {
              for (var n = r + 1; n--;) {
                if (e[n] === t) return n;
              }

              return n;
            }(e, t, o) : Dt(e, Ot, o, !0);
          }, Lr.lowerCase = Vc, Lr.lowerFirst = Wc, Lr.lt = uc, Lr.lte = hc, Lr.max = function (e) {
            return e && e.length ? pn(e, is, kn) : i;
          }, Lr.maxBy = function (e, t) {
            return e && e.length ? pn(e, ao(t, 2), kn) : i;
          }, Lr.mean = function (e) {
            return Pt(e, is);
          }, Lr.meanBy = function (e, t) {
            return Pt(e, ao(t, 2));
          }, Lr.min = function (e) {
            return e && e.length ? pn(e, is, Pn) : i;
          }, Lr.minBy = function (e, t) {
            return e && e.length ? pn(e, ao(t, 2), Pn) : i;
          }, Lr.stubArray = bs, Lr.stubFalse = gs, Lr.stubObject = function () {
            return {};
          }, Lr.stubString = function () {
            return "";
          }, Lr.stubTrue = function () {
            return !0;
          }, Lr.multiply = Ms, Lr.nth = function (e, t) {
            return e && e.length ? zn(e, mc(t)) : i;
          }, Lr.noConflict = function () {
            return ot._ === this && (ot._ = Le), this;
          }, Lr.noop = fs, Lr.now = Sa, Lr.pad = function (e, t, r) {
            e = yc(e);
            var n = (t = mc(t)) ? ir(e) : 0;
            if (!t || n >= t) return e;
            var i = (t - n) / 2;
            return qi(dr(i), r) + e + qi(fr(i), r);
          }, Lr.padEnd = function (e, t, r) {
            e = yc(e);
            var n = (t = mc(t)) ? ir(e) : 0;
            return t && n < t ? e + qi(t - n, r) : e;
          }, Lr.padStart = function (e, t, r) {
            e = yc(e);
            var n = (t = mc(t)) ? ir(e) : 0;
            return t && n < t ? qi(t - n, r) + e : e;
          }, Lr.parseInt = function (e, t, r) {
            return r || null == t ? t = 0 : t && (t = +t), yr(yc(e).replace(ne, ""), t || 0);
          }, Lr.random = function (e, t, r) {
            if (r && "boolean" != typeof r && vo(e, t, r) && (t = r = i), r === i && ("boolean" == typeof t ? (r = t, t = i) : "boolean" == typeof e && (r = e, e = i)), e === i && t === i ? (e = 0, t = 1) : (e = pc(e), t === i ? (t = e, e = 0) : t = pc(t)), e > t) {
              var n = e;
              e = t, t = n;
            }

            if (r || e % 1 || t % 1) {
              var o = wr();
              return gr(e + o * (t - e + tt("1e-" + ((o + "").length - 1))), t);
            }

            return Vn(e, t);
          }, Lr.reduce = function (e, t, r) {
            var n = Ka(e) ? St : Gt,
                i = arguments.length < 3;
            return n(e, ao(t, 4), r, i, un);
          }, Lr.reduceRight = function (e, t, r) {
            var n = Ka(e) ? It : Gt,
                i = arguments.length < 3;
            return n(e, ao(t, 4), r, i, hn);
          }, Lr.repeat = function (e, t, r) {
            return t = (r ? vo(e, t, r) : t === i) ? 1 : mc(t), Wn(yc(e), t);
          }, Lr.replace = function () {
            var e = arguments,
                t = yc(e[0]);
            return e.length < 3 ? t : t.replace(e[1], e[2]);
          }, Lr.result = function (e, t, r) {
            var n = -1,
                o = (t = gi(t, e)).length;

            for (o || (o = 1, e = i); ++n < o;) {
              var a = null == e ? i : e[Lo(t[n])];
              a === i && (n = o, a = r), e = Ja(a) ? a.call(e) : a;
            }

            return e;
          }, Lr.round = xs, Lr.runInContext = e, Lr.sample = function (e) {
            return (Ka(e) ? Zr : Zn)(e);
          }, Lr.size = function (e) {
            if (null == e) return 0;
            if (Wa(e)) return sc(e) ? ir(e) : e.length;
            var t = lo(e);
            return t == _ || t == S ? e.size : On(e).length;
          }, Lr.snakeCase = Xc, Lr.some = function (e, t, r) {
            var n = Ka(e) ? Ct : ri;
            return r && vo(e, t, r) && (t = i), n(e, ao(t, 3));
          }, Lr.sortedIndex = function (e, t) {
            return ni(e, t);
          }, Lr.sortedIndexBy = function (e, t, r) {
            return ii(e, t, ao(r, 2));
          }, Lr.sortedIndexOf = function (e, t) {
            var r = null == e ? 0 : e.length;

            if (r) {
              var n = ni(e, t);
              if (n < r && za(e[n], t)) return n;
            }

            return -1;
          }, Lr.sortedLastIndex = function (e, t) {
            return ni(e, t, !0);
          }, Lr.sortedLastIndexBy = function (e, t, r) {
            return ii(e, t, ao(r, 2), !0);
          }, Lr.sortedLastIndexOf = function (e, t) {
            if (null != e && e.length) {
              var r = ni(e, t, !0) - 1;
              if (za(e[r], t)) return r;
            }

            return -1;
          }, Lr.startCase = Zc, Lr.startsWith = function (e, t, r) {
            return e = yc(e), r = null == r ? 0 : an(mc(r), 0, e.length), t = ci(t), e.slice(r, r + t.length) == t;
          }, Lr.subtract = ks, Lr.sum = function (e) {
            return e && e.length ? jt(e, is) : 0;
          }, Lr.sumBy = function (e, t) {
            return e && e.length ? jt(e, ao(t, 2)) : 0;
          }, Lr.template = function (e, t, r) {
            var n = Lr.templateSettings;
            r && vo(e, t, r) && (t = i), e = yc(e), t = _c({}, t, n, $i);

            var o,
                a,
                c = _c({}, t.imports, n.imports, $i),
                s = Dc(c),
                f = Ht(c, s),
                d = 0,
                u = t.interpolate || ye,
                h = "__p += '",
                l = ke((t.escape || ye).source + "|" + u.source + "|" + (u === Y ? ue : ye).source + "|" + (t.evaluate || ye).source + "|$", "g"),
                p = "//# sourceURL=" + (Ne.call(t, "sourceURL") ? (t.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++Ye + "]") + "\n";

            e.replace(l, function (t, r, n, i, c, s) {
              return n || (n = i), h += e.slice(d, s).replace(we, Yt), r && (o = !0, h += "' +\n__e(" + r + ") +\n'"), c && (a = !0, h += "';\n" + c + ";\n__p += '"), n && (h += "' +\n((__t = (" + n + ")) == null ? '' : __t) +\n'"), d = s + t.length, t;
            }), h += "';\n";
            var m = Ne.call(t, "variable") && t.variable;

            if (m) {
              if (fe.test(m)) throw new Ae("Invalid `variable` option passed into `_.template`");
            } else h = "with (obj) {\n" + h + "\n}\n";

            h = (a ? h.replace(q, "") : h).replace(U, "$1").replace(H, "$1;"), h = "function(" + (m || "obj") + ") {\n" + (m ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (o ? ", __e = _.escape" : "") + (a ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + h + "return __p\n}";
            var b = Qc(function () {
              return _e(s, p + "return " + h).apply(i, f);
            });
            if (b.source = h, Ya(b)) throw b;
            return b;
          }, Lr.times = function (e, t) {
            if ((e = mc(e)) < 1 || e > u) return [];
            var r = l,
                n = gr(e, l);
            t = ao(t), e -= l;

            for (var i = zt(n, t); ++r < e;) {
              t(r);
            }

            return i;
          }, Lr.toFinite = pc, Lr.toInteger = mc, Lr.toLength = bc, Lr.toLower = function (e) {
            return yc(e).toLowerCase();
          }, Lr.toNumber = gc, Lr.toSafeInteger = function (e) {
            return e ? an(mc(e), -9007199254740991, u) : 0 === e ? e : 0;
          }, Lr.toString = yc, Lr.toUpper = function (e) {
            return yc(e).toUpperCase();
          }, Lr.trim = function (e, t, r) {
            if ((e = yc(e)) && (r || t === i)) return qt(e);
            if (!e || !(t = ci(t))) return e;
            var n = or(e),
                o = or(t);
            return yi(n, Vt(n, o), Wt(n, o) + 1).join("");
          }, Lr.trimEnd = function (e, t, r) {
            if ((e = yc(e)) && (r || t === i)) return e.slice(0, ar(e) + 1);
            if (!e || !(t = ci(t))) return e;
            var n = or(e);
            return yi(n, 0, Wt(n, or(t)) + 1).join("");
          }, Lr.trimStart = function (e, t, r) {
            if ((e = yc(e)) && (r || t === i)) return e.replace(ne, "");
            if (!e || !(t = ci(t))) return e;
            var n = or(e);
            return yi(n, Vt(n, or(t))).join("");
          }, Lr.truncate = function (e, t) {
            var r = 30,
                n = "...";

            if (tc(t)) {
              var o = "separator" in t ? t.separator : o;
              r = "length" in t ? mc(t.length) : r, n = "omission" in t ? ci(t.omission) : n;
            }

            var a = (e = yc(e)).length;

            if (Jt(e)) {
              var c = or(e);
              a = c.length;
            }

            if (r >= a) return e;
            var s = r - ir(n);
            if (s < 1) return n;
            var f = c ? yi(c, 0, s).join("") : e.slice(0, s);
            if (o === i) return f + n;

            if (c && (s += f.length - s), ac(o)) {
              if (e.slice(s).search(o)) {
                var d,
                    u = f;

                for (o.global || (o = ke(o.source, yc(he.exec(o)) + "g")), o.lastIndex = 0; d = o.exec(u);) {
                  var h = d.index;
                }

                f = f.slice(0, h === i ? s : h);
              }
            } else if (e.indexOf(ci(o), s) != s) {
              var l = f.lastIndexOf(o);
              l > -1 && (f = f.slice(0, l));
            }

            return f + n;
          }, Lr.unescape = function (e) {
            return (e = yc(e)) && W.test(e) ? e.replace(K, cr) : e;
          }, Lr.uniqueId = function (e) {
            var t = ++Re;
            return yc(e) + t;
          }, Lr.upperCase = $c, Lr.upperFirst = Yc, Lr.each = ya, Lr.eachRight = wa, Lr.first = Wo, ss(Lr, (vs = {}, yn(Lr, function (e, t) {
            Ne.call(Lr.prototype, t) || (vs[t] = e);
          }), vs), {
            chain: !1
          }), Lr.VERSION = "4.17.21", yt(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function (e) {
            Lr[e].placeholder = Lr;
          }), yt(["drop", "take"], function (e, t) {
            qr.prototype[e] = function (r) {
              r = r === i ? 1 : br(mc(r), 0);
              var n = this.__filtered__ && !t ? new qr(this) : this.clone();
              return n.__filtered__ ? n.__takeCount__ = gr(r, n.__takeCount__) : n.__views__.push({
                size: gr(r, l),
                type: e + (n.__dir__ < 0 ? "Right" : "")
              }), n;
            }, qr.prototype[e + "Right"] = function (t) {
              return this.reverse()[e](t).reverse();
            };
          }), yt(["filter", "map", "takeWhile"], function (e, t) {
            var r = t + 1,
                n = 1 == r || 3 == r;

            qr.prototype[e] = function (e) {
              var t = this.clone();
              return t.__iteratees__.push({
                iteratee: ao(e, 3),
                type: r
              }), t.__filtered__ = t.__filtered__ || n, t;
            };
          }), yt(["head", "last"], function (e, t) {
            var r = "take" + (t ? "Right" : "");

            qr.prototype[e] = function () {
              return this[r](1).value()[0];
            };
          }), yt(["initial", "tail"], function (e, t) {
            var r = "drop" + (t ? "" : "Right");

            qr.prototype[e] = function () {
              return this.__filtered__ ? new qr(this) : this[r](1);
            };
          }), qr.prototype.compact = function () {
            return this.filter(is);
          }, qr.prototype.find = function (e) {
            return this.filter(e).head();
          }, qr.prototype.findLast = function (e) {
            return this.reverse().find(e);
          }, qr.prototype.invokeMap = Xn(function (e, t) {
            return "function" == typeof e ? new qr(this) : this.map(function (r) {
              return Cn(r, e, t);
            });
          }), qr.prototype.reject = function (e) {
            return this.filter(Pa(ao(e)));
          }, qr.prototype.slice = function (e, t) {
            e = mc(e);
            var r = this;
            return r.__filtered__ && (e > 0 || t < 0) ? new qr(r) : (e < 0 ? r = r.takeRight(-e) : e && (r = r.drop(e)), t !== i && (r = (t = mc(t)) < 0 ? r.dropRight(-t) : r.take(t - e)), r);
          }, qr.prototype.takeRightWhile = function (e) {
            return this.reverse().takeWhile(e).reverse();
          }, qr.prototype.toArray = function () {
            return this.take(l);
          }, yn(qr.prototype, function (e, t) {
            var r = /^(?:filter|find|map|reject)|While$/.test(t),
                n = /^(?:head|last)$/.test(t),
                o = Lr[n ? "take" + ("last" == t ? "Right" : "") : t],
                a = n || /^find/.test(t);
            o && (Lr.prototype[t] = function () {
              var t = this.__wrapped__,
                  c = n ? [1] : arguments,
                  s = t instanceof qr,
                  f = c[0],
                  d = s || Ka(t),
                  u = function u(e) {
                var t = o.apply(Lr, Et([e], c));
                return n && h ? t[0] : t;
              };

              d && r && "function" == typeof f && 1 != f.length && (s = d = !1);
              var h = this.__chain__,
                  l = !!this.__actions__.length,
                  p = a && !h,
                  m = s && !l;

              if (!a && d) {
                t = m ? t : new qr(this);
                var b = e.apply(t, c);
                return b.__actions__.push({
                  func: pa,
                  args: [u],
                  thisArg: i
                }), new zr(b, h);
              }

              return p && m ? e.apply(this, c) : (b = this.thru(u), p ? n ? b.value()[0] : b.value() : b);
            });
          }), yt(["pop", "push", "shift", "sort", "splice", "unshift"], function (e) {
            var t = Ie[e],
                r = /^(?:push|sort|unshift)$/.test(e) ? "tap" : "thru",
                n = /^(?:pop|shift)$/.test(e);

            Lr.prototype[e] = function () {
              var e = arguments;

              if (n && !this.__chain__) {
                var i = this.value();
                return t.apply(Ka(i) ? i : [], e);
              }

              return this[r](function (r) {
                return t.apply(Ka(r) ? r : [], e);
              });
            };
          }), yn(qr.prototype, function (e, t) {
            var r = Lr[t];

            if (r) {
              var n = r.name + "";
              Ne.call(Cr, n) || (Cr[n] = []), Cr[n].push({
                name: t,
                func: r
              });
            }
          }), Cr[Li(i, 2).name] = [{
            name: "wrapper",
            func: i
          }], qr.prototype.clone = function () {
            var e = new qr(this.__wrapped__);
            return e.__actions__ = Si(this.__actions__), e.__dir__ = this.__dir__, e.__filtered__ = this.__filtered__, e.__iteratees__ = Si(this.__iteratees__), e.__takeCount__ = this.__takeCount__, e.__views__ = Si(this.__views__), e;
          }, qr.prototype.reverse = function () {
            if (this.__filtered__) {
              var e = new qr(this);
              e.__dir__ = -1, e.__filtered__ = !0;
            } else (e = this.clone()).__dir__ *= -1;

            return e;
          }, qr.prototype.value = function () {
            var e = this.__wrapped__.value(),
                t = this.__dir__,
                r = Ka(e),
                n = t < 0,
                i = r ? e.length : 0,
                o = function (e, t, r) {
              for (var n = -1, i = r.length; ++n < i;) {
                var o = r[n],
                    a = o.size;

                switch (o.type) {
                  case "drop":
                    e += a;
                    break;

                  case "dropRight":
                    t -= a;
                    break;

                  case "take":
                    t = gr(t, e + a);
                    break;

                  case "takeRight":
                    e = br(e, t - a);
                }
              }

              return {
                start: e,
                end: t
              };
            }(0, i, this.__views__),
                a = o.start,
                c = o.end,
                s = c - a,
                f = n ? c : a - 1,
                d = this.__iteratees__,
                u = d.length,
                h = 0,
                l = gr(s, this.__takeCount__);

            if (!r || !n && i == s && l == s) return hi(e, this.__actions__);
            var p = [];

            e: for (; s-- && h < l;) {
              for (var m = -1, b = e[f += t]; ++m < u;) {
                var g = d[m],
                    v = g.iteratee,
                    y = g.type,
                    w = v(b);
                if (2 == y) b = w;else if (!w) {
                  if (1 == y) continue e;
                  break e;
                }
              }

              p[h++] = b;
            }

            return p;
          }, Lr.prototype.at = ma, Lr.prototype.chain = function () {
            return la(this);
          }, Lr.prototype.commit = function () {
            return new zr(this.value(), this.__chain__);
          }, Lr.prototype.next = function () {
            this.__values__ === i && (this.__values__ = lc(this.value()));
            var e = this.__index__ >= this.__values__.length;
            return {
              done: e,
              value: e ? i : this.__values__[this.__index__++]
            };
          }, Lr.prototype.plant = function (e) {
            for (var t, r = this; r instanceof jr;) {
              var n = jo(r);
              n.__index__ = 0, n.__values__ = i, t ? o.__wrapped__ = n : t = n;
              var o = n;
              r = r.__wrapped__;
            }

            return o.__wrapped__ = e, t;
          }, Lr.prototype.reverse = function () {
            var e = this.__wrapped__;

            if (e instanceof qr) {
              var t = e;
              return this.__actions__.length && (t = new qr(this)), (t = t.reverse()).__actions__.push({
                func: pa,
                args: [ta],
                thisArg: i
              }), new zr(t, this.__chain__);
            }

            return this.thru(ta);
          }, Lr.prototype.toJSON = Lr.prototype.valueOf = Lr.prototype.value = function () {
            return hi(this.__wrapped__, this.__actions__);
          }, Lr.prototype.first = Lr.prototype.head, at && (Lr.prototype[at] = function () {
            return this;
          }), Lr;
        }();

        ot._ = sr, (n = function () {
          return sr;
        }.call(t, r, t, e)) === i || (e.exports = n);
      }.call(this);
    },
    9746: function _(e) {
      function t(e, t) {
        if (!e) throw new Error(t || "Assertion failed");
      }

      e.exports = t, t.equal = function (e, t, r) {
        if (e != t) throw new Error(r || "Assertion failed: " + e + " != " + t);
      };
    },
    4504: function _(e, t) {
      "use strict";

      var r = t;

      function n(e) {
        return 1 === e.length ? "0" + e : e;
      }

      function i(e) {
        for (var t = "", r = 0; r < e.length; r++) {
          t += n(e[r].toString(16));
        }

        return t;
      }

      r.toArray = function (e, t) {
        if (Array.isArray(e)) return e.slice();
        if (!e) return [];
        var r = [];

        if ("string" != typeof e) {
          for (var n = 0; n < e.length; n++) {
            r[n] = 0 | e[n];
          }

          return r;
        }

        if ("hex" === t) for ((e = e.replace(/[^a-z0-9]+/gi, "")).length % 2 != 0 && (e = "0" + e), n = 0; n < e.length; n += 2) {
          r.push(parseInt(e[n] + e[n + 1], 16));
        } else for (n = 0; n < e.length; n++) {
          var i = e.charCodeAt(n),
              o = i >> 8,
              a = 255 & i;
          o ? r.push(o, a) : r.push(a);
        }
        return r;
      }, r.zero2 = n, r.toHex = i, r.encode = function (e, t) {
        return "hex" === t ? i(e) : e;
      };
    },
    9516: function _(e, t, r) {
      var n = r(7147),
          i = r(1017),
          o = r(2037),
          a = require,
          c = process.config && process.config.variables || {},
          s = !!process.env.PREBUILDS_ONLY,
          f = process.versions.modules,
          d = process.versions && process.versions.electron || process.env.ELECTRON_RUN_AS_NODE || "undefined" != typeof window && window.process && "renderer" === window.process.type ? "electron" : "node",
          u = o.arch(),
          h = o.platform(),
          l = process.env.LIBC || (function (e) {
        return "linux" === e && n.existsSync("/etc/alpine-release");
      }(h) ? "musl" : "glibc"),
          p = process.env.ARM_VERSION || ("arm64" === u ? "8" : c.arm_version) || "",
          m = (process.versions.uv || "").split(".")[0];

      function b(e) {
        return a(b.path(e));
      }

      function g(e) {
        try {
          return n.readdirSync(e);
        } catch (e) {
          return [];
        }
      }

      function v(e, t) {
        var r = g(e).filter(t);
        return r[0] && i.join(e, r[0]);
      }

      function y(e) {
        return /\.node$/.test(e);
      }

      function w(e) {
        var t = e.split("-");

        if (2 === t.length) {
          var r = t[0],
              n = t[1].split("+");
          if (r && n.length && n.every(Boolean)) return {
            name: e,
            platform: r,
            architectures: n
          };
        }
      }

      function A(e, t) {
        return function (r) {
          return null != r && r.platform === e && r.architectures.includes(t);
        };
      }

      function _(e, t) {
        return e.architectures.length - t.architectures.length;
      }

      function M(e) {
        var t = e.split("."),
            r = {
          file: e,
          specificity: 0
        };

        if ("node" === t.pop()) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            if ("node" === i || "electron" === i || "node-webkit" === i) r.runtime = i;else if ("napi" === i) r.napi = !0;else if ("abi" === i.slice(0, 3)) r.abi = i.slice(3);else if ("uv" === i.slice(0, 2)) r.uv = i.slice(2);else if ("armv" === i.slice(0, 4)) r.armv = i.slice(4);else {
              if ("glibc" !== i && "musl" !== i) continue;
              r.libc = i;
            }
            r.specificity++;
          }

          return r;
        }
      }

      function x(e, t) {
        return function (r) {
          return !(null == r || r.runtime !== e && !function (e) {
            return "node" === e.runtime && e.napi;
          }(r) || r.abi !== t && !r.napi || r.uv && r.uv !== m || r.armv && r.armv !== p || r.libc && r.libc !== l);
        };
      }

      function k(e) {
        return function (t, r) {
          return t.runtime !== r.runtime ? t.runtime === e ? -1 : 1 : t.abi !== r.abi ? t.abi ? -1 : 1 : t.specificity !== r.specificity ? t.specificity > r.specificity ? -1 : 1 : 0;
        };
      }

      e.exports = b, b.path = function (e) {
        e = i.resolve(e || ".");

        try {
          var t = a(i.join(e, "package.json")).name.toUpperCase().replace(/-/g, "_");
          process.env[t + "_PREBUILD"] && (e = process.env[t + "_PREBUILD"]);
        } catch (e) {}

        if (!s) {
          var r = v(i.join(e, "build/Release"), y);
          if (r) return r;
          var n = v(i.join(e, "build/Debug"), y);
          if (n) return n;
        }

        var o = E(e);
        if (o) return o;
        var c = E(i.dirname(process.execPath));
        if (c) return c;
        var b = ["platform=" + h, "arch=" + u, "runtime=" + d, "abi=" + f, "uv=" + m, p ? "armv=" + p : "", "libc=" + l, "node=" + process.versions.node, process.versions.electron ? "electron=" + process.versions.electron : "", "webpack=true"].filter(Boolean).join(" ");
        throw new Error("No native build was found for " + b + "\n    loaded from: " + e + "\n");

        function E(e) {
          var t = g(i.join(e, "prebuilds")).map(w).filter(A(h, u)).sort(_)[0];

          if (t) {
            var r = i.join(e, "prebuilds", t.name),
                n = g(r).map(M).filter(x(d, f)).sort(k(d))[0];
            return n ? i.join(r, n.file) : void 0;
          }
        }
      }, b.parseTags = M, b.matchTags = x, b.compareTags = k, b.parseTuple = w, b.matchTuple = A, b.compareTuples = _;
    },
    1353: function _(e, t, r) {
      e.exports = r(6113).randomBytes;
    },
    6636: function _(e, t, r) {
      "use strict";

      var n = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.getLength = t.decode = t.encode = void 0;
      var i = n(r(3550));

      function o(e, t) {
        if ("0" === e[0] && "0" === e[1]) throw new Error("invalid RLP: extra zeros");
        return parseInt(e, t);
      }

      function a(e, t) {
        if (e < 56) return Buffer.from([e + t]);
        {
          var _r14 = f(e),
              _n15 = f(t + 55 + _r14.length / 2);

          return Buffer.from(_n15 + _r14, "hex");
        }
      }

      function c(e) {
        var t, r, n, i, a;
        var s = [],
            f = e[0];
        if (f <= 127) return {
          data: e.slice(0, 1),
          remainder: e.slice(1)
        };

        if (f <= 183) {
          if (t = f - 127, n = 128 === f ? Buffer.from([]) : e.slice(1, t), 2 === t && n[0] < 128) throw new Error("invalid rlp encoding: byte must be less 0x80");
          return {
            data: n,
            remainder: e.slice(t)
          };
        }

        if (f <= 191) {
          if (r = f - 182, e.length - 1 < r) throw new Error("invalid RLP: not enough bytes for string length");
          if (t = o(e.slice(1, r).toString("hex"), 16), t <= 55) throw new Error("invalid RLP: expected string length to be greater than 55");
          if (n = e.slice(r, t + r), n.length < t) throw new Error("invalid RLP: not enough bytes for string");
          return {
            data: n,
            remainder: e.slice(t + r)
          };
        }

        if (f <= 247) {
          for (t = f - 191, i = e.slice(1, t); i.length;) {
            a = c(i), s.push(a.data), i = a.remainder;
          }

          return {
            data: s,
            remainder: e.slice(t)
          };
        }

        {
          r = f - 246, t = o(e.slice(1, r).toString("hex"), 16);

          var _n16 = r + t;

          if (_n16 > e.length) throw new Error("invalid rlp: total length is larger than the data");
          if (i = e.slice(r, _n16), 0 === i.length) throw new Error("invalid rlp, List has a invalid length");

          for (; i.length;) {
            a = c(i), s.push(a.data), i = a.remainder;
          }

          return {
            data: s,
            remainder: e.slice(_n16)
          };
        }
      }

      function s(e) {
        return "0x" === e.slice(0, 2);
      }

      function f(e) {
        if (e < 0) throw new Error("Invalid integer as argument, must be unsigned!");
        var t = e.toString(16);
        return t.length % 2 ? "0".concat(t) : t;
      }

      function d(e) {
        if (!Buffer.isBuffer(e)) {
          if ("string" == typeof e) return s(e) ? Buffer.from((t = "string" != typeof (r = e) ? r : s(r) ? r.slice(2) : r).length % 2 ? "0".concat(t) : t, "hex") : Buffer.from(e);
          if ("number" == typeof e || "bigint" == typeof e) return e ? function (e) {
            var t = f(e);
            return Buffer.from(t, "hex");
          }(e) : Buffer.from([]);
          if (null == e) return Buffer.from([]);
          if (e instanceof Uint8Array) return Buffer.from(e);
          if (i.default.isBN(e)) return Buffer.from(e.toArray());
          throw new Error("invalid type");
        }

        var t, r;
        return e;
      }

      t.encode = function e(t) {
        if (Array.isArray(t)) {
          var _r15 = [];

          for (var _n18 = 0; _n18 < t.length; _n18++) {
            _r15.push(e(t[_n18]));
          }

          var _n17 = Buffer.concat(_r15);

          return Buffer.concat([a(_n17.length, 192), _n17]);
        }

        {
          var _e12 = d(t);

          return 1 === _e12.length && _e12[0] < 128 ? _e12 : Buffer.concat([a(_e12.length, 128), _e12]);
        }
      }, t.decode = function (e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
        if (!e || 0 === e.length) return Buffer.from([]);
        var r = c(d(e));
        if (t) return r;
        if (0 !== r.remainder.length) throw new Error("invalid remainder");
        return r.data;
      }, t.getLength = function (e) {
        if (!e || 0 === e.length) return Buffer.from([]);
        var t = d(e),
            r = t[0];
        if (r <= 127) return t.length;
        if (r <= 183) return r - 127;
        if (r <= 191) return r - 182;
        if (r <= 247) return r - 191;
        {
          var _e13 = r - 246;

          return _e13 + o(t.slice(1, _e13).toString("hex"), 16);
        }
      };
    },
    9509: function _(e, t, r) {
      var n = r(4300),
          i = n.Buffer;

      function o(e, t) {
        for (var r in e) {
          t[r] = e[r];
        }
      }

      function a(e, t, r) {
        return i(e, t, r);
      }

      i.from && i.alloc && i.allocUnsafe && i.allocUnsafeSlow ? e.exports = n : (o(n, t), t.Buffer = a), o(i, a), a.from = function (e, t, r) {
        if ("number" == typeof e) throw new TypeError("Argument must not be a number");
        return i(e, t, r);
      }, a.alloc = function (e, t, r) {
        if ("number" != typeof e) throw new TypeError("Argument must be a number");
        var n = i(e);
        return void 0 !== t ? "string" == typeof r ? n.fill(t, r) : n.fill(t) : n.fill(0), n;
      }, a.allocUnsafe = function (e) {
        if ("number" != typeof e) throw new TypeError("Argument must be a number");
        return i(e);
      }, a.allocUnsafeSlow = function (e) {
        if ("number" != typeof e) throw new TypeError("Argument must be a number");
        return n.SlowBuffer(e);
      };
    },
    216: function _(e, t, r) {
      var n = r(9516)(__dirname);
      e.exports = r(9119)(new n.Secp256k1());
    },
    7221: function _(e, t, r) {
      e.exports = r(9119)(r(8573));
    },
    7972: function _(e, t, r) {
      try {
        e.exports = r(216);
      } catch (t) {
        e.exports = r(7221);
      }
    },
    8573: function _(e, t, r) {
      var n = new (0, r(6266).ec)("secp256k1"),
          i = n.curve,
          o = i.n.constructor;

      function a(e) {
        var t = e[0];

        switch (t) {
          case 2:
          case 3:
            return 33 !== e.length ? null : function (e, t) {
              var r = new o(t);
              if (r.cmp(i.p) >= 0) return null;
              r = r.toRed(i.red);
              var a = r.redSqr().redIMul(r).redIAdd(i.b).redSqrt();
              return 3 === e !== a.isOdd() && (a = a.redNeg()), n.keyPair({
                pub: {
                  x: r,
                  y: a
                }
              });
            }(t, e.subarray(1, 33));

          case 4:
          case 6:
          case 7:
            return 65 !== e.length ? null : function (e, t, r) {
              var a = new o(t),
                  c = new o(r);
              if (a.cmp(i.p) >= 0 || c.cmp(i.p) >= 0) return null;
              if (a = a.toRed(i.red), c = c.toRed(i.red), (6 === e || 7 === e) && c.isOdd() !== (7 === e)) return null;
              var s = a.redSqr().redIMul(a);
              return c.redSqr().redISub(s.redIAdd(i.b)).isZero() ? n.keyPair({
                pub: {
                  x: a,
                  y: c
                }
              }) : null;
            }(t, e.subarray(1, 33), e.subarray(33, 65));

          default:
            return null;
        }
      }

      function c(e, t) {
        var r = t.encode(null, 33 === e.length);

        for (var _t15 = 0; _t15 < e.length; ++_t15) {
          e[_t15] = r[_t15];
        }
      }

      e.exports = {
        contextRandomize: function contextRandomize() {
          return 0;
        },
        privateKeyVerify: function privateKeyVerify(e) {
          var t = new o(e);
          return t.cmp(i.n) < 0 && !t.isZero() ? 0 : 1;
        },
        privateKeyNegate: function privateKeyNegate(e) {
          var t = new o(e),
              r = i.n.sub(t).umod(i.n).toArrayLike(Uint8Array, "be", 32);
          return e.set(r), 0;
        },
        privateKeyTweakAdd: function privateKeyTweakAdd(e, t) {
          var r = new o(t);
          if (r.cmp(i.n) >= 0) return 1;
          if (r.iadd(new o(e)), r.cmp(i.n) >= 0 && r.isub(i.n), r.isZero()) return 1;
          var n = r.toArrayLike(Uint8Array, "be", 32);
          return e.set(n), 0;
        },
        privateKeyTweakMul: function privateKeyTweakMul(e, t) {
          var r = new o(t);
          if (r.cmp(i.n) >= 0 || r.isZero()) return 1;
          r.imul(new o(e)), r.cmp(i.n) >= 0 && (r = r.umod(i.n));
          var n = r.toArrayLike(Uint8Array, "be", 32);
          return e.set(n), 0;
        },
        publicKeyVerify: function publicKeyVerify(e) {
          return null === a(e) ? 1 : 0;
        },
        publicKeyCreate: function publicKeyCreate(e, t) {
          var r = new o(t);
          return r.cmp(i.n) >= 0 || r.isZero() ? 1 : (c(e, n.keyFromPrivate(t).getPublic()), 0);
        },
        publicKeyConvert: function publicKeyConvert(e, t) {
          var r = a(t);
          return null === r ? 1 : (c(e, r.getPublic()), 0);
        },
        publicKeyNegate: function publicKeyNegate(e, t) {
          var r = a(t);
          if (null === r) return 1;
          var n = r.getPublic();
          return n.y = n.y.redNeg(), c(e, n), 0;
        },
        publicKeyCombine: function publicKeyCombine(e, t) {
          var r = new Array(t.length);

          for (var _e14 = 0; _e14 < t.length; ++_e14) {
            if (r[_e14] = a(t[_e14]), null === r[_e14]) return 1;
          }

          var n = r[0].getPublic();

          for (var _e15 = 1; _e15 < r.length; ++_e15) {
            n = n.add(r[_e15].pub);
          }

          return n.isInfinity() ? 2 : (c(e, n), 0);
        },
        publicKeyTweakAdd: function publicKeyTweakAdd(e, t, r) {
          var n = a(t);
          if (null === n) return 1;
          if ((r = new o(r)).cmp(i.n) >= 0) return 2;
          var s = n.getPublic().add(i.g.mul(r));
          return s.isInfinity() ? 2 : (c(e, s), 0);
        },
        publicKeyTweakMul: function publicKeyTweakMul(e, t, r) {
          var n = a(t);
          return null === n ? 1 : (r = new o(r)).cmp(i.n) >= 0 || r.isZero() ? 2 : (c(e, n.getPublic().mul(r)), 0);
        },
        signatureNormalize: function signatureNormalize(e) {
          var t = new o(e.subarray(0, 32)),
              r = new o(e.subarray(32, 64));
          return t.cmp(i.n) >= 0 || r.cmp(i.n) >= 0 ? 1 : (1 === r.cmp(n.nh) && e.set(i.n.sub(r).toArrayLike(Uint8Array, "be", 32), 32), 0);
        },
        signatureExport: function signatureExport(e, t) {
          var r = t.subarray(0, 32),
              n = t.subarray(32, 64);
          if (new o(r).cmp(i.n) >= 0) return 1;
          if (new o(n).cmp(i.n) >= 0) return 1;
          var a = e.output;
          var c = a.subarray(4, 37);
          c[0] = 0, c.set(r, 1);
          var s = 33,
              f = 0;

          for (; s > 1 && 0 === c[f] && !(128 & c[f + 1]); --s, ++f) {
            ;
          }

          if (c = c.subarray(f), 128 & c[0]) return 1;
          if (s > 1 && 0 === c[0] && !(128 & c[1])) return 1;
          var d = a.subarray(39, 72);
          d[0] = 0, d.set(n, 1);
          var u = 33,
              h = 0;

          for (; u > 1 && 0 === d[h] && !(128 & d[h + 1]); --u, ++h) {
            ;
          }

          return d = d.subarray(h), 128 & d[0] || u > 1 && 0 === d[0] && !(128 & d[1]) ? 1 : (e.outputlen = 6 + s + u, a[0] = 48, a[1] = e.outputlen - 2, a[2] = 2, a[3] = c.length, a.set(c, 4), a[4 + s] = 2, a[5 + s] = d.length, a.set(d, 6 + s), 0);
        },
        signatureImport: function signatureImport(e, t) {
          if (t.length < 8) return 1;
          if (t.length > 72) return 1;
          if (48 !== t[0]) return 1;
          if (t[1] !== t.length - 2) return 1;
          if (2 !== t[2]) return 1;
          var r = t[3];
          if (0 === r) return 1;
          if (5 + r >= t.length) return 1;
          if (2 !== t[4 + r]) return 1;
          var n = t[5 + r];
          if (0 === n) return 1;
          if (6 + r + n !== t.length) return 1;
          if (128 & t[4]) return 1;
          if (r > 1 && 0 === t[4] && !(128 & t[5])) return 1;
          if (128 & t[r + 6]) return 1;
          if (n > 1 && 0 === t[r + 6] && !(128 & t[r + 7])) return 1;
          var a = t.subarray(4, 4 + r);
          if (33 === a.length && 0 === a[0] && (a = a.subarray(1)), a.length > 32) return 1;
          var c = t.subarray(6 + r);
          if (33 === c.length && 0 === c[0] && (c = c.slice(1)), c.length > 32) throw new Error("S length is too long");
          var s = new o(a);
          s.cmp(i.n) >= 0 && (s = new o(0));
          var f = new o(t.subarray(6 + r));
          return f.cmp(i.n) >= 0 && (f = new o(0)), e.set(s.toArrayLike(Uint8Array, "be", 32), 0), e.set(f.toArrayLike(Uint8Array, "be", 32), 32), 0;
        },
        ecdsaSign: function ecdsaSign(e, t, r, a, c) {
          if (c) {
            var _e16 = c;

            c = function c(n) {
              var i = _e16(t, r, null, a, n);

              if (!(i instanceof Uint8Array && 32 === i.length)) throw new Error("This is the way");
              return new o(i);
            };
          }

          var s = new o(r);
          if (s.cmp(i.n) >= 0 || s.isZero()) return 1;
          var f;

          try {
            f = n.sign(t, r, {
              canonical: !0,
              k: c,
              pers: a
            });
          } catch (e) {
            return 1;
          }

          return e.signature.set(f.r.toArrayLike(Uint8Array, "be", 32), 0), e.signature.set(f.s.toArrayLike(Uint8Array, "be", 32), 32), e.recid = f.recoveryParam, 0;
        },
        ecdsaVerify: function ecdsaVerify(e, t, r) {
          var c = {
            r: e.subarray(0, 32),
            s: e.subarray(32, 64)
          },
              s = new o(c.r),
              f = new o(c.s);
          if (s.cmp(i.n) >= 0 || f.cmp(i.n) >= 0) return 1;
          if (1 === f.cmp(n.nh) || s.isZero() || f.isZero()) return 3;
          var d = a(r);
          if (null === d) return 2;
          var u = d.getPublic();
          return n.verify(t, c, u) ? 0 : 3;
        },
        ecdsaRecover: function ecdsaRecover(e, t, r, a) {
          var s = {
            r: t.slice(0, 32),
            s: t.slice(32, 64)
          },
              f = new o(s.r),
              d = new o(s.s);
          if (f.cmp(i.n) >= 0 || d.cmp(i.n) >= 0) return 1;
          if (f.isZero() || d.isZero()) return 2;
          var u;

          try {
            u = n.recoverPubKey(a, s, r);
          } catch (e) {
            return 2;
          }

          return c(e, u), 0;
        },
        ecdh: function ecdh(e, t, r, c, s, f, d) {
          var u = a(t);
          if (null === u) return 1;
          var h = new o(r);
          if (h.cmp(i.n) >= 0 || h.isZero()) return 2;
          var l = u.getPublic().mul(h);

          if (void 0 === s) {
            var _t16 = l.encode(null, !0),
                _r16 = n.hash().update(_t16).digest();

            for (var _t17 = 0; _t17 < 32; ++_t17) {
              e[_t17] = _r16[_t17];
            }
          } else {
            f || (f = new Uint8Array(32));

            var _t18 = l.getX().toArray("be", 32);

            for (var _e17 = 0; _e17 < 32; ++_e17) {
              f[_e17] = _t18[_e17];
            }

            d || (d = new Uint8Array(32));

            var _r17 = l.getY().toArray("be", 32);

            for (var _e18 = 0; _e18 < 32; ++_e18) {
              d[_e18] = _r17[_e18];
            }

            var _n19 = s(f, d, c);

            if (!(_n19 instanceof Uint8Array && _n19.length === e.length)) return 2;
            e.set(_n19);
          }

          return 0;
        }
      };
    },
    9119: function _(e) {
      var t = "Impossible case. Please create issue.",
          r = "The tweak was out of range or the resulted private key is invalid",
          n = "The tweak was out of range or equal to zero",
          i = "Public Key could not be parsed",
          o = "Public Key serialization error",
          a = "Signature could not be parsed";

      function c(e, t) {
        if (!e) throw new Error(t);
      }

      function s(e, t, r) {
        if (c(t instanceof Uint8Array, "Expected ".concat(e, " to be an Uint8Array")), void 0 !== r) if (Array.isArray(r)) {
          var _n20 = "Expected ".concat(e, " to be an Uint8Array with length [").concat(r.join(", "), "]");

          c(r.includes(t.length), _n20);
        } else {
          var _n21 = "Expected ".concat(e, " to be an Uint8Array with length ").concat(r);

          c(t.length === r, _n21);
        }
      }

      function f(e) {
        c("Boolean" === u(e), "Expected compressed to be a Boolean");
      }

      function d() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (e) {
          return new Uint8Array(e);
        };
        var t = arguments.length > 1 ? arguments[1] : undefined;
        return "function" == typeof e && (e = e(t)), s("output", e, t), e;
      }

      function u(e) {
        return Object.prototype.toString.call(e).slice(8, -1);
      }

      e.exports = function (e) {
        return {
          contextRandomize: function contextRandomize(t) {
            if (c(null === t || t instanceof Uint8Array, "Expected seed to be an Uint8Array or null"), null !== t && s("seed", t, 32), 1 === e.contextRandomize(t)) throw new Error("Unknow error on context randomization");
          },
          privateKeyVerify: function privateKeyVerify(t) {
            return s("private key", t, 32), 0 === e.privateKeyVerify(t);
          },
          privateKeyNegate: function privateKeyNegate(r) {
            switch (s("private key", r, 32), e.privateKeyNegate(r)) {
              case 0:
                return r;

              case 1:
                throw new Error(t);
            }
          },
          privateKeyTweakAdd: function privateKeyTweakAdd(t, n) {
            switch (s("private key", t, 32), s("tweak", n, 32), e.privateKeyTweakAdd(t, n)) {
              case 0:
                return t;

              case 1:
                throw new Error(r);
            }
          },
          privateKeyTweakMul: function privateKeyTweakMul(t, r) {
            switch (s("private key", t, 32), s("tweak", r, 32), e.privateKeyTweakMul(t, r)) {
              case 0:
                return t;

              case 1:
                throw new Error(n);
            }
          },
          publicKeyVerify: function publicKeyVerify(t) {
            return s("public key", t, [33, 65]), 0 === e.publicKeyVerify(t);
          },
          publicKeyCreate: function publicKeyCreate(t) {
            var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
            var n = arguments.length > 2 ? arguments[2] : undefined;

            switch (s("private key", t, 32), f(r), n = d(n, r ? 33 : 65), e.publicKeyCreate(n, t)) {
              case 0:
                return n;

              case 1:
                throw new Error("Private Key is invalid");

              case 2:
                throw new Error(o);
            }
          },
          publicKeyConvert: function publicKeyConvert(t) {
            var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
            var n = arguments.length > 2 ? arguments[2] : undefined;

            switch (s("public key", t, [33, 65]), f(r), n = d(n, r ? 33 : 65), e.publicKeyConvert(n, t)) {
              case 0:
                return n;

              case 1:
                throw new Error(i);

              case 2:
                throw new Error(o);
            }
          },
          publicKeyNegate: function publicKeyNegate(r) {
            var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
            var a = arguments.length > 2 ? arguments[2] : undefined;

            switch (s("public key", r, [33, 65]), f(n), a = d(a, n ? 33 : 65), e.publicKeyNegate(a, r)) {
              case 0:
                return a;

              case 1:
                throw new Error(i);

              case 2:
                throw new Error(t);

              case 3:
                throw new Error(o);
            }
          },
          publicKeyCombine: function publicKeyCombine(t) {
            var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
            var n = arguments.length > 2 ? arguments[2] : undefined;
            c(Array.isArray(t), "Expected public keys to be an Array"), c(t.length > 0, "Expected public keys array will have more than zero items");
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var _e19 = _step.value;
                s("public key", _e19, [33, 65]);
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }

            switch (f(r), n = d(n, r ? 33 : 65), e.publicKeyCombine(n, t)) {
              case 0:
                return n;

              case 1:
                throw new Error(i);

              case 2:
                throw new Error("The sum of the public keys is not valid");

              case 3:
                throw new Error(o);
            }
          },
          publicKeyTweakAdd: function publicKeyTweakAdd(t, n) {
            var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
            var a = arguments.length > 3 ? arguments[3] : undefined;

            switch (s("public key", t, [33, 65]), s("tweak", n, 32), f(o), a = d(a, o ? 33 : 65), e.publicKeyTweakAdd(a, t, n)) {
              case 0:
                return a;

              case 1:
                throw new Error(i);

              case 2:
                throw new Error(r);
            }
          },
          publicKeyTweakMul: function publicKeyTweakMul(t, r) {
            var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
            var a = arguments.length > 3 ? arguments[3] : undefined;

            switch (s("public key", t, [33, 65]), s("tweak", r, 32), f(o), a = d(a, o ? 33 : 65), e.publicKeyTweakMul(a, t, r)) {
              case 0:
                return a;

              case 1:
                throw new Error(i);

              case 2:
                throw new Error(n);
            }
          },
          signatureNormalize: function signatureNormalize(t) {
            switch (s("signature", t, 64), e.signatureNormalize(t)) {
              case 0:
                return t;

              case 1:
                throw new Error(a);
            }
          },
          signatureExport: function signatureExport(r, n) {
            s("signature", r, 64);
            var i = {
              output: n = d(n, 72),
              outputlen: 72
            };

            switch (e.signatureExport(i, r)) {
              case 0:
                return n.slice(0, i.outputlen);

              case 1:
                throw new Error(a);

              case 2:
                throw new Error(t);
            }
          },
          signatureImport: function signatureImport(r, n) {
            switch (s("signature", r), n = d(n, 64), e.signatureImport(n, r)) {
              case 0:
                return n;

              case 1:
                throw new Error(a);

              case 2:
                throw new Error(t);
            }
          },
          ecdsaSign: function ecdsaSign(r, n) {
            var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            var o = arguments.length > 3 ? arguments[3] : undefined;
            s("message", r, 32), s("private key", n, 32), c("Object" === u(i), "Expected options to be an Object"), void 0 !== i.data && s("options.data", i.data), void 0 !== i.noncefn && c("Function" === u(i.noncefn), "Expected options.noncefn to be a Function");
            var a = {
              signature: o = d(o, 64),
              recid: null
            };

            switch (e.ecdsaSign(a, r, n, i.data, i.noncefn)) {
              case 0:
                return a;

              case 1:
                throw new Error("The nonce generation function failed, or the private key was invalid");

              case 2:
                throw new Error(t);
            }
          },
          ecdsaVerify: function ecdsaVerify(t, r, n) {
            switch (s("signature", t, 64), s("message", r, 32), s("public key", n, [33, 65]), e.ecdsaVerify(t, r, n)) {
              case 0:
                return !0;

              case 3:
                return !1;

              case 1:
                throw new Error(a);

              case 2:
                throw new Error(i);
            }
          },
          ecdsaRecover: function ecdsaRecover(r, n, i) {
            var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !0;
            var h = arguments.length > 4 ? arguments[4] : undefined;

            switch (s("signature", r, 64), c("Number" === u(n) && n >= 0 && n <= 3, "Expected recovery id to be a Number within interval [0, 3]"), s("message", i, 32), f(o), h = d(h, o ? 33 : 65), e.ecdsaRecover(h, r, n, i)) {
              case 0:
                return h;

              case 1:
                throw new Error(a);

              case 2:
                throw new Error("Public key could not be recover");

              case 3:
                throw new Error(t);
            }
          },
          ecdh: function ecdh(t, r) {
            var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            var o = arguments.length > 3 ? arguments[3] : undefined;

            switch (s("public key", t, [33, 65]), s("private key", r, 32), c("Object" === u(n), "Expected options to be an Object"), void 0 !== n.data && s("options.data", n.data), void 0 !== n.hashfn ? (c("Function" === u(n.hashfn), "Expected options.hashfn to be a Function"), void 0 !== n.xbuf && s("options.xbuf", n.xbuf, 32), void 0 !== n.ybuf && s("options.ybuf", n.ybuf, 32), s("output", o)) : o = d(o, 32), e.ecdh(o, t, r, n.data, n.hashfn, n.xbuf, n.ybuf)) {
              case 0:
                return o;

              case 1:
                throw new Error(i);

              case 2:
                throw new Error("Scalar was invalid (zero or overflow)");
            }
          }
        };
      };
    },
    2553: function _(e, t, r) {
      "use strict";

      var n = r(9509).Buffer,
          i = n.isEncoding || function (e) {
        switch ((e = "" + e) && e.toLowerCase()) {
          case "hex":
          case "utf8":
          case "utf-8":
          case "ascii":
          case "binary":
          case "base64":
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
          case "raw":
            return !0;

          default:
            return !1;
        }
      };

      function o(e) {
        var t;

        switch (this.encoding = function (e) {
          var t = function (e) {
            if (!e) return "utf8";

            for (var t;;) {
              switch (e) {
                case "utf8":
                case "utf-8":
                  return "utf8";

                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                  return "utf16le";

                case "latin1":
                case "binary":
                  return "latin1";

                case "base64":
                case "ascii":
                case "hex":
                  return e;

                default:
                  if (t) return;
                  e = ("" + e).toLowerCase(), t = !0;
              }
            }
          }(e);

          if ("string" != typeof t && (n.isEncoding === i || !i(e))) throw new Error("Unknown encoding: " + e);
          return t || e;
        }(e), this.encoding) {
          case "utf16le":
            this.text = s, this.end = f, t = 4;
            break;

          case "utf8":
            this.fillLast = c, t = 4;
            break;

          case "base64":
            this.text = d, this.end = u, t = 3;
            break;

          default:
            return this.write = h, void (this.end = l);
        }

        this.lastNeed = 0, this.lastTotal = 0, this.lastChar = n.allocUnsafe(t);
      }

      function a(e) {
        return e <= 127 ? 0 : e >> 5 == 6 ? 2 : e >> 4 == 14 ? 3 : e >> 3 == 30 ? 4 : e >> 6 == 2 ? -1 : -2;
      }

      function c(e) {
        var t = this.lastTotal - this.lastNeed,
            r = function (e, t, r) {
          if (128 != (192 & t[0])) return e.lastNeed = 0, "�";

          if (e.lastNeed > 1 && t.length > 1) {
            if (128 != (192 & t[1])) return e.lastNeed = 1, "�";
            if (e.lastNeed > 2 && t.length > 2 && 128 != (192 & t[2])) return e.lastNeed = 2, "�";
          }
        }(this, e);

        return void 0 !== r ? r : this.lastNeed <= e.length ? (e.copy(this.lastChar, t, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal)) : (e.copy(this.lastChar, t, 0, e.length), void (this.lastNeed -= e.length));
      }

      function s(e, t) {
        if ((e.length - t) % 2 == 0) {
          var r = e.toString("utf16le", t);

          if (r) {
            var n = r.charCodeAt(r.length - 1);
            if (n >= 55296 && n <= 56319) return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = e[e.length - 2], this.lastChar[1] = e[e.length - 1], r.slice(0, -1);
          }

          return r;
        }

        return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = e[e.length - 1], e.toString("utf16le", t, e.length - 1);
      }

      function f(e) {
        var t = e && e.length ? this.write(e) : "";

        if (this.lastNeed) {
          var r = this.lastTotal - this.lastNeed;
          return t + this.lastChar.toString("utf16le", 0, r);
        }

        return t;
      }

      function d(e, t) {
        var r = (e.length - t) % 3;
        return 0 === r ? e.toString("base64", t) : (this.lastNeed = 3 - r, this.lastTotal = 3, 1 === r ? this.lastChar[0] = e[e.length - 1] : (this.lastChar[0] = e[e.length - 2], this.lastChar[1] = e[e.length - 1]), e.toString("base64", t, e.length - r));
      }

      function u(e) {
        var t = e && e.length ? this.write(e) : "";
        return this.lastNeed ? t + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : t;
      }

      function h(e) {
        return e.toString(this.encoding);
      }

      function l(e) {
        return e && e.length ? this.write(e) : "";
      }

      t.s = o, o.prototype.write = function (e) {
        if (0 === e.length) return "";
        var t, r;

        if (this.lastNeed) {
          if (void 0 === (t = this.fillLast(e))) return "";
          r = this.lastNeed, this.lastNeed = 0;
        } else r = 0;

        return r < e.length ? t ? t + this.text(e, r) : this.text(e, r) : t || "";
      }, o.prototype.end = function (e) {
        var t = e && e.length ? this.write(e) : "";
        return this.lastNeed ? t + "�" : t;
      }, o.prototype.text = function (e, t) {
        var r = function (e, t, r) {
          var n = t.length - 1;
          if (n < r) return 0;
          var i = a(t[n]);
          return i >= 0 ? (i > 0 && (e.lastNeed = i - 1), i) : --n < r || -2 === i ? 0 : (i = a(t[n])) >= 0 ? (i > 0 && (e.lastNeed = i - 2), i) : --n < r || -2 === i ? 0 : (i = a(t[n])) >= 0 ? (i > 0 && (2 === i ? i = 0 : e.lastNeed = i - 3), i) : 0;
        }(this, e, t);

        if (!this.lastNeed) return e.toString("utf8", t);
        this.lastTotal = r;
        var n = e.length - (r - this.lastNeed);
        return e.copy(this.lastChar, 0, n), e.toString("utf8", t, n);
      }, o.prototype.fillLast = function (e) {
        if (this.lastNeed <= e.length) return e.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
        e.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, e.length), this.lastNeed -= e.length;
      };
    },
    7307: function _(e, t, r) {
      "use strict";

      var n = this && this.__assign || function () {
        return n = Object.assign || function (e) {
          for (var t, r = 1, n = arguments.length; r < n; r++) {
            for (var i in t = arguments[r]) {
              Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
            }
          }

          return e;
        }, n.apply(this, arguments);
      },
          i = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.chainToTestnetTokenAddressMap = t.chainToTokenAddressMap = t.testnetErc20Assets = t.erc20Assets = void 0;
      var o = r(6486),
          a = i(r(7956)),
          c = i(r(5285)),
          s = i(r(560)),
          f = i(r(6935)),
          d = i(r(5078)),
          u = r(3280),
          h = r(9699),
          l = (0, o.mapValues)(c.default, function (e) {
        return n(n({}, e), {
          chain: h.ChainId.Rootstock
        });
      }),
          p = (0, o.mapValues)(a.default, function (e) {
        return n(n({}, e), {
          chain: h.ChainId.Ethereum
        });
      }),
          m = (0, o.mapValues)(s.default, function (e) {
        return n(n({}, e), {
          chain: h.ChainId.Polygon
        });
      }),
          b = (0, o.mapValues)(f.default, function (e) {
        return n(n({}, e), {
          chain: h.ChainId.Avalanche
        });
      }),
          g = (0, o.mapValues)(d.default, function (e) {
        return n(n({}, e), {
          chain: h.ChainId.Terra
        });
      }),
          v = (0, o.mapValues)(n(n(n(n(n({}, l), p), m), g), b), function (e) {
        return n(n({}, e), {
          type: "erc20"
        });
      });
      t.erc20Assets = v;
      var y = u.TESTNET_TOKENS.reduce(function (e, t) {
        var r;
        return Object.assign(e, ((r = {})[t] = n(n({}, v[t]), {
          contractAddress: u.TESTNET_CONTRACT_ADDRESSES[t]
        }), r));
      }, {});
      t.testnetErc20Assets = y;

      var w = function w(e) {
        return (0, o.transform)(e, function (e, t) {
          var r;
          return t.chain && (e[t.chain] = n(n({}, e[t.chain]), ((r = {})[t.contractAddress] = t, r)));
        });
      },
          A = w(v);

      t.chainToTokenAddressMap = A;

      var _ = w(y);

      t.chainToTestnetTokenAddressMap = _;
    },
    9633: function _(e, t, r) {
      "use strict";

      var n = this && this.__assign || function () {
        return n = Object.assign || function (e) {
          for (var t, r = 1, n = arguments.length; r < n; r++) {
            for (var i in t = arguments[r]) {
              Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
            }
          }

          return e;
        }, n.apply(this, arguments);
      };

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.chainToTestnetTokenAddressMap = t.chainToTokenAddressMap = t.testnetAssets = t.assets = void 0;
      var i = r(514),
          o = r(7307);
      Object.defineProperty(t, "chainToTokenAddressMap", {
        enumerable: !0,
        get: function get() {
          return o.chainToTokenAddressMap;
        }
      }), Object.defineProperty(t, "chainToTestnetTokenAddressMap", {
        enumerable: !0,
        get: function get() {
          return o.chainToTestnetTokenAddressMap;
        }
      });
      var a = n(n({}, i.nativeAssets), o.erc20Assets);
      t.assets = a;
      var c = n(n({}, i.testnetNativeAssets), o.testnetErc20Assets);
      t.testnetAssets = c;
    },
    514: function _(e, t, r) {
      "use strict";

      var n = this && this.__assign || function () {
        return n = Object.assign || function (e) {
          for (var t, r = 1, n = arguments.length; r < n; r++) {
            for (var i in t = arguments[r]) {
              Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
            }
          }

          return e;
        }, n.apply(this, arguments);
      };

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.testnetNativeAssets = t.nativeAssets = void 0;
      var i = r(3280),
          o = r(9699),
          a = {
        BTC: {
          name: "Bitcoin",
          chain: o.ChainId.Bitcoin,
          type: "native",
          code: "BTC",
          coinGeckoId: "bitcoin",
          color: "#f7931a",
          decimals: 8
        },
        BCH: {
          name: "Bitcoin Cash",
          chain: o.ChainId.BitcoinCash,
          type: "native",
          code: "BCH",
          coinGeckoId: "bitcoin-cash",
          color: "#a1db5e",
          decimals: 8
        },
        ETH: {
          name: "Ether",
          chain: o.ChainId.Ethereum,
          type: "native",
          code: "ETH",
          coinGeckoId: "ethereum",
          color: "#627eea",
          decimals: 18
        },
        RBTC: {
          name: "Rootstock BTC",
          chain: o.ChainId.Rootstock,
          type: "native",
          code: "RBTC",
          coinGeckoId: "rootstock",
          color: "#006e3c",
          decimals: 18
        },
        BNB: {
          name: "Binance Coin",
          chain: o.ChainId.BinanceSmartChain,
          type: "native",
          code: "BNB",
          coinGeckoId: "binancecoin",
          color: "#f9a825",
          decimals: 18
        },
        NEAR: {
          name: "Near",
          chain: o.ChainId.Near,
          type: "native",
          code: "NEAR",
          coinGeckoId: "near",
          color: "#000000",
          decimals: 24
        },
        SOL: {
          name: "Solana",
          chain: o.ChainId.Solana,
          type: "native",
          code: "SOL",
          coinGeckoId: "solana",
          color: "#008080",
          decimals: 9
        },
        MATIC: {
          name: "Matic",
          chain: o.ChainId.Polygon,
          type: "native",
          code: "MATIC",
          coinGeckoId: "matic-network",
          color: "#8247E5",
          decimals: 18
        },
        ARBETH: {
          name: "Arbitrum ETH",
          chain: o.ChainId.Arbitrum,
          type: "native",
          code: "ARBETH",
          coinGeckoId: "ethereum",
          color: "#28A0EF",
          decimals: 18,
          matchingAsset: "ETH"
        },
        FUSE: {
          name: "Fuse Network",
          chain: o.ChainId.Fuse,
          type: "native",
          code: "FUSE",
          coinGeckoId: "fuse-network-token",
          color: "#46e8b6",
          decimals: 18
        },
        LUNA: {
          name: "Luna",
          chain: o.ChainId.Terra,
          type: "native",
          code: "LUNA",
          coinGeckoId: "terra-luna",
          color: "#008080",
          decimals: 6
        },
        UST: {
          name: "TerraUSD",
          chain: o.ChainId.Terra,
          type: "native",
          code: "UST",
          decimals: 6,
          color: "#0083ff",
          coinGeckoId: "terrausd",
          feeAsset: "UST"
        },
        AVAX: {
          name: "Avalanche",
          chain: o.ChainId.Avalanche,
          type: "native",
          code: "AVAX",
          coinGeckoId: "avalanche-2",
          color: "#E84141",
          decimals: 18
        }
      };
      t.nativeAssets = a;
      var c = i.TESTNET_NATIVE.reduce(function (e, t) {
        var r;
        return Object.assign(e, ((r = {})[t] = n({}, a[t]), r));
      }, {});
      t.testnetNativeAssets = c;
    },
    3280: function _(e, t) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.TESTNET_NATIVE = t.TESTNET_TOKENS = t.TESTNET_CONTRACT_ADDRESSES = void 0, t.TESTNET_CONTRACT_ADDRESSES = {
        DAI: "0xad6d458402f60fd3bd25163575031acdce07538d",
        WBTC: "0x1371597fc11aedbd2446f5390fa1dbf22491752a",
        SOV: "0x6a9A07972D07E58f0daF5122D11e069288A375fB",
        PWETH: "0xA6FA4fB5f76172d178d61B04b0ecd319C5d1C0aa",
        SUSHI: "0x0769fd68dFb93167989C6f7254cd0D766Fb2841F"
      }, t.TESTNET_TOKENS = Object.keys(t.TESTNET_CONTRACT_ADDRESSES), t.TESTNET_NATIVE = ["BTC", "ETH", "RBTC", "BNB", "NEAR", "MATIC", "ARBETH", "SOL", "LUNA", "UST", "FUSE", "AVAX"];
    },
    6550: function _(e, t, r) {
      "use strict";

      var n,
          i = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.isEthereumChain = t.chains = void 0;
      var o = r(1964),
          a = i(r(9918)),
          c = r(9699),
          s = r(3200),
          f = ((n = {})[c.ChainId.Bitcoin] = {
        name: "Bitcoin",
        code: "BTC",
        nativeAsset: "BTC",
        fees: {
          unit: "sat/b"
        },
        safeConfirmations: 1,
        txFailureTimeout: 108e5,
        isValidAddress: function isValidAddress(e) {
          return !!(0, a.default)(e);
        },
        formatAddress: function formatAddress(e) {
          return e;
        },
        isValidTransactionHash: function isValidTransactionHash(e) {
          return (0, s.isValidHex)(e);
        },
        formatTransactionHash: function formatTransactionHash(e) {
          return (0, s.toLowerCaseWithout0x)(e);
        }
      }, n[c.ChainId.BitcoinCash] = {
        name: "Bitcoin Cash",
        code: "BCH",
        nativeAsset: "BCH",
        fees: {
          unit: "sat/b"
        },
        safeConfirmations: 1,
        txFailureTimeout: 108e5,
        isValidAddress: function isValidAddress(e) {
          return (0, s.isValidBitcoinCashAddress)(e);
        },
        formatAddress: function formatAddress(e) {
          return (0, s.formatBitcoinCashAddress)(e);
        },
        isValidTransactionHash: function isValidTransactionHash(e) {
          return (0, s.isValidHex)(e);
        },
        formatTransactionHash: function formatTransactionHash(e) {
          return (0, s.toLowerCaseWithout0x)(e);
        }
      }, n[c.ChainId.Ethereum] = {
        name: "Ethereum",
        code: "ETH",
        nativeAsset: "ETH",
        fees: {
          unit: "gwei"
        },
        safeConfirmations: 3,
        txFailureTimeout: 18e5,
        isValidAddress: function isValidAddress(e) {
          return (0, o.isValidAddress)((0, s.with0x)(e));
        },
        formatAddress: function formatAddress(e) {
          return (0, o.toChecksumAddress)((0, s.with0x)(e));
        },
        isValidTransactionHash: function isValidTransactionHash(e) {
          return (0, s.isValidHex)(e);
        },
        formatTransactionHash: function formatTransactionHash(e) {
          return (0, s.toLowerCaseWithout0x)(e);
        }
      }, n[c.ChainId.Rootstock] = {
        name: "Rootstock",
        code: "RSK",
        nativeAsset: "RBTC",
        fees: {
          unit: "gwei"
        },
        safeConfirmations: 5,
        txFailureTimeout: 18e5,
        isValidAddress: function isValidAddress(e) {
          return (0, o.isValidAddress)((0, s.with0x)(e));
        },
        formatAddress: function formatAddress(e, t) {
          return (0, o.toChecksumAddress)((0, s.with0x)(e), (0, s.getRSKChainID)(t));
        },
        isValidTransactionHash: function isValidTransactionHash(e) {
          return (0, s.isValidHex)(e);
        },
        formatTransactionHash: function formatTransactionHash(e) {
          return (0, s.toLowerCaseWithout0x)(e);
        }
      }, n[c.ChainId.BinanceSmartChain] = {
        name: "Binance Smart Chain",
        code: "BSC",
        nativeAsset: "BNB",
        fees: {
          unit: "gwei"
        },
        safeConfirmations: 5,
        txFailureTimeout: 6e5,
        isValidAddress: function isValidAddress(e) {
          return (0, o.isValidAddress)((0, s.with0x)(e));
        },
        formatAddress: function formatAddress(e) {
          return (0, o.toChecksumAddress)((0, s.with0x)(e));
        },
        isValidTransactionHash: function isValidTransactionHash(e) {
          return (0, s.isValidHex)(e);
        },
        formatTransactionHash: function formatTransactionHash(e) {
          return (0, s.toLowerCaseWithout0x)(e);
        }
      }, n[c.ChainId.Near] = {
        name: "Near",
        code: "NEAR",
        nativeAsset: "NEAR",
        fees: {
          unit: "TGas"
        },
        safeConfirmations: 10,
        txFailureTimeout: 3e5,
        isValidAddress: function isValidAddress(e) {
          return (0, s.isValidNearAddress)(e);
        },
        formatAddress: function formatAddress(e) {
          return e;
        },
        isValidTransactionHash: function isValidTransactionHash(e) {
          return (0, s.isValidNearTx)(e);
        },
        formatTransactionHash: function formatTransactionHash(e) {
          return e;
        }
      }, n[c.ChainId.Solana] = {
        name: "Solana",
        code: "SOL",
        nativeAsset: "SOL",
        fees: {
          unit: "Lamports"
        },
        safeConfirmations: 31,
        txFailureTimeout: 3e5,
        isValidAddress: function isValidAddress(e) {
          return (0, s.isValidSolanaAddress)(e);
        },
        formatAddress: function formatAddress(e) {
          return e;
        },
        isValidTransactionHash: function isValidTransactionHash(e) {
          return (0, s.isValidSolanaTx)(e);
        },
        formatTransactionHash: function formatTransactionHash(e) {
          return e;
        }
      }, n[c.ChainId.Terra] = {
        name: "Terra",
        code: "LUNA",
        nativeAsset: "LUNA",
        fees: {
          unit: "LUNA"
        },
        safeConfirmations: 1,
        txFailureTimeout: 9e5,
        isValidAddress: function isValidAddress(e) {
          return (0, s.isValidTerraAddress)(e);
        },
        formatAddress: function formatAddress(e) {
          return e;
        },
        isValidTransactionHash: function isValidTransactionHash(e) {
          return (0, s.isValidTerraTx)(e);
        },
        formatTransactionHash: function formatTransactionHash(e) {
          return e;
        }
      }, n[c.ChainId.Polygon] = {
        name: "Polygon",
        code: "POLYGON",
        nativeAsset: "MATIC",
        fees: {
          unit: "gwei"
        },
        safeConfirmations: 5,
        txFailureTimeout: 6e5,
        isValidAddress: function isValidAddress(e) {
          return (0, o.isValidAddress)((0, s.with0x)(e));
        },
        formatAddress: function formatAddress(e) {
          return (0, o.toChecksumAddress)((0, s.with0x)(e));
        },
        isValidTransactionHash: function isValidTransactionHash(e) {
          return (0, s.isValidHex)(e);
        },
        formatTransactionHash: function formatTransactionHash(e) {
          return (0, s.toLowerCaseWithout0x)(e);
        }
      }, n[c.ChainId.Arbitrum] = {
        name: "Arbitrum",
        code: "ARBITRUM",
        nativeAsset: "ARBETH",
        fees: {
          unit: "gwei"
        },
        safeConfirmations: 5,
        txFailureTimeout: 6e5,
        isValidAddress: function isValidAddress(e) {
          return (0, o.isValidAddress)((0, s.with0x)(e));
        },
        formatAddress: function formatAddress(e) {
          return (0, o.toChecksumAddress)((0, s.with0x)(e));
        },
        isValidTransactionHash: function isValidTransactionHash(e) {
          return (0, s.isValidHex)(e);
        },
        formatTransactionHash: function formatTransactionHash(e) {
          return (0, s.toLowerCaseWithout0x)(e);
        }
      }, n[c.ChainId.Fuse] = {
        name: "Fuse",
        code: "FUSE",
        nativeAsset: "FUSE",
        fees: {
          unit: "gwei"
        },
        safeConfirmations: 5,
        txFailureTimeout: 9e5,
        isValidAddress: function isValidAddress(e) {
          return (0, o.isValidAddress)((0, s.with0x)(e));
        },
        formatAddress: function formatAddress(e) {
          return (0, o.toChecksumAddress)((0, s.with0x)(e));
        },
        isValidTransactionHash: function isValidTransactionHash(e) {
          return (0, s.isValidHex)(e);
        },
        formatTransactionHash: function formatTransactionHash(e) {
          return (0, s.toLowerCaseWithout0x)(e);
        }
      }, n[c.ChainId.Avalanche] = {
        name: "Avalanche",
        code: "AVALANCHE",
        nativeAsset: "AVAX",
        fees: {
          unit: "gwei"
        },
        safeConfirmations: 5,
        txFailureTimeout: 6e5,
        isValidAddress: function isValidAddress(e) {
          return (0, o.isValidAddress)((0, s.with0x)(e));
        },
        formatAddress: function formatAddress(e) {
          return (0, o.toChecksumAddress)((0, s.with0x)(e));
        },
        isValidTransactionHash: function isValidTransactionHash(e) {
          return (0, s.isValidHex)(e);
        },
        formatTransactionHash: function formatTransactionHash(e) {
          return e;
        }
      }, n);
      t.chains = f, t.isEthereumChain = function (e) {
        return [c.ChainId.BinanceSmartChain, c.ChainId.Ethereum, c.ChainId.Rootstock, c.ChainId.Polygon, c.ChainId.Avalanche, c.ChainId.Arbitrum, c.ChainId.Fuse].includes(e);
      };
    },
    3200: function _(e, t, r) {
      "use strict";

      var n = this && this.__createBinding || (Object.create ? function (e, t, r, n) {
        void 0 === n && (n = r), Object.defineProperty(e, n, {
          enumerable: !0,
          get: function get() {
            return t[r];
          }
        });
      } : function (e, t, r, n) {
        void 0 === n && (n = r), e[n] = t[r];
      }),
          i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
          o = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var r in e) {
          "default" !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
        }
        return i(t, e), t;
      },
          a = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.getRSKChainID = t.isValidTerraTx = t.isValidTerraAddress = t.isValidSolanaTx = t.isValidSolanaAddress = t.formatBitcoinCashAddress = t.isValidBitcoinCashAddress = t.isValidNearTx = t.isValidNearAddress = t.with0x = t.toLowerCaseWithout0x = t.isValidHex = void 0;
      var c = a(r(7191)),
          s = o(r(7707));
      t.isValidHex = function (e) {
        return /^([A-Fa-f0-9]{64})$/.test(e);
      }, t.toLowerCaseWithout0x = function (e) {
        return e.toLowerCase().replace(/0x/g, "");
      }, t.with0x = function (e) {
        return e.startsWith("0x") ? e : "0x" + e;
      }, t.isValidNearAddress = function (e) {
        return e.endsWith(".near") || /^[0-9a-fA-F]{64}$/.test(e);
      }, t.isValidNearTx = function (e) {
        try {
          var r = e.split("_"),
              n = r[0],
              i = r[1];
          return 32 === c.default.decode(n).length && (0, t.isValidNearAddress)(i);
        } catch (e) {
          return !1;
        }
      }, t.isValidBitcoinCashAddress = function (e) {
        try {
          e.includes(":") || (e = "bitcoincash:" + e);
          var t = s.decode(e),
              r = t.prefix,
              n = t.type,
              i = t.hash;
          return !["bitcoincash", "bchtest", "bchreg"].includes(r) && !["P2PKH", "P2SH"].includes(n) && 20 == i.length;
        } catch (e) {
          return !1;
        }
      }, t.formatBitcoinCashAddress = function (e) {
        return (e = e.toLowerCase()).startsWith("bitcoincash:") && (e = e.slice(12)), e;
      }, t.isValidSolanaAddress = function (e) {
        return "string" == typeof e && e.length >= 32 && e.length <= 44;
      }, t.isValidSolanaTx = function (e) {
        return !0;
      }, t.isValidTerraAddress = function (e) {
        return 44 === e.length;
      }, t.isValidTerraTx = function (e) {
        return "string" == typeof e && 64 === e.length;
      }, t.getRSKChainID = function (e) {
        return "mainnet" == e ? 30 : "testnet" == e ? 31 : void 0;
      };
    },
    6665: function _(e, t, r) {
      "use strict";

      var n = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.dappChains = void 0;
      var i = n(r(9745)).default;
      t.dappChains = i;
    },
    3607: function _(e, t, r) {
      "use strict";

      var n = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.ChainId = t.currencyToUnit = t.unitToCurrency = t.isEthereumChain = t.dappChains = t.chains = t.chainToTestnetTokenAddressMap = t.testnetAssets = t.chainToTokenAddressMap = t.assets = void 0;
      var i = n(r(794)),
          o = r(9633);
      Object.defineProperty(t, "assets", {
        enumerable: !0,
        get: function get() {
          return o.assets;
        }
      }), Object.defineProperty(t, "testnetAssets", {
        enumerable: !0,
        get: function get() {
          return o.testnetAssets;
        }
      }), Object.defineProperty(t, "chainToTokenAddressMap", {
        enumerable: !0,
        get: function get() {
          return o.chainToTokenAddressMap;
        }
      }), Object.defineProperty(t, "chainToTestnetTokenAddressMap", {
        enumerable: !0,
        get: function get() {
          return o.chainToTestnetTokenAddressMap;
        }
      });
      var a = r(6550);
      Object.defineProperty(t, "chains", {
        enumerable: !0,
        get: function get() {
          return a.chains;
        }
      }), Object.defineProperty(t, "isEthereumChain", {
        enumerable: !0,
        get: function get() {
          return a.isEthereumChain;
        }
      });
      var c = r(6665);
      Object.defineProperty(t, "dappChains", {
        enumerable: !0,
        get: function get() {
          return c.dappChains;
        }
      });
      var s = r(9699);
      Object.defineProperty(t, "ChainId", {
        enumerable: !0,
        get: function get() {
          return s.ChainId;
        }
      }), t.unitToCurrency = function (e, t) {
        var r = new i.default(10).pow(e.decimals);
        return new i.default(t).dividedBy(r);
      }, t.currencyToUnit = function (e, t) {
        var r = new i.default(10).pow(e.decimals);
        return new i.default(t).times(r);
      };
    },
    9699: function _(e, t) {
      "use strict";

      var r;
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.ChainId = void 0, (r = t.ChainId || (t.ChainId = {})).Bitcoin = "bitcoin", r.BitcoinCash = "bitcoin_cash", r.Ethereum = "ethereum", r.Rootstock = "rsk", r.BinanceSmartChain = "bsc", r.Near = "near", r.Polygon = "polygon", r.Arbitrum = "arbitrum", r.Solana = "solana", r.Fuse = "fuse", r.Terra = "terra", r.Avalanche = "avalanche";
    },
    1159: function _(e, t, r) {
      e.exports = r(3837).deprecate;
    },
    9491: function _(e) {
      "use strict";

      e.exports = require("assert");
    },
    4300: function _(e) {
      "use strict";

      e.exports = require("buffer");
    },
    6113: function _(e) {
      "use strict";

      e.exports = require("crypto");
    },
    2361: function _(e) {
      "use strict";

      e.exports = require("events");
    },
    7147: function _(e) {
      "use strict";

      e.exports = require("fs");
    },
    2037: function _(e) {
      "use strict";

      e.exports = require("os");
    },
    1017: function _(e) {
      "use strict";

      e.exports = require("path");
    },
    2781: function _(e) {
      "use strict";

      e.exports = require("stream");
    },
    3837: function _(e) {
      "use strict";

      e.exports = require("util");
    },
    794: function _(e, t, r) {
      "use strict";

      r.r(t), r.d(t, {
        BigNumber: function BigNumber() {
          return A;
        },
        default: function _default() {
          return _;
        }
      });
      var n = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i,
          i = Math.ceil,
          o = Math.floor,
          a = "[BigNumber Error] ",
          c = a + "Number primitive has more than 15 significant digits: ",
          s = 1e14,
          f = 14,
          d = 9007199254740991,
          u = [1, 10, 100, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8, 1e9, 1e10, 1e11, 1e12, 1e13],
          h = 1e7,
          l = 1e9;

      function p(e) {
        var t = 0 | e;
        return e > 0 || e === t ? t : t - 1;
      }

      function m(e) {
        for (var t, r, n = 1, i = e.length, o = e[0] + ""; n < i;) {
          for (t = e[n++] + "", r = f - t.length; r--; t = "0" + t) {
            ;
          }

          o += t;
        }

        for (i = o.length; 48 === o.charCodeAt(--i);) {
          ;
        }

        return o.slice(0, i + 1 || 1);
      }

      function b(e, t) {
        var r,
            n,
            i = e.c,
            o = t.c,
            a = e.s,
            c = t.s,
            s = e.e,
            f = t.e;
        if (!a || !c) return null;
        if (r = i && !i[0], n = o && !o[0], r || n) return r ? n ? 0 : -c : a;
        if (a != c) return a;
        if (r = a < 0, n = s == f, !i || !o) return n ? 0 : !i ^ r ? 1 : -1;
        if (!n) return s > f ^ r ? 1 : -1;

        for (c = (s = i.length) < (f = o.length) ? s : f, a = 0; a < c; a++) {
          if (i[a] != o[a]) return i[a] > o[a] ^ r ? 1 : -1;
        }

        return s == f ? 0 : s > f ^ r ? 1 : -1;
      }

      function g(e, t, r, n) {
        if (e < t || e > r || e !== o(e)) throw Error(a + (n || "Argument") + ("number" == typeof e ? e < t || e > r ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(e));
      }

      function v(e) {
        var t = e.c.length - 1;
        return p(e.e / f) == t && e.c[t] % 2 != 0;
      }

      function y(e, t) {
        return (e.length > 1 ? e.charAt(0) + "." + e.slice(1) : e) + (t < 0 ? "e" : "e+") + t;
      }

      function w(e, t, r) {
        var n, i;

        if (t < 0) {
          for (i = r + "."; ++t; i += r) {
            ;
          }

          e = i + e;
        } else if (++t > (n = e.length)) {
          for (i = r, t -= n; --t; i += r) {
            ;
          }

          e += i;
        } else t < n && (e = e.slice(0, t) + "." + e.slice(t));

        return e;
      }

      var A = function e(t) {
        var r,
            A,
            _,
            M,
            x,
            k,
            E,
            S,
            I,
            C,
            T = H.prototype = {
          constructor: H,
          toString: null,
          valueOf: null
        },
            B = new H(1),
            D = 20,
            N = 4,
            R = -7,
            O = 21,
            P = -1e7,
            F = 1e7,
            L = !1,
            G = 1,
            j = 0,
            z = {
          prefix: "",
          groupSize: 3,
          secondaryGroupSize: 0,
          groupSeparator: ",",
          decimalSeparator: ".",
          fractionGroupSize: 0,
          fractionGroupSeparator: " ",
          suffix: ""
        },
            q = "0123456789abcdefghijklmnopqrstuvwxyz",
            U = !0;

        function H(e, t) {
          var r,
              i,
              a,
              s,
              u,
              h,
              l,
              p,
              m = this;
          if (!(m instanceof H)) return new H(e, t);

          if (null == t) {
            if (e && !0 === e._isBigNumber) return m.s = e.s, void (!e.c || e.e > F ? m.c = m.e = null : e.e < P ? m.c = [m.e = 0] : (m.e = e.e, m.c = e.c.slice()));

            if ((h = "number" == typeof e) && 0 * e == 0) {
              if (m.s = 1 / e < 0 ? (e = -e, -1) : 1, e === ~~e) {
                for (s = 0, u = e; u >= 10; u /= 10, s++) {
                  ;
                }

                return void (s > F ? m.c = m.e = null : (m.e = s, m.c = [e]));
              }

              p = String(e);
            } else {
              if (!n.test(p = String(e))) return _(m, p, h);
              m.s = 45 == p.charCodeAt(0) ? (p = p.slice(1), -1) : 1;
            }

            (s = p.indexOf(".")) > -1 && (p = p.replace(".", "")), (u = p.search(/e/i)) > 0 ? (s < 0 && (s = u), s += +p.slice(u + 1), p = p.substring(0, u)) : s < 0 && (s = p.length);
          } else {
            if (g(t, 2, q.length, "Base"), 10 == t && U) return X(m = new H(e), D + m.e + 1, N);

            if (p = String(e), h = "number" == typeof e) {
              if (0 * e != 0) return _(m, p, h, t);
              if (m.s = 1 / e < 0 ? (p = p.slice(1), -1) : 1, H.DEBUG && p.replace(/^0\.0*|\./, "").length > 15) throw Error(c + e);
            } else m.s = 45 === p.charCodeAt(0) ? (p = p.slice(1), -1) : 1;

            for (r = q.slice(0, t), s = u = 0, l = p.length; u < l; u++) {
              if (r.indexOf(i = p.charAt(u)) < 0) {
                if ("." == i) {
                  if (u > s) {
                    s = l;
                    continue;
                  }
                } else if (!a && (p == p.toUpperCase() && (p = p.toLowerCase()) || p == p.toLowerCase() && (p = p.toUpperCase()))) {
                  a = !0, u = -1, s = 0;
                  continue;
                }

                return _(m, String(e), h, t);
              }
            }

            h = !1, (s = (p = A(p, t, 10, m.s)).indexOf(".")) > -1 ? p = p.replace(".", "") : s = p.length;
          }

          for (u = 0; 48 === p.charCodeAt(u); u++) {
            ;
          }

          for (l = p.length; 48 === p.charCodeAt(--l);) {
            ;
          }

          if (p = p.slice(u, ++l)) {
            if (l -= u, h && H.DEBUG && l > 15 && (e > d || e !== o(e))) throw Error(c + m.s * e);
            if ((s = s - u - 1) > F) m.c = m.e = null;else if (s < P) m.c = [m.e = 0];else {
              if (m.e = s, m.c = [], u = (s + 1) % f, s < 0 && (u += f), u < l) {
                for (u && m.c.push(+p.slice(0, u)), l -= f; u < l;) {
                  m.c.push(+p.slice(u, u += f));
                }

                u = f - (p = p.slice(u)).length;
              } else u -= l;

              for (; u--; p += "0") {
                ;
              }

              m.c.push(+p);
            }
          } else m.c = [m.e = 0];
        }

        function K(e, t, r, n) {
          var i, o, a, c, s;
          if (null == r ? r = N : g(r, 0, 8), !e.c) return e.toString();
          if (i = e.c[0], a = e.e, null == t) s = m(e.c), s = 1 == n || 2 == n && (a <= R || a >= O) ? y(s, a) : w(s, a, "0");else if (o = (e = X(new H(e), t, r)).e, c = (s = m(e.c)).length, 1 == n || 2 == n && (t <= o || o <= R)) {
            for (; c < t; s += "0", c++) {
              ;
            }

            s = y(s, o);
          } else if (t -= a, s = w(s, o, "0"), o + 1 > c) {
            if (--t > 0) for (s += "."; t--; s += "0") {
              ;
            }
          } else if ((t += o - c) > 0) for (o + 1 == c && (s += "."); t--; s += "0") {
            ;
          }
          return e.s < 0 && i ? "-" + s : s;
        }

        function V(e, t) {
          for (var r, n = 1, i = new H(e[0]); n < e.length; n++) {
            if (!(r = new H(e[n])).s) {
              i = r;
              break;
            }

            t.call(i, r) && (i = r);
          }

          return i;
        }

        function W(e, t, r) {
          for (var n = 1, i = t.length; !t[--i]; t.pop()) {
            ;
          }

          for (i = t[0]; i >= 10; i /= 10, n++) {
            ;
          }

          return (r = n + r * f - 1) > F ? e.c = e.e = null : r < P ? e.c = [e.e = 0] : (e.e = r, e.c = t), e;
        }

        function X(e, t, r, n) {
          var a,
              c,
              d,
              h,
              l,
              p,
              m,
              b = e.c,
              g = u;

          if (b) {
            e: {
              for (a = 1, h = b[0]; h >= 10; h /= 10, a++) {
                ;
              }

              if ((c = t - a) < 0) c += f, d = t, m = (l = b[p = 0]) / g[a - d - 1] % 10 | 0;else if ((p = i((c + 1) / f)) >= b.length) {
                if (!n) break e;

                for (; b.length <= p; b.push(0)) {
                  ;
                }

                l = m = 0, a = 1, d = (c %= f) - f + 1;
              } else {
                for (l = h = b[p], a = 1; h >= 10; h /= 10, a++) {
                  ;
                }

                m = (d = (c %= f) - f + a) < 0 ? 0 : l / g[a - d - 1] % 10 | 0;
              }
              if (n = n || t < 0 || null != b[p + 1] || (d < 0 ? l : l % g[a - d - 1]), n = r < 4 ? (m || n) && (0 == r || r == (e.s < 0 ? 3 : 2)) : m > 5 || 5 == m && (4 == r || n || 6 == r && (c > 0 ? d > 0 ? l / g[a - d] : 0 : b[p - 1]) % 10 & 1 || r == (e.s < 0 ? 8 : 7)), t < 1 || !b[0]) return b.length = 0, n ? (t -= e.e + 1, b[0] = g[(f - t % f) % f], e.e = -t || 0) : b[0] = e.e = 0, e;
              if (0 == c ? (b.length = p, h = 1, p--) : (b.length = p + 1, h = g[f - c], b[p] = d > 0 ? o(l / g[a - d] % g[d]) * h : 0), n) for (;;) {
                if (0 == p) {
                  for (c = 1, d = b[0]; d >= 10; d /= 10, c++) {
                    ;
                  }

                  for (d = b[0] += h, h = 1; d >= 10; d /= 10, h++) {
                    ;
                  }

                  c != h && (e.e++, b[0] == s && (b[0] = 1));
                  break;
                }

                if (b[p] += h, b[p] != s) break;
                b[p--] = 0, h = 1;
              }

              for (c = b.length; 0 === b[--c]; b.pop()) {
                ;
              }
            }

            e.e > F ? e.c = e.e = null : e.e < P && (e.c = [e.e = 0]);
          }

          return e;
        }

        function Z(e) {
          var t,
              r = e.e;
          return null === r ? e.toString() : (t = m(e.c), t = r <= R || r >= O ? y(t, r) : w(t, r, "0"), e.s < 0 ? "-" + t : t);
        }

        return H.clone = e, H.ROUND_UP = 0, H.ROUND_DOWN = 1, H.ROUND_CEIL = 2, H.ROUND_FLOOR = 3, H.ROUND_HALF_UP = 4, H.ROUND_HALF_DOWN = 5, H.ROUND_HALF_EVEN = 6, H.ROUND_HALF_CEIL = 7, H.ROUND_HALF_FLOOR = 8, H.EUCLID = 9, H.config = H.set = function (e) {
          var t, r;

          if (null != e) {
            if ("object" != typeof e) throw Error(a + "Object expected: " + e);
            if (e.hasOwnProperty(t = "DECIMAL_PLACES") && (g(r = e[t], 0, l, t), D = r), e.hasOwnProperty(t = "ROUNDING_MODE") && (g(r = e[t], 0, 8, t), N = r), e.hasOwnProperty(t = "EXPONENTIAL_AT") && ((r = e[t]) && r.pop ? (g(r[0], -l, 0, t), g(r[1], 0, l, t), R = r[0], O = r[1]) : (g(r, -l, l, t), R = -(O = r < 0 ? -r : r))), e.hasOwnProperty(t = "RANGE")) if ((r = e[t]) && r.pop) g(r[0], -l, -1, t), g(r[1], 1, l, t), P = r[0], F = r[1];else {
              if (g(r, -l, l, t), !r) throw Error(a + t + " cannot be zero: " + r);
              P = -(F = r < 0 ? -r : r);
            }

            if (e.hasOwnProperty(t = "CRYPTO")) {
              if ((r = e[t]) !== !!r) throw Error(a + t + " not true or false: " + r);

              if (r) {
                if ("undefined" == typeof crypto || !crypto || !crypto.getRandomValues && !crypto.randomBytes) throw L = !r, Error(a + "crypto unavailable");
                L = r;
              } else L = r;
            }

            if (e.hasOwnProperty(t = "MODULO_MODE") && (g(r = e[t], 0, 9, t), G = r), e.hasOwnProperty(t = "POW_PRECISION") && (g(r = e[t], 0, l, t), j = r), e.hasOwnProperty(t = "FORMAT")) {
              if ("object" != typeof (r = e[t])) throw Error(a + t + " not an object: " + r);
              z = r;
            }

            if (e.hasOwnProperty(t = "ALPHABET")) {
              if ("string" != typeof (r = e[t]) || /^.?$|[+\-.\s]|(.).*\1/.test(r)) throw Error(a + t + " invalid: " + r);
              U = "0123456789" == r.slice(0, 10), q = r;
            }
          }

          return {
            DECIMAL_PLACES: D,
            ROUNDING_MODE: N,
            EXPONENTIAL_AT: [R, O],
            RANGE: [P, F],
            CRYPTO: L,
            MODULO_MODE: G,
            POW_PRECISION: j,
            FORMAT: z,
            ALPHABET: q
          };
        }, H.isBigNumber = function (e) {
          if (!e || !0 !== e._isBigNumber) return !1;
          if (!H.DEBUG) return !0;
          var t,
              r,
              n = e.c,
              i = e.e,
              c = e.s;

          e: if ("[object Array]" == {}.toString.call(n)) {
            if ((1 === c || -1 === c) && i >= -l && i <= l && i === o(i)) {
              if (0 === n[0]) {
                if (0 === i && 1 === n.length) return !0;
                break e;
              }

              if ((t = (i + 1) % f) < 1 && (t += f), String(n[0]).length == t) {
                for (t = 0; t < n.length; t++) {
                  if ((r = n[t]) < 0 || r >= s || r !== o(r)) break e;
                }

                if (0 !== r) return !0;
              }
            }
          } else if (null === n && null === i && (null === c || 1 === c || -1 === c)) return !0;

          throw Error(a + "Invalid BigNumber: " + e);
        }, H.maximum = H.max = function () {
          return V(arguments, T.lt);
        }, H.minimum = H.min = function () {
          return V(arguments, T.gt);
        }, H.random = (M = 9007199254740992, x = Math.random() * M & 2097151 ? function () {
          return o(Math.random() * M);
        } : function () {
          return 8388608 * (1073741824 * Math.random() | 0) + (8388608 * Math.random() | 0);
        }, function (e) {
          var t,
              r,
              n,
              c,
              s,
              d = 0,
              h = [],
              p = new H(B);
          if (null == e ? e = D : g(e, 0, l), c = i(e / f), L) if (crypto.getRandomValues) {
            for (t = crypto.getRandomValues(new Uint32Array(c *= 2)); d < c;) {
              (s = 131072 * t[d] + (t[d + 1] >>> 11)) >= 9e15 ? (r = crypto.getRandomValues(new Uint32Array(2)), t[d] = r[0], t[d + 1] = r[1]) : (h.push(s % 1e14), d += 2);
            }

            d = c / 2;
          } else {
            if (!crypto.randomBytes) throw L = !1, Error(a + "crypto unavailable");

            for (t = crypto.randomBytes(c *= 7); d < c;) {
              (s = 281474976710656 * (31 & t[d]) + 1099511627776 * t[d + 1] + 4294967296 * t[d + 2] + 16777216 * t[d + 3] + (t[d + 4] << 16) + (t[d + 5] << 8) + t[d + 6]) >= 9e15 ? crypto.randomBytes(7).copy(t, d) : (h.push(s % 1e14), d += 7);
            }

            d = c / 7;
          }
          if (!L) for (; d < c;) {
            (s = x()) < 9e15 && (h[d++] = s % 1e14);
          }

          for (c = h[--d], e %= f, c && e && (s = u[f - e], h[d] = o(c / s) * s); 0 === h[d]; h.pop(), d--) {
            ;
          }

          if (d < 0) h = [n = 0];else {
            for (n = -1; 0 === h[0]; h.splice(0, 1), n -= f) {
              ;
            }

            for (d = 1, s = h[0]; s >= 10; s /= 10, d++) {
              ;
            }

            d < f && (n -= f - d);
          }
          return p.e = n, p.c = h, p;
        }), H.sum = function () {
          for (var e = 1, t = arguments, r = new H(t[0]); e < t.length;) {
            r = r.plus(t[e++]);
          }

          return r;
        }, A = function () {
          var e = "0123456789";

          function t(e, t, r, n) {
            for (var i, o, a = [0], c = 0, s = e.length; c < s;) {
              for (o = a.length; o--; a[o] *= t) {
                ;
              }

              for (a[0] += n.indexOf(e.charAt(c++)), i = 0; i < a.length; i++) {
                a[i] > r - 1 && (null == a[i + 1] && (a[i + 1] = 0), a[i + 1] += a[i] / r | 0, a[i] %= r);
              }
            }

            return a.reverse();
          }

          return function (n, i, o, a, c) {
            var s,
                f,
                d,
                u,
                h,
                l,
                p,
                b,
                g = n.indexOf("."),
                v = D,
                y = N;

            for (g >= 0 && (u = j, j = 0, n = n.replace(".", ""), l = (b = new H(i)).pow(n.length - g), j = u, b.c = t(w(m(l.c), l.e, "0"), 10, o, e), b.e = b.c.length), d = u = (p = t(n, i, o, c ? (s = q, e) : (s = e, q))).length; 0 == p[--u]; p.pop()) {
              ;
            }

            if (!p[0]) return s.charAt(0);
            if (g < 0 ? --d : (l.c = p, l.e = d, l.s = a, p = (l = r(l, b, v, y, o)).c, h = l.r, d = l.e), g = p[f = d + v + 1], u = o / 2, h = h || f < 0 || null != p[f + 1], h = y < 4 ? (null != g || h) && (0 == y || y == (l.s < 0 ? 3 : 2)) : g > u || g == u && (4 == y || h || 6 == y && 1 & p[f - 1] || y == (l.s < 0 ? 8 : 7)), f < 1 || !p[0]) n = h ? w(s.charAt(1), -v, s.charAt(0)) : s.charAt(0);else {
              if (p.length = f, h) for (--o; ++p[--f] > o;) {
                p[f] = 0, f || (++d, p = [1].concat(p));
              }

              for (u = p.length; !p[--u];) {
                ;
              }

              for (g = 0, n = ""; g <= u; n += s.charAt(p[g++])) {
                ;
              }

              n = w(n, d, s.charAt(0));
            }
            return n;
          };
        }(), r = function () {
          function e(e, t, r) {
            var n,
                i,
                o,
                a,
                c = 0,
                s = e.length,
                f = t % h,
                d = t / h | 0;

            for (e = e.slice(); s--;) {
              c = ((i = f * (o = e[s] % h) + (n = d * o + (a = e[s] / h | 0) * f) % h * h + c) / r | 0) + (n / h | 0) + d * a, e[s] = i % r;
            }

            return c && (e = [c].concat(e)), e;
          }

          function t(e, t, r, n) {
            var i, o;
            if (r != n) o = r > n ? 1 : -1;else for (i = o = 0; i < r; i++) {
              if (e[i] != t[i]) {
                o = e[i] > t[i] ? 1 : -1;
                break;
              }
            }
            return o;
          }

          function r(e, t, r, n) {
            for (var i = 0; r--;) {
              e[r] -= i, i = e[r] < t[r] ? 1 : 0, e[r] = i * n + e[r] - t[r];
            }

            for (; !e[0] && e.length > 1; e.splice(0, 1)) {
              ;
            }
          }

          return function (n, i, a, c, d) {
            var u,
                h,
                l,
                m,
                b,
                g,
                v,
                y,
                w,
                A,
                _,
                M,
                x,
                k,
                E,
                S,
                I,
                C = n.s == i.s ? 1 : -1,
                T = n.c,
                B = i.c;

            if (!(T && T[0] && B && B[0])) return new H(n.s && i.s && (T ? !B || T[0] != B[0] : B) ? T && 0 == T[0] || !B ? 0 * C : C / 0 : NaN);

            for (w = (y = new H(C)).c = [], C = a + (h = n.e - i.e) + 1, d || (d = s, h = p(n.e / f) - p(i.e / f), C = C / f | 0), l = 0; B[l] == (T[l] || 0); l++) {
              ;
            }

            if (B[l] > (T[l] || 0) && h--, C < 0) w.push(1), m = !0;else {
              for (k = T.length, S = B.length, l = 0, C += 2, (b = o(d / (B[0] + 1))) > 1 && (B = e(B, b, d), T = e(T, b, d), S = B.length, k = T.length), x = S, _ = (A = T.slice(0, S)).length; _ < S; A[_++] = 0) {
                ;
              }

              I = B.slice(), I = [0].concat(I), E = B[0], B[1] >= d / 2 && E++;

              do {
                if (b = 0, (u = t(B, A, S, _)) < 0) {
                  if (M = A[0], S != _ && (M = M * d + (A[1] || 0)), (b = o(M / E)) > 1) for (b >= d && (b = d - 1), v = (g = e(B, b, d)).length, _ = A.length; 1 == t(g, A, v, _);) {
                    b--, r(g, S < v ? I : B, v, d), v = g.length, u = 1;
                  } else 0 == b && (u = b = 1), v = (g = B.slice()).length;
                  if (v < _ && (g = [0].concat(g)), r(A, g, _, d), _ = A.length, -1 == u) for (; t(B, A, S, _) < 1;) {
                    b++, r(A, S < _ ? I : B, _, d), _ = A.length;
                  }
                } else 0 === u && (b++, A = [0]);

                w[l++] = b, A[0] ? A[_++] = T[x] || 0 : (A = [T[x]], _ = 1);
              } while ((x++ < k || null != A[0]) && C--);

              m = null != A[0], w[0] || w.splice(0, 1);
            }

            if (d == s) {
              for (l = 1, C = w[0]; C >= 10; C /= 10, l++) {
                ;
              }

              X(y, a + (y.e = l + h * f - 1) + 1, c, m);
            } else y.e = h, y.r = +m;

            return y;
          };
        }(), k = /^(-?)0([xbo])(?=\w[\w.]*$)/i, E = /^([^.]+)\.$/, S = /^\.([^.]+)$/, I = /^-?(Infinity|NaN)$/, C = /^\s*\+(?=[\w.])|^\s+|\s+$/g, _ = function _(e, t, r, n) {
          var i,
              o = r ? t : t.replace(C, "");
          if (I.test(o)) e.s = isNaN(o) ? null : o < 0 ? -1 : 1;else {
            if (!r && (o = o.replace(k, function (e, t, r) {
              return i = "x" == (r = r.toLowerCase()) ? 16 : "b" == r ? 2 : 8, n && n != i ? e : t;
            }), n && (i = n, o = o.replace(E, "$1").replace(S, "0.$1")), t != o)) return new H(o, i);
            if (H.DEBUG) throw Error(a + "Not a" + (n ? " base " + n : "") + " number: " + t);
            e.s = null;
          }
          e.c = e.e = null;
        }, T.absoluteValue = T.abs = function () {
          var e = new H(this);
          return e.s < 0 && (e.s = 1), e;
        }, T.comparedTo = function (e, t) {
          return b(this, new H(e, t));
        }, T.decimalPlaces = T.dp = function (e, t) {
          var r,
              n,
              i,
              o = this;
          if (null != e) return g(e, 0, l), null == t ? t = N : g(t, 0, 8), X(new H(o), e + o.e + 1, t);
          if (!(r = o.c)) return null;
          if (n = ((i = r.length - 1) - p(this.e / f)) * f, i = r[i]) for (; i % 10 == 0; i /= 10, n--) {
            ;
          }
          return n < 0 && (n = 0), n;
        }, T.dividedBy = T.div = function (e, t) {
          return r(this, new H(e, t), D, N);
        }, T.dividedToIntegerBy = T.idiv = function (e, t) {
          return r(this, new H(e, t), 0, 1);
        }, T.exponentiatedBy = T.pow = function (e, t) {
          var r,
              n,
              c,
              s,
              d,
              u,
              h,
              l,
              p = this;
          if ((e = new H(e)).c && !e.isInteger()) throw Error(a + "Exponent not an integer: " + Z(e));
          if (null != t && (t = new H(t)), d = e.e > 14, !p.c || !p.c[0] || 1 == p.c[0] && !p.e && 1 == p.c.length || !e.c || !e.c[0]) return l = new H(Math.pow(+Z(p), d ? 2 - v(e) : +Z(e))), t ? l.mod(t) : l;

          if (u = e.s < 0, t) {
            if (t.c ? !t.c[0] : !t.s) return new H(NaN);
            (n = !u && p.isInteger() && t.isInteger()) && (p = p.mod(t));
          } else {
            if (e.e > 9 && (p.e > 0 || p.e < -1 || (0 == p.e ? p.c[0] > 1 || d && p.c[1] >= 24e7 : p.c[0] < 8e13 || d && p.c[0] <= 9999975e7))) return s = p.s < 0 && v(e) ? -0 : 0, p.e > -1 && (s = 1 / s), new H(u ? 1 / s : s);
            j && (s = i(j / f + 2));
          }

          for (d ? (r = new H(.5), u && (e.s = 1), h = v(e)) : h = (c = Math.abs(+Z(e))) % 2, l = new H(B);;) {
            if (h) {
              if (!(l = l.times(p)).c) break;
              s ? l.c.length > s && (l.c.length = s) : n && (l = l.mod(t));
            }

            if (c) {
              if (0 === (c = o(c / 2))) break;
              h = c % 2;
            } else if (X(e = e.times(r), e.e + 1, 1), e.e > 14) h = v(e);else {
              if (0 == (c = +Z(e))) break;
              h = c % 2;
            }

            p = p.times(p), s ? p.c && p.c.length > s && (p.c.length = s) : n && (p = p.mod(t));
          }

          return n ? l : (u && (l = B.div(l)), t ? l.mod(t) : s ? X(l, j, N, void 0) : l);
        }, T.integerValue = function (e) {
          var t = new H(this);
          return null == e ? e = N : g(e, 0, 8), X(t, t.e + 1, e);
        }, T.isEqualTo = T.eq = function (e, t) {
          return 0 === b(this, new H(e, t));
        }, T.isFinite = function () {
          return !!this.c;
        }, T.isGreaterThan = T.gt = function (e, t) {
          return b(this, new H(e, t)) > 0;
        }, T.isGreaterThanOrEqualTo = T.gte = function (e, t) {
          return 1 === (t = b(this, new H(e, t))) || 0 === t;
        }, T.isInteger = function () {
          return !!this.c && p(this.e / f) > this.c.length - 2;
        }, T.isLessThan = T.lt = function (e, t) {
          return b(this, new H(e, t)) < 0;
        }, T.isLessThanOrEqualTo = T.lte = function (e, t) {
          return -1 === (t = b(this, new H(e, t))) || 0 === t;
        }, T.isNaN = function () {
          return !this.s;
        }, T.isNegative = function () {
          return this.s < 0;
        }, T.isPositive = function () {
          return this.s > 0;
        }, T.isZero = function () {
          return !!this.c && 0 == this.c[0];
        }, T.minus = function (e, t) {
          var r,
              n,
              i,
              o,
              a = this,
              c = a.s;
          if (t = (e = new H(e, t)).s, !c || !t) return new H(NaN);
          if (c != t) return e.s = -t, a.plus(e);
          var d = a.e / f,
              u = e.e / f,
              h = a.c,
              l = e.c;

          if (!d || !u) {
            if (!h || !l) return h ? (e.s = -t, e) : new H(l ? a : NaN);
            if (!h[0] || !l[0]) return l[0] ? (e.s = -t, e) : new H(h[0] ? a : 3 == N ? -0 : 0);
          }

          if (d = p(d), u = p(u), h = h.slice(), c = d - u) {
            for ((o = c < 0) ? (c = -c, i = h) : (u = d, i = l), i.reverse(), t = c; t--; i.push(0)) {
              ;
            }

            i.reverse();
          } else for (n = (o = (c = h.length) < (t = l.length)) ? c : t, c = t = 0; t < n; t++) {
            if (h[t] != l[t]) {
              o = h[t] < l[t];
              break;
            }
          }

          if (o && (i = h, h = l, l = i, e.s = -e.s), (t = (n = l.length) - (r = h.length)) > 0) for (; t--; h[r++] = 0) {
            ;
          }

          for (t = s - 1; n > c;) {
            if (h[--n] < l[n]) {
              for (r = n; r && !h[--r]; h[r] = t) {
                ;
              }

              --h[r], h[n] += s;
            }

            h[n] -= l[n];
          }

          for (; 0 == h[0]; h.splice(0, 1), --u) {
            ;
          }

          return h[0] ? W(e, h, u) : (e.s = 3 == N ? -1 : 1, e.c = [e.e = 0], e);
        }, T.modulo = T.mod = function (e, t) {
          var n,
              i,
              o = this;
          return e = new H(e, t), !o.c || !e.s || e.c && !e.c[0] ? new H(NaN) : !e.c || o.c && !o.c[0] ? new H(o) : (9 == G ? (i = e.s, e.s = 1, n = r(o, e, 0, 3), e.s = i, n.s *= i) : n = r(o, e, 0, G), (e = o.minus(n.times(e))).c[0] || 1 != G || (e.s = o.s), e);
        }, T.multipliedBy = T.times = function (e, t) {
          var r,
              n,
              i,
              o,
              a,
              c,
              d,
              u,
              l,
              m,
              b,
              g,
              v,
              y,
              w,
              A = this,
              _ = A.c,
              M = (e = new H(e, t)).c;
          if (!(_ && M && _[0] && M[0])) return !A.s || !e.s || _ && !_[0] && !M || M && !M[0] && !_ ? e.c = e.e = e.s = null : (e.s *= A.s, _ && M ? (e.c = [0], e.e = 0) : e.c = e.e = null), e;

          for (n = p(A.e / f) + p(e.e / f), e.s *= A.s, (d = _.length) < (m = M.length) && (v = _, _ = M, M = v, i = d, d = m, m = i), i = d + m, v = []; i--; v.push(0)) {
            ;
          }

          for (y = s, w = h, i = m; --i >= 0;) {
            for (r = 0, b = M[i] % w, g = M[i] / w | 0, o = i + (a = d); o > i;) {
              r = ((u = b * (u = _[--a] % w) + (c = g * u + (l = _[a] / w | 0) * b) % w * w + v[o] + r) / y | 0) + (c / w | 0) + g * l, v[o--] = u % y;
            }

            v[o] = r;
          }

          return r ? ++n : v.splice(0, 1), W(e, v, n);
        }, T.negated = function () {
          var e = new H(this);
          return e.s = -e.s || null, e;
        }, T.plus = function (e, t) {
          var r,
              n = this,
              i = n.s;
          if (t = (e = new H(e, t)).s, !i || !t) return new H(NaN);
          if (i != t) return e.s = -t, n.minus(e);
          var o = n.e / f,
              a = e.e / f,
              c = n.c,
              d = e.c;

          if (!o || !a) {
            if (!c || !d) return new H(i / 0);
            if (!c[0] || !d[0]) return d[0] ? e : new H(c[0] ? n : 0 * i);
          }

          if (o = p(o), a = p(a), c = c.slice(), i = o - a) {
            for (i > 0 ? (a = o, r = d) : (i = -i, r = c), r.reverse(); i--; r.push(0)) {
              ;
            }

            r.reverse();
          }

          for ((i = c.length) - (t = d.length) < 0 && (r = d, d = c, c = r, t = i), i = 0; t;) {
            i = (c[--t] = c[t] + d[t] + i) / s | 0, c[t] = s === c[t] ? 0 : c[t] % s;
          }

          return i && (c = [i].concat(c), ++a), W(e, c, a);
        }, T.precision = T.sd = function (e, t) {
          var r,
              n,
              i,
              o = this;
          if (null != e && e !== !!e) return g(e, 1, l), null == t ? t = N : g(t, 0, 8), X(new H(o), e, t);
          if (!(r = o.c)) return null;

          if (n = (i = r.length - 1) * f + 1, i = r[i]) {
            for (; i % 10 == 0; i /= 10, n--) {
              ;
            }

            for (i = r[0]; i >= 10; i /= 10, n++) {
              ;
            }
          }

          return e && o.e + 1 > n && (n = o.e + 1), n;
        }, T.shiftedBy = function (e) {
          return g(e, -9007199254740991, d), this.times("1e" + e);
        }, T.squareRoot = T.sqrt = function () {
          var e,
              t,
              n,
              i,
              o,
              a = this,
              c = a.c,
              s = a.s,
              f = a.e,
              d = D + 4,
              u = new H("0.5");
          if (1 !== s || !c || !c[0]) return new H(!s || s < 0 && (!c || c[0]) ? NaN : c ? a : 1 / 0);
          if (0 == (s = Math.sqrt(+Z(a))) || s == 1 / 0 ? (((t = m(c)).length + f) % 2 == 0 && (t += "0"), s = Math.sqrt(+t), f = p((f + 1) / 2) - (f < 0 || f % 2), n = new H(t = s == 1 / 0 ? "5e" + f : (t = s.toExponential()).slice(0, t.indexOf("e") + 1) + f)) : n = new H(s + ""), n.c[0]) for ((s = (f = n.e) + d) < 3 && (s = 0);;) {
            if (o = n, n = u.times(o.plus(r(a, o, d, 1))), m(o.c).slice(0, s) === (t = m(n.c)).slice(0, s)) {
              if (n.e < f && --s, "9999" != (t = t.slice(s - 3, s + 1)) && (i || "4999" != t)) {
                +t && (+t.slice(1) || "5" != t.charAt(0)) || (X(n, n.e + D + 2, 1), e = !n.times(n).eq(a));
                break;
              }

              if (!i && (X(o, o.e + D + 2, 0), o.times(o).eq(a))) {
                n = o;
                break;
              }

              d += 4, s += 4, i = 1;
            }
          }
          return X(n, n.e + D + 1, N, e);
        }, T.toExponential = function (e, t) {
          return null != e && (g(e, 0, l), e++), K(this, e, t, 1);
        }, T.toFixed = function (e, t) {
          return null != e && (g(e, 0, l), e = e + this.e + 1), K(this, e, t);
        }, T.toFormat = function (e, t, r) {
          var n,
              i = this;
          if (null == r) null != e && t && "object" == typeof t ? (r = t, t = null) : e && "object" == typeof e ? (r = e, e = t = null) : r = z;else if ("object" != typeof r) throw Error(a + "Argument not an object: " + r);

          if (n = i.toFixed(e, t), i.c) {
            var o,
                c = n.split("."),
                s = +r.groupSize,
                f = +r.secondaryGroupSize,
                d = r.groupSeparator || "",
                u = c[0],
                h = c[1],
                l = i.s < 0,
                p = l ? u.slice(1) : u,
                m = p.length;

            if (f && (o = s, s = f, f = o, m -= o), s > 0 && m > 0) {
              for (o = m % s || s, u = p.substr(0, o); o < m; o += s) {
                u += d + p.substr(o, s);
              }

              f > 0 && (u += d + p.slice(o)), l && (u = "-" + u);
            }

            n = h ? u + (r.decimalSeparator || "") + ((f = +r.fractionGroupSize) ? h.replace(new RegExp("\\d{" + f + "}\\B", "g"), "$&" + (r.fractionGroupSeparator || "")) : h) : u;
          }

          return (r.prefix || "") + n + (r.suffix || "");
        }, T.toFraction = function (e) {
          var t,
              n,
              i,
              o,
              c,
              s,
              d,
              h,
              l,
              p,
              b,
              g,
              v = this,
              y = v.c;
          if (null != e && (!(d = new H(e)).isInteger() && (d.c || 1 !== d.s) || d.lt(B))) throw Error(a + "Argument " + (d.isInteger() ? "out of range: " : "not an integer: ") + Z(d));
          if (!y) return new H(v);

          for (t = new H(B), l = n = new H(B), i = h = new H(B), g = m(y), c = t.e = g.length - v.e - 1, t.c[0] = u[(s = c % f) < 0 ? f + s : s], e = !e || d.comparedTo(t) > 0 ? c > 0 ? t : l : d, s = F, F = 1 / 0, d = new H(g), h.c[0] = 0; p = r(d, t, 0, 1), 1 != (o = n.plus(p.times(i))).comparedTo(e);) {
            n = i, i = o, l = h.plus(p.times(o = l)), h = o, t = d.minus(p.times(o = t)), d = o;
          }

          return o = r(e.minus(n), i, 0, 1), h = h.plus(o.times(l)), n = n.plus(o.times(i)), h.s = l.s = v.s, b = r(l, i, c *= 2, N).minus(v).abs().comparedTo(r(h, n, c, N).minus(v).abs()) < 1 ? [l, i] : [h, n], F = s, b;
        }, T.toNumber = function () {
          return +Z(this);
        }, T.toPrecision = function (e, t) {
          return null != e && g(e, 1, l), K(this, e, t, 2);
        }, T.toString = function (e) {
          var t,
              r = this,
              n = r.s,
              i = r.e;
          return null === i ? n ? (t = "Infinity", n < 0 && (t = "-" + t)) : t = "NaN" : (null == e ? t = i <= R || i >= O ? y(m(r.c), i) : w(m(r.c), i, "0") : 10 === e && U ? t = w(m((r = X(new H(r), D + i + 1, N)).c), r.e, "0") : (g(e, 2, q.length, "Base"), t = A(w(m(r.c), i, "0"), 10, e, n, !0)), n < 0 && r.c[0] && (t = "-" + t)), t;
        }, T.valueOf = T.toJSON = function () {
          return Z(this);
        }, T._isBigNumber = !0, T[Symbol.toStringTag] = "BigNumber", T[Symbol.for("nodejs.util.inspect.custom")] = T.valueOf, null != t && H.set(t), H;
      }();

      var _ = A;
    },
    8597: function _(e) {
      "use strict";

      e.exports = {
        i8: "6.5.4"
      };
    },
    6935: function _(e) {
      "use strict";

      e.exports = JSON.parse('{"WBTC.e":{"name":"Avax Wrapped Bitcoin","code":"WBTC","decimals":8,"contractAddress":"0x50b7545627a5162f82a992c33b87adc75187b218","color":"#5b3159","coinGeckoId":"wrapped-bitcoin","matchingAsset":"WBTC"},"USDC.e":{"name":"Avax USD Coin","code":"USDC","decimals":6,"contractAddress":"0xa7d7079b0fead91f3e65f86e8915cb59c1a4c664","color":"#5b31b9","coinGeckoId":"usd-coin","matchingAsset":"USDC"},"USDT.e":{"name":"Avax Tether USD","code":"USDT","decimals":6,"contractAddress":"0xc7198437980c041c805a1edcba50c1ce5db95118","color":"#5b31f9","coinGeckoId":"tether","matchingAsset":"USDT"}}');
    },
    7956: function _(e) {
      "use strict";

      e.exports = JSON.parse('{"ZAP":{"name":"ZAP TOKEN","code":"ZAP","decimals":18,"contractAddress":"0x6781a0F84c7E9e846DCb84A9a5bd49333067b104","coinGeckoId":"zap"},"SKL":{"name":"SKALE","code":"SKL","decimals":18,"contractAddress":"0x00c83aeCC790e8a4453e5dD3B0B4b3680501a7A7","coinGeckoId":"skale"},"USDN":{"name":"Neutrino USD","code":"USDN","decimals":18,"contractAddress":"0x674C6Ad92Fd080e4004b2312b45f796a192D27a0","coinGeckoId":"neutrino"},"FRM":{"name":"Ferrum Network Token","code":"FRM","decimals":6,"contractAddress":"0xE5CAeF4Af8780E59Df925470b050Fb23C43CA68C","coinGeckoId":"ferrum-network"},"IDRT":{"name":"Rupiah Token","code":"IDRT","decimals":2,"contractAddress":"0x998FFE1E43fAcffb941dc337dD0468d52bA5b48A","coinGeckoId":"rupiah-token"},"FTM":{"name":"Fantom","code":"FTM","decimals":18,"contractAddress":"0x4E15361FD6b4BB609Fa63C81A2be19d873717870","coinGeckoId":"fantom"},"REVV":{"name":"REVV","code":"REVV","decimals":18,"contractAddress":"0x557B933a7C2c45672B610F8954A3deB39a51A8Ca","coinGeckoId":"revv"},"aAAVE":{"name":"Aave AAVE","code":"aAAVE","decimals":18,"contractAddress":"0xFFC97d72E13E01096502Cb8Eb52dEe56f74DAD7B"},"aBAT":{"name":"Aave BAT","code":"aBAT","decimals":18,"contractAddress":"0x05Ec93c0365baAeAbF7AefFb0972ea7ECdD39CF1"},"aBUSD":{"name":"Aave BUSD","code":"aBUSD","decimals":18,"contractAddress":"0xA361718326c15715591c299427c62086F69923D9"},"aDAI":{"name":"Aave DAI","code":"aDAI","decimals":18,"contractAddress":"0x028171bCA77440897B824Ca71D1c56caC55b68A3"},"aENJ":{"name":"Aave ENJ","code":"aENJ","decimals":18,"contractAddress":"0xaC6Df26a590F08dcC95D5a4705ae8abbc88509Ef"},"aKNC":{"name":"Aave KNC","code":"aKNC","decimals":18,"contractAddress":"0x39C6b3e42d6A679d7D776778Fe880BC9487C2EDA"},"aLINK":{"name":"Aave LINK","code":"aLINK","decimals":18,"contractAddress":"0xa06bC25B5805d5F8d82847D191Cb4Af5A3e873E0"},"aMANA":{"name":"Aave MANA","code":"aMANA","decimals":18,"contractAddress":"0xa685a61171bb30d4072B338c80Cb7b2c865c873E"},"aMKR":{"name":"Aave MKR","code":"aMKR","decimals":18,"contractAddress":"0xc713e5E149D5D0715DcD1c156a020976e7E56B88"},"aREN":{"name":"Aave REN","code":"aREN","decimals":18,"contractAddress":"0xCC12AbE4ff81c9378D670De1b57F8e0Dd228D77a"},"aSNX":{"name":"Aave SNX","code":"aSNX","decimals":18,"contractAddress":"0x35f6B052C598d933D69A4EEC4D04c73A191fE6c2"},"aSUSD":{"name":"Aave SUSD","code":"aSUSD","decimals":18,"contractAddress":"0x6C5024Cd4F8A59110119C56f8933403A539555EB"},"aTUSD":{"name":"Aave TUSD","code":"aTUSD","decimals":18,"contractAddress":"0x101cc05f4A51C0319f570d5E146a8C625198e636"},"aUNI":{"name":"Aave UNI","code":"aUNI","decimals":18,"contractAddress":"0xB9D7CB55f463405CDfBe4E90a6D2Df01C2B92BF1"},"aUSDC":{"name":"Aave USDC","code":"aUSDC","decimals":6,"contractAddress":"0xBcca60bB61934080951369a648Fb03DF4F96263C"},"aUSDT":{"name":"Aave USDT","code":"aUSDT","decimals":6,"contractAddress":"0x3Ed3B47Dd13EC9a98b44e6204A523E766B225811"},"aWBTC":{"name":"Aave WBTC","code":"aWBTC","decimals":8,"contractAddress":"0x9ff58f4fFB29fA2266Ab25e75e2A8b3503311656"},"aWETH":{"name":"Aave WETH","code":"aWETH","decimals":18,"contractAddress":"0x030bA81f1c18d280636F32af80b9AAd02Cf0854e"},"aYFI":{"name":"Aave YFI","code":"aYFI","decimals":18,"contractAddress":"0x5165d24277cD063F5ac44Efd447B27025e888f37"},"aZRX":{"name":"Aave ZRX","code":"aZRX","decimals":18,"contractAddress":"0xDf7FF54aAcAcbFf42dfe29DD6144A69b629f8C9e"},"AAVE":{"name":"Aave","code":"AAVE","decimals":18,"contractAddress":"0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9","coinGeckoId":"aave"},"stAAVE":{"name":"Staked Aave","code":"stAAVE","decimals":18,"contractAddress":"0x4da27a545c0c5B758a6BA100e3a049001de870f5"},"LEND":{"name":"ETHLend Token","code":"LEND","decimals":18,"contractAddress":"0x80fB784B7eD66730e8b1DBd9820aFD29931aab03","color":"#0fa9c9","coinGeckoId":"ethlend"},"GLM":{"name":"Golem Network Token","code":"GLM","decimals":18,"contractAddress":"0x7DD9c5Cba05E151C895FDe1CF355C9A1D5DA6429","coinGeckoId":"golem"},"OCTO":{"name":"OctoFi","code":"OCTO","decimals":18,"contractAddress":"0x7240aC91f01233BaAf8b064248E80feaA5912BA3","coinGeckoId":"octofi"},"ORBS":{"name":"Orbs","code":"ORBS","decimals":18,"contractAddress":"0xff56Cc6b1E6dEd347aA0B7676C85AB0B3D08B0FA","coinGeckoId":"orbs"},"GAME":{"name":"GAME Credits","code":"GAME","decimals":18,"contractAddress":"0x63f88A2298a5c4AEE3c216Aa6D926B184a4b2437","color":"#2d475b","coinGeckoId":"gamecredits"},"DIA":{"name":"DIAdata","code":"DIA","decimals":18,"contractAddress":"0x84cA8bc7997272c7CfB4D0Cd3D55cd942B3c9419","coinGeckoId":"dia-data"},"MTL":{"name":"Metal","code":"MTL","decimals":8,"contractAddress":"0xF433089366899D83a9f26A773D59ec7eCF30355e","color":"#1e1f25","coinGeckoId":"metal"},"TBTC":{"name":"tBTC","code":"TBTC","decimals":18,"contractAddress":"0x8dAEBADE922dF735c38C80C7eBD708Af50815fAa","coinGeckoId":"tbtc"},"XPR":{"name":"Proton","code":"XPR","decimals":4,"contractAddress":"0xD7EFB00d12C2c13131FD319336Fdf952525dA2af","coinGeckoId":"proton"},"EWTB":{"name":"Energy Web Token Bridged","code":"EWTB","decimals":18,"contractAddress":"0x178c820f862B14f316509ec36b13123DA19A6054"},"HEX":{"name":"HEX","code":"HEX","decimals":8,"contractAddress":"0x2b591e99afE9f32eAA6214f7B7629768c40Eeb39","coinGeckoId":"hex"},"RARI":{"name":"Rarible","code":"RARI","decimals":18,"contractAddress":"0xFca59Cd816aB1eaD66534D82bc21E7515cE441CF","coinGeckoId":"rarible"},"SNTVT":{"name":"Sentivate","code":"SNTVT","decimals":18,"contractAddress":"0x7865af71cf0b288b4E7F654f4F7851EB46a2B7F8","coinGeckoId":"sentivate"},"MET":{"name":"Metronome","code":"MET","decimals":18,"contractAddress":"0xa3d58c4E56fedCae3a7c43A725aeE9A71F0ece4e","coinGeckoId":"metronome"},"PLDAI":{"name":"PoolTogether Dai","code":"PLDAI","decimals":18,"contractAddress":"0x49d716DFe60b37379010A75329ae09428f17118d"},"PLSAI":{"name":"PoolTogether Sai","code":"PLSAI","decimals":18,"contractAddress":"0xfE6892654CBB05eB73d28DCc1Ff938f59666Fe9f"},"BLZ":{"name":"Bluzelle Token","code":"BLZ","decimals":18,"contractAddress":"0x5732046A883704404F284Ce41FfADd5b007FD668","color":"#18578c","coinGeckoId":"bluzelle"},"PLUSDC":{"name":"PoolTogether USDC","code":"PLUSDC","decimals":6,"contractAddress":"0xBD87447F48ad729C5c4b8bcb503e1395F62e8B98"},"YFI":{"name":"yearn.finance","code":"YFI","decimals":18,"contractAddress":"0x0bc529c00C6401aEF6D220BE8C6Ea1667F6Ad93e","color":"#006ae3","coinGeckoId":"yearn-finance"},"rDAI":{"name":"rDAI","code":"rDAI","decimals":18,"contractAddress":"0x261b45D85cCFeAbb11F022eBa346ee8D1cd488c0","coinGeckoId":"rdai"},"rSAI":{"name":"rSAI","code":"rSAI","decimals":18,"contractAddress":"0xea8b224eDD3e342DEb514C4176c2E72Bcce6fFF9"},"GRID":{"name":"GridPlus","code":"GRID","decimals":12,"contractAddress":"0x12B19D3e2ccc14Da04FAe33e63652ce469b3F2FD","coinGeckoId":"grid"},"OXT":{"name":"Orchid","code":"OXT","decimals":18,"contractAddress":"0x4575f41308EC1483f3d399aa9a2826d74Da13Deb","coinGeckoId":"orchid-protocol"},"KEY":{"name":"Selfkey","code":"KEY","decimals":18,"contractAddress":"0x4CC19356f2D37338b9802aa8E8fc58B0373296E7","coinGeckoId":"selfkey"},"ERT":{"name":"Eristica","code":"ERT","decimals":18,"contractAddress":"0x92A5B04D0ED5D94D7a193d1d334D3D16996f4E13","coinGeckoId":"eristica"},"USDT":{"name":"Tether USD","code":"USDT","decimals":6,"contractAddress":"0xdAC17F958D2ee523a2206206994597C13D831ec7","color":"#26a17b","coinGeckoId":"tether"},"CHAI":{"name":"Chai","code":"CHAI","decimals":18,"contractAddress":"0x06AF07097C9Eeb7fD685c692751D5C66dB49c215","coinGeckoId":"chai"},"UMA":{"name":"UMA","code":"UMA","decimals":18,"contractAddress":"0x04Fa0d235C4abf4BcF4787aF4CF447DE572eF828","coinGeckoId":"uma"},"UPX":{"name":"UPX Token","code":"UPX","decimals":18,"contractAddress":"0x5f778ec4B31a506c1Dfd8b06F131E9B451a61D39","coinGeckoId":"udap"},"ENG":{"name":"Enigma","code":"ENG","decimals":18,"contractAddress":"0xf0Ee6b27b759C9893Ce4f094b49ad28fd15A23e4","color":"#2f2f2f","coinGeckoId":"enigma"},"CEL":{"name":"Celsius","code":"CEL","decimals":4,"contractAddress":"0xaaAEBE6Fe48E54f431b0C390CfaF0b017d09D42d","coinGeckoId":"celsius-degree-token"},"BTU":{"name":"BTU","code":"BTU","decimals":18,"contractAddress":"0xb683D83a532e2Cb7DFa5275eED3698436371cc9f","coinGeckoId":"btu-protocol"},"BOA":{"name":"BOSAGORA","code":"BOA","decimals":7,"contractAddress":"0x746DdA2ea243400D5a63e0700F190aB79f06489e","coinGeckoId":"bosagora"},"POP":{"name":"POP Network Token","code":"POP","decimals":18,"contractAddress":"0x5D858bcd53E085920620549214a8b27CE2f04670","coinGeckoId":"pop-chest-token"},"SKM":{"name":"Skrumble Network V2","code":"SKM","decimals":18,"contractAddress":"0x048Fe49BE32adfC9ED68C37D32B5ec9Df17b3603","coinGeckoId":"skrumble-network"},"ENQ":{"name":"Enecuum","code":"ENQ","decimals":10,"contractAddress":"0x16EA01aCB4b0Bca2000ee5473348B6937ee6f72F"},"ZEON":{"name":"ZEON Network","code":"ZEON","decimals":18,"contractAddress":"0xE5B826Ca2Ca02F09c1725e9bd98d9a8874C30532","coinGeckoId":"zeon"},"REMI":{"name":"REMIIT REMI Token","code":"REMI","decimals":18,"contractAddress":"0x13cb85823f78Cff38f0B0E90D3e975b8CB3AAd64","coinGeckoId":"remiit"},"HAK":{"name":"Shaka","code":"HAK","decimals":18,"contractAddress":"0x93a7174dafd31d13400cD9fa01f4e5B5BAa00D39","coinGeckoId":"shaka"},"IOTX":{"name":"IoTeX","code":"IOTX","decimals":18,"contractAddress":"0x6fB3e0A217407EFFf7Ca062D46c26E5d60a14d69","color":"#00d4d5","coinGeckoId":"iotex"},"RAE":{"name":"RAE Token","code":"RAE","decimals":18,"contractAddress":"0xE5a3229CCb22b6484594973A03a3851dCd948756","coinGeckoId":"rae-token"},"ADXL":{"name":"AdEx Legacy Token","code":"ADXL","decimals":4,"contractAddress":"0x4470BB87d77b963A013DB939BE332f927f2b992e"},"ADX":{"name":"AdEx Token","code":"ADX","decimals":18,"contractAddress":"0xADE00C28244d5CE17D72E40330B1c318cD12B7c3","color":"#1b75bc","coinGeckoId":"adex"},"NDX":{"name":"nDEX","code":"NDX","decimals":18,"contractAddress":"0x1966d718A565566e8E202792658D7b5Ff4ECe469","coinGeckoId":"ndex"},"WBTC":{"name":"Wrapped BTC","code":"WBTC","decimals":8,"contractAddress":"0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599","coinGeckoId":"wrapped-bitcoin"},"GOLD":{"name":"Dragonereum Gold","code":"GOLD","decimals":18,"contractAddress":"0x150b0b96933B75Ce27af8b92441F8fB683bF9739","color":"#f1b32b","coinGeckoId":"dragonereum-gold"},"DREAM":{"name":"DreamTeam Token","code":"DREAM","decimals":6,"contractAddress":"0x82f4dED9Cec9B5750FBFf5C2185AEe35AfC16587","coinGeckoId":"dreamteam"},"MYB":{"name":"MyBit","code":"MYB","decimals":18,"contractAddress":"0x5d60d8d7eF6d37E16EBABc324de3bE57f135e0BC","coinGeckoId":"mybit-token"},"CVL":{"name":"Civil Token","code":"CVL","decimals":18,"contractAddress":"0x01FA555c97D7958Fa6f771f3BbD5CCD508f81e22","coinGeckoId":"civil"},"DTH":{"name":"Dether","code":"DTH","decimals":18,"contractAddress":"0x5adc961D6AC3f7062D2eA45FEFB8D8167d44b190","color":"#3c80f1","coinGeckoId":"dether"},"WIB":{"name":"Wibson","code":"WIB","decimals":9,"contractAddress":"0x3F17Dd476faF0a4855572F0B6ed5115D9bBA22AD","coinGeckoId":"wibson"},"BOB":{"name":"Bob\'s Repair","code":"BOB","decimals":18,"contractAddress":"0xDF347911910b6c9A4286bA8E2EE5ea4a39eB2134","coinGeckoId":"bobs_repair"},"SWM":{"name":"SWARM","code":"SWM","decimals":18,"contractAddress":"0x3505F494c3f0fed0B594E01Fa41Dd3967645ca39","coinGeckoId":"swarm"},"ONL":{"name":"On.Live","code":"ONL","decimals":18,"contractAddress":"0x6863bE0e7CF7ce860A574760e9020D519a8bDC47","coinGeckoId":"on-live"},"PARETO":{"name":"Pareto","code":"PARETO","decimals":18,"contractAddress":"0xea5f88E54d982Cbb0c441cde4E79bC305e5b43Bc","coinGeckoId":"pareto-network"},"HERC":{"name":"Hercules","code":"HERC","decimals":18,"contractAddress":"0x2e91E3e54C5788e9FdD6A181497FDcEa1De1bcc1","coinGeckoId":"hercules"},"FOAM":{"name":"FOAM","code":"FOAM","decimals":18,"contractAddress":"0x4946Fcea7C692606e8908002e55A582af44AC121","coinGeckoId":"foam-protocol"},"ONE":{"name":"Menlo One","code":"ONE","decimals":18,"contractAddress":"0x4D807509aECe24C0fa5A102b6a3B059Ec6E14392","coinGeckoId":"menlo-one"},"SPND":{"name":"Spendcoin","code":"SPND","decimals":18,"contractAddress":"0xDDD460bBD9F79847ea08681563e8A9696867210C","coinGeckoId":"spendcoin"},"AST":{"name":"AirSwap Token","code":"AST","decimals":4,"contractAddress":"0x27054b13b1B798B345b591a4d22e6562d47eA75a","color":"#0061ff","coinGeckoId":"airswap"},"RMESH":{"name":"RightMesh Token","code":"RMESH","decimals":18,"contractAddress":"0x8D5682941cE456900b12d47ac06a88b47C764CE1","coinGeckoId":"rightmesh"},"JOY":{"name":"JOYSO","code":"JOY","decimals":6,"contractAddress":"0xDDe12a12A6f67156e0DA672be05c374e1B0a3e57","coinGeckoId":"joyso"},"J8T":{"name":"JET8 Token","code":"J8T","decimals":8,"contractAddress":"0x0D262e5dC4A06a0F1c90cE79C7a60C09DfC884E4","coinGeckoId":"jet8"},"QNT":{"name":"Quant Network","code":"QNT","decimals":18,"contractAddress":"0x4a220E6096B25EADb88358cb44068A3248254675","coinGeckoId":"quant-network"},"XNK":{"name":"Ink Protocol","code":"XNK","decimals":18,"contractAddress":"0xBC86727E770de68B1060C91f6BB6945c73e10388","coinGeckoId":"ink-protocol"},"AION":{"name":"Aion Network","code":"AION","decimals":8,"contractAddress":"0x4CEdA7906a5Ed2179785Cd3A40A69ee8bc99C466","color":"#00bfec"},"ELY":{"name":"ELY Token","code":"ELY","decimals":18,"contractAddress":"0xa95592DCFfA3C080B4B40E459c5f5692F67DB7F8","coinGeckoId":"elysian"},"NCT":{"name":"PolySwarm Nectar","code":"NCT","decimals":18,"contractAddress":"0x9E46A38F5DaaBe8683E10793b06749EEF7D733d1","coinGeckoId":"polyswarm"},"BOX":{"name":"BOX Token","code":"BOX","decimals":18,"contractAddress":"0xe1A178B681BD05964d3e3Ed33AE731577d9d96dD","coinGeckoId":"box-token"},"VDOC":{"name":"dutyof.care Token","code":"VDOC","decimals":18,"contractAddress":"0x82BD526bDB718C6d4DD2291Ed013A5186cAE2DCa"},"RHOC":{"name":"Rhoc","code":"RHOC","decimals":8,"contractAddress":"0x168296bb09e24A88805CB9c33356536B980D3fC5","color":"#cc1e46"},"GEN":{"name":"DAOstack","code":"GEN","decimals":18,"contractAddress":"0x543Ff227F64Aa17eA132Bf9886cAb5DB55DCAddf","coinGeckoId":"daostack"},"DGS":{"name":"Dragonglass","code":"DGS","decimals":8,"contractAddress":"0x6aEDbF8dFF31437220dF351950Ba2a3362168d1b","coinGeckoId":"dragonglass"},"OMG":{"name":"OmiseGO","code":"OMG","decimals":18,"contractAddress":"0xd26114cd6EE289AccF82350c8d8487fedB8A0C07","color":"#1a53f0","coinGeckoId":"omisego"},"QSP":{"name":"Quantstamp","code":"QSP","decimals":18,"contractAddress":"0x99ea4dB9EE77ACD40B119BD1dC4E33e1C070b80d","color":"#454545","coinGeckoId":"quantstamp"},"CLN":{"name":"Colu Local Network","code":"CLN","decimals":18,"contractAddress":"0x4162178B78D6985480A308B2190EE5517460406D","coinGeckoId":"colu"},"STORJ":{"name":"Storj","code":"STORJ","decimals":8,"contractAddress":"0xB64ef51C888972c908CFacf59B47C1AfBC0Ab8aC","color":"#2683ff","coinGeckoId":"storj"},"MANA":{"name":"Decentraland","code":"MANA","decimals":18,"contractAddress":"0x0F5D2fB29fb7d3CFeE444a200298f468908cC942","color":"#bfb5af","coinGeckoId":"decentraland"},"XSC":{"name":"CrowdstartCoin","code":"XSC","decimals":18,"contractAddress":"0x0F513fFb4926ff82D7F60A05069047AcA295C413","coinGeckoId":"crowdstart-coin"},"ENTRP":{"name":"Hut34 Entropy Token","code":"ENTRP","decimals":18,"contractAddress":"0x5BC7e5f0Ab8b2E10D2D0a3F21739FCe62459aeF3","color":"#fa5836","coinGeckoId":"hut34-entropy"},"HYDRO":{"name":"Hydro","code":"HYDRO","decimals":18,"contractAddress":"0xEBBdf302c940c6bfd49C6b165f457fdb324649bc","coinGeckoId":"hydro"},"PKT":{"name":"Playkey Token","code":"PKT","decimals":18,"contractAddress":"0x2604FA406Be957E542BEb89E6754fCdE6815e83f","coinGeckoId":"playkey"},"ZRX":{"name":"0x","code":"ZRX","decimals":18,"contractAddress":"0xE41d2489571d322189246DaFA5ebDe1F4699F498","color":"#302c2c","coinGeckoId":"0x"},"REDC":{"name":"RedCab","code":"REDC","decimals":18,"contractAddress":"0xB563300A3BAc79FC09B93b6F84CE0d4465A2AC27","coinGeckoId":"redcab"},"MOD":{"name":"Modum Token","code":"MOD","decimals":0,"contractAddress":"0x957c30aB0426e0C93CD8241E2c60392d08c6aC8e","color":"#09547d","coinGeckoId":"modum"},"APPC":{"name":"AppCoins","code":"APPC","decimals":18,"contractAddress":"0x1a7a8BD9106F2B8D977E08582DC7d24c723ab0DB","color":"#fd875e","coinGeckoId":"appcoins"},"EURS":{"name":"STASIS EURS Token","code":"EURS","decimals":2,"contractAddress":"0xdB25f211AB05b1c97D595516F45794528a807ad8","coinGeckoId":"stasis-eurs"},"AMLT":{"name":"AMLT","code":"AMLT","decimals":18,"contractAddress":"0xCA0e7269600d353F70b14Ad118A49575455C0f2f","coinGeckoId":"coinfirm-amlt"},"SNX":{"name":"Synthetix Network Token","code":"SNX","decimals":18,"contractAddress":"0xC011a73ee8576Fb46F5E1c5751cA3B9Fe0af2a6F","coinGeckoId":"havven"},"SUSD":{"name":"Synth sUSD","code":"SUSD","decimals":18,"contractAddress":"0x57Ab1ec28D129707052df4dF418D58a2D46d5f51","coinGeckoId":"nusd"},"SETH":{"name":"Synth sETH","code":"SETH","decimals":18,"contractAddress":"0x5e74C9036fb86BD7eCdcb084a0673EFc32eA31cb","coinGeckoId":"seth"},"SBTC":{"name":"Synth sBTC","code":"SBTC","decimals":18,"contractAddress":"0xfE18be6b3Bd88A2D2A7f928d00292E7a9963CfC6","coinGeckoId":"sbtc"},"IQN":{"name":"IQeon","code":"IQN","decimals":18,"contractAddress":"0x0DB8D8b76BC361bAcbB72E2C491E06085A97Ab31","coinGeckoId":"iqeon"},"C10":{"name":"CRYPTO10 Hedged","code":"C10","decimals":18,"contractAddress":"0x000C100050E98C91f9114fa5Dd75CE6869Bf4F53"},"C20":{"name":"Crypto20","code":"C20","decimals":18,"contractAddress":"0x26E75307Fc0C021472fEb8F727839531F112f317","coinGeckoId":"crypto20"},"PLAY":{"name":"Herocoin","code":"PLAY","decimals":18,"contractAddress":"0xE477292f1B3268687A29376116B0ED27A9c76170","coinGeckoId":"herocoin"},"GEE":{"name":"Geens Platform Token","code":"GEE","decimals":8,"contractAddress":"0x4F4f0Db4de903B88f2B1a2847971E231D54F8fd3"},"MLN":{"name":"Melon","code":"MLN","decimals":18,"contractAddress":"0xec67005c4E498Ec7f55E092bd1d35cbC47C91892","color":"#0b1529","coinGeckoId":"melon"},"HGT":{"name":"HelloGold Token","code":"HGT","decimals":8,"contractAddress":"0xba2184520A1cC49a6159c57e61E1844E085615B6","coinGeckoId":"hellogold"},"GOLDX":{"name":"GOLDX","code":"GOLDX","decimals":18,"contractAddress":"0xeAb43193CF0623073Ca89DB9B712796356FA7414"},"JET":{"name":"Jetcoin Institute Token","code":"JET","decimals":18,"contractAddress":"0x8727c112C712c4a03371AC87a74dD6aB104Af768","coinGeckoId":"jetcoin"},"IND":{"name":"Indorse Token","code":"IND","decimals":18,"contractAddress":"0xf8e386EDa857484f5a12e4B5DAa9984E06E73705","coinGeckoId":"indorse"},"NDC":{"name":"NEVERDIE Coin","code":"NDC","decimals":18,"contractAddress":"0xA54ddC7B3CcE7FC8b1E3Fa0256D0DB80D2c10970","coinGeckoId":"neverdie"},"BCPT":{"name":"BlockMason Credit Protocol Token","code":"BCPT","decimals":18,"contractAddress":"0x1c4481750daa5Ff521A2a7490d9981eD46465Dbd","color":"#404040","coinGeckoId":"blockmason-credit-protocol"},"SPN":{"name":"Sapien Network Token","code":"SPN","decimals":6,"contractAddress":"0x20F7A3DdF244dc9299975b4Da1C39F8D5D75f05A","coinGeckoId":"sapien"},"LOOM":{"name":"Loom Network Token","code":"LOOM","decimals":18,"contractAddress":"0xA4e8C3Ec456107eA67d3075bF9e3DF3A75823DB0","color":"#48beff","coinGeckoId":"loom-network"},"CELR":{"name":"Celer Network Token","code":"CELR","decimals":18,"contractAddress":"0x4F9254C83EB525f9FCf346490bbb3ed28a81C667","coinGeckoId":"celer-network"},"GLA":{"name":"Gladius","code":"GLA","decimals":8,"contractAddress":"0x71D01dB8d6a2fBEa7f8d434599C237980C234e4C","coinGeckoId":"gladius-token"},"KNC":{"name":"Kyber Network Crystal","code":"KNC","decimals":18,"contractAddress":"0xdd974D5C2e2928deA5F71b9825b8b646686BD200","color":"#188c92","coinGeckoId":"kyber-network"},"BNT":{"name":"Bancor Network Token","code":"BNT","decimals":18,"contractAddress":"0x1F573D6Fb3F13d689FF844B4cE37794d79a7FF1C","color":"#000d2b","coinGeckoId":"bancor"},"LUN":{"name":"Lunyr Token","code":"LUN","decimals":18,"contractAddress":"0xfa05A73FfE78ef8f1a739473e462c54bae6567D9","color":"#f55749","coinGeckoId":"lunyr"},"LEDU":{"name":"LEDU Token","code":"LEDU","decimals":8,"contractAddress":"0xC741f06082AA47F93729070aD0dD95E223Bda091"},"VSL":{"name":"vSlice","code":"VSL","decimals":18,"contractAddress":"0x5c543e7AE0A1104f78406C340E9C64FD9fCE5170"},"BCAP":{"name":"Blockchain Capital","code":"BCAP","decimals":0,"contractAddress":"0x1f41E42D0a9e3c0Dd3BA15B527342783B43200A9","coinGeckoId":"bcap"},"TIME":{"name":"Chronobank TIME","code":"TIME","decimals":8,"contractAddress":"0x6531f133e6DeeBe7F2dcE5A0441aA7ef330B4e53"},"TAAS":{"name":"Token-as-a-Service","code":"TAAS","decimals":6,"contractAddress":"0xE7775A6e9Bcf904eb39DA2b68c5efb4F9360e08C","color":"#002342","coinGeckoId":"taas"},"TKN":{"name":"Monolith TKN","code":"TKN","decimals":8,"contractAddress":"0xaAAf91D9b90dF800Df4F55c205fd6989c977E73a","color":"#24dd7b","coinGeckoId":"tokencard"},"EDG":{"name":"Edgeless","code":"EDG","decimals":0,"contractAddress":"0x08711D3B02C8758F2FB3ab4e80228418a7F8e39c","color":"#2b1544","coinGeckoId":"edgeless"},"GUP":{"name":"Guppy","code":"GUP","decimals":3,"contractAddress":"0xf7B098298f7C69Fc14610bf71d5e02c60792894C","color":"#37dcd8","coinGeckoId":"matchpool"},"XAUR":{"name":"Xaurum","code":"XAUR","decimals":8,"contractAddress":"0x4DF812F6064def1e5e029f1ca858777CC98D2D81","coinGeckoId":"xaurum"},"SWT":{"name":"Swarm City Token","code":"SWT","decimals":18,"contractAddress":"0xB9e7F8568e08d5659f5D29C4997173d84CdF2607","coinGeckoId":"swarm-city"},"TRST":{"name":"Trustcoin","code":"TRST","decimals":6,"contractAddress":"0xCb94be6f13A1182E4A4B6140cb7bf2025d28e41B","coinGeckoId":"wetrust"},"ANTv1":{"name":"Aragon Network Token v1","code":"ANTv1","decimals":18,"contractAddress":"0x960b236A07cf122663c4303350609A66A7B288C0"},"WINGS":{"name":"WINGS","code":"WINGS","decimals":18,"contractAddress":"0x667088b212ce3d06a1b553a7221E1fD19000d9aF","color":"#0dc9f7","coinGeckoId":"wings"},"FKX":{"name":"Knoxstertoken","code":"FKX","decimals":18,"contractAddress":"0x009e864923b49263c7F10D19B7f8Ab7a9A5AAd33","coinGeckoId":"fortknoxter"},"1ST":{"name":"FirstBlood Token","code":"1ST","decimals":18,"contractAddress":"0xAf30D2a7E90d7DC361c8C4585e9BB7D2F6f15bc7","coinGeckoId":"first-blood"},"RLC":{"name":"iExec RLC Token","code":"RLC","decimals":9,"contractAddress":"0x607F4C5BB672230e8672085532f7e901544a7375","color":"#ffd800","coinGeckoId":"iexec-rlc"},"SNGLS":{"name":"SingularDTV","code":"SNGLS","decimals":0,"contractAddress":"0xaeC2E87E0A235266D9C5ADc9DEb4b2E29b54D009","color":"#b30d23","coinGeckoId":"singulardtv"},"ICN":{"name":"ICONOMI","code":"ICN","decimals":18,"contractAddress":"0x888666CA69E0f178DED6D75b5726Cee99A87D698","color":"#4c6f8c","coinGeckoId":"iconomi"},"DGD":{"name":"Digix","code":"DGD","decimals":9,"contractAddress":"0xE0B7927c4aF23765Cb51314A0E0521A9645F0E2A","color":"#f4d029","coinGeckoId":"digixdao"},"MKR":{"name":"Maker","code":"MKR","decimals":18,"contractAddress":"0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2","color":"#1abc9c","coinGeckoId":"maker"},"SAI":{"name":"Sai Stablecoin v1.0","code":"SAI","decimals":18,"contractAddress":"0x89d24A6b4CcB1B6fAA2625fE562bDD9a23260359","color":"#b68900","coinGeckoId":"sai"},"DAI":{"name":"Dai Stablecoin","code":"DAI","decimals":18,"contractAddress":"0x6B175474E89094C44Da98b954EedeAC495271d0F","color":"#AB7E21","coinGeckoId":"dai"},"AMPL":{"name":"Ampleforth","code":"AMPL","decimals":9,"contractAddress":"0xD46bA6D942050d489DBd938a2C909A5d5039A161","color":"#000000","coinGeckoId":"ampleforth"},"MFT":{"name":"Mainframe Token","code":"MFT","decimals":18,"contractAddress":"0xDF2C7238198Ad8B389666574f2d8bc411A4b7428","color":"#da1157","coinGeckoId":"mainframe"},"BAT":{"name":"Basic Attention Token","code":"BAT","decimals":18,"contractAddress":"0x0D8775F648430679A709E98d2b0Cb6250d2887EF","color":"#ff5000","coinGeckoId":"basic-attention-token"},"BEE":{"name":"BEE Token","code":"BEE","decimals":18,"contractAddress":"0x4D8fc1453a0F359e99c9675954e656D80d996FbF","coinGeckoId":"bee-token"},"GNO":{"name":"Gnosis Token","code":"GNO","decimals":18,"contractAddress":"0x6810e776880C02933D47DB1b9fc05908e5386b96","color":"#00a6c4","coinGeckoId":"gnosis"},"LINK":{"name":"Chainlink Token","code":"LINK","decimals":18,"contractAddress":"0x514910771AF9Ca656af840dff83E8264EcF986CA","color":"#01a6fb","coinGeckoId":"chainlink"},"PLU":{"name":"Pluton","code":"PLU","decimals":18,"contractAddress":"0xD8912C10681D8B21Fd3742244f44658dBA12264E","coinGeckoId":"pluton"},"REP":{"name":"Reputation Old","code":"REP","decimals":18,"contractAddress":"0x1985365e9f78359a9B6AD760e32412f4a445E862","color":"#602a52"},"REPv2":{"name":"Reputation","code":"REPv2","decimals":18,"contractAddress":"0x221657776846890989a759BA2973e427DfF5C9bB","coinGeckoId":"augur"},"RFR":{"name":"Refereum","code":"RFR","decimals":4,"contractAddress":"0xd0929d411954c47438dc1d871dd6081F5C5e149c","coinGeckoId":"refereum"},"NFC":{"name":"NoFakeCoin","code":"NFC","decimals":18,"contractAddress":"0xb0866289e870D2efc282406cF4123Df6E5BcB652","coinGeckoId":"nofakecoin"},"OST":{"name":"Open Simple Token","code":"OST","decimals":18,"contractAddress":"0x2C4e8f2D746113d0696cE89B35F0d8bF88E0AEcA","color":"#34445b","coinGeckoId":"simple-token"},"REN":{"name":"Republic Token","code":"REN","decimals":18,"contractAddress":"0x408e41876cCCDC0F92210600ef50372656052a38","color":"#001b3a","coinGeckoId":"republic-protocol"},"renBTC":{"name":"renBTC","code":"renBTC","decimals":8,"contractAddress":"0xEB4C2781e4ebA804CE9a9803C67d0893436bB27D","coinGeckoId":"renbtc"},"renZEC":{"name":"renZEC","code":"renZEC","decimals":8,"contractAddress":"0x1C5db575E2Ff833E46a2E9864C22F4B22E0B37C2","coinGeckoId":"renzec"},"renBCH":{"name":"renBCH","code":"renBCH","decimals":8,"contractAddress":"0x459086F2376525BdCebA5bDDA135e4E9d3FeF5bf","coinGeckoId":"renbch"},"renFIL":{"name":"renFIL","code":"renFIL","decimals":18,"contractAddress":"0xD5147bc8e386d91Cc5DBE72099DAC6C9b99276F5","coinGeckoId":"renfil"},"GNT":{"name":"Golem Network Token","code":"GNT","decimals":18,"contractAddress":"0xa74476443119A942dE498590Fe1f2454d7D4aC0d","color":"#001d57"},"SIG":{"name":"Spectiv Signal Token","code":"SIG","decimals":18,"contractAddress":"0x6888a16eA9792c15A4DCF2f6C623D055c8eDe792","coinGeckoId":"signal-token"},"QTUM":{"name":"Qtum","code":"QTUM","decimals":18,"contractAddress":"0x9a642d6b3368ddc662CA244bAdf32cDA716005BC","color":"#2e9ad0"},"CAT":{"name":"BitClave","code":"CAT","decimals":18,"contractAddress":"0x1234567461d3f8Db7496581774Bd869C83D51c93","coinGeckoId":"bitclave"},"CAG":{"name":"Change Coin","code":"CAG","decimals":18,"contractAddress":"0x7d4b8Cce0591C9044a22ee543533b72E976E36C3","coinGeckoId":"change"},"CAN":{"name":"CanYaCoin","code":"CAN","decimals":6,"contractAddress":"0x1d462414fe14cf489c7A21CaC78509f4bF8CD7c0","coinGeckoId":"canyacoin"},"RVT":{"name":"Rivetz","code":"RVT","decimals":18,"contractAddress":"0x3d1BA9be9f66B8ee101911bC36D3fB562eaC2244","coinGeckoId":"rivetz"},"WYV":{"name":"Project Wyvern Token","code":"WYV","decimals":18,"contractAddress":"0x056017c55aE7AE32d12AeF7C679dF83A85ca75Ff"},"ART":{"name":"Maecenas ART Token","code":"ART","decimals":18,"contractAddress":"0xfec0cF7fE078a500abf15F1284958F22049c2C7e","coinGeckoId":"maecenas"},"ZIL":{"name":"Zilliqa","code":"ZIL","decimals":12,"contractAddress":"0x05f4a42e251f2d52b8ed15E9FEdAacFcEF1FAD27","color":"#49c1bf"},"BMX":{"name":"BitMartToken","code":"BMX","decimals":18,"contractAddress":"0x986EE2B944c42D017F52Af21c4c69B84DBeA35d8","coinGeckoId":"bitmart-token"},"VIEW":{"name":"Viewly","code":"VIEW","decimals":18,"contractAddress":"0xF03f8D65BaFA598611C3495124093c56e8F638f0","coinGeckoId":"viewly"},"WETH":{"name":"Wrapped Ether","code":"WETH","decimals":18,"contractAddress":"0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2","coinGeckoId":"weth"},"cBAT":{"name":"Compound Basic Attention Token","code":"cBAT","decimals":8,"contractAddress":"0x6C8c6b02E7b2BE14d4fA6022Dfd6d75921D90E4E","coinGeckoId":"compound-basic-attention-token"},"cDAI":{"name":"Compound Dai","code":"cDAI","decimals":8,"contractAddress":"0x5d3a536E4D6DbD6114cc1Ead35777bAB948E3643","coinGeckoId":"cdai"},"cSAI":{"name":"Compound Sai (Legacy Dai)","code":"cSAI","decimals":8,"contractAddress":"0xF5DCe57282A584D2746FaF1593d3121Fcac444dC","coinGeckoId":"compound-sai"},"cETH":{"name":"Compound Ether","code":"cETH","decimals":8,"contractAddress":"0x4Ddc2D193948926D02f9B1fE9e1daa0718270ED5","coinGeckoId":"compound-ether"},"cREP":{"name":"Compound Augur","code":"cREP","decimals":8,"contractAddress":"0x158079Ee67Fce2f58472A96584A73C7Ab9AC95c1","coinGeckoId":"compound-augur"},"cUSDC":{"name":"Compound USD Coin","code":"cUSDC","decimals":8,"contractAddress":"0x39AA39c021dfbaE8faC545936693aC917d5E7563","coinGeckoId":"compound-usd-coin"},"cUSDT":{"name":"Compound Tether","code":"cUSDT","decimals":8,"contractAddress":"0xf650C3d88D12dB855b8bf7D11Be6C55A4e07dCC9","coinGeckoId":"compound-usdt"},"cWBTC":{"name":"Compound Wrapped BTC","code":"cWBTC","decimals":8,"contractAddress":"0xC11b1268C1A384e55C48c2391d8d480264A3A7F4","coinGeckoId":"compound-wrapped-btc"},"cZRX":{"name":"Compound 0x","code":"cZRX","decimals":8,"contractAddress":"0xB3319f5D18Bc0D84dD1b4825Dcde5d5f7266d407","coinGeckoId":"compound-0x"},"COMP":{"name":"Compound","code":"COMP","decimals":18,"contractAddress":"0xc00e94Cb662C3520282E6f5717214004A7f26888","coinGeckoId":"compound-governance-token"},"NANJ":{"name":"NANJCOIN","code":"NANJ","decimals":8,"contractAddress":"0xFFE02ee4C69eDf1b340fCaD64fbd6b37a7b9e265","coinGeckoId":"nanjcoin"},"0xBTC":{"name":"0xBitcoin Token","code":"0xBTC","decimals":8,"contractAddress":"0xB6eD7644C69416d67B522e20bC294A9a9B405B31","coinGeckoId":"oxbitcoin"},"SNT":{"name":"Status Network Token","code":"SNT","decimals":18,"contractAddress":"0x744d70FDBE2Ba4CF95131626614a1763DF805B9E","color":"#5b6dee","coinGeckoId":"status"},"SPANK":{"name":"SPANK","code":"SPANK","decimals":18,"contractAddress":"0x42d6622deCe394b54999Fbd73D108123806f6a18","color":"#ff3b81","coinGeckoId":"spankchain"},"BOOTY":{"name":"BOOTY","code":"BOOTY","decimals":18,"contractAddress":"0x6B01c3170ae1EFEBEe1a3159172CB3F7A5ECf9E5","color":"#00b4f4"},"BBK":{"name":"Brickblock","code":"BBK","decimals":18,"contractAddress":"0x4a6058666cf1057eaC3CD3A5a614620547559fc9","coinGeckoId":"brickblock"},"IMP":{"name":"Ether Kingdoms Token","code":"IMP","decimals":7,"contractAddress":"0x48FF53777F747cFB694101222a944dE070c15D36","coinGeckoId":"ether-kingdoms-token"},"LIKE":{"name":"LikeCoin","code":"LIKE","decimals":18,"contractAddress":"0x02F61Fd266DA6E8B102D4121f5CE7b992640CF98","coinGeckoId":"likecoin-erc20"},"VEN":{"name":"VeChain","code":"VEN","decimals":18,"contractAddress":"0xD850942eF8811f2A866692A623011bDE52a462C1","coinGeckoId":"vechain-old-erc20"},"ICX":{"name":"ICON","code":"ICX","decimals":18,"contractAddress":"0xb5A5F22694352C15B00323844aD545ABb2B11028","color":"#1fc5c9"},"AERGO":{"name":"Aergo","code":"AERGO","decimals":18,"contractAddress":"0x91Af0fBB28ABA7E31403Cb457106Ce79397FD4E6","coinGeckoId":"aergo"},"AE":{"name":"Aeternity","code":"AE","decimals":18,"contractAddress":"0x5CA9a71B1d01849C0a95490Cc00559717fCF0D1d","color":"#de3f6b","coinGeckoId":"aeternity"},"PPT":{"name":"Populous","code":"PPT","decimals":8,"contractAddress":"0xd4fa1460F537bb9085d22C7bcCB5DD450Ef28e3a","color":"#152743","coinGeckoId":"populous"},"IOST":{"name":"IOST","code":"IOST","decimals":18,"contractAddress":"0xFA1a856Cfa3409CFa145Fa4e20Eb270dF3EB21ab","color":"#1c1c1c"},"KCS":{"name":"Kucoin Shares","code":"KCS","decimals":6,"contractAddress":"0x039B5649A59967e3e936D7471f9c3700100Ee1ab","color":"#0093dd","coinGeckoId":"kucoin-shares"},"MITH":{"name":"Mithril","code":"MITH","decimals":18,"contractAddress":"0x3893b9422Cd5D70a81eDeFfe3d5A1c6A978310BB","color":"#00316d","coinGeckoId":"mithril"},"WTC":{"name":"Walton","code":"WTC","decimals":18,"contractAddress":"0xb7cB1C96dB6B22b0D3d9536E0108d062BD488F74","color":"#8200ff","coinGeckoId":"waltonchain"},"NMR":{"name":"Numeraire","code":"NMR","decimals":18,"contractAddress":"0x1776e1F26f98b1A5dF9cD347953a26dd3Cb46671","coinGeckoId":"numeraire"},"GUSD":{"name":"Gemini Dollar","code":"GUSD","decimals":2,"contractAddress":"0x056Fd409E1d7A124BD7017459dFEa2F387b6d5Cd","color":"#00dcfa","coinGeckoId":"gemini-dollar"},"USDC":{"name":"USD Coin","code":"USDC","decimals":6,"contractAddress":"0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48","color":"#2775c9","coinGeckoId":"usd-coin"},"PNK":{"name":"Pinakion Token","code":"PNK","decimals":18,"contractAddress":"0x93ED3FBe21207Ec2E8f2d3c3de6e058Cb73Bc04d","coinGeckoId":"kleros"},"FUN":{"name":"FunFair","code":"FUN","decimals":8,"contractAddress":"0x419D0d8BdD9aF5e606Ae2232ed285Aff190E711b","color":"#ed1968","coinGeckoId":"funfair"},"YEED":{"name":"YGGDRASH YEED Token","code":"YEED","decimals":18,"contractAddress":"0xcA2796F9F61dc7b238Aab043971e49c6164DF375","coinGeckoId":"yggdrash"},"DSCP":{"name":"Disciplina Token","code":"DSCP","decimals":18,"contractAddress":"0x03e3f0c25965f13DbbC58246738C183E27b26a56","coinGeckoId":"disciplina-project-by-teachmeplease"},"DAY":{"name":"Chronologic DAY Token","code":"DAY","decimals":18,"contractAddress":"0xE814aeE960a85208C3dB542C53E7D4a6C8D5f60F","coinGeckoId":"chronologic"},"PLAT":{"name":"PLATINUM","code":"PLAT","decimals":18,"contractAddress":"0x7E43581b19ab509BCF9397a2eFd1ab10233f27dE"},"PAX":{"name":"PAX Stablecoin","code":"PAX","decimals":18,"contractAddress":"0x8E870D67F660D95d5be530380D0eC0bd388289E1","color":"#ede708","coinGeckoId":"paxos-standard"},"PAXG":{"name":"PAX Gold","code":"PAXG","decimals":18,"contractAddress":"0x45804880De22913dAFE09f4980848ECE6EcbAf78","coinGeckoId":"pax-gold"},"TUSD":{"name":"TrueUSD","code":"TUSD","decimals":18,"contractAddress":"0x0000000000085d4780B73119b644AE5ecd22b376","color":"#2b2e7f","coinGeckoId":"true-usd"},"BUSD":{"name":"Binance USD","code":"BUSD","decimals":18,"contractAddress":"0x4Fabb145d64652a948d72533023f6E7A623C7C53","coinGeckoId":"binance-usd"},"MAS":{"name":"MidasProtocol","code":"MAS","decimals":18,"contractAddress":"0x23Ccc43365D9dD3882eab88F43d515208f832430","coinGeckoId":"midas-protocol"},"ROCK2":{"name":"ICE ROCK MINING","code":"ROCK2","decimals":0,"contractAddress":"0xC16b542ff490e01fcc0DC58a60e1EFdc3e357cA6","coinGeckoId":"ice-rock-mining"},"POA20":{"name":"POA20 Token","code":"POA20","decimals":18,"contractAddress":"0x6758B7d441a9739b98552B373703d8d3d14f9e62"},"LTO":{"name":"LTO Network Token","code":"LTO","decimals":8,"contractAddress":"0x3DB6Ba6ab6F95efed1a6E794caD492fAAabF294D","coinGeckoId":"lto-network"},"VIDT":{"name":"VIDT Datalink","code":"VIDT","decimals":18,"contractAddress":"0xfeF4185594457050cC9c23980d301908FE057Bb1","coinGeckoId":"v-id-blockchain"},"CPLO":{"name":"Cpollo","code":"CPLO","decimals":18,"contractAddress":"0x7064aAb39A0Fcf7221c3396719D0917a65E35515","coinGeckoId":"cpollo"},"NEEO":{"name":"NEEO","code":"NEEO","decimals":18,"contractAddress":"0xd8446236FA95b9b5f9fd0f8E7Df1a944823c683d","coinGeckoId":"neeo-token"},"NEU":{"name":"Neumark","code":"NEU","decimals":18,"contractAddress":"0xA823E6722006afe99E91c30FF5295052fe6b8E32","color":"#b3ba00","coinGeckoId":"neumark"},"DATA":{"name":"Streamr","code":"DATA","decimals":18,"contractAddress":"0x0Cf0Ee63788A0849fE5297F3407f701E122cC023","color":"#e9570f","coinGeckoId":"streamr-datacoin"},"CRO":{"name":"Crypto.com Chain","code":"CRO","decimals":8,"contractAddress":"0xA0b73E1Ff0B80914AB6fe0444E65848C4C34450b","coinGeckoId":"crypto-com-chain"},"STAR":{"name":"STAR","code":"STAR","decimals":18,"contractAddress":"0xF70a642bD387F94380fFb90451C2c81d4Eb82CBc","coinGeckoId":"starbase"},"SAN":{"name":"Santiment","code":"SAN","decimals":18,"contractAddress":"0x7C5A0CE9267ED19B22F8cae653F198e3E8daf098","color":"#2b77b3","coinGeckoId":"santiment-network-token"},"LPT":{"name":"Livepeer","code":"LPT","decimals":18,"contractAddress":"0x58b6A8A3302369DAEc383334672404Ee733aB239","color":"#000000","coinGeckoId":"livepeer"},"PROPS":{"name":"Props","code":"PROPS","decimals":18,"contractAddress":"0x6fe56C0bcdD471359019FcBC48863d6c3e9d4F41","coinGeckoId":"props"},"HOT":{"name":"HoloToken","code":"HOT","decimals":18,"contractAddress":"0x6c6EE5e31d828De241282B9606C8e98Ea48526E2","color":"#8834ff","coinGeckoId":"holotoken"},"ENJ":{"name":"Enjin Coin","code":"ENJ","decimals":18,"contractAddress":"0xF629cBd94d3791C9250152BD8dfBDF380E2a3B9c","color":"#624dbf","coinGeckoId":"enjincoin"},"ELF":{"name":"AELF","code":"ELF","decimals":18,"contractAddress":"0xbf2179859fc6D5BEE9Bf9158632Dc51678a4100e","color":"#2b5ebb","coinGeckoId":"aelf"},"WAX":{"name":"Wax","code":"WAX","decimals":8,"contractAddress":"0x39Bb259F66E1C59d5ABEF88375979b4D20D98022","color":"#f89022"},"POWR":{"name":"PowerLedger","code":"POWR","decimals":6,"contractAddress":"0x595832F8FC6BF59c85C527fEC3740A1b7a361269","color":"#05bca9","coinGeckoId":"power-ledger"},"XBP":{"name":"BlitzPredict","code":"XBP","decimals":18,"contractAddress":"0x28dee01D53FED0Edf5f6E310BF8Ef9311513Ae40","color":"#21af67","coinGeckoId":"blitzpredict"},"KODA":{"name":"KnownOrigin","code":"KODA","decimals":0,"contractAddress":"0xFBeef911Dc5821886e1dda71586d90eD28174B7d"},"OGN":{"name":"Origin Protocol","code":"OGN","decimals":18,"contractAddress":"0x8207c1FfC5B6804F6024322CcF34F29c3541Ae26","coinGeckoId":"origin-protocol"},"REQ":{"name":"Request","code":"REQ","decimals":18,"contractAddress":"0x8f8221aFbB33998d8584A2B05749bA73c37a938a","color":"#00e6a0","coinGeckoId":"request-network"},"BETHER":{"name":"Bethereum","code":"BETHER","decimals":18,"contractAddress":"0x14C926F2290044B647e1Bf2072e67B495eff1905","coinGeckoId":"bethereum"},"HUNT":{"name":"Hunt Token","code":"HUNT","decimals":18,"contractAddress":"0x9AAb071B4129B083B01cB5A0Cb513Ce7ecA26fa5","coinGeckoId":"hunt-token"},"METM":{"name":"Metamorph","code":"METM","decimals":18,"contractAddress":"0xFEF3884b603C33EF8eD4183346E093A173C94da6","coinGeckoId":"metamorph"},"DNT":{"name":"district0x","code":"DNT","decimals":18,"contractAddress":"0x0AbdAce70D3790235af448C88547603b945604ea","color":"#2c398f","coinGeckoId":"district0x"},"NUSD":{"name":"Neutral Dollar","code":"NUSD","decimals":6,"contractAddress":"0x0C6144c16af288948C8fdB37fD8fEc94bfF3d1d9","coinGeckoId":"neutral-dollar"},"MINDS":{"name":"Minds","code":"MINDS","decimals":18,"contractAddress":"0xB26631c6dda06aD89B93C71400D25692de89c068","coinGeckoId":"minds"},"SOUL":{"name":"CryptoSoul","code":"SOUL","decimals":18,"contractAddress":"0xBb1f24C0c1554b9990222f036b0AaD6Ee4CAec29","coinGeckoId":"cryptosoul"},"OGO":{"name":"Origo","code":"OGO","decimals":18,"contractAddress":"0xFF0E5e014cf97e0615cb50F6f39Da6388E2FaE6E","coinGeckoId":"origo"},"DANK":{"name":"DANKToken","code":"DANK","decimals":18,"contractAddress":"0x0cB8D0B37C7487b11d57F1f33dEfA2B1d3cFccfE"},"PLA":{"name":"PlayDapp Token","code":"PLA","decimals":18,"contractAddress":"0x3a4f40631a4f906c2BaD353Ed06De7A5D3fCb430"},"STMX":{"name":"StormX Token","code":"STMX","decimals":18,"contractAddress":"0xbE9375C6a420D2eEB258962efB95551A5b722803","coinGeckoId":"storm"},"WMATIC":{"name":"Wrapped Matic Network Token","code":"MATIC","decimals":18,"contractAddress":"0x7D1AfA7B718fb893dB30A3aBc0Cfc608AaCfeBB0","color":"#2b6def","coinGeckoId":"matic-network"},"POLY":{"name":"Polymath","code":"POLY","decimals":18,"contractAddress":"0x9992eC3cF6A55b00978cdDF2b27BC6882d88D1eC","color":"#4c5a95","coinGeckoId":"polymath-network"},"LGO":{"name":"LGO Token","code":"LGO","decimals":8,"contractAddress":"0x0a50C93c762fDD6E56D86215C24AaAD43aB629aa","coinGeckoId":"legolas-exchange"},"LVN":{"name":"LivenCoin","code":"LVN","decimals":18,"contractAddress":"0xc8Cac7672f4669685817cF332a33Eb249F085475","coinGeckoId":"livenpay"},"LRC":{"name":"Loopring","code":"LRC","decimals":18,"contractAddress":"0xBBbbCA6A901c926F240b89EacB641d8Aec7AEafD","color":"#2ab6f6","coinGeckoId":"loopring"},"RDN":{"name":"Raiden Network Token","code":"RDN","decimals":18,"contractAddress":"0x255Aa6DF07540Cb5d3d297f0D0D4D84cb52bc8e6","color":"#2a2a2a","coinGeckoId":"raiden-network"},"LMY":{"name":"Lunch Money","code":"LMY","decimals":18,"contractAddress":"0x66fD97a78d8854fEc445cd1C80a07896B0b4851f","coinGeckoId":"lunch-money"},"TLN":{"name":"Trustlines Network Token","code":"TLN","decimals":18,"contractAddress":"0x679131F591B4f369acB8cd8c51E68596806c3916","coinGeckoId":"trustline-network"},"TOP":{"name":"TOP Network Token","code":"TOP","decimals":18,"contractAddress":"0xdcD85914b8aE28c1E62f1C488E1D968D5aaFfE2b","coinGeckoId":"top-network"},"FET":{"name":"Fetch","code":"FET","decimals":18,"contractAddress":"0xaea46A60368A7bD060eec7DF8CBa43b7EF41Ad85","coinGeckoId":"fetch-ai"},"MTLX":{"name":"Mettalex","code":"MTLX","decimals":18,"contractAddress":"0x2e1E15C44Ffe4Df6a0cb7371CD00d5028e571d14","coinGeckoId":"mettalex"},"UNI":{"name":"Uniswap","code":"UNI","decimals":18,"contractAddress":"0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984","coinGeckoId":"uniswap"},"YFDOT":{"name":"Yearn Finance Dot","code":"YFDOT","decimals":18,"contractAddress":"0x2e6539edc3b76f1E21B71d214527FAbA875F70F3","coinGeckoId":"yearn-finance-dot"},"KTON":{"name":"Darwinia Commitment Token","code":"KTON","decimals":18,"contractAddress":"0x9F284E1337A815fe77D2Ff4aE46544645B20c5ff","coinGeckoId":"darwinia-commitment-token"},"2KEY":{"name":"TwoKeyEconomy","code":"2KEY","decimals":18,"contractAddress":"0xE48972fCd82a274411c01834e2f031D4377Fa2c0","coinGeckoId":"2key"},"STAKE":{"name":"STAKE Token","code":"STAKE","decimals":18,"contractAddress":"0x0Ae055097C6d159879521C384F1D2123D1f195e6","coinGeckoId":"xdai-stake"},"DKA":{"name":"dKargo","code":"DKA","decimals":18,"contractAddress":"0x5dc60C4D5e75D22588FA17fFEB90A63E535efCE0","coinGeckoId":"dkargo"},"RING":{"name":"Darwinia Network Native Token","code":"RING","decimals":18,"contractAddress":"0x9469D013805bFfB7D3DEBe5E7839237e535ec483","coinGeckoId":"darwinia-network-native-token"},"ROOBEE":{"name":"ROOBEE","code":"ROOBEE","decimals":18,"contractAddress":"0xA31B1767e09f842ECFd4bc471Fe44F830E3891AA","coinGeckoId":"roobee"},"ZCRT":{"name":"ZCore Token","code":"ZCRT","decimals":18,"contractAddress":"0xC7e43A1c8E118aA2965F5EAbe0e718D83DB7A63C","coinGeckoId":"zcore-token"},"DCN":{"name":"Dentacoin Token","code":"DCN","decimals":0,"contractAddress":"0x08d32b0da63e2C3bcF8019c9c5d849d7a9d791e6","color":"#136485","coinGeckoId":"dentacoin"},"mUSD":{"name":"mStable USD","code":"mUSD","decimals":18,"contractAddress":"0xe2f2a5C287993345a840Db3B0845fbC70f5935a5","coinGeckoId":"musd"},"MTA":{"name":"Meta","code":"MTA","decimals":18,"contractAddress":"0xa3BeD4E1c75D00fa6f4E5E6922DB7261B5E9AcD2","coinGeckoId":"meta"},"PLR":{"name":"Pillar","code":"PLR","decimals":18,"contractAddress":"0xe3818504c1B32bF1557b16C238B2E01Fd3149C17","color":"#00bfff","coinGeckoId":"pillar"},"BAL":{"name":"Balancer (BAL)","code":"BAL","decimals":18,"contractAddress":"0xba100000625a3754423978a60c9317c58a424e3D","coinGeckoId":"balancer"},"GET":{"name":"Guaranteed Entrance Token","code":"GET","decimals":18,"contractAddress":"0x8a854288a5976036A725879164Ca3e91d30c6A1B","coinGeckoId":"get-token"},"AUC":{"name":"Auctus","code":"AUC","decimals":18,"contractAddress":"0xc12d099be31567add4e4e4d0D45691C3F58f5663","coinGeckoId":"auctus"},"HUSD":{"name":"HUSD","code":"HUSD","decimals":8,"contractAddress":"0xdF574c24545E5FfEcb9a659c229253D4111d87e1","coinGeckoId":"husd"},"BC":{"name":"Block-Chain.com Token","code":"BC","decimals":18,"contractAddress":"0x2ecB13A8c458c379c4d9a7259e202De03c8F3D19","coinGeckoId":"block-chain-com"},"CVP":{"name":"Concentrated Voting Power","code":"CVP","decimals":18,"contractAddress":"0x38e4adB44ef08F22F5B5b76A8f0c2d0dCbE7DcA1","coinGeckoId":"concentrated-voting-power"},"ANT":{"name":"Aragon Network Token","code":"ANT","decimals":18,"contractAddress":"0xa117000000f279D81A1D3cc75430fAA017FA5A2e","color":"#2cd3e1","coinGeckoId":"aragon"},"WIS":{"name":"Experty Wisdom Token","code":"WIS","decimals":18,"contractAddress":"0xDecade1c6Bf2cD9fb89aFad73e4a519C867adcF5","coinGeckoId":"experty-wisdom-token"},"AXN":{"name":"Axion","code":"AXN","decimals":18,"contractAddress":"0x7D85e23014F84E6E21d5663aCD8751bEF3562352"},"NEXO":{"name":"NEXO","code":"NEXO","decimals":18,"contractAddress":"0xB62132e35a6c13ee1EE0f84dC5d40bad8d815206","color":"#1a4199","coinGeckoId":"nexo"},"CAMP":{"name":"Camp","code":"CAMP","decimals":18,"contractAddress":"0xE9E73E1aE76D17A16cC53E3e87a9a7dA78834d37","coinGeckoId":"camp"},"ATRI":{"name":"Atari Token","code":"ATRI","decimals":0,"contractAddress":"0xdacD69347dE42baBfAEcD09dC88958378780FB62","coinGeckoId":"atari"},"GRT":{"name":"The Graph","code":"GRT","decimals":18,"contractAddress":"0xc944e90c64b2c07662a292be6244bdf05cda44a7","color":"#1a41a9","coinGeckoId":"the-graph"},"SUSHI":{"name":"Sushi","code":"SUSHI","decimals":18,"contractAddress":"0x6b3595068778dd592e39a122f4f5a5cf09c90fe2","color":"#1a41b9","coinGeckoId":"sushi"},"1INCH":{"name":"1INCH","code":"1INCH","decimals":18,"contractAddress":"0x111111111117dc0aa78b770fa6a738034120c302","color":"#1a41c9","coinGeckoId":"1inch"},"USDK":{"name":"USDK","code":"USDK","decimals":18,"contractAddress":"0x1c48f86ae57291f7686349f12601910bd8d470bb","color":"#1a41d9","coinGeckoId":"usdk"},"CRV":{"name":"CRV","code":"CRV","decimals":18,"contractAddress":"0xd533a949740bb3306d119cc777fa900ba034cd52","color":"#1a41e9","coinGeckoId":"curve-dao-token"},"ELON":{"name":"Dogelon MARS","code":"ELON","decimals":18,"contractAddress":"0x761d38e5ddf6ccf6cf7c55759d5210750b5d60f3","color":"#1a41ee","coinGeckoId":"dogelon-mars"},"OCEAN":{"name":"OCEAN Protocol","code":"OCEAN","decimals":18,"contractAddress":"0x967da4048cd07ab37855c090aaf366e4ce1b9f48","color":"#1a413e","coinGeckoId":"ocean-protocol"},"WOO":{"name":"Wootrade Network","code":"WOO","decimals":18,"contractAddress":"0x4691937a7508860f876c9c0a2a617e7d9e945d4b","color":"#1aa13e","coinGeckoId":"woo-network"}}');
    },
    560: function _(e) {
      "use strict";

      e.exports = JSON.parse('{"PWETH":{"name":"Polygon Wrapped Ether","code":"WETH","decimals":18,"contractAddress":"0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619","color":"#5b3159","coinGeckoId":"weth","matchingAsset":"WETH"},"PUSDC":{"name":"Polygon USD Coin","code":"USDC","decimals":6,"contractAddress":"0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174","color":"#5b31b9","coinGeckoId":"usd-coin","matchingAsset":"USDC"},"PUSDT":{"name":"Polygon Tether USD","code":"USDT","decimals":6,"contractAddress":"0xc2132D05D31c914a87C6611C10748AEb04B58e8F","color":"#5b31f9","coinGeckoId":"tether","matchingAsset":"USDT"},"PBUSD":{"name":"Polygon BUSD","code":"BUSD","decimals":18,"contractAddress":"0xdab529f40e671a1d4bf91361c21bf9f0c9712ab7","color":"#5b31a9","coinGeckoId":"binance-usd","matchingAsset":"BUSD"},"PBNB":{"name":"Polygon BNB","code":"WBNB","decimals":18,"contractAddress":"0x3BA4c387f786bFEE076A58914F5Bd38d668B42c3","color":"#1b31a9","coinGeckoId":"wbnb"},"PLINK":{"name":"Polygon LINK","code":"LINK","decimals":18,"contractAddress":"0x53e0bca35ec356bd5dddfebbd1fc0fd03fabad39","color":"#2b31a9","coinGeckoId":"chainlink","matchingAsset":"LINK"},"PDAI":{"name":"Polygon DAI","code":"DAI","decimals":18,"contractAddress":"0x8f3cf7ad23cd3cadbd9735aff958023239c6a063","color":"#3b31a9","coinGeckoId":"dai","matchingAsset":"DAI"},"POMG":{"name":"Polygon OMG","code":"OMG","decimals":18,"contractAddress":"0x62414d03084eeb269e18c970a21f45d2967f0170","color":"#4b31a9","coinGeckoId":"omisego","matchingAsset":"OMG"},"PWBTC":{"name":"Polygon WBTC","code":"WBTC","decimals":8,"contractAddress":"0x1bfd67037b42cf73acf2047067bd4f2c47d9bfd6","color":"#4b31a9","coinGeckoId":"wrapped-bitcoin","matchingAsset":"WBTC"},"PFANTOM":{"name":"Polygon Fantom","code":"FTM","decimals":18,"contractAddress":"0xc9c1c1c20b3658f8787cc2fd702267791f224ce1","color":"#6b31a9","coinGeckoId":"fantom","matchingAsset":"FTM"},"PENJ":{"name":"Polygon Enjin Coin","code":"ENJ","decimals":18,"contractAddress":"0x7ec26842f195c852fa843bb9f6d8b583a274a157","color":"#6b31a9","coinGeckoId":"enjincoin","matchingAsset":"ENJ"},"PUNI":{"name":"Polygon Uniswap","code":"UNI","decimals":18,"contractAddress":"0xb33eaad8d922b1083446dc23f610c2567fb5180f","color":"#6ba1a9","coinGeckoId":"uniswap","matchingAsset":"UNI"},"PGRT":{"name":"Polygon The Graph","code":"GRT","decimals":18,"contractAddress":"0x5fe2b58c013d7601147dcdd68c143a77499f5531","color":"#6b31c9","coinGeckoId":"the-graph","matchingAsset":"GRT"},"PHUSD":{"name":"Polygon HUSD","code":"HUSD","decimals":8,"contractAddress":"0x2088c47fc0c78356c622f79dba4cbe1ccfa84a91","color":"#6b3ea9","coinGeckoId":"husd","matchingAsset":"HUSD"},"PAAVE":{"name":"Polygon Aave","code":"AAVE","decimals":18,"contractAddress":"0xd6df932a45c0f255f85145f286ea0b292b21c90b","color":"#6b38a9","coinGeckoId":"aave","matchingAsset":"AAVE"},"PSUSHI":{"name":"Polygon Sushi","code":"SUSHI","decimals":18,"contractAddress":"0x0b3f868e0be5597d5db7feb59e1cadbb0fdda50a","color":"#6b37a9","coinGeckoId":"sushi","matchingAsset":"SUSHI"},"P1INCH":{"name":"Polygon 1INCH","code":"1INCH","decimals":18,"contractAddress":"0x9c2c5fd7b07e95ee044ddeba0e97a665f142394f","color":"#6b23a9","coinGeckoId":"1INCH","matchingAsset":"1INCH"},"PUSDK":{"name":"Polygon USDK","code":"USDK","decimals":18,"contractAddress":"0xd07a7fac2857901e4bec0d89bbdae764723aab86","color":"#6cd1a9","coinGeckoId":"usdk","matchingAsset":"USDK"},"PHOT":{"name":"Polygon HoloToken","code":"HOT","decimals":18,"contractAddress":"0x0c51f415cf478f8d08c246a6c6ee180c5dc3a012","color":"#8834ff","coinGeckoId":"holotoken","matchingAsset":"HOT"},"PYFI":{"name":"Polygon yearn.finance","code":"YFI","decimals":18,"contractAddress":"0xda537104d6a5edd53c6fbba9a898708e465260b6","color":"#007ae3","coinGeckoId":"yearn-finance","matchingAsset":"YFI"},"PCRV":{"name":"Polygon CRV","code":"CRV","decimals":18,"contractAddress":"0x172370d5cd63279efa6d502dab29171933a610af","color":"#1a41e9","coinGeckoId":"curve-dao-token","matchingAsset":"CRV"},"PCOMP":{"name":"Polygon Compound","code":"COMP","decimals":18,"contractAddress":"0x8505b9d2254a7ae468c0e9dd10ccea3a837aef5c","color":"#1a41f9","coinGeckoId":"compound-governance-token","matchingAsset":"COMP"},"PZRX":{"name":"Polygon 0x","code":"ZRX","decimals":18,"contractAddress":"0x5559edb74751a0ede9dea4dc23aee72cca6be3d5","color":"#302c3c","coinGeckoId":"0x","matchingAsset":"ZRX"},"PTUSD":{"name":"Polygon TrueUSD","code":"TUSD","decimals":18,"contractAddress":"0x2e1ad108ff1d8c782fcbbb89aad783ac49586756","color":"#2b2e8f","coinGeckoId":"true-usd","matchingAsset":"TUSD"},"PUST":{"name":"Polygon UST","code":"PUST","decimals":18,"contractAddress":"0x692597b009d13c4049a947cab2239b7d6517875f","color":"#2b2e9f","coinGeckoId":"terra-usd"},"PPOLY":{"name":"Polygon Polymath","code":"POLY","decimals":18,"contractAddress":"0xcb059c5573646047d6d88dddb87b745c18161d3b","color":"#4c5ae5","coinGeckoId":"polymath-network","matchingAsset":"POLY"},"PMKR":{"name":"Polygon Maker","code":"MKR","decimals":18,"contractAddress":"0x6f7C932e7684666C9fd1d44527765433e01fF61d","color":"#1abcec","coinGeckoId":"maker","matchingAsset":"MKR"},"PMANA":{"name":"Polygon Decentraland","code":"MANA","decimals":18,"contractAddress":"0xa1c57f48f0deb89f569dfbe6e2b7f46d33606fd4","color":"#bfb5ef","coinGeckoId":"decentraland","matchingAsset":"MANA"},"PBAT":{"name":"Polygon Basic Attention Token","code":"BAT","decimals":18,"contractAddress":"0x3cef98bb43d732e2f285ee605a8158cde967d219","color":"#ff5200","coinGeckoId":"basic-attention-token","matchingAsset":"BAT"},"PELON":{"name":"Polygon Dogelon MARS","code":"ELON","decimals":18,"contractAddress":"0xe0339c80ffde91f3e20494df88d4206d86024cdf","color":"#1a41fe","coinGeckoId":"dogelon-mars","matchingAsset":"ELON"},"PSNX":{"name":"Polygon Synthetix Network Token","code":"SNX","decimals":18,"contractAddress":"0x50b728d8d964fd00c2d0aad81718b71311fef68a","coinGeckoId":"havven","matchingAsset":"SNX"},"PBNT":{"name":"Polygon Bancor Network Token","code":"BNT","decimals":18,"contractAddress":"0xc26d47d5c33ac71ac5cf9f776d63ba292a4f7842","color":"#000d2b","coinGeckoId":"bancor","matchingAsset":"BNT"},"POCEAN":{"name":"Polygon OCEAN Protocol","code":"OCEAN","decimals":18,"contractAddress":"0x282d8efce846a88b159800bd4130ad77443fa1a1","color":"#1a413e","coinGeckoId":"ocean-protocol","matchingAsset":"OCEAN"},"PWOO":{"name":"Polygon Wootrade Network","code":"WOO","decimals":18,"contractAddress":"0x1b815d120b3ef02039ee11dc2d33de7aa4a8c603","color":"#1ba13e","coinGeckoId":"woo-network","matchingAsset":"WOO"},"PFET":{"name":"Polygon Fetch","code":"FET","decimals":18,"contractAddress":"0x7583feddbcefa813dc18259940f76a02710a8905","color":"#1bac3e","coinGeckoId":"fetch-ai","matchingAsset":"FET"},"PWMATIC":{"name":"Polygon Wrapped Matic Network Token","code":"WMATIC","decimals":18,"contractAddress":"0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270","color":"#2b6cef","coinGeckoId":"matic-network","matchingAsset":"WMATIC"},"PCRO":{"name":"Polygon Crypto.com Chain","code":"CRO","decimals":8,"contractAddress":"0xada58df0f643d959c2a47c9d4d4c1a4defe3f11c","color":"#1b6cef","coinGeckoId":"crypto-com-chain","matchingAsset":"CRO"},"PUMA":{"name":"Polygon UMA","code":"UMA","decimals":18,"contractAddress":"0x3066818837c5e6ed6601bd5a91b0762877a6b731","color":"#ab6cef","coinGeckoId":"uma","matchingAsset":"UMA"},"PHEX":{"name":"Polygon HEX","code":"HEX","decimals":8,"contractAddress":"0x23d29d30e35c5e8d321e1dc9a8a61bfd846d4c5c","color":"#ee6cef","coinGeckoId":"hex","matchingAsset":"HEX"},"PIOTX":{"name":"Polygon IoTeX","code":"IOTX","decimals":18,"contractAddress":"0xf6372cdb9c1d3674e83842e3800f2a62ac9f3c66","color":"#00d4d8","coinGeckoId":"iotex","matchingAsset":"IOTX"}}');
    },
    5285: function _(e) {
      "use strict";

      e.exports = JSON.parse('{"BPRO":{"name":"Bit Pro","code":"BPRO","decimals":18,"contractAddress":"0x440cd83c160de5c96ddb20246815ea44c7abbca8","color":"#ff9415"},"DOC":{"name":"Dollar On Chain","code":"DOC","decimals":18,"contractAddress":"0xe700691da7b9851f2f35f8b8182c69c53ccad9db","color":"#00a651"},"RIF":{"name":"RSK Infrastructure Framework","code":"RIF","decimals":18,"contractAddress":"0x2acc95758f8b5f583470ba265eb685a8f45fc9d5","color":"#0083ff","coinGeckoId":"rif-token"},"RDOC":{"name":"RIF Dollar On Chain","code":"RDOC","decimals":18,"contractAddress":"0x2d919f19d4892381d58edebeca66d5642cef1a1f","color":"#0083ff"},"RIFP":{"name":"RIF Pro","code":"RIFP","decimals":18,"contractAddress":"0xf4d27c56595ed59b66cc7f03cff5193e4bd74a61","color":"#0083ff"},"SOV":{"name":"Sovryn","code":"SOV","decimals":18,"contractAddress":"0xefc78fc7d48b64958315949279ba181c2114abbd","color":"#000000","coinGeckoId":"sovryn"},"FISH":{"name":"Fish","code":"FISH","decimals":18,"contractAddress":"0x055a902303746382fbb7d18f6ae0df56efdc5213","color":"#4D9CDC"}}');
    },
    5078: function _(e) {
      "use strict";

      e.exports = JSON.parse('{"ABR":{"name":"ABR","code":"ABR","decimals":6,"coinGeckoId":"allbridge","contractAddress":"terra1a7ye2splpfzyenu0yrdu8t83uzgusx2malkc7u"},"bLUNA":{"name":"bLuna","code":"bLuna","decimals":6,"contractAddress":"terra1kc87mu460fwkqte29rquh4hc20m54fxwtsx7gp"},"bETH":{"name":"bETH","code":"bETH","decimals":6,"contractAddress":"terra1dzhzukyezv0etz22ud940z7adyv7xgcjkahuun"},"aUST":{"name":"aUST","code":"aUST","decimals":6,"contractAddress":"terra1hzh9vpxhsk8253se0vv5jj6etdvxu3nv8z07zu"},"ANC":{"name":"ANC","code":"ANC","decimals":6,"coinGeckoId":"anchor-protocol","contractAddress":"terra14z56l0fp2lsf86zy3hty2z47ezkhnthtr9yq76"},"HALO":{"name":"HALO","code":"HALO","decimals":6,"contractAddress":"terra1w8kvd6cqpsthupsk4l0clwnmek4l3zr7c84kwq"},"APOLLO":{"name":"APOLLO","code":"APOLLO","decimals":6,"coinGeckoId":"apollo-dao","contractAddress":"terra100yeqvww74h4yaejj6h733thgcafdaukjtw397"},"ASTRO":{"name":"ASTRO","code":"ASTRO","decimals":6,"coinGeckoId":"astroport","contractAddress":"terra1xj49zyqrwpv5k928jwfpfy2ha668nwdgkwlrg3"},"PUG":{"name":"PUG","code":"PUG","decimals":6,"contractAddress":"terra1kdfsdm3c4reun9j3m4mk3nmyw4a4ns7mj24q3j"},"BTL":{"name":"BTL","code":"BTL","decimals":6,"coinGeckoId":"bitlocus","contractAddress":"terra193c42lfwmlkasvcw22l9qqzc5q2dx208tkd7wl"},"SITY":{"name":"SITY","code":"SITY","decimals":6,"contractAddress":"terra1z09gnzufuflz6ckd9k0u456l9dnpgsynu0yyhe"},"MIR":{"name":"Mirror","code":"MIR","decimals":6,"coinGeckoId":"mirror-protocol","contractAddress":"terra15gwkyepfc6xgca5t5zefzwy42uts8l2m4g40k6"},"mAAPL":{"name":"Apple Inc.","code":"mAAPL","decimals":6,"coinGeckoId":"mirrored-apple","contractAddress":"terra1vxtwu4ehgzz77mnfwrntyrmgl64qjs75mpwqaz"},"mABNB":{"name":"Airbnb Inc.","code":"mABNB","decimals":6,"coinGeckoId":"mirrored-airbnb","contractAddress":"terra1g4x2pzmkc9z3mseewxf758rllg08z3797xly0n"},"mAMC":{"name":"AMC Entertainment Holdings Inc.","code":"mAMC","decimals":6,"coinGeckoId":"mirrored-amc-entertainment","contractAddress":"terra1qelfthdanju7wavc5tq0k5r0rhsyzyyrsn09qy"},"mAMD":{"name":"Advanced Micro Devices, Inc.","code":"mAMD","decimals":6,"contractAddress":"terra18ej5nsuu867fkx4tuy2aglpvqjrkcrjjslap3z"},"mAMZN":{"name":"Amazon.com, Inc.","code":"mAMZN","decimals":6,"coinGeckoId":"mirrored-amzn","contractAddress":"terra165nd2qmrtszehcfrntlplzern7zl4ahtlhd5t2"},"mARKK":{"name":"ARK Innovation ETF","code":"mARKK","decimals":6,"contractAddress":"terra1qqfx5jph0rsmkur2zgzyqnfucra45rtjae5vh6"},"mBABA":{"name":"Alibaba Group Holding Limited","code":"mBABA","decimals":6,"contractAddress":"terra1w7zgkcyt7y4zpct9dw8mw362ywvdlydnum2awa"},"mBTC":{"name":"Bitcoin","code":"mBTC","decimals":6,"contractAddress":"terra1rhhvx8nzfrx5fufkuft06q5marfkucdqwq5sjw"},"mCOIN":{"name":"Coinbase Global, Inc","code":"mCOIN","decimals":6,"contractAddress":"terra18wayjpyq28gd970qzgjfmsjj7dmgdk039duhph"},"mDOT":{"name":"Polkadot","code":"mDOT","decimals":6,"contractAddress":"terra19ya4jpvjvvtggepvmmj6ftmwly3p7way0tt08r"},"mETH":{"name":"Ether","code":"mETH","decimals":6,"contractAddress":"terra1dk3g53js3034x4v5c3vavhj2738une880yu6kx"},"mFB":{"name":"Facebook Inc.","code":"mFB","decimals":6,"contractAddress":"terra1mqsjugsugfprn3cvgxsrr8akkvdxv2pzc74us7"},"mGLXY":{"name":"Galaxy Digital Holdings Ltd","code":"mGLXY","decimals":6,"contractAddress":"terra1l5lrxtwd98ylfy09fn866au6dp76gu8ywnudls"},"mGME":{"name":"GameStop Corp","code":"mGME","decimals":6,"contractAddress":"terra1m6j6j9gw728n82k78s0j9kq8l5p6ne0xcc820p"},"mGOOGL":{"name":"Alphabet Inc.","code":"mGOOGL","decimals":6,"coinGeckoId":"mirrored-googl","contractAddress":"terra1h8arz2k547uvmpxctuwush3jzc8fun4s96qgwt"},"mGS":{"name":"Goldman Sachs Group Inc.","code":"mGS","decimals":6,"contractAddress":"terra137drsu8gce5thf6jr5mxlfghw36rpljt3zj73v"},"mIAU":{"name":"iShares Gold Trust","code":"mIAU","decimals":6,"contractAddress":"terra10h7ry7apm55h4ez502dqdv9gr53juu85nkd4aq"},"MOON":{"name":"MOON","code":"MOON","decimals":6,"contractAddress":"terra1hmxxq0y8h79f3228vs0czc4uz5jdgjt0appp26"},"mMSFT":{"name":"Microsoft Corporation","code":"mMSFT","decimals":6,"contractAddress":"terra1227ppwxxj3jxz8cfgq00jgnxqcny7ryenvkwj6"},"mNFLX":{"name":"Netflix, Inc.","code":"mNFLX","decimals":6,"contractAddress":"terra1jsxngqasf2zynj5kyh0tgq9mj3zksa5gk35j4k"},"mQQQ":{"name":"Invesco QQQ Trust","code":"mQQQ","decimals":6,"contractAddress":"terra1csk6tc7pdmpr782w527hwhez6gfv632tyf72cp"},"mSLV":{"name":"iShares Silver Trust","code":"mSLV","decimals":6,"contractAddress":"terra1kscs6uhrqwy6rx5kuw5lwpuqvm3t6j2d6uf2lp"},"mSPY":{"name":"SPDR S&P 500","code":"mSPY","decimals":6,"contractAddress":"terra1aa00lpfexyycedfg5k2p60l9djcmw0ue5l8fhc"},"mSQ":{"name":"Square, Inc.","code":"mSQ","decimals":6,"contractAddress":"terra1u43zu5amjlsgty5j64445fr9yglhm53m576ugh"},"mTSLA":{"name":"Tesla, Inc.","code":"mTSLA","decimals":6,"contractAddress":"terra14y5affaarufk3uscy2vr6pe6w6zqf2wpjzn5sh"},"mTWTR":{"name":"Twitter, Inc.","code":"mTWTR","decimals":6,"contractAddress":"terra1cc3enj9qgchlrj34cnzhwuclc4vl2z3jl7tkqg"},"mUSO":{"name":"United States Oil Fund, LP","code":"mUSO","decimals":6,"contractAddress":"terra1lvmx8fsagy70tv0fhmfzdw9h6s3sy4prz38ugf"},"mVIXY":{"name":"ProShares VIX Short-Term Futures ETF","code":"mVIXY","decimals":6,"contractAddress":"terra19cmt6vzvhnnnfsmccaaxzy2uaj06zjktu6yzjx"},"LOTA":{"name":"LOTA","code":"LOTA","decimals":6,"coinGeckoId":"loterra","contractAddress":"terra1ez46kxtulsdv07538fh5ra5xj8l68mu8eg24vr"},"LUNI":{"name":"LUNI","code":"LUNI","decimals":6,"coinGeckoId":"loterra","contractAddress":"terra1m3tdguf59xq3pa2twk5fjte5g6szj5y9x5npy7"},"DPH":{"name":"Digipharm","code":"DPH","decimals":6,"coinGeckoId":"digipharm","contractAddress":"terra17jnhankdfl8vyzj6vejt7ag8uz0cjc9crkl2h7"},"MARS":{"name":"MARS","code":"MARS","decimals":6,"contractAddress":"terra1a7zxk56c72elupp7p44hn4k94fsvavnhylhr6h"},"GLOW":{"name":"GLOW","code":"GLOW","decimals":6,"coinGeckoId":"glow-token","contractAddress":"terra13zx49nk8wjavedjzu8xkk95r3t0ta43c9ptul7"},"KUJI":{"name":"KUJI","code":"KUJI","decimals":6,"coinGeckoId":"kujira","contractAddress":"terra1xfsdgcemqwxp4hhnyk4rle6wr22sseq7j07dnn"},"stLuna":{"name":"stLuna","code":"stLuna","decimals":6,"contractAddress":"terra1yg3j2s986nyp5z7r2lvt0hx3r0lnd7kwvwwtsc"},"MINE":{"name":"Pylon MINE Token","code":"pylon-protocol","decimals":6,"coinGeckoId":"mirrored-amd","contractAddress":"terra1kcthelkax4j9x8d3ny6sdag0qmxxynl3qtcrpy"},"SPEC":{"name":"Spectrum","code":"SPEC","decimals":6,"coinGeckoId":"mirrored-amd","contractAddress":"terra1s5eczhe0h0jutf46re52x5z4r03c8hupacxmdr"},"LOOP":{"name":"LOOP","code":"LOOP","decimals":6,"coinGeckoId":"mirrored-amd","contractAddress":"terra1nef5jf6c7js9x6gkntlehgywvjlpytm7pcgkn4"},"LOOPR":{"name":"LOOPR","code":"LOOPR","decimals":6,"coinGeckoId":"mirrored-amd","contractAddress":"terra1jx4lmmke2srcvpjeereetc9hgegp4g5j0p9r2q"},"aLOT":{"name":"aLOT","code":"aLOT","decimals":0,"contractAddress":"terra1366wmr8t8rrkh6mag8fagqxntmf2qe4kyte784"},"STT":{"name":"StarTerra","code":"STT","decimals":6,"coinGeckoId":"mirrored-amd","contractAddress":"terra13xujxcrc9dqft4p9a8ls0w3j0xnzm6y2uvve8n"},"TWD":{"name":"TerraWorld","code":"TWD","decimals":6,"coinGeckoId":"mirrored-amd","contractAddress":"terra19djkaepjjswucys4npd5ltaxgsntl7jf0xz7w6"},"MIAW":{"name":"MIAW","code":"MIAW","decimals":6,"coinGeckoId":"mirrored-amd","contractAddress":"terra1vtr50tw0pgqpes34zqu60n554p9x4950wk8f63"},"Psi":{"name":"Nexus Governance","code":"Psi","decimals":6,"coinGeckoId":"mirrored-amd","contractAddress":"terra12897djskt9rge8dtmm86w654g7kzckkd698608"},"VKR":{"name":"VKR","code":"VKR","decimals":6,"coinGeckoId":"mirrored-amd","contractAddress":"terra1dy9kmlm4anr92e42mrkjwzyvfqwz66un00rwr5"},"ORION":{"name":"ORION","code":"ORION","decimals":8,"coinGeckoId":"orion-money","contractAddress":"terra1mddcdx0ujx89f38gu7zspk2r2ffdl5enyz2u03"},"ORNE":{"name":"ORNE","code":"ORNE","decimals":6,"coinGeckoId":"orne","contractAddress":"terra1hnezwjqlhzawcrfysczcxs6xqxu2jawn729kkf"},"PLY":{"name":"PLY","code":"PLY","decimals":6,"coinGeckoId":"playnity","contractAddress":"terra1hnezwjqlhzawcrfysczcxs6xqxu2jawn729kkf"},"PRISM":{"name":"PRISM","code":"PRISM","decimals":6,"coinGeckoId":"prism-protocol","contractAddress":"terra1dh9478k2qvqhqeajhn75a2a7dsnf74y5ukregw"},"xPRISM":{"name":"xPRISM","code":"xPRISM","decimals":6,"contractAddress":"terra1042wzrwg2uk6jqxjm34ysqquyr9esdgm5qyswz"},"bPsiDP-24m":{"name":"bPsiDP-24m","code":"bPsiDP-24m","decimals":6,"contractAddress":"terra1zsaswh926ey8qa5x4vj93kzzlfnef0pstuca0y"},"SDOLLAR":{"name":"SDOLLAR","code":"SDOLLAR","decimals":2,"coinGeckoId":"space-dollars","contractAddress":"terra1l0y8yg0s86x299nqw0p6fhh7ngex3r4phtjeuq"},"LunaX":{"name":"LunaX","code":"LunaX","decimals":6,"coinGeckoId":"stader-lunax","contractAddress":"terra17y9qkl8dfkeg4py7n0g5407emqnemc3yqk5rup"},"TFLOKI":{"name":"TFLOKI","code":"TFLOKI","decimals":6,"coinGeckoId":"terrafloki","contractAddress":"terra1u2k0nkenw0p25ljsr4ksh7rxm65y466vkdewwj"},"TFTIC":{"name":"TFTIC","code":"TFTIC","decimals":6,"contractAddress":"terra1a8k3jyv3wf6k3zngza5h6srrxcckdf7zv90p6u"},"TFTICII":{"name":"TFTICII","code":"TFTICII","decimals":6,"contractAddress":"terra1xt9fgu7965kgvunnjts9zkprd8986kcc444q86"},"TFTICIII":{"name":"TFTICIII","code":"TFTICIII","decimals":6,"contractAddress":"terra1vte2xv7dr8sfnrnwdf9arcyprqgr0hty5ads28"},"TLAND":{"name":"TLAND","code":"TLAND","decimals":6,"coinGeckoId":"terraland-token","contractAddress":"terra1r5506ckw5tfr3z52jwlek8vg9sn3yflrqrzfsc"},"XRUNE":{"name":"XRUNE","code":"XRUNE","decimals":6,"coinGeckoId":"thorstarter","contractAddress":"terra1td743l5k5cmfy7tqq202g7vkmdvq35q48u2jfm"},"WHALE":{"name":"WHALE","code":"WHALE","decimals":6,"coinGeckoId":"white-whale","contractAddress":"terra1php5m8a6qd68z02t3zpw4jv2pj4vgw4wz0t8mz"},"weWETH":{"name":"weWETH","code":"weWETH","decimals":8,"coinGeckoId":"ethereum","contractAddress":"terra14tl83xcwqjy0ken9peu4pjjuu755lrry2uy25r"},"weWBTC":{"name":"weWBTC","code":"weWBTC","decimals":8,"coinGeckoId":"bitcoin","contractAddress":"terra1aa7upykmmqqc63l924l5qfap8mrmx5rfdm0v55"},"wsSOL":{"name":"wsSOL","code":"wsSOL","decimals":8,"coinGeckoId":"solana","contractAddress":"terra190tqwgqx7s8qrknz6kckct7v607cu068gfujpk"},"weMATIC":{"name":"weMATIC","code":"weMATIC","decimals":8,"coinGeckoId":"matic-network","contractAddress":"terra1dfasranqm4uyaz72r960umxy0w8t6zewqlnkuq"},"wbWBNB":{"name":"wbWBNB","code":"wbWBNB","decimals":8,"coinGeckoId":"binancecoin","contractAddress":"terra1cetg5wruw2wsdjp7j46rj44xdel00z006e9yg8"},"wbCake":{"name":"wbCake","code":"wbCake","decimals":8,"coinGeckoId":"pancakeswap-token","contractAddress":"terra1xvqlpjl2dxyel9qrp6qvtrg04xe3jh9cyxc6av"},"weLINK":{"name":"weLINK","code":"weLINK","decimals":8,"coinGeckoId":"chainlink","contractAddress":"terra12dfv3f0e6m22z6cnhfn3nxk2en3z3zeqy6ctym"},"weSUSHI":{"name":"weSUSHI","code":"weSUSHI","decimals":8,"coinGeckoId":"sushi","contractAddress":"terra1csvuzlf92nyemu6tv25h0l79etpe8hz3h5vn4a"},"weUNI":{"name":"weUNI","code":"weUNI","decimals":8,"coinGeckoId":"uniswap","contractAddress":"terra1wyxkuy5jq545fn7xfn3enpvs5zg9f9dghf6gxf"},"weUSDT":{"name":"weUSDT","code":"weUSDT","decimals":8,"coinGeckoId":"tether","contractAddress":"terra1ce06wkrdm4vl6t0hvc0g86rsy27pu8yadg3dva"},"weUSDC":{"name":"weUSDC","code":"weUSDC","decimals":8,"coinGeckoId":"usd-coin","contractAddress":"terra1pepwcav40nvj3kh60qqgrk8k07ydmc00xyat06"},"wewstETH":{"name":"wewstETH","code":"wewstETH","decimals":8,"coinGeckoId":"ethereum","contractAddress":"terra133chr09wu8sakfte5v7vd8qzq9vghtkv4tn0ur"},"wsstSOL":{"name":"wsstSOL","code":"wsstSOL","decimals":8,"coinGeckoId":"solana","contractAddress":"terra1t9ul45l7m6jw6sxgvnp8e5hj8xzkjsg82g84ap"},"weLDO":{"name":"weLDO","code":"weLDO","decimals":8,"contractAddress":"terra1jxypgnfa07j6w92wazzyskhreq2ey2a5crgt6z"},"webETH":{"name":"webETH","code":"webETH","decimals":8,"coinGeckoId":"ethereum","contractAddress":"terra1u5szg038ur9kzuular3cae8hq6q5rk5u27tuvz"},"XDEFI":{"name":"XDEFI","code":"XDEFI","decimals":8,"coinGeckoId":"xdefi","contractAddress":"terra169edevav3pdrtjcx35j6pvzuv54aevewar4nlh"},"whGTPS":{"name":"whGTPS","code":"whGTPS","decimals":8,"contractAddress":"terra1y3d5qexmyac0fg53pfglh2pjk0664ymfvcq9mc"},"whSAIL":{"name":"whSAIL","code":"whSAIL","decimals":8,"contractAddress":"terra1ku5e0dhutxhuxudsmsn5647wwcz6ndr3rsh90k"},"whgSAIL":{"name":"whgSAIL","code":"whgSAIL","decimals":8,"contractAddress":"terra1rl0cpwgtwl4utnaynugevdje37fnmsea7rv4uu"},"nLUNA":{"name":"nLUNA","code":"nLUNA","decimals":6,"contractAddress":"terra10f2mt82kjnkxqj2gepgwl637u2w4ue2z5nhz5j"},"nETH":{"name":"nETH","code":"nETH","decimals":6,"contractAddress":"terra178v546c407pdnx5rer3hu8s2c0fc924k74ymnn"},"wgOHM":{"name":"wgOHM","code":"wgOHM","decimals":6,"contractAddress":"terra1fpfn2kkr8mv390wx4dtpfk3vkjx9ch3thvykl3"},"wAVAX":{"name":"wAVAX","code":"wAVAX","decimals":6,"contractAddress":"terra1hj8de24c3yqvcsv9r8chr03fzwsak3hgd8gv3m"},"wsoUSDC":{"name":"wsoUSDC","code":"wsoUSDC","decimals":6,"contractAddress":"terra1e6mq63y64zcxz8xyu5van4tgkhemj3r86yvgu4"},"wavUSDC":{"name":"wavUSDC","code":"wavUSDC","decimals":6,"contractAddress":"terra1pvel56a2hs93yd429pzv9zp5aptcjg5ulhkz7w"},"wBUSD":{"name":"wBUSD","code":"wBUSD","decimals":6,"contractAddress":"terra1skjr69exm6v8zellgjpaa2emhwutrk5a6dz7dd"}}');
    },
    9745: function _(e) {
      "use strict";

      e.exports = JSON.parse('{"app.uniswap.org":["ethereum","polygon"],"beta.curve.fi":["ethereum","avalanche","polygon"],"1inch.exchange":["ethereum","bsc","polygon"],"opensea.io":["ethereum","polygon"],"app.sushi.com":["ethereum","bsc","avalanche","fuse","polygon"],"looksrare.org":["ethereum"],"compound.finance":["ethereum"],"app.cream.finance":["bsc"],"cowswap.exchange":["ethereum"],"wallet.polygon.technology":["ethereum"],"tokenlon.im":["ethereum"],"tokemak.xyz":["ethereum"],"metamask.io":["ethereum"],"convexfinance.com":["ethereum"],"dydx.exchange":["ethereum"],"larvalabs.com":["ethereum"],"stake.lido.fi":["ethereum"],"genie.xyz":["ethereum"],"launchpad.ethereum.org":["ethereum"],"balancer.finance":["ethereum"],"wormholenetwork.com":["ethereum","polygon","bsc","avalanche"],"euler.finance":["ethereum"],"v2beta.dodoex.io":["ethereum"],"renproject.io":["ethereum","bsc","polygon"],"saddle.finance":["ethereum"],"indexcoop.com":["ethereum"],"crypto.com":["ethereum"],"app.liquity.fi":["ethereum"],"fei.money":["ethereum"],"foundation.app":["ethereum"],"oasis.app":["ethereum"],"yearn.finance":["ethereum"],"unic.ly":["ethereum"],"stakedao.org":["ethereum"],"shibaswap.com":["ethereum","bsc"],"peakdefi.com":["ethereum"],"decentral.games":["polygon","ethereum"],"reflexer.finance":["ethereum"],"integral.link":["ethereum"],"idle.finance":["ethereum"],"defiplaza.net":["ethereum"],"furucombo.app":["ethereum"],"app.alchemix.fi":["ethereum"],"studio.fuse.io":["fuse"],"arbitrum.io":["ethereum"],"smoothy.finance":["bsc"],"tewkenaire.com":["ethereum"],"app.dodoex.io":["ethereum","polygon","bsc"],"app.aave.com":["ethereum","avalanche","polygon"],"invictuscapital.com":["ethereum"],"multisender.app":["ethereum"],"pay.sablier.finance":["ethereum"],"allbridge.io":["ethereum","polygon","bsc","avalanche"],"bao.finance":["ethereum"],"kyberswap.com":["ethereum","polygon","bsc","avalanche"],"zapper.fi":["ethereum"],"uniswap.org":["ethereum"],"swapr.eth.link":["ethereum"],"solace.fi":["ethereum"],"terravirtua.io":["ethereum"],"cointool.app":["ethereum","bsc"],"insurace.io":["ethereum","bsc","polygon"],"app.pooltogether.com":["ethereum","bsc","polygon"],"request.network":["ethereum"],"monolith.xyz":["ethereum"],"swap.blocto.app":["ethereum","bsc"],"bulksender.app":["ethereum"],"krystal.app":["ethereum"],"mushrooms.finance":["ethereum"],"mintable.app":["ethereum"],"swerve.fi":["ethereum"],"meebits.larvalabs.com":["ethereum"],"cryptokitties.co":["ethereum"],"inventorclub.io":["ethereum"],"vesper.finance":["ethereum"],"mooniswap.exchange":["ethereum"],"megacryptopolis.com":["ethereum","polygon"],"bitpie.com":["ethereum"],"meta-island.io":["ethereum"],"superworldapp.com":["ethereum"],"sorbet.finance":["polygon"],"openalexa.io":["ethereum"],"strike.org":["ethereum"],"leagueofkingdoms.com":["ethereum"],"forkdelta.app":["ethereum"],"everrise.com":["bsc","avalanche","ethereum","polygon"],"happyastronauts.com":["ethereum"],"eswap.tube":["ethereum"],"ethereumgold.io":["ethereum"],"illuvium.io":["ethereum"],"gen.art":["ethereum"],"nftrade.com":["ethereum","polygon","bsc","avalanche"],"relaychain.com":["ethereum","polygon","bsc","avalanche"],"lootexplorers.quest":["ethereum"],"evolution.land":["polygon"],"cvault.finance":["ethereum"],"cryptospells.jp":["ethereum"],"emberfund.io":["ethereum"],"farsite.online":["ethereum"],"nft20.io":["ethereum"],"naos.finance":["ethereum"],"bamboodefi.com":["ethereum"],"v2.tonbridge.io":["ethereum","polygon","bsc"],"olympusdao.finance":["ethereum"],"degens.com":["ethereum"],"delphi.akropolis.io":["ethereum"],"sassyunicorns.io":["ethereum"],"9cat.io":["ethereum"],"openocean.finance":["ethereum","polygon","avalanche","bsc"],"neondistrict.io":["ethereum"],"elyfi.world":["ethereum"],"matcha.xyz":["ethereum"],"miime.io":["ethereum"],"swap.arken.finance":["bsc","avalanche","polygon","ethereum"],"piedao.org":["ethereum"],"tokenminer.online":["fantom"],"app.bumper.fi":["ethereum"],"unilend.finance":["ethereum"],"knownorigin.io":["ethereum"],"bearhood.club":["ethereum"],"forsage.io":["ethereum"],"capital-dao.io":["ethereum"],"shiboshis.shibaswap.com":["ethereum"],"assassinbearsquad.com":["ethereum"],"milliondollartokenpage.com":["ethereum"],"beta.cent.co":["ethereum"],"etholvants.com":["ethereum"],"wbtc.network":["ethereum"],"monsterbuds.io":["ethereum"],"unifiprotocol.com":["ethereum","bsc","polygon","avalanche"],"wepiggy.com":["ethereum","bsc","polygon"],"genzeroes.com":["ethereum"],"abs.thehundreds.com":["ethereum"],"mybae.io":["ethereum"],"bravefrontierheroes.com":["ethereum"],"dozerbird.io":["ethereum"],"cryptodozer.io":["ethereum"],"subtraction.gallery":["ethereum"],"hashelot.com":["ethereum"],"0n1force.com":["ethereum"],"0xproject.com":["ethereum"],"0xbabylon.com":["ethereum"],"0xbitcoin.org":["polygon"],"0xbitcoincash.io":["ethereum"],"0xbitconnect.co":["ethereum"],"catether.org":["ethereum"],"0xdogecoin.com":["ethereum"],"0xdrop.com":["ethereum"],"0xearth.github.io":["ethereum"],"0xfair.com":["ethereum"],"0xgame.io":["ethereum"],"0xmons.xyz":["ethereum"],"0xmultiply.com":["ethereum"],"0xowns.art":["ethereum"],"zeroxracer.surge.sh":["ethereum"],"0xracers.com":["ethereum","polygon"],"0xracing.github.io":["ethereum"],"0xuniverse.com":["ethereum","polygon"],"ethverify.net":["ethereum"],"0xwarriors.com":["ethereum","polygon"],"1eth.com":["ethereum"],"casino.keepr3v1.network":["ethereum"],"monkey.game":["ethereum"],"10finiti.com":["ethereum"],"10ktf.com":["ethereum"],"12daily.club":["ethereum"],"1200percent.tk":["ethereum"],"12beteth.epizy.com":["ethereum"],"12hourrush.com":["ethereum"],"12hourtoken.github.io":["ethereum"],"12hourtrains.github.io":["ethereum"],"1address.io":["ethereum"],"refpazkjixes.top":["ethereum"],"twoplustwo.wpengine.com":["ethereum"],"200eth.com":["ethereum"],"2545.io":["ethereum"],"255eth.club":["ethereum"],"2daysprofit.site":["ethereum"],"2key.network":["ethereum"],"2xknockout.me":["ethereum"],"2xmachine.surge.sh":["ethereum"],"2xeth.win":["ethereum"],"333eth.io":["ethereum"],"399energy.com":["ethereum"],"3dayprofits.info":["ethereum"],"3duel.com":["ethereum"],"3ether.io":["ethereum"],"3fmutual.com":["ethereum"],"3space.art":["ethereum"],"4out5.com":["ethereum"],"4sgaming.io":["ethereum"],"4tune.win":["ethereum"],"acereturns.github.io":["ethereum"],"50shades.ethercolors.co":["ethereum"],"50plus.io":["ethereum"],"520.geekgit.com":["ethereum"],"5coins.bet":["ethereum"],"5eth.io":["ethereum"],"5inv.site":["ethereum"],"666eth.ga":["ethereum"],"game.7fun.io":["ethereum"],"8coins.org":["ethereum"],"8therbank.com":["ethereum"],"8thereum.io":["ethereum"],"8zen.io":["ethereum"],"tools.94eth.com":["ethereum"],"ni9.bid":["ethereum"],"9tales.io":["ethereum"],"atablegame.io":["ethereum"],"atoy.co":["ethereum"],"a21.app":["ethereum"],"abclotto.io":["ethereum"],"abracadabra.money":["ethereum","avalanche","bsc"],"absgoldenmatrix.io":["ethereum"],"absolutus.top":["ethereum"],"acebusters.com":["ethereum"],"acedapp.net":["ethereum"],"acedice.bet":["ethereum"],"acereturns.io":["ethereum"],"adamantx.network":["ethereum"],"addresswars.io":["ethereum"],"adidas.com":["ethereum"],"adrena.herokuapp.com":["ethereum"],"adrenaline.finance":["ethereum"],"adsearneth.com":["ethereum"],"0xadventures.com":["ethereum"],"aethercity.org":["ethereum"],"aethia.co":["ethereum"],"afrodroids.io":["ethereum"],"afterorder.io":["ethereum"],"aipixelbuddies.com":["ethereum"],"aion.ethpantheon.com":["ethereum"],"airswap.io":["ethereum"],"aiwallet.io":["ethereum"],"alcabones.io":["ethereum"],"daostack.io":["ethereum"],"alchemydao.com":["ethereum"],"alchemygod.top":["ethereum"],"alias.earth":["ethereum"],"alienfrens.io":["ethereum"],"earn.alkemi.network":["ethereum"],"allfor1.io":["ethereum"],"all-for-one.club":["ethereum"],"allforthewinner.com":["ethereum"],"allbet.io":["ethereum"],"aloss.finance":["ethereum"],"alpaca.city":["ethereum"],"homora.alphafinance.io":["ethereum"],"alphaplay.online":["ethereum"],"amber-game.com":["ethereum"],"amexofficial.com":["ethereum"],"amis-erc20.github.io":["ethereum"],"amphorium.io":["ethereum","bsc"],"ampt.tech":["ethereum"],"angelbattles.com":["ethereum"],"angoname.com":["ethereum"],"angryapesunited.com":["ethereum"],"angryboars.com":["ethereum"],"generative-transfer-art.vercel.app":["ethereum"],"animegang.io":["ethereum"],"animetas.io":["ethereum"],"launchpad.animocabrands.com":["ethereum"],"anomus.io":["ethereum"],"anrkeyx.io":["ethereum"],"crypto-botics.com":["ethereum"],"apedaoremix.com":["ethereum"],"dfyn.network":["polygon"],"solo.top":["bsc","polygon"],"quickswap.exchange":["polygon"],"beefy.finance":["bsc","avalanche","polygon"],"pegaxy.io":["polygon"],"apeswap.finance":["bsc","polygon"],"sportx.bet":["polygon"],"gains.trade":["polygon"],"richethereum.com":["bsc","avalanche","polygon"],"app.mai.finance":["polygon","avalanche"],"idex.io":["polygon"],"iron.finance":["polygon"],"stableone.io":["polygon"],"tetu.io":["polygon"],"nachoxyz.com":["polygon"],"polycat.finance":["polygon"],"vesq.io":["polygon"],"vulcandex.vulcanforged.com":["polygon"],"polyroll.org":["polygon"],"polylion.exchange":["polygon"],"app.elk.finance":["polygon","avalanche","fuse","bsc"],"swap.cometh.io":["polygon"],"polymeryield.finance":["polygon"],"findsixdice.com":["bsc","polygon"],"app.ethalend.org":["polygon"],"otterclam.finance":["polygon"],"wardenswap.com":["bsc","polygon"],"market.playdapp.io":["ethereum","polygon"],"o3swap.com":["polygon","avalanche","arbitrum"],"autofarm.network":["bsc","avalanche","polygon"],"polycow.finance":["polygon"],"polytoken.finance":["polygon"],"for.tube":["ethereum","bsc","polygon"],"ricochet.exchange":["polygon"],"polydex.fi":["polygon"],"polygon.pancakebunny.finance":["polygon"],"magicianmetaverse.com":["polygon"],"game.cometh.io":["polygon"],"gamee.com":["polygon"],"mia.bet":["polygon"],"jetswap.finance":["bsc","polygon"],"tofunft.com":["bsc","fuse","ethereum","avalanche","polygon"],"grassland.finance":["polygon"],"ethlas.com":["polygon"],"cyborglegends.io":["polygon"],"app.algebra.finance":["polygon"],"gravis.finance":["bsc","polygon"],"chaino.chaingames.io":["polygon"],"gravityfinance.io":["polygon"],"wault.finance":["bsc","polygon"],"counterstake.org":["polygon"],"deltatheta.tech":["ethereum","polygon","bsc"],"bcmhunt.com":["ethereum","bsc","polygon"],"axion.network":["polygon"],"dehive.finance":["polygon"],"revvracing.com":["polygon"],"cafeswap.finance":["bsc","polygon"],"adamant.finance":["polygon"],"cremepieswap.finance":["polygon"],"pepperattack.com":["ethereum","polygon"],"polygonapes.com":["polygon"],"kogefarm.io":["polygon"],"polywolf.finance":["polygon"],"app.argano.io":["polygon"],"fakhama.network":["polygon"],"sunflower-farmers.com":["polygon"],"acy.finance":["bsc","polygon"],"app.zesty.market":["polygon"],"justmoney.exchange":["polygon","bsc","ethereum"],"hunnyplay.com":["bsc","avalanche","polygon"],"stake.agromatic.io":["polygon"],"polypup.finance":["polygon"],"app.harpy.finance":["polygon"],"mycryptosaga.net":["polygon"],"maticboost.online":["polygon"],"yugen.finance":["polygon"],"blockchaincuties.com":["ethereum","polygon"],"polygonpro.xyz":["polygon"],"polyblocks.io":["polygon"],"icecolony.com":["polygon","bsc"],"multichain-miner.net":["fantom"],"polyprime.finance":["polygon"],"bogged.finance":["bsc","polygon","avalanche"],"prdt.finance":["bsc","polygon"],"app.polyquity.org":["polygon"],"babyquick.app":["polygon"],"protofi.app":["polygon"],"veggiesfarmgame.com":["polygon"],"app.cryptoblades.io":["bsc","polygon","avalanche"],"metadice.org":["polygon"],"retrofarms.net":["bsc","polygon"],"polygonpenguins.com":["polygon"],"dappbuilder.org":["polygon"],"element.market":["ethereum","bsc","polygon"],"app.cougarswap.io":["bsc","polygon","avalanche"],"polychainmonsters.com":["ethereum","bsc","polygon"],"maticdice.com":["polygon"],"maticgains.com":["polygon"],"polylime.finance":["polygon"],"psprotocol.com":["polygon"],"polyminer.network":["polygon"],"drakons.io":["polygon"],"farmhousegame.live":["polygon"],"app.metroswap.org":["avalanche","bsc","fuse","polygon"],"automatic.network":["polygon"],"polycake.finance":["polygon"],"dx.app":["ethereum","polygon","bsc","avalanche"],"pirates2048.com":["polygon"],"darkside.finance":["polygon","bsc"],"singular.farm":["polygon","avalanche","bsc"],"acquisitionroyale.com":["polygon"],"polydex.org":["polygon"],"app.firebird.finance":["polygon"],"polygon.dojofarm.finance":["polygon","bsc"],"gemstones.finance":["polygon"],"eggsonchain.com":["polygon"],"polykiwi.finance":["polygon"],"swamp.finance":["bsc","polygon"],"orcinuslabs.ca":["polygon"],"maticincome.networkcoin.de":["polygon"],"gamma.polypulsar.farm":["polygon"],"app.kakidex.com":["polygon"],"infinitumx.io":["polygon"],"littleheroes.io":["polygon"],"win95.finance":["polygon"],"hotpotato.market":["polygon"],"lootex.io":["ethereum","bsc","polygon"],"exchange.idamurni.de":["polygon"],"polygame.finance":["polygon"],"arena.cryptocolosseum.com":["polygon"],"parrotdefi.com":["polygon"],"treasureland.market":["bsc","ethereum","polygon"],"bakery-swap.finance":["polygon"],"0xpandemic.com":["polygon"],"2022bucketlist.xyz":["polygon"],"8ballfinance.io":["polygon"],"aavegotchi.com":["polygon"],"adbets.io":["polygon"],"aestandard.finance":["polygon"],"afksystem.finance":["polygon"],"ba.net":["polygon"],"airnfts.com":["bsc","polygon"],"amigo.polymax.club":["polygon"],"angle.farm":["polygon"],"ape.community":["polygon"],"aplyza.com":["polygon"],"hermesdefi.io":["polygon"],"arabella.farm":["polygon"],"af.uniarts.network":["polygon","bsc"],"artvalue.org":["polygon"],"art.army":["bsc","polygon"],"app.artislife.network":["polygon"],"artvatars.com":["polygon"],"astroctopusfarm.com":["bsc","polygon"],"astrofarms.finance":["polygon"],"scorpio.astrofarms.finance":["polygon"],"atlas.adityavijaykumar.me":["polygon"],"augur.net":["polygon"],"augury.finance":["polygon"],"australopithecus.hdks.org":["polygon"],"autoshark.finance":["bsc","polygon"],"avengers.exchange":["polygon"],"avocadonft.herokuapp.com":["polygon"],"bagprojekt.com":["polygon"],"barbershop.finance":["polygon"],"barns.finance":["polygon"],"batswap.finance":["polygon"],"battlewave2323.com":["polygon"],"bcharityecssen.netlify.app":["polygon"],"polygon.bearlydefi.com":["polygon"],"biswap.org":["bsc"],"venus.io":["bsc"],"pancakeswap.finance":["bsc"],"home.babyswap.finance":["bsc"],"pinksale.finance":["bsc"],"acryptos.com":["bsc"],"drip.community":["bsc"],"marketplace.biswap.org":["bsc"],"app.marsecosystem.com":["bsc"],"app.knightswap.financial":["bsc"],"alpacafinance.org":["bsc"],"bombcrypto.io":["bsc"],"app.position.exchange":["bsc"],"belt.fi":["bsc"],"pancakebunny.finance":["bsc"],"bsc.mdex.co":["bsc"],"coinflipping.xyz":["bsc"],"nerve.fi":["bsc"],"elfinkingdom.com":["bsc"],"nominex.io":["bsc"],"atlantis.loans":["bsc"],"rabbitfinance.io":["bsc"],"app.dforce.network":["ethereum","bsc"],"meta.auto":["bsc"],"annex.finance":["bsc"],"alienworlds.io":["bsc"],"app.killswitch.finance":["bsc"],"dsgmetaverse.com":["bsc"],"mobox.io":["bsc"],"tranchess.com":["bsc"],"devdefi.finance":["bsc"],"yuklaswap.com":["bsc"],"bnb42.com":["bsc"],"swapx.bscex.org":["bsc"],"faraland.io":["bsc"],"squid-nft.io":["bsc"],"bakeryswap.org":["bsc"],"sidekick.finance":["bsc"],"candlegenie.io":["bsc"],"ten.finance":["bsc"],"niob.app":["bsc"],"wisteriaswap.com":["bsc"],"iqi.wata.finance":["bsc"],"app.alita.finance":["bsc"],"acet.finance":["bsc"],"bnbshield.io":["bsc"],"nemesisdao.finance":["bsc"],"pacoca.io":["bsc"],"planetfinance.io":["bsc"],"xwg.games":["bsc"],"buffer.finance":["bsc"],"templar.finance":["bsc"],"titano.finance":["bsc"],"elephant.money":["bsc"],"jadeprotocol.io":["bsc"],"dex.leonicornswap.com":["bsc"],"xdao.app":["bsc","polygon","ethereum"],"dopple.finance":["bsc"],"apollox.finance":["bsc"],"dehero.co":["bsc"],"busd.forsage.io":["bsc"],"play.moonpot.com":["bsc"],"bnbv2.justliquidity.org":["bsc"],"ellipsis.finance":["bsc"],"adamantmine.com":["bsc"],"bsc.definix.com":["bsc"],"shibanova.io":["bsc"],"herocat.io":["bsc"],"solv.finance":["ethereum","polygon","bsc"],"sheepdex.org":["bsc"],"dapp.spartanprotocol.org":["bsc"],"dibs.money":["bsc"],"nftb.io":["bsc","polygon"],"ducknetwork.io":["bsc"],"wowswap.io":["bsc","polygon","avalanche"],"avvaken.org":["bsc"],"pantherswap.com":["bsc"],"joe.thegarden.finance":["bsc"],"zoogame.app":["bsc"],"elpis.game":["bsc"],"app.latteswap.com":["bsc"],"fletaconnect.io":["bsc"],"mouse.farm":["bsc"],"ysl.io":["bsc"],"atlantis.autoshark.finance":["bsc"],"bnbfactory.org":["bsc"],"aperocket.finance":["bsc"],"hunny.finance":["bsc"],"anchorswap.app":["bsc"],"predictcoin.finance":["bsc"],"springrolls.app":["bsc"],"mydiamondteam.online":["bsc"],"presidents-nft.com":["bsc"],"mt.nextype.finance":["bsc"],"ocp.finance":["bsc"],"jojo.fun":["bsc"],"catsworld.io":["bsc"],"moonshots.farm":["bsc"],"bscmithril.com":["bsc"],"unusdao.finance":["bsc"],"yieldparrot.finance":["bsc"],"bunicorn.exchange":["bsc"],"app.bomb.money":["bsc"],"clamisland.fi":["bsc"],"epichero.io":["bsc"],"revault.network":["bsc"],"farm.br34p.finance":["bsc"],"growing.fi":["bsc"],"bnbcold.com":["bsc"],"app.typhoon.network":["bsc"],"game.binaryx.pro":["bsc"],"mydefipet.com":["bsc"],"macaronswap.finance":["bsc"],"cubdefi.com":["bsc"],"itam.games":["bsc"],"newb.farm":["bsc"],"pentas.io":["bsc"],"nftkey.app":["bsc","ethereum","avalanche","fantom"],"bsc.bitfresh.win":["bsc"],"feeder.finance":["bsc","fantom","avalanche"],"blackeyegalaxy.space":["bsc"],"app.liquidifty.io":["bsc"],"dnaxcat.io":["bsc"],"xwin.finance":["bsc"],"crystalkingdoms.io":["bsc"],"bee.honeyfarm.finance":["bsc","avalanche"],"milkshakeswap.finance":["bsc"],"foodcourt.finance":["bsc"],"gyro.money":["bsc"],"starmon.io":["bsc"],"silo.br34p.finance":["bsc"],"klend.finance":["bsc"],"hyperjump.fi":["bsc"],"app.kalata.io":["bsc"],"pinecone.finance":["bsc"],"1000blocks.space":["bsc"],"dontplaywithkitty.io":["bsc"],"bscswap.com":["bsc"],"thoreum.finance":["bsc"],"cryptopiece.online":["bsc"],"trustroll.win":["bsc"],"app.catecoin.club":["bsc"],"metareserve.finance":["bsc"],"dapp.beglobal.finance":["bsc"],"donkswap.com":["bsc"],"meowswap.net":["bsc"],"bnbminer.finance":["bsc"],"qbt.fi":["bsc"],"pets.micropets.io":["bsc"],"smartswap.jointer.io":["bsc"],"wanakafarm.com":["bsc"],"hashland.com":["bsc"],"ibg.finance":["bsc"],"fateorigin.com":["bsc"],"fomoeth.net":["ethereum","bsc"],"app.bagels.finance":["bsc"],"app.buffer.finance":["bsc"],"finance.zcore.network":["bsc"],"blizzard.money":["bsc"],"get.1-b.tc":["bsc"],"traderjoexyz.com":["avalanche"],"pangolin.exchange":["avalanche"],"kalao.io":["avalanche"],"lydia.finance":["avalanche"],"yieldhunt.game":["avalanche"],"alligator.exchange":["avalanche"],"thorus.fi":["avalanche"],"heroesofnft.com":["avalanche"],"avaxtars.com":["avalanche"],"avaxwolfgame.io":["avalanche"],"avaxfactory.finance":["avalanche"],"avalancheprime.com":["avalanche"],"yetiswap.app":["avalanche"],"canary.exchange":["avalanche"],"teddy.cash":["avalanche"],"defifarmers.net":["avalanche"],"talecraft.io":["avalanche"],"avaxguitars.com":["avalanche"],"complus.exchange":["avalanche"],"bifi.finance":["ethereum","bsc","avalanche"],"alienxava.com":["avalanche"],"arafinance.land":["avalanche"],"avaco.finance":["avalanche"],"avaeagle.com":["avalanche"],"avaxpunks.com":["avalanche"],"avalaunch.app":["avalanche"],"luan.avaterra.finance":["avalanche"],"avanyan.io":["avalanche"],"app.avaterra.finance":["avalanche"],"avaware.network":["avalanche"],"avaxdoge.club":["avalanche"],"avaxduels.com":["avalanche"],"vfart.tools":["fantom"],"avaxblobs.io":["avalanche"],"axdao.club":["avalanche"],"traderjoebaby.com":["avalanche"],"baguette.exchange":["avalanche"],"banksy.farm":["avalanche"],"avaxgive.netlify.app":["avalanche"],"avaxtrifleberry.world":["avalanche"],"avax.boneswap.finance":["avalanche"],"bulgingturtles.com":["avalanche"],"app.cesta.finance":["avalanche"],"cflcomru.turbo.site":["avalanche"],"chestproject.com":["avalanche"],"chillafsloths.com":["avalanche"],"colonylab.io":["avalanche"],"algonetwork.github.io":["polygon","bsc","avalanche","fantom"],"coup.farm":["avalanche"],"crabada.com":["avalanche"],"crabfinance.live":["avalanche"],"crypto-companions.art":["avalanche"],"cryptomultisender.com":["ethereum","bsc","polygon","avalanche"],"cryptoseals.art":["avalanche"],"cryptowaifus.art":["avalanche"],"cryptoyieldfocus.com":["avalanche"],"cycle.finance":["avalanche"],"defikingdoms.com":["avalanche"],"egg.avaeagle.com":["avalanche"],"avax.eternalfinance.live":["avalanche"],"bridge.evodefi.com":["ethereum","polygon","bsc","avalanche","fantom"],"farmersofavax.com":["avalanche"],"dao.farmersonly.farm":["avalanche"],"farmersonly.farm":["avalanche"],"tmt.farmersonly.farm":["avalanche"],"onion.farmersonly.farm":["avalanche"],"app.forbitspace.com":["ethereum","bsc","polygon","avalanche"],"fortunehunter.me":["bsc","polygon","avalanche"],"frogdefi.com":["bsc","avalanche","polygon"],"fundz.finance":["avalanche"],"g2.money":["avalanche","polygon","bsc"],"ghostmarket.io":["bsc","polygon","avalanche"],"gmbyrykyart.com":["avalanche"],"gondola.finance":["avalanche"],"grapestaking.lidia.in":["bsc","avalanche","polygon"],"growthdefi.com":["ethereum","bsc","avalanche"],"hatchypocket.com":["avalanche"],"hedgey.finance":["ethereum","polygon","bsc","avalanche"],"hunnypoker.com":["bsc","avalanche"],"icecubes.finance":["avalanche"],"iceflake.finance":["avalanche"],"iceslush.finance":["avalanche"],"imperiumempires.com":["avalanche"],"instadapp.io":["ethereum","polygon","avalanche"],"killking.io":["polygon","bsc","avalanche"],"polygon.mantarayswap.finance":["polygon","bsc","avalanche"],"lootfish.co":["avalanche"],"luffyswap.finance":["avalanche"],"mammothfinance.io":["avalanche"],"marginswap.finance":["avalanche"],"maximus.farm":["avalanche"],"binance.mermaidswap.com":["bsc","avalanche"],"mifuto.com":["avalanche"],"mint-swap.com":["avalanche"],"mozza.farm":["avalanche"],"nftbear.art":["avalanche","polygon","bsc"],"noahark.money":["avalanche"],"nonfungiblepixels.com":["avalanche"],"nukevaults.com":["polygon","avalanche","arbitrum"],"avalanche-oberon.galaxyfinance.one":["avalanche"],"avax.olive.cash":["avalanche"],"onyx.farm":["avalanche","polygon","fantom"],"penguinfinance.io":["avalanche"],"piratedao.money":["avalanche"],"pixelseedlings.com":["avalanche"],"pixelpenguinz.com":["avalanche"],"platypus.finance":["avalanche"],"polydragon.gold":["polygon","avalanche","bsc"],"app.redbees.finance":["avalanche"],"swap.rug.farm":["avalanche"],"salmondefi.com":["bsc","polygon","avalanche"],"smitheryfarms.world":["avalanche"],"snowball.network":["avalanche"],"snowbank.finance":["avalanche"],"snowdream.network":["avalanche"],"aurafi.org":["fantom"],"bakerguild.com":["fantom"],"fantomballoons.com":["fantom"],"bearfinance.org":["fantom"],"app.fanblackgoat.finance":["fantom"],"bouje.finance":["fantom"],"broomswap.finance":["fantom"],"bullrun.finance":["fantom"],"coffin.finance":["fantom"],"pod.town":["fantom"],"dark.knightswap.financial":["fantom"],"dmu.zone":["fantom"],"pixelducks.online":["fantom"],"cave.dracoforce.com":["fantom"],"dracoforce.com":["fantom"],"eldritch.app":["fantom"],"app.ester.finance":["fantom"],"luan.fanterra.finance":["fantom"],"app.fanterra.finance":["fantom"],"fantomfroggy.com":["fantom"],"fantomapp.cougarswap.io":["fantom"],"ftmpunks.com":["fantom"],"fastyield.app":["fantom"],"genesys.app":["fantom"],"hellhound.finance":["fantom"],"fantom.kavian.finance":["fantom"],"knight-finance.xyz":["fantom"],"knightsfinance.xyz":["fantom"],"matrix.farm":["fantom"],"maximum.farm":["fantom"],"meowfinance.org":["fantom"],"ftm.metanetwork.vip":["fantom"],"moon-vault.com":["bsc","polygon","fantom"],"morpheusswap.finance":["fantom"],"mun-swap.com":["fantom"],"nutcrackerfi.com":["fantom"],"orangeswap.space":["fantom"],"procyonswap.com":["fantom"],"raccoondefi.com":["fantom"],"fantom.rediant.finance":["fantom"],"sapphiredefi.com":["fantom"],"recycle.sapphiredefi.com":["fantom"],"war.sapphiredefi.com":["fantom"],"scarecrow.fi":["fantom"],"shibafantom.finance":["fantom"],"skeleton.finance":["fantom"],"spookyskeletoons.com":["fantom"],"spookyswap.finance":["fantom"],"squid-defi.com":["fantom"],"gasstationcrypto.com":["bsc","polygon","fantom"],"timechainswap.com":["fantom"],"trickortreat.farm":["fantom"],"unidexbot.com":["ethereum","polygon","bsc","avalanche","fantom"],"unirex.finance":["fantom"],"vaultworldftm.finance":["fantom"],"xmas-past.com":["fantom"],"yoshi.exchange":["fantom"],"zonster.cool":["fantom"],"raydium.io":[],"depools.extraton.io":[],"katana.roninchain.com":[],"neutrino.at":[],"vvs.finance":[],"wax.alcor.exchange":[],"klayswap.com":[],"vires.finance":[],"mm.finance":[],"magiceden.io":[],"tectonic.finance":[],"axieinfinity.com":["ethereum"],"saber.so":[],"justswap.network":[],"solend.fi":[],"projectlarix.com":[],"crowfi.app":[],"swop.fi":[],"coinwind.com":["ethereum","bsc"],"viper.exchange":[],"tinyman.org":[],"app.beamswap.io":[],"fuse.fi":["fuse"],"port.finance":[],"home.omnidex.finance":[],"solanart.io":[],"bluewhale-protocol.com":[],"sovryn.app":["rsk"],"nbatopshot.com":[],"mercurial.finance":[],"dapp.defibox.io":[],"solarbeam.io":[],"staking.fuse.io":["fuse"],"goodswap.xyz":["ethereum","fuse"],"jinfinance.com":["fuse"],"artrific.io":["fuse"],"comunitaria.com":["fuse"],"flambu.com":["fuse"],"fuse.cash":["fuse"],"ola.finance":["fuse"],"itsaboutpeepl.com":["fuse"],"babelfish.money":["rsk"],"moneyonchain.com":["rsk"],"rskswap.com":["rsk"],"tropykus.finance":["rsk"],"watafan.com":["rsk"]}');
    }
  },
      t = {};

  function r(n) {
    var i = t[n];
    if (void 0 !== i) return i.exports;
    var o = t[n] = {
      id: n,
      loaded: !1,
      exports: {}
    };
    return e[n].call(o.exports, o, o.exports, r), o.loaded = !0, o.exports;
  }

  r.d = function (e, t) {
    for (var n in t) {
      r.o(t, n) && !r.o(e, n) && Object.defineProperty(e, n, {
        enumerable: !0,
        get: t[n]
      });
    }
  }, r.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, r.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, r.nmd = function (e) {
    return e.paths = [], e.children || (e.children = []), e;
  };
  var n = r(3607);
  module.exports = n;
})();